import PropTypes from 'prop-types';
import { withStyles, registerDefaultsForModule, createUseStyles } from '@glu/theming';
import classNames from 'classnames';
import React, { useState, useCallback, useEffect, useRef, Fragment, useMemo } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

registerDefaultsForModule('actionableIcon', function (_ref) {
  var palette = _ref.palette;
  return {
    backgroundColor: palette.background,
    color: palette.primary.normal,
    disabledColor: palette.primary.disabled,
    borderColor: palette.primary.light,
    hoverColor: palette.text.light,
    hoverBackgroundColor: palette.primary.normal
  };
});

var styles = function styles(_ref2) {
  var _ref2$actionableIcon = _ref2.actionableIcon,
      backgroundColor = _ref2$actionableIcon.backgroundColor,
      color = _ref2$actionableIcon.color,
      disabledColor = _ref2$actionableIcon.disabledColor,
      borderColor = _ref2$actionableIcon.borderColor,
      hoverColor = _ref2$actionableIcon.hoverColor,
      hoverBackgroundColor = _ref2$actionableIcon.hoverBackgroundColor;
  return {
    actionableIcon: {
      backgroundColor: backgroundColor,
      border: '1px solid transparent',
      display: 'flex',
      padding: 8,
      '&:active, &:focus': {
        outline: 'none',
        borderColor: borderColor,
        borderRadius: 32
      },
      '&:hover:not([disabled])': {
        border: "1px solid ".concat(hoverBackgroundColor),
        background: hoverBackgroundColor,
        borderRadius: 32,
        '& svg': {
          fill: hoverColor
        }
      },
      '&:not([disabled]) svg': {
        fill: color
      },
      '&[disabled] svg': {
        fill: disabledColor
      }
    }
  };
};

var ActionableIcon = function ActionableIcon(_ref3) {
  var children = _ref3.children,
      onClick = _ref3.onClick,
      classes = _ref3.classes,
      className = _ref3.className,
      type = _ref3.type,
      theme = _ref3.theme,
      rest = _objectWithoutProperties(_ref3, ["children", "onClick", "classes", "className", "type", "theme"]);

  return (// eslint-disable-next-line react/button-has-type
    React.createElement("button", _extends({
      className: "".concat(classes.actionableIcon, " ").concat(className),
      onClick: onClick,
      type: type
    }, rest, {
      "aria-label": type
    }), typeof children === 'function' ? children() : children)
  );
};

ActionableIcon.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,

  /**
   * Classes for JSS styling
   */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  theme: PropTypes.objectOf(PropTypes.any).isRequired
};
ActionableIcon.defaultProps = {
  className: '',
  type: 'button'
};
var ActionableIcon$1 = withStyles(styles)(ActionableIcon);

registerDefaultsForModule('actionableMenuIcon', function (_ref) {
  var palette = _ref.palette;
  return {
    menuBackgroundColor: palette.background,
    menuBorder: "1px solid ".concat(palette.primary.normal),
    menuButtonColor: '#4C4C4C',
    menuButtonHoverColor: '#3f3f3f',
    menuButtonHoverBackground: palette.highlightBackground,
    menuButtonPadding: [8, 10],
    menuBorderRadius: 4,
    menuFontSize: 14,
    menuPadding: [5, 0]
  };
});

var styles$1 = function styles(_ref2) {
  var _ref2$actionableIcon = _ref2.actionableIcon,
      actionableIconHoverBackgroundColor = _ref2$actionableIcon.hoverBackgroundColor,
      actionableIconHoverColor = _ref2$actionableIcon.hoverColor,
      _ref2$actionableMenuI = _ref2.actionableMenuIcon,
      menuBackgroundColor = _ref2$actionableMenuI.menuBackgroundColor,
      menuBorder = _ref2$actionableMenuI.menuBorder,
      menuBorderRadius = _ref2$actionableMenuI.menuBorderRadius,
      menuButtonColor = _ref2$actionableMenuI.menuButtonColor,
      menuButtonHoverColor = _ref2$actionableMenuI.menuButtonHoverColor,
      menuButtonHoverBackground = _ref2$actionableMenuI.menuButtonHoverBackground,
      menuButtonPadding = _ref2$actionableMenuI.menuButtonPadding,
      menuFontSize = _ref2$actionableMenuI.menuFontSize,
      menuPadding = _ref2$actionableMenuI.menuPadding;
  return {
    root: {
      position: 'relative'
    },
    left: {},
    right: {},
    menu: {
      '&$left': {
        left: 0
      },
      '&$right': {
        right: 0
      },
      backgroundClip: 'padding-box',
      backgroundColor: menuBackgroundColor,
      border: menuBorder,
      borderRadius: menuBorderRadius,
      fontSize: menuFontSize,
      margin: [2, 0, 0, 0],
      minWidth: function minWidth(_ref3) {
        var _minWidth = _ref3.minWidth;
        return _minWidth || undefined;
      },
      padding: menuPadding,
      position: 'absolute',
      textAlign: 'left',
      top: '100%',
      zIndex: 1000
    },
    menuButton: {
      color: menuButtonColor,
      display: 'block',
      lineHeight: 1,
      margin: 0,
      padding: menuButtonPadding,
      textAlign: 'left',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      width: '100%',
      backgroundColor: 'initial',
      border: 'none',
      '&:hover:not([disabled]),&:focus': {
        color: menuButtonHoverColor,
        backgroundColor: menuButtonHoverBackground,
        textDecoration: 'none'
      }
    },
    openMenuIcon: {
      background: actionableIconHoverBackgroundColor,
      borderRadius: 32,
      '&$openMenuIcon svg': {
        fill: actionableIconHoverColor
      }
    }
  };
};

var useStyles = createUseStyles(styles$1);

var ActionableMenuIcon = function ActionableMenuIcon(_ref4) {
  var _classnames;

  var menuChoices = _ref4.menuChoices,
      className = _ref4.className,
      children = _ref4.children,
      minWidth = _ref4.minWidth,
      iconMenuAlignment = _ref4.iconMenuAlignment,
      actionableIconProps = _objectWithoutProperties(_ref4, ["menuChoices", "className", "children", "minWidth", "iconMenuAlignment"]);

  var classes = useStyles(useMemo(function () {
    return {
      minWidth: minWidth
    };
  }, [minWidth]));
  var component = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  useEffect(function () {
    var handleClick = function handleClick(event) {
      if (component.current && !component.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClick);
    return function () {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [component]);
  var onClickIcon = useCallback(function () {
    setOpen(!isOpen);
  }, [isOpen]);
  var onClickMenuChoice = useCallback(function (event, menuChoice) {
    setOpen(false);

    if (menuChoice.onClick) {
      menuChoice.onClick(event, menuChoice);
    }
  }, [setOpen]);
  return React.createElement("div", {
    className: "".concat(classes.root, " ").concat(className),
    ref: component
  }, React.createElement(ActionableIcon$1, _extends({
    className: isOpen ? classes.openMenuIcon : undefined,
    onClick: onClickIcon
  }, actionableIconProps), children), isOpen && React.createElement("div", {
    className: classNames(classes.menu, (_classnames = {}, _defineProperty(_classnames, classes.left, iconMenuAlignment === 'left'), _defineProperty(_classnames, classes.right, iconMenuAlignment === 'right'), _classnames)),
    style: minWidth ? {
      minWidth: minWidth
    } : undefined
  }, menuChoices.map(function (menuChoice) {
    var _ref5 = menuChoice.hrefOptions || {},
        _ref5$className = _ref5.className,
        hrefClassName = _ref5$className === void 0 ? '' : _ref5$className,
        hrefOptions = _objectWithoutProperties(_ref5, ["className"]);

    return React.createElement(Fragment, {
      key: menuChoice.label
    }, menuChoice.hrefOptions ? React.createElement("a", _extends({
      className: "".concat(classes.menuButton, " ").concat(hrefClassName),
      href: menuChoice.href
    }, hrefOptions, {
      onClick: function onClick(event) {
        return onClickMenuChoice(event, menuChoice);
      }
    }), menuChoice.label) : React.createElement("button", {
      type: "button",
      className: classes.menuButton,
      onClick: function onClick(event) {
        return onClickMenuChoice(event, menuChoice);
      }
    }, menuChoice.label));
  })));
};

var menuChoicesPropType = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  // optional if href is present otherwise required
  href: PropTypes.string,
  hrefOptions: PropTypes.shape({}) // spread onto the href if href is set

}));
ActionableMenuIcon.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,

  /**
   * List of choices and what to call for them for display in a menu that appears under the
   * icon.  Using the href option will get you an href in the menu, which you can handle
   * with the onClick. The standard choice is rendered as a button though and handled
   * with the onClick. Href would be more the edge case if you need it.
   */
  menuChoices: menuChoicesPropType.isRequired,

  /**
   * A minWidth for the menu that appears when the icon is clicked if you want more than what the
   * menu's choices gives you (ie they are all short and you want a bit more).
   */
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Whether to align to the menu with the right or left edge of the actionable icon */
  iconMenuAlignment: PropTypes.oneOf(['left', 'right']),

  /** Optional JSS class for further styling */
  className: PropTypes.string
};
ActionableMenuIcon.defaultProps = {
  className: '',
  iconMenuAlignment: 'right',
  minWidth: undefined
};

var defaultTheme = function defaultTheme(_ref) {
  var palette = _ref.palette;
  return {
    fill: palette.primary.normal,
    size: 16
  };
};

registerDefaultsForModule('icons', defaultTheme); // istanbul ignore next

var styles$2 = function styles(_ref2) {
  var icons = _ref2.icons;
  return {
    icon: {
      display: 'block',
      fill: function fill(_ref3) {
        var _fill = _ref3.fill;
        return _fill || icons.fill;
      },
      height: function height(_ref4) {
        var _height = _ref4.height;
        return _height || icons.size;
      },
      width: function width(_ref5) {
        var _width = _ref5.width;
        return _width || icons.size;
      },
      '&:before': {
        content: 'none'
      }
    },
    iconWrapper: {
      display: 'inline-block'
    }
  };
};

var useStyles$1 = createUseStyles(styles$2);
var propTypes = {
  /**
   * If truthy show ActionableIcon with BareIcon inside unless its an object with menuChoices
   * in which case show an ActionableMenuIcon
   */
  actionable: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    menuChoices: menuChoicesPropType
  })]),
  onClick: PropTypes.func,

  /** Name of the icon, almost always matches the name of the svg file it came from */
  name: PropTypes.string.isRequired,

  /** Svgz generated icon component that has the full svg tag built right into the component */
  SvgIcon: PropTypes.func.isRequired,

  /** Title to set for the icon, this will inject a title attribute into the svg tag */
  title: PropTypes.string,

  /**
   * String with any additional class names you wish to add to the outer div container for the
   * icon.  Will not apply if noIconWrapper is true
   */
  className: PropTypes.string,

  /** Fill of the svg if the default is not desired, should be a legal CSS color */
  fill: PropTypes.string,
  // eslint-disable-line

  /** Height of the svg icon itself, should be a legal CSS unit */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // eslint-disable-line

  /** Width of the svg icon itself, should be a legal CSS unit */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // eslint-disable-line

  /** Optional text to show in a sibling span to the svg tag */
  text: PropTypes.string,

  /** True if you want the text property's text to be made visible */
  textVisible: PropTypes.bool,

  /**
   * True if you don't want the icon span element wrapped and just want the bare span containing
   * the svg tag.
   */
  noIconWrapper: PropTypes.bool
};
var defaultProps = {
  actionable: false,
  onClick: undefined,
  height: 16,
  width: 16,
  className: undefined,
  title: undefined,
  text: undefined,
  textVisible: false,
  noIconWrapper: false
};
var svgPropBlackList = ['fill', 'height', 'width'];

var Icon = function Icon(props) {
  var SvgIcon = props.SvgIcon,
      name = props.name,
      className = props.className,
      textVisible = props.textVisible,
      text = props.text,
      noIconWrapper = props.noIconWrapper,
      actionable = props.actionable,
      onClick = props.onClick,
      fill = props.fill,
      height = props.height,
      width = props.width,
      svgProps = _objectWithoutProperties(props, ["SvgIcon", "name", "className", "textVisible", "text", "noIconWrapper", "actionable", "onClick", "fill", "height", "width"]);

  var classes = useStyles$1(useMemo(function () {
    return {
      height: height,
      width: width,
      fill: fill
    };
  }, [height, width, fill])); // omit these on the svg as we are handling them in CSS so they can later be themable

  svgPropBlackList.forEach(function (prop) {
    return delete svgProps[prop];
  });

  if (!SvgIcon) {
    return null;
  }

  var bareIcon = React.createElement(SvgIcon, _extends({
    className: "icon-".concat(name, "\n      ").concat(classes.icon),
    onClick: actionable ? undefined : onClick
  }, svgProps));

  if (actionable) {
    return actionable.menuChoices ? React.createElement(ActionableMenuIcon, _extends({
      className: className
    }, actionable), bareIcon) : React.createElement(ActionableIcon$1, _extends({
      className: className,
      onClick: onClick
    }, actionable), bareIcon);
  }

  return noIconWrapper ? bareIcon : React.createElement("div", {
    className: classNames(classes.iconWrapper, className)
  }, bareIcon, text ? React.createElement("span", {
    className: textVisible ? '' : 'sr-only'
  }, text) : '');
};

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;
var StyledIcon = Icon;
/**
 * Creates an Icon component with the provided title so it doesn't need to be provided later at the
 * point of use.
 *
 * @param {Icon} IconComponent - Icon component to wrap
 * @param {string} title - Title to use for the svg in the icon
 * @return {function(*): *}
 */

function withTitle(IconComponent, title) {
  return function (props) {
    return React.createElement(IconComponent, _extends({}, props, {
      title: title
    }));
  };
}

var SvgIcon = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.332 7.4V5.5h.4a.624.624 0 00.35-1.191L7.923.35a1.348 1.348 0 00-1.382 0L.382 4.309a.651.651 0 00-.359.753c.1.297.398.481.709.438h.4v7.513A1.025 1.025 0 00.2 14.1v.95a.977.977 0 001 .95h10.3a4.5 4.5 0 001.832-8.6zm-6.25-6.209a.373.373 0 01.3 0L12.528 4.5H1.934l5.148-3.309zm5.25 4.309v1.584A4.472 4.472 0 0011.5 7c-.326.002-.65.039-.968.11V5.5h1.8zm-2.8 0v1.971a4.519 4.519 0 00-1.8 1.58V5.5h1.8zm-2.8 0V13h-1.8V5.5h1.8zm-2.8 0V13h-1.8V5.5h1.8zM1.2 15.05V14h6.56c.267.388.593.732.966 1.019L1.2 15.05zM11.5 15a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm2-4H12V9.5a.5.5 0 00-1 0V11H9.5a.5.5 0 000 1H11v1.5a.5.5 0 001 0V12h1.5a.5.5 0 000-1z"
  }));
};

var SvgAddBank = function SvgAddBank(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon,
    name: "add-bank"
  }, props));
};

var SvgIcon$1 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.332 7.4V5.5h.4a.624.624 0 00.35-1.191L7.923.35a1.348 1.348 0 00-1.382 0L.382 4.309a.651.651 0 00-.359.753c.1.297.398.481.709.438h.4v7.513A1.025 1.025 0 00.2 14.1v.95a.977.977 0 001 .95h10.3a4.5 4.5 0 001.832-8.6zm-6.25-6.209a.373.373 0 01.3 0L12.528 4.5H1.934l5.148-3.309zm5.25 4.309v1.584A4.472 4.472 0 0011.5 7c-.326.002-.65.039-.968.11V5.5h1.8zm-2.8 0v1.971a4.519 4.519 0 00-1.8 1.58V5.5h1.8zm-2.8 0V13h-1.8V5.5h1.8zm-2.8 0V13h-1.8V5.5h1.8zM1.2 15.05V14h6.56c.267.388.593.732.966 1.019L1.2 15.05zM11.5 15a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm2-4H12V9.5a.5.5 0 00-1 0V11H9.5a.5.5 0 000 1H11v1.5a.5.5 0 001 0V12h1.5a.5.5 0 000-1z"
  }));
};

var SvgAddBankNext = function SvgAddBankNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1,
    name: "add-bank-next"
  }, props));
};

var SvgIcon$2 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 0H.9v3.9H0v3h.9v2H0v3h.9v3.9h14.8V0H12zM8.8 4.7c.9 0 1.7.7 1.7 1.7S9.7 8 8.8 8c-.9 0-1.7-.7-1.7-1.6 0-.9.8-1.7 1.7-1.7zm-6.9 6.1h-1v-1h1v1zm0-4.9h-1v-1h1v1zm9.9 5H5.7c0-.5 0-1 .1-1.4.7-.4 1.4-.8 2.2-1 .5.3 1.1.3 1.6 0 .8.3 1.5.6 2.2 1 0 .4.1.9 0 1.4z"
  }));
};

var SvgAddressBook = function SvgAddressBook(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2,
    name: "address-book"
  }, props));
};

var SvgIcon$3 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14.5 14.5"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.1 5.1C13.4 2.8 11.4 1 9 .7c1.5-1.1 3.6-.9 4.8.6.8 1.2.9 2.6.3 3.8zM5.5.7C3.1 1 1.1 2.7.4 5-.5 3.3.1 1.3 1.8.4 3-.2 4.5-.1 5.5.7zm2.3 7.2l2.9 2.9-.7.7-3.2-3.1V5.2h1v2.7zm-.5 6.6C3.7 14.5.8 11.6.8 8s2.9-6.5 6.5-6.5 6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5zm0-12C4.3 2.5 1.8 5 1.8 8s2.5 5.5 5.5 5.5S12.8 11 12.8 8c0-3.1-2.5-5.5-5.5-5.5zm-5 9.6l.7.7-1.3 1.3-.7-.6 1.3-1.4zm10 0l-.7.7 1.3 1.3.7-.7-1.3-1.3z"
  }));
};

var SvgAlarmClock = function SvgAlarmClock(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3,
    name: "alarm-clock"
  }, props));
};

var SvgIcon$4 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15 12.4"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.2 1.8c2.4 2.4 2.4 6.4-.1 8.8-1.6 1.6-3.9 2.2-6 1.6l.5-1.7c2.4.7 4.8-.7 5.5-3.1s-.8-4.8-3.1-5.5-4.8.8-5.5 3.1c-.1.4-.1.8-.1 1.2h3.2L3.7 9.9 0 6.2h2.6C2.6 2.7 5.4 0 8.8 0c1.7 0 3.2.7 4.4 1.8z"
  }));
};

var SvgArrowCircleLeft = function SvgArrowCircleLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4,
    name: "arrow-circle-left"
  }, props));
};

var SvgIcon$5 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M.5 8.5c.3 0 .5-.2.5-.5 0-.5 0-.9.1-1.4.1-.4.2-.9.4-1.3s.4-.8.7-1.2c.5-.8 1.1-1.4 1.9-1.9.4-.3.8-.5 1.2-.6.4-.2.9-.3 1.3-.4.9-.2 1.9-.2 2.8 0 .4.1.9.2 1.3.4l1.2.6c.8.5 1.4 1.1 1.9 1.9.2.3.3.5.5.8l-1.4-.6c-.3-.1-.5 0-.7.3-.1.3 0 .5.3.7l2.3 1c.1.1.2.1.4.1s.3 0 .4-.1c.3-.3.4-.6.4-.9V2.8c0-.3-.2-.5-.5-.5s-.5.2-.5.5v1.3c-.1-.2-.2-.4-.4-.6-.6-.9-1.3-1.6-2.2-2.2C12 1 11.5.8 11 .6c-.5-.2-1-.4-1.5-.5-1-.1-2-.1-3.1.1-.5.1-1 .3-1.5.5-.5.1-.9.4-1.4.7-.8.5-1.6 1.3-2.1 2.1-.3.5-.6.9-.8 1.4-.2.5-.4 1-.5 1.5C.1 6.9 0 7.5 0 8c0 .3.2.5.5.5zm15-1c-.3 0-.5.2-.5.5 0 .5 0 .9-.1 1.4-.1.4-.2.9-.4 1.3l-.6 1.2c-.5.8-1.1 1.4-1.9 1.9-.4.3-.8.5-1.2.6-.4.2-.9.3-1.3.4-.9.2-1.9.2-2.8 0-.4-.1-.9-.2-1.3-.4l-1.2-.6c-.8-.5-1.4-1.1-1.9-1.9-.2-.3-.3-.5-.5-.8l1.4.6c.3.1.5 0 .7-.3.1-.3 0-.5-.3-.6l-2.3-1c-.4-.2-.7-.1-.9 0-.3.2-.4.4-.4.7v2.6c0 .3.2.5.5.5s.5-.2.5-.4v-1.3c.1.2.2.4.4.6.6.9 1.3 1.6 2.2 2.2.4.3.9.5 1.4.7.5.2 1 .4 1.5.5 1.1.2 2.2.2 3.2 0 .5-.1 1-.3 1.5-.5s.9-.4 1.4-.7c.9-.6 1.6-1.3 2.2-2.2.3-.4.5-.9.7-1.4.2-.5.4-1 .5-1.5-.1-.5 0-1.1 0-1.6 0-.3-.2-.5-.5-.5z"
  }));
};

var SvgArrowCircles = function SvgArrowCircles(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5,
    name: "arrow-circles"
  }, props));
};

var SvgIcon$6 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M.5 8.5c.3 0 .5-.2.5-.5 0-.5 0-.9.1-1.4.1-.4.2-.9.4-1.3s.4-.8.7-1.2c.5-.8 1.1-1.4 1.9-1.9.4-.3.8-.5 1.2-.6.4-.2.9-.3 1.3-.4.9-.2 1.9-.2 2.8 0 .4.1.9.2 1.3.4l1.2.6c.8.5 1.4 1.1 1.9 1.9.2.3.3.5.5.8l-1.4-.6c-.3-.1-.5 0-.7.3-.1.3 0 .5.3.7l2.3 1c.1.1.2.1.4.1s.3 0 .4-.1c.3-.3.4-.6.4-.9V2.8c0-.3-.2-.5-.5-.5s-.5.2-.5.5v1.3c-.1-.2-.2-.4-.4-.6-.6-.9-1.3-1.6-2.2-2.2C12 1 11.5.8 11 .6c-.5-.2-1-.4-1.5-.5-1-.1-2-.1-3.1.1-.5.1-1 .3-1.5.5-.5.1-.9.4-1.4.7-.8.5-1.6 1.3-2.1 2.1-.3.5-.6.9-.8 1.4-.2.5-.4 1-.5 1.5C.1 6.9 0 7.5 0 8c0 .3.2.5.5.5zm15-1c-.3 0-.5.2-.5.5 0 .5 0 .9-.1 1.4-.1.4-.2.9-.4 1.3l-.6 1.2c-.5.8-1.1 1.4-1.9 1.9-.4.3-.8.5-1.2.6-.4.2-.9.3-1.3.4-.9.2-1.9.2-2.8 0-.4-.1-.9-.2-1.3-.4l-1.2-.6c-.8-.5-1.4-1.1-1.9-1.9-.2-.3-.3-.5-.5-.8l1.4.6c.3.1.5 0 .7-.3.1-.3 0-.5-.3-.6l-2.3-1c-.4-.2-.7-.1-.9 0-.3.2-.4.4-.4.7v2.6c0 .3.2.5.5.5s.5-.2.5-.4v-1.3c.1.2.2.4.4.6.6.9 1.3 1.6 2.2 2.2.4.3.9.5 1.4.7.5.2 1 .4 1.5.5 1.1.2 2.2.2 3.2 0 .5-.1 1-.3 1.5-.5s.9-.4 1.4-.7c.9-.6 1.6-1.3 2.2-2.2.3-.4.5-.9.7-1.4.2-.5.4-1 .5-1.5-.1-.5 0-1.1 0-1.6 0-.3-.2-.5-.5-.5z"
  }));
};

var SvgArrowCirclesNext = function SvgArrowCirclesNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6,
    name: "arrow-circles-next"
  }, props));
};

var SvgIcon$7 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.9 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 6.1L5 0v4.1C16 3.4 15.9 11 15.9 12 14.1 6.5 6 7.9 5 7.9V12L0 6.1z"
  }));
};

var SvgArrowCurvedLeft = function SvgArrowCurvedLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7,
    name: "arrow-curved-left"
  }, props));
};

var SvgIcon$8 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.9 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.9 12V7.9C9.9 7.9 1.8 6.5 0 12c0-1-.1-8.6 10.9-7.9V0l5 6.1-5 5.9z"
  }));
};

var SvgArrowCurvedRight = function SvgArrowCurvedRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$8,
    name: "arrow-curved-right"
  }, props));
};

var SvgIcon$9 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13.4 11"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.4 5.5L7.8 11V7.5H4.4v-4h3.4V0l5.6 5.5zm-9.9-2H2.1v4h1.4v-4zm-3.1 0H0v4h.4v-4z"
  }));
};

var SvgArrowDashes = function SvgArrowDashes(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$9,
    name: "arrow-dashes"
  }, props));
};

var SvgIcon$a = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 8.2c-.2-.2-.5-.2-.7 0l-5.5 5.5V1.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v12.5L2 8.2c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l6 6c.4.4 1 .4 1.4 0l6-6c.2-.2.2-.5 0-.7z"
  }));
};

var SvgArrowDown = function SvgArrowDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$a,
    name: "arrow-down"
  }, props));
};

var SvgIcon$b = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.6 15.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 8.1l1.4-1.4 5.4 5.4V0h2v12l5.3-5.3 1.4 1.4-7.8 7.8L0 8.1z"
  }));
};

var SvgArrowDown$1 = function SvgArrowDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$b,
    name: "arrow-down"
  }, props));
};

var SvgIcon$c = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 8.2c-.2-.2-.5-.2-.7 0l-5.5 5.5V1.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v12.5L2 8.2c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l6 6c.4.4 1 .4 1.4 0l6-6c.2-.2.2-.5 0-.7z"
  }));
};

var SvgArrowDownNext = function SvgArrowDownNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$c,
    name: "arrow-down-next"
  }, props));
};

var SvgIcon$d = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 7.5H2.3L7.8 2c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L2.3 8.5h12.5c.3 0 .5-.2.5-.5-.1-.3-.3-.5-.6-.5z"
  }));
};

var SvgArrowLeft = function SvgArrowLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$d,
    name: "arrow-left"
  }, props));
};

var SvgIcon$e = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.9 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 7.8L7.8 0l1.4 1.4-5.3 5.3h12v2H3.7l5.4 5.4-1.4 1.4L0 7.8z"
  }));
};

var SvgArrowLeft$1 = function SvgArrowLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$e,
    name: "arrow-left"
  }, props));
};

var SvgIcon$f = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 7.5H2.3L7.8 2c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L2.3 8.5h12.5c.3 0 .5-.2.5-.5-.1-.3-.3-.5-.6-.5z"
  }));
};

var SvgArrowLeftNext = function SvgArrowLeftNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$f,
    name: "arrow-left-next"
  }, props));
};

var SvgIcon$g = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.9 7.3l-6-6c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.5 5.5H1.3c-.3 0-.5.2-.5.5s.2.5.5.5h12.5L8.2 14c-.2.2-.2.5 0 .7.2.2.5.2.7 0l6-6c.4-.4.4-1 0-1.4z"
  }));
};

var SvgArrowRight = function SvgArrowRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$g,
    name: "arrow-right"
  }, props));
};

var SvgIcon$h = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.9 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.1 15.6l-1.4-1.4 5.4-5.4H0v-2h12L6.7 1.4 8.1 0l7.8 7.8-7.8 7.8z"
  }));
};

var SvgArrowRight$1 = function SvgArrowRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$h,
    name: "arrow-right"
  }, props));
};

var SvgIcon$i = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.9 7.3l-6-6c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.5 5.5H1.3c-.3 0-.5.2-.5.5s.2.5.5.5h12.5L8.2 14c-.2.2-.2.5 0 .7.2.2.5.2.7 0l6-6c.4-.4.4-1 0-1.4z"
  }));
};

var SvgArrowRightNext = function SvgArrowRightNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$i,
    name: "arrow-right-next"
  }, props));
};

var SvgIcon$j = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 7.1l-6-6c-.4-.4-1-.4-1.4 0l-6 6c-.2.2-.2.5 0 .7.2.2.5.2.7 0l5.5-5.5v12.5c0 .3.2.5.5.5s.5-.2.5-.5V2.3L14 7.8c.1.1.2.1.4.1.1 0 .3 0 .4-.1.1-.2.1-.5-.1-.7z"
  }));
};

var SvgArrowUp = function SvgArrowUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$j,
    name: "arrow-up"
  }, props));
};

var SvgIcon$k = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.6 15.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.6 7.7l-1.4 1.4-5.5-5.4v12.1h-2v-12L1.4 9.2 0 7.8 7.8 0l7.8 7.7z"
  }));
};

var SvgArrowUp$1 = function SvgArrowUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$k,
    name: "arrow-up"
  }, props));
};

var SvgIcon$l = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 7.1l-6-6c-.4-.4-1-.4-1.4 0l-6 6c-.2.2-.2.5 0 .7.2.2.5.2.7 0l5.5-5.5v12.5c0 .3.2.5.5.5s.5-.2.5-.5V2.3L14 7.8c.1.1.2.1.4.1.1 0 .3 0 .4-.1.1-.2.1-.5-.1-.7z"
  }));
};

var SvgArrowUpNext = function SvgArrowUpNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$l,
    name: "arrow-up-next"
  }, props));
};

var SvgIcon$m = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.5 12.4"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.9 3.1c-1.7-1.7-4.5-1.8-6.3 0-.8.8-1.2 1.9-1.2 3.1h1.7L2.7 9.9 0 6.2h1.6C1.6 2.7 4.4 0 7.8 0c1.4 0 2.7.5 3.8 1.4.1.1.2.2.3.2m-8.3 9.2l.3.3c2.7 2.1 6.6 1.6 8.7-1 .9-1.1 1.3-2.4 1.3-3.8h1.5l-2.7-3.8-2.3 3.8h1.7c0 2.5-2 4.4-4.5 4.4-1.2 0-2.3-.5-3.1-1.3"
  }));
};

var SvgArrowsCircles = function SvgArrowsCircles(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$m,
    name: "arrows-circles"
  }, props));
};

var SvgIcon$n = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.2 10H2.7c-.3 0-.5.2-.5.5s.2.5.5.5h1.8L.2 15.1c-.2.2-.2.5 0 .7 0 .1.2.2.3.2.1 0 .3-.1.4-.1l4.3-4.2v1.8c0 .3.2.5.5.5s.5-.2.5-.5V11c0-.6-.5-1-1-1zm5.6-4h2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1.8L15.8.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-4.3 4.2V2.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V5c0 .6.5 1 1 1zM5.7 2c-.3 0-.5.2-.5.5v1.8L.9.1C.7-.1.3 0 .1.2S0 .7.2.9L4.5 5H2.7c-.3 0-.5.2-.5.5s.2.5.5.5h2.5c.6 0 1-.4 1-1V2.5c0-.3-.2-.5-.5-.5zm5.8 9h1.8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-2.5c-.6 0-1 .4-1 1v2.5c0 .3.2.5.5.5s.5-.2.5-.5v-1.8l4.3 4.2c.1.1.2.1.4.1.3 0 .5-.2.5-.5 0-.1-.1-.3-.2-.4L11.5 11z"
  }));
};

var SvgArrowsCornersIn = function SvgArrowsCornersIn(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$n,
    name: "arrows-corners-in"
  }, props));
};

var SvgIcon$o = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M3.6 11.7L0 15.3l.7.7 3.7-3.7L6 14v-4H2l1.6 1.7zM14 10h-4v4l1.6-1.7 3.7 3.7.7-.7-3.6-3.6L14 10zM2 6h4V2L4.4 3.7.7 0 0 .7l3.6 3.6L2 6zm10.4-1.7L16 .7l-.7-.7-3.7 3.7L10 2v4h4l-1.6-1.7z"
  }));
};

var SvgArrowsCornersIn$1 = function SvgArrowsCornersIn(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$o,
    name: "arrows-corners-in"
  }, props));
};

var SvgIcon$p = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.2 10H2.7c-.3 0-.5.2-.5.5s.2.5.5.5h1.8L.2 15.1c-.2.2-.2.5 0 .7 0 .1.2.2.3.2.1 0 .3-.1.4-.1l4.3-4.2v1.8c0 .3.2.5.5.5s.5-.2.5-.5V11c0-.6-.5-1-1-1zm5.6-4h2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1.8L15.8.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-4.3 4.2V2.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V5c0 .6.5 1 1 1zM5.7 2c-.3 0-.5.2-.5.5v1.8L.9.1C.7-.1.3 0 .1.2S0 .7.2.9L4.5 5H2.7c-.3 0-.5.2-.5.5s.2.5.5.5h2.5c.6 0 1-.4 1-1V2.5c0-.3-.2-.5-.5-.5zm5.8 9h1.8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-2.5c-.6 0-1 .4-1 1v2.5c0 .3.2.5.5.5s.5-.2.5-.5v-1.8l4.3 4.2c.1.1.2.1.4.1.3 0 .5-.2.5-.5 0-.1-.1-.3-.2-.4L11.5 11z"
  }));
};

var SvgArrowsCornersInNext = function SvgArrowsCornersInNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$p,
    name: "arrows-corners-in-next"
  }, props));
};

var SvgIcon$q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M1.7 1h1.8c.3 0 .5-.2.5-.5S3.8 0 3.5 0H1C.4 0 0 .4 0 1v2.5c0 .3.2.5.5.5s.5-.2.5-.5V1.7l4.3 4.2c.1 0 .3.1.4.1.3 0 .5-.2.5-.5 0-.1-.1-.2-.2-.3L1.7 1zm3.6 9.1L1 14.3v-1.8c0-.3-.2-.5-.5-.5s-.5.2-.5.5V15c0 .6.4 1 1 1h2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H1.7L6 10.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7-.1zM15.5 12c-.3 0-.5.2-.5.5v1.8l-4.3-4.2c-.3-.1-.6-.1-.7.1-.2.2-.2.5 0 .7l4.3 4.1h-1.8c-.3 0-.5.2-.5.5s.2.5.5.5H15c.6 0 1-.4 1-1v-2.5c0-.3-.2-.5-.5-.5zM15 0h-2.5c-.3 0-.5.2-.5.5s.2.5.5.5h1.8L10 5.1c-.2.2-.2.5 0 .7.1.1.2.2.4.2.1 0 .2-.1.3-.1L15 1.7v1.8c0 .3.2.5.5.5s.5-.2.5-.5V1c0-.6-.4-1-1-1z"
  }));
};

var SvgArrowsCornersOut = function SvgArrowsCornersOut(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$q,
    name: "arrows-corners-out"
  }, props));
};

var SvgIcon$r = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4 0H0v4l1.6-1.7L5.3 6l.7-.7-3.6-3.6L4 0zm7.6 1.7L8 5.3l.7.7 3.7-3.7L14 4V0h-4l1.6 1.7zM10 14h4v-4l-1.6 1.6L8.7 8l-.7.7 3.6 3.6L10 14zm-7.6-1.7L6 8.7 5.3 8l-3.7 3.6L0 10v4h4l-1.6-1.7z"
  }));
};

var SvgArrowsCornersOut$1 = function SvgArrowsCornersOut(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$r,
    name: "arrows-corners-out"
  }, props));
};

var SvgIcon$s = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M1.7 1h1.8c.3 0 .5-.2.5-.5S3.8 0 3.5 0H1C.4 0 0 .4 0 1v2.5c0 .3.2.5.5.5s.5-.2.5-.5V1.7l4.3 4.2c.1 0 .3.1.4.1.3 0 .5-.2.5-.5 0-.1-.1-.2-.2-.3L1.7 1zm3.6 9.1L1 14.3v-1.8c0-.3-.2-.5-.5-.5s-.5.2-.5.5V15c0 .6.4 1 1 1h2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H1.7L6 10.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7-.1zM15.5 12c-.3 0-.5.2-.5.5v1.8l-4.3-4.2c-.3-.1-.6-.1-.7.1-.2.2-.2.5 0 .7l4.3 4.1h-1.8c-.3 0-.5.2-.5.5s.2.5.5.5H15c.6 0 1-.4 1-1v-2.5c0-.3-.2-.5-.5-.5zM15 0h-2.5c-.3 0-.5.2-.5.5s.2.5.5.5h1.8L10 5.1c-.2.2-.2.5 0 .7.1.1.2.2.4.2.1 0 .2-.1.3-.1L15 1.7v1.8c0 .3.2.5.5.5s.5-.2.5-.5V1c0-.6-.4-1-1-1z"
  }));
};

var SvgArrowsCornersOutNext = function SvgArrowsCornersOutNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$s,
    name: "arrows-corners-out-next"
  }, props));
};

var SvgIcon$t = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.8 4.3L4.7 1.2c-.4-.4-1-.4-1.4 0L.2 4.3c-.2.2-.3.5-.1.7.2.2.5.2.7 0l2.7-2.6v12.5c0 .3.2.5.5.5s.5-.2.5-.5V2.4L7.2 5c.2.2.5.2.7 0 .1-.2.1-.5-.1-.7.1 0 .1 0 0 0zm8.1 6.7c-.2-.2-.5-.2-.7 0l-2.7 2.6V1.2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v12.5L8.9 11c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l3.1 3.2c.4.4 1 .4 1.4 0l3.1-3.1c.2-.3.2-.6.1-.8-.1 0-.1 0 0 0z"
  }));
};

var SvgArrowsDouble = function SvgArrowsDouble(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$t,
    name: "arrows-double"
  }, props));
};

var SvgIcon$u = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.8 4.3L4.7 1.2c-.4-.4-1-.4-1.4 0L.2 4.3c-.2.2-.3.5-.1.7.2.2.5.2.7 0l2.7-2.6v12.5c0 .3.2.5.5.5s.5-.2.5-.5V2.4L7.2 5c.2.2.5.2.7 0 .1-.2.1-.5-.1-.7.1 0 .1 0 0 0zm8.1 6.7c-.2-.2-.5-.2-.7 0l-2.7 2.6V1.2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v12.5L8.9 11c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l3.1 3.2c.4.4 1 .4 1.4 0l3.1-3.1c.2-.3.2-.6.1-.8-.1 0-.1 0 0 0z"
  }));
};

var SvgArrowsDoubleNext = function SvgArrowsDoubleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$u,
    name: "arrows-double-next"
  }, props));
};

var SvgIcon$v = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#006",
    fillRule: "nonzero",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    d: "M0 0v.932l10.235 7.401h1.288v-.931L1.288 0H0zm11.523 0v.932L1.288 8.333H0v-.931L10.235 0h1.288z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M4.801 0v8.333h1.92V0h-1.92zM0 2.778v2.778h11.523V2.778H0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M0 3.333V5h11.523V3.333H0zM5.185 0v8.333h1.153V0H5.185zM0 8.333l3.84-2.777h.86L.859 8.333H0zM0 0l3.84 2.778h-.858L0 .62V0zm6.823 2.778L10.664 0h.859L7.682 2.778h-.859zm4.7 5.555L7.682 5.556h.859l2.982 2.156v.621z",
    fill: "#C00",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M10.259 13.084l-1.455.127.2 1.446L7.998 13.6l-1.006 1.058.2-1.446-1.455-.127 1.256-.745-.808-1.217 1.366.517.447-1.39.447 1.39 1.366-.517-.808 1.217m7.481 2.079l-.351-.529.594.225.194-.604.194.604.594-.225-.352.529.546.324-.632.055.087.628-.437-.46-.437.46.087-.628-.632-.055m.545-9.728l-.351-.528.594.225.194-.604.194.604.594-.225-.352.528.546.324-.632.055.087.629-.437-.46-.437.46.087-.629-.632-.055m-2.98 3.496l-.352-.528.593.225.195-.604.194.604.593-.225-.35.528.545.324-.632.055.087.629-.437-.46-.438.46.088-.629-.633-.055m7.208-1.264l-.352-.528.594.224.192-.604.196.604.592-.224-.35.528.545.324-.632.055.087.628-.438-.46-.437.46.087-.628-.631-.055m-.742 2.447l-.345.214.097-.395-.31-.262.405-.03.153-.376.154.376.405.03-.31.262.097.395",
    fill: "#FFF"
  })));
};

var SvgAustralia = function SvgAustralia(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$v,
    name: "australia"
  }, props));
};

var SvgIcon$w = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.5 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.1 10.2L13.8 9v-.4l1.7-.8-1.7-.7c0-.2 0-.3-.1-.5L15 5.4l-1.8-.2s0-.1-.1-.1c0-.1-.1-.2-.1-.3l1-1.6-1.9.4-.1-.1s0-.1-.1-.2l.4-1.9-1.6 1c-.1-.1-.2-.1-.4-.2L10.1.4 9 1.8h-.4L7.7 0 7 1.8c-.1 0-.2 0-.4.1L5.4.4l-.2 1.9s-.1 0-.2.1c0 0-.1 0-.2.1l-1.7-1 .5 1.8-.1.1-.2.2-1.9-.4 1 1.6c-.1.1-.1.3-.2.5l-1.8.1 1.3 1.2V7L0 7.8l1.7.7c0 .2 0 .4.1.5L.5 10.2l1.8.2s0 .1.1.1c0 .1.1.2.1.3l-1.1 1.7 2-.5.1.1c.1.1.1.2.2.2l-.5 1.8 1.7-1c.1.1.2.1.4.2l.2 1.8 1.2-1.4h.4l.7 1.7.7-1.7c.1 0 .2 0 .4-.1l1.3 1.4.1-1.8c.1 0 .1-.1.2-.1s.2-.1.3-.1l1.6.9-.4-1.8.1-.1.2-.2 1.8.4-1-1.6c.1-.2.2-.3.2-.5l1.8.1zm-7.3 2.7c-2.8 0-5-2.2-5-4.9s2.2-5 5-5c2.7 0 4.9 2.2 4.9 4.9 0 2.8-2.2 5-4.9 5zm-1.2-1.6l4.6-4.6-.7-.7-3.9 3.9-2.1-2.1-.8.7 2.9 2.8z"
  }));
};

var SvgBadgeCheckmark = function SvgBadgeCheckmark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$w,
    name: "badge-checkmark"
  }, props));
};

var SvgIcon$x = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 8v8H9V8m7-2V0H0v6m0 1.9v8h7v-8"
  }));
};

var SvgBlocks = function SvgBlocks(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$x,
    name: "blocks"
  }, props));
};

var SvgIcon$y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12.9 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.9 0v6.6l-1.5-1-1.5 1V0H0v15.7h12.9V0h-2z"
  }));
};

var SvgBook = function SvgBook(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$y,
    name: "book"
  }, props));
};

var SvgIcon$z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 7.6 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 0v15.7l3.8-5.2 3.8 5.2V0H0zm1.9 10.5l-1 1V1h1v9.5zm4.8.9l-1-1V1h1v10.4z"
  }));
};

var SvgBookmark = function SvgBookmark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$z,
    name: "bookmark"
  }, props));
};

var SvgIcon$A = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.2 14.5H1.8V1c0-.3-.2-.5-.5-.5S.8.7.8 1v13.5c0 .6.4 1 1 1h13.5c.3 0 .5-.2.5-.5s-.3-.5-.6-.5zm-.4-14H6.9c-.3 0-.5.2-.5.5s.2.5.5.5H14L5.9 9.6c-.2.2-.2.5 0 .7.2.2.5.2.7 0l8.1-8.1v7.2c0 .3.2.5.5.5s.5-.2.5-.5V1.5c.1-.6-.4-1-.9-1z"
  }));
};

var SvgBoxArrowOut = function SvgBoxArrowOut(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$A,
    name: "box-arrow-out"
  }, props));
};

var SvgIcon$B = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 16H0V4h9v1H1v10h10V8h1v8zm4-9h-1V1.7l-8.1 8-.7-.6L14.3 1H9V0h7v7z"
  }));
};

var SvgBoxArrowOut$1 = function SvgBoxArrowOut(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$B,
    name: "box-arrow-out"
  }, props));
};

var SvgIcon$C = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.2 14.5H1.8V1c0-.3-.2-.5-.5-.5S.8.7.8 1v13.5c0 .6.4 1 1 1h13.5c.3 0 .5-.2.5-.5s-.3-.5-.6-.5zm-.4-14H6.9c-.3 0-.5.2-.5.5s.2.5.5.5H14L5.9 9.6c-.2.2-.2.5 0 .7.2.2.5.2.7 0l8.1-8.1v7.2c0 .3.2.5.5.5s.5-.2.5-.5V1.5c.1-.6-.4-1-.9-1z"
  }));
};

var SvgBoxArrowOutNext = function SvgBoxArrowOutNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$C,
    name: "box-arrow-out-next"
  }, props));
};

var SvgIcon$D = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 11H9v4H1V1h8v4h1V0H0v16h10v-5zm2.1 1.1l-.7-.7 2.8-2.9L6 8.4v-.9h8.2l-2.9-2.8.7-.7 4 4-3.9 4.1z"
  }));
};

var SvgBoxArrowRight = function SvgBoxArrowRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$D,
    name: "box-arrow-right"
  }, props));
};

var SvgIcon$E = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M3 10.1h4.3V5.9H3v4.2zm1-3.2h2.3v2.3H4V6.9zM3 16h4.3v-4.3H3V16zm1-3.3h2.3V15H4v-2.3zm4.7-2.6H13V5.9H8.7v4.2zm1-3.2H12v2.3H9.7V6.9zM8.7 0v4.3H13V0H8.7zM12 3.3H9.7V1H12v2.3zM8.7 16H13v-4.3H8.7V16zm1-3.3H12V15H9.7v-2.3zM3 4.3h4.3V0H3v4.3zM4 1h2.3v2.3H4V1z"
  }));
};

var SvgBoxesColumns = function SvgBoxesColumns(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$E,
    name: "boxes-columns"
  }, props));
};

var SvgIcon$F = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 10 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4 4H0V0h4v4zm0 2H0v4h4V6zm0 6H0v4h4v-4zm6-12H6v4h4V0zm0 6H6v4h4V6zm0 6H6v4h4v-4z"
  }));
};

var SvgBoxesColumns$1 = function SvgBoxesColumns(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$F,
    name: "boxes-columns"
  }, props));
};

var SvgIcon$G = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M3 10.1h4.3V5.9H3v4.2zm1-3.2h2.3v2.3H4V6.9zM3 16h4.3v-4.3H3V16zm1-3.3h2.3V15H4v-2.3zm4.7-2.6H13V5.9H8.7v4.2zm1-3.2H12v2.3H9.7V6.9zM8.7 0v4.3H13V0H8.7zM12 3.3H9.7V1H12v2.3zM8.7 16H13v-4.3H8.7V16zm1-3.3H12V15H9.7v-2.3zM3 4.3h4.3V0H3v4.3zM4 1h2.3v2.3H4V1z"
  }));
};

var SvgBoxesColumnsNext = function SvgBoxesColumnsNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$G,
    name: "boxes-columns-next"
  }, props));
};

var SvgIcon$H = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.7 3v4.3H16V3h-4.3zM15 6.3h-2.3V4H15v2.3zM0 13h4.3V8.7H0V13zm1-3.3h2.3V12H1V9.7zm4.9-2.4h4.3V3H5.9v4.3zm1-3.3h2.3v2.3H6.9V4zm4.8 9H16V8.7h-4.3V13zm1-3.3H15V12h-2.3V9.7zM0 7.3h4.3V3H0v4.3zM1 4h2.3v2.3H1V4zm4.9 9h4.3V8.7H5.9V13zm1-3.3h2.3V12H6.9V9.7z"
  }));
};

var SvgBoxesRows = function SvgBoxesRows(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$H,
    name: "boxes-rows"
  }, props));
};

var SvgIcon$I = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.7 3v4.3H16V3h-4.3zM15 6.3h-2.3V4H15v2.3zM0 13h4.3V8.7H0V13zm1-3.3h2.3V12H1V9.7zm4.9-2.4h4.3V3H5.9v4.3zm1-3.3h2.3v2.3H6.9V4zm4.8 9H16V8.7h-4.3V13zm1-3.3H15V12h-2.3V9.7zM0 7.3h4.3V3H0v4.3zM1 4h2.3v2.3H1V4zm4.9 9h4.3V8.7H5.9V13zm1-3.3h2.3V12H6.9V9.7z"
  }));
};

var SvgBoxesRowsNext = function SvgBoxesRowsNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$I,
    name: "boxes-rows-next"
  }, props));
};

var SvgIcon$J = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#229E45",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    fill: "#F8E509",
    d: "M12.043 14.529l10.05-6.522-10.11-6.54L1.9 8.022l10.143 6.507z"
  }), React.createElement("path", {
    d: "M16.422 7.998a4.248 4.248 0 0 1-4.251 4.245 4.248 4.248 0 0 1-4.252-4.245 4.248 4.248 0 0 1 4.252-4.245c2.348 0 4.251 1.9 4.251 4.245z",
    fill: "#2B49A3"
  }), React.createElement("path", {
    d: "M10.773 10.54l-.131-.075-.137.067.03-.152-.105-.11.151-.018.07-.136.064.14.149.027-.112.105m2.87.874l-.131-.076-.137.067.03-.151-.105-.111.151-.018.07-.136.064.14.149.028-.112.104m-1.207-1l-.113-.065-.118.058.026-.13-.09-.097.13-.015.06-.118.055.122.128.023-.096.09m2.895-.282l-.11-.064-.117.057.026-.129-.09-.094.129-.015.06-.115.053.119.126.023-.094.088m-2.912-.733l-.131-.076-.137.068.03-.152-.105-.11.151-.018.07-.136.064.14.149.027-.112.105M8.834 7.515l-.131-.076-.137.068.03-.152-.105-.11.151-.018.07-.136.064.14.149.027-.112.105m.443 1.904l-.131-.076-.137.068.03-.152-.105-.11.15-.019.072-.136.063.141.148.027-.111.105m4.398-2.245l-.116-.067-.12.06.027-.134-.093-.098.133-.016.062-.12.056.124.132.024-.099.092m-.222 1.275l-.091-.053-.095.047.02-.105-.072-.078.104-.012.05-.094.044.097.103.02-.078.072m-4.74 1.68l-.087-.05-.091.045.02-.101-.07-.074.1-.012.048-.09.042.093.099.018-.075.07m6.672.505l-.072-.038-.074.034.017-.076-.058-.055.082-.009.039-.068.034.07.081.014-.06.052",
    fill: "#FFFFEF"
  }), React.createElement("path", {
    fill: "#FFFFEF",
    d: "M8.638 9.585l-.087-.051-.091.045.02-.101-.07-.074.1-.012.047-.09.043.093.099.018-.075.07"
  }), React.createElement("path", {
    d: "M8.638 9.585l-.087-.051-.091.045.02-.101-.07-.074.1-.012.047-.09.043.093.099.018-.075.07m1.41.101l-.087-.05-.091.045.02-.101-.07-.075.1-.011.048-.091.042.094.099.018-.074.07m-.16.566l-.088-.05-.09.044.02-.101-.07-.074.1-.012.047-.09.042.093.1.018-.075.07m2.913-.744l-.088-.05-.091.045.02-.101-.07-.075.1-.011.048-.091.042.094.1.018-.075.07m-.837.101l-.088-.05-.09.044.02-.1-.07-.075.1-.012.047-.09.042.093.1.018-.075.07m-2.293-.195l-.055-.031-.057.028.013-.063-.044-.047.063-.007.03-.057.026.059.062.011-.047.044m5.595 1.512l-.088-.05-.091.045.02-.101-.07-.075.1-.011.048-.091.042.094.1.018-.075.07m-.695.194l-.072-.042-.076.038.017-.084-.058-.062.083-.01.04-.075.034.078.082.015-.061.058m.346.076l-.068-.039-.07.035.015-.078-.054-.058.078-.009.036-.07.033.073.076.014-.057.054m.97-.76l-.065-.037-.068.034.015-.076-.052-.055.075-.008.035-.068.031.07.074.013-.055.052m-1.292 1.394l-.085-.047-.089.042.02-.093-.068-.068.098-.011.045-.083.041.086.097.016-.073.064m.019.475l-.078-.046-.08.041.018-.093-.063-.068.09-.01.041-.084.037.086.088.017-.066.064m-.63-.769l-.066-.038-.067.034.015-.075-.053-.055.075-.01.035-.067.032.07.073.013-.055.052m-.593.076l-.065-.038-.067.034.015-.075-.053-.055.075-.01.035-.067.032.07.073.013-.055.052m-1.014-.82l-.065-.037-.067.033.015-.075-.053-.055.075-.009.035-.067.032.07.073.013-.055.052m.125 1.9l-.056-.031-.057.028.013-.064-.044-.046.063-.008.03-.057.026.06.063.01-.047.044m-1.538-2.887l-.131-.076-.137.067.03-.151-.105-.111.151-.018.07-.136.064.14.149.028-.112.104",
    fill: "#FFFFEF"
  }), React.createElement("path", {
    d: "M16.142 9.525a4.2 4.2 0 0 0 .193-.66c-2.258-1.983-4.776-3-7.956-2.79a4.151 4.151 0 0 0-.283.695 10.176 10.176 0 0 1 8.046 2.755z",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M15.127 8.41l.08.044a.114.114 0 0 0-.01.075c.006.021.021.04.045.056.025.017.047.025.067.023a.057.057 0 0 0 .044-.025.042.042 0 0 0 .008-.028.077.077 0 0 0-.017-.036 1.187 1.187 0 0 0-.05-.06.257.257 0 0 1-.063-.097.122.122 0 0 1 .071-.146.126.126 0 0 1 .075-.007.232.232 0 0 1 .085.038c.048.033.077.069.087.106a.136.136 0 0 1-.018.112l-.08-.05a.08.08 0 0 0 .007-.057.1.1 0 0 0-.04-.047.107.107 0 0 0-.063-.022.034.034 0 0 0-.029.016.036.036 0 0 0-.004.031c.004.015.022.04.054.075a.45.45 0 0 1 .065.085.129.129 0 0 1-.01.14.137.137 0 0 1-.141.058.265.265 0 0 1-.094-.043.203.203 0 0 1-.09-.11.18.18 0 0 1 .02-.131zm-.383-.251l.083.04a.113.113 0 0 0-.008.076c.007.021.023.04.047.054.026.016.048.023.068.02a.057.057 0 0 0 .044-.026.042.042 0 0 0 .006-.03.076.076 0 0 0-.018-.034 1.153 1.153 0 0 0-.053-.057.256.256 0 0 1-.066-.096.122.122 0 0 1 .139-.158.233.233 0 0 1 .086.035c.05.03.08.065.092.102a.136.136 0 0 1-.014.112l-.082-.046a.083.083 0 0 0 .005-.057c-.006-.017-.02-.031-.042-.045a.107.107 0 0 0-.064-.02.034.034 0 0 0-.028.017.036.036 0 0 0-.003.031.248.248 0 0 0 .057.073c.034.033.056.06.069.082a.129.129 0 0 1-.004.14.139.139 0 0 1-.14.064.266.266 0 0 1-.095-.04.203.203 0 0 1-.093-.106.179.179 0 0 1 .014-.131zm-.473-.127l.242-.399.295.18-.041.068-.215-.131-.053.088.199.122-.04.067-.2-.122-.066.109.222.136-.041.067-.302-.185zm-.69-.567l.036-.07.18.094-.085.165a.312.312 0 0 1-.21-.027.256.256 0 0 1-.1-.086.197.197 0 0 1-.032-.116.287.287 0 0 1 .033-.123.268.268 0 0 1 .086-.101.205.205 0 0 1 .12-.037c.033 0 .07.01.109.03a.221.221 0 0 1 .103.096.164.164 0 0 1 .01.118l-.09-.027a.098.098 0 0 0-.009-.065.11.11 0 0 0-.05-.05.127.127 0 0 0-.106-.01.167.167 0 0 0-.085.087c-.025.05-.034.092-.024.128a.12.12 0 0 0 .067.081.162.162 0 0 0 .057.017c.022.003.04.002.059-.001l.027-.053-.096-.05zm-3.008-.746l.068-.462.139.02.037.328.129-.303.14.02-.068.463-.087-.012.054-.364-.145.35-.09-.013-.037-.378-.054.364-.086-.013zm-.47-.054l.043-.465.344.032-.008.079-.25-.024-.01.103.233.022-.007.079-.233-.022-.011.126.258.025-.007.078-.352-.033z",
    fill: "#309E3A",
    fillRule: "nonzero"
  }), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M8.546 6.374a.3.3 0 0 1 .025-.12.222.222 0 0 1 .045-.062.18.18 0 0 1 .061-.04.255.255 0 0 1 .101-.016.218.218 0 0 1 .163.068c.04.044.059.104.057.18a.245.245 0 0 1-.066.175.217.217 0 0 1-.166.06.219.219 0 0 1-.163-.068.243.243 0 0 1-.057-.177z",
    fill: "#309E3A"
  }), React.createElement("path", {
    d: "M8.643 6.373c-.001.053.01.093.034.121a.119.119 0 0 0 .091.044.118.118 0 0 0 .093-.038c.025-.027.038-.067.04-.121.001-.054-.01-.094-.032-.121a.118.118 0 0 0-.092-.042.12.12 0 0 0-.095.037c-.024.026-.037.066-.039.12z",
    fill: "#F7FFFF"
  })), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M9.098 6.615l.006-.467.197.002c.05 0 .086.005.108.014.023.009.04.024.054.045.013.022.02.046.02.074a.126.126 0 0 1-.032.087.148.148 0 0 1-.093.042c.02.012.037.025.05.04a.63.63 0 0 1 .053.076l.055.092-.112-.002-.067-.102a.644.644 0 0 0-.048-.07.07.07 0 0 0-.028-.019.152.152 0 0 0-.048-.006h-.019l-.002.195-.094-.001z",
    fill: "#309E3A"
  }), React.createElement("path", {
    d: "M9.196 6.346l.07.001a.356.356 0 0 0 .084-.005.05.05 0 0 0 .026-.02c.007-.008.01-.02.01-.034a.055.055 0 0 0-.012-.038.056.056 0 0 0-.035-.019.778.778 0 0 0-.069-.002l-.073-.001-.001.118z",
    fill: "#FFF"
  })), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M9.63 6.17l.171.01a.334.334 0 0 1 .088.013c.027.01.05.025.068.046a.204.204 0 0 1 .04.078c.01.03.013.068.01.111a.308.308 0 0 1-.019.099.206.206 0 0 1-.054.08.165.165 0 0 1-.068.034.284.284 0 0 1-.083.005l-.177-.009.024-.466z",
    fill: "#309E3A"
  }), React.createElement("path", {
    d: "M9.72 6.254l-.016.31.07.003c.027.001.046 0 .057-.002a.086.086 0 0 0 .039-.017.097.097 0 0 0 .027-.044.307.307 0 0 0 .014-.085.28.28 0 0 0-.005-.084.107.107 0 0 0-.025-.046.09.09 0 0 0-.042-.024.42.42 0 0 0-.077-.009l-.042-.002z",
    fill: "#FFF"
  })), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M11.917 7.005l.109-.454.147.035a.547.547 0 0 1 .107.033.122.122 0 0 1 .054.06.146.146 0 0 1 .005.095.152.152 0 0 1-.032.067.128.128 0 0 1-.05.036.135.135 0 0 1-.051.01.533.533 0 0 1-.097-.017l-.06-.014-.04.171-.092-.022z",
    fill: "#309E3A"
  }), React.createElement("path", {
    d: "M12.1 6.65l-.032.129.05.012a.258.258 0 0 0 .074.01.062.062 0 0 0 .053-.048.06.06 0 0 0-.005-.045.065.065 0 0 0-.032-.029.435.435 0 0 0-.065-.019l-.044-.01z",
    fill: "#FFF"
  })), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M12.35 7.135l.155-.441.186.066c.047.017.08.033.098.048a.11.11 0 0 1 .036.06.135.135 0 0 1-.005.077.125.125 0 0 1-.058.071.148.148 0 0 1-.1.01.215.215 0 0 1 .034.054.52.52 0 0 1 .025.09l.024.104-.106-.037-.03-.119a.65.65 0 0 0-.025-.08.071.071 0 0 0-.02-.029.15.15 0 0 0-.043-.02l-.018-.007-.064.184-.089-.031z",
    fill: "#309E3A"
  }), React.createElement("path", {
    d: "M12.528 6.912l.065.023c.043.015.07.023.082.023a.05.05 0 0 0 .031-.01.06.06 0 0 0 .02-.03.055.055 0 0 0 .001-.04.057.057 0 0 0-.027-.029.793.793 0 0 0-.064-.024l-.07-.025-.038.112z",
    fill: "#FFF"
  })), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M12.897 7.118a.298.298 0 0 1 .055-.108.22.22 0 0 1 .06-.048.183.183 0 0 1 .07-.023.254.254 0 0 1 .102.013c.066.02.112.057.138.11a.246.246 0 0 1 .006.189.245.245 0 0 1-.11.15.216.216 0 0 1-.176.012.22.22 0 0 1-.139-.11.243.243 0 0 1-.006-.185z",
    fill: "#309E3A"
  }), React.createElement("path", {
    d: "M12.99 7.144a.18.18 0 0 0 0 .126.12.12 0 0 0 .076.067.117.117 0 0 0 .1-.012c.031-.018.055-.054.07-.105.017-.051.017-.093.003-.125a.118.118 0 0 0-.078-.066.119.119 0 0 0-.1.01c-.031.019-.055.054-.07.105z",
    fill: "#FFF"
  })), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M13.806 7.769l.214-.415.176.09a.33.33 0 0 1 .09.062c.017.018.026.04.028.065a.135.135 0 0 1-.015.074.125.125 0 0 1-.068.064.147.147 0 0 1-.101-.005c.012.02.021.04.026.058a.53.53 0 0 1 .013.092l.01.108-.1-.052-.014-.122a.65.65 0 0 0-.013-.084.07.07 0 0 0-.016-.03.15.15 0 0 0-.04-.027l-.017-.008-.089.173-.083-.043z",
    fill: "#309E3A"
  }), React.createElement("path", {
    d: "M14.013 7.572l.062.032c.04.02.066.032.078.034a.05.05 0 0 0 .032-.005.06.06 0 0 0 .024-.027.056.056 0 0 0 .007-.04.057.057 0 0 0-.023-.032.79.79 0 0 0-.06-.033l-.066-.034-.054.105z",
    fill: "#FFF"
  })), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M15.533 8.621a.297.297 0 0 1 .085-.087.22.22 0 0 1 .071-.029.182.182 0 0 1 .074 0c.03.005.062.02.093.04a.22.22 0 0 1 .1.146.246.246 0 0 1-.048.182.245.245 0 0 1-.15.113.217.217 0 0 1-.17-.04.22.22 0 0 1-.102-.145.243.243 0 0 1 .047-.18z",
    fill: "#309E3A"
  }), React.createElement("path", {
    d: "M15.616 8.673c-.03.044-.042.084-.037.12a.12.12 0 0 0 .054.086.118.118 0 0 0 .098.019c.036-.01.068-.036.099-.081.03-.045.042-.084.037-.12a.119.119 0 0 0-.055-.084.119.119 0 0 0-.1-.02c-.034.009-.066.036-.096.08z",
    fill: "#FFF"
  })), React.createElement("path", {
    fill: "#309E3A",
    fillRule: "nonzero",
    d: "M11.39 6.815l.075-.328.243.056-.013.056-.176-.041-.017.073.164.037-.012.056-.164-.038-.02.09.182.041-.013.055-.249-.057z"
  })));
};

var SvgBrazil = function SvgBrazil(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$J,
    name: "brazil"
  }, props));
};

var SvgIcon$K = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 3.5h-4c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2h-4c-.3 0-.5.2-.5.5v10c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5V4c0-.3-.2-.5-.5-.5zm-9-1h3c.6 0 1 .4 1 1h-5c0-.6.4-1 1-1zM1 13.5v-9h1.5v9H1zm2.5 0v-9h9v9h-9zm11.5 0h-1.5v-9H15v9z"
  }));
};

var SvgBriefcase = function SvgBriefcase(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$K,
    name: "briefcase"
  }, props));
};

var SvgIcon$L = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 0H5v3H0v13h16V3h-5V0zM6 .9h4v2H6v-2z"
  }));
};

var SvgBriefcase$1 = function SvgBriefcase(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$L,
    name: "briefcase"
  }, props));
};

var SvgIcon$M = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 3.5h-4c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2h-4c-.3 0-.5.2-.5.5v10c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5V4c0-.3-.2-.5-.5-.5zm-9-1h3c.6 0 1 .4 1 1h-5c0-.6.4-1 1-1zM1 13.5v-9h1.5v9H1zm2.5 0v-9h9v9h-9zm11.5 0h-1.5v-9H15v9z"
  }));
};

var SvgBriefcaseNext = function SvgBriefcaseNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$M,
    name: "briefcase-next"
  }, props));
};

var SvgIcon$N = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16.1"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 11.8l-1.9 2.8c-.3.5-.9.7-1.5.4-.5-.3-.7-.9-.4-1.5l.1-.1 1.5-2.3.4.3-1.5 2.3c-.5.8.5 1.4 1 .6l1.9-2.8c1-1.5-.8-2.7-1.8-1.2l-1.8 2.8c-.5.7-.5 1.6.2 2.2s1.6.5 2.2-.2c.1-.1.1-.2.2-.3l1.4-2.2.4.3-1.4 2.1c-.5 1-1.8 1.4-2.8.8-1-.5-1.4-1.8-.8-2.8.1-.1.1-.2.2-.3l1.8-2.8c.4-.8 1.3-1.1 2.1-.7s1.1 1.3.7 2.1c0 .2-.1.3-.2.5zm-6.1-.1l1.8-2.8c.7-1.2 2-1.9 3.4-1.8.5 0 1 .2 1.4.4V3h-5V0H5v3H0v13h9.2c-.2-.4-.4-.8-.5-1.3-.1-1.1.1-2.1.7-3zM6 .9h4v2H6v-2z"
  }));
};

var SvgBriefcasePaperclip = function SvgBriefcasePaperclip(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$N,
    name: "briefcase-paperclip"
  }, props));
};

var SvgIcon$O = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 13H9v-1h7v1zm-4 3V9h1v7h-1zm-5-1v-5h3V7h5v3h1V3h-5V0H5v3H0v13h10v-1H7zM6 .9h4v2H6v-2z"
  }));
};

var SvgBriefcasePlus = function SvgBriefcasePlus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$O,
    name: "briefcase-plus"
  }, props));
};

var SvgIcon$P = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 557.03 126.25"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M165.16 53.86c4.7-3 6.6-9.16 6.6-14.53 0-14.9-8.58-20.36-22.52-20.36H131V94h23c13.63 0 24-6.55 24-21.29 0-8.27-4-17.25-12.84-18.85zm-19.51-23.18h1.9c6.17 0 10.55 2 10.55 9.65s-3.49 9.84-10.65 9.84h-1.8zm3.09 51.61h-3.09v-21H148c7.37 0 15.33.41 15.33 10.18s-6.73 10.82-14.59 10.82zM206 43.63c-15.23 0-25.65 10.85-25.65 26S190.66 95.55 206 95.55s25.65-10.84 25.65-25.91S221.2 43.63 206 43.63zm0 39.59c-7.17 0-11.55-7-11.55-13.58C194.43 62.9 198.81 56 206 56s11.55 6.93 11.55 13.67c-.02 6.51-4.4 13.55-11.55 13.55zm79.66-38h-8.56V28.68h-13.9v16.51h-11.38V28.68h-13.89v16.51h-4.77V56.9h4.77V94h13.89V56.9h11.38V94h13.88V56.9h8.56zM309 43.63c-15.22 0-25.64 10.85-25.64 26S293.71 95.55 309 95.55s25.65-10.84 25.65-25.91S324.26 43.63 309 43.63zm0 39.59c-7.17 0-11.55-7-11.55-13.58C297.48 62.9 301.86 56 309 56s11.56 6.93 11.56 13.67c.03 6.51-4.35 13.55-11.56 13.55zm84.55-39.58a17 17 0 00-14.27 7.68c-3.18-5.18-7.94-7.68-14-7.68a14.8 14.8 0 00-12 6h-.2v-4.45h-13.85V94h13.88V70c0-5.1-.39-15.21 7.4-15.21 7.29 0 6.7 9.72 6.7 14.48V94h13.88V70.09c0-5.06-.1-15.27 7.5-15.27 6.89 0 6.6 8.82 6.6 13.59V94h13.88V63.64c0-10.64-3.07-20-15.49-20zM417 94h13.9V9.65H417zm29.4-77.62a8.24 8.24 0 108.24 8.24 8.28 8.28 0 00-8.22-8.24zM439.53 94h13.88V45.19h-13.88zm49.3-50.36c-5 0-9.88 1.7-12.76 6.09h-.21v-4.54H462V94h13.88V69.84c0-5.8.1-15 8.38-15 7.88 0 7.58 7.53 7.58 13.39V94h13.86V64.24c0-11.32-3.76-20.6-16.87-20.6zM557 70.11c0-14.67-7.16-26.48-23.18-26.48-15.82 0-23.63 11.62-23.63 26.37s9.24 25.53 24.36 25.53c10.25 0 18.8-5.48 22.18-15.21l-12.83-2.07c-1.89 3.86-4.77 6.64-9.35 6.64-7.27 0-9.65-6.94-9.65-13.08H557zm-31.73-7c.69-5 3.78-9.75 9.35-9.75 5.37 0 8.55 4.82 9.25 9.75zM94.92 30.09c-.23-8.2-7.43-11.31-7.43-11.31-10.86-5.47-23.16-1.39-27.27.28 0 0 .5 1.63-.09-6.85s-8.74-11-8.74-11a31.86 31.86 0 00-22.46 1.84c-.78.32-22.37 13.75-26.07 16.06a4.48 4.48 0 00-2.41 3.68v18.29c0 2 1 2.47 1.19 2.59C5.78 46.09 48.33 70.61 59.88 77c1.75 1 2.16 1.25 2.95 1.23s1.41-.5 3-1.42c5.18-2.93 6-3.21 14.78-8.65s14.26-10 14.26-14.08c.02-5.61.13-22.27.05-23.99zM28.37 24.6a26.34 26.34 0 0123.05-1.42l-23 13.47-10.11-5.82zM80 45.65L61.89 56l-14.48-8.38 10.76-6.35S73 31.7 88.42 39.72A39.9 39.9 0 0180 45.65z"
  }), React.createElement("path", {
    d: "M3.9 52.63c-.86-.5-1.27-.69-2.1-1.14a1.2 1.2 0 00-1.8.83V71a3.49 3.49 0 001.59 2.7s41.55 23.59 41.57 23.9-10 5.82-10 5.82a3.43 3.43 0 00-1.57 2.7v19c0 1 .7 1.41 1.56.91l28.1-16.25a15.72 15.72 0 011.62-.88 18.33 18.33 0 011.57-1l29.39-17a3.48 3.48 0 001.56-2.72V69.56c0-1-.7-1.4-1.57-.91l-29.65 17a3.51 3.51 0 01-3.14 0z"
  }));
};

var SvgBtLogo = function SvgBtLogo(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$P,
    name: "bt-logo"
  }, props));
};

var SvgIcon$Q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 557.03 126.25"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M165.16 53.86c4.7-3 6.6-9.16 6.6-14.53 0-14.9-8.58-20.36-22.52-20.36H131V94h23c13.63 0 24-6.55 24-21.29 0-8.27-4-17.25-12.84-18.85zm-19.51-23.18h1.9c6.17 0 10.55 2 10.55 9.65s-3.49 9.84-10.65 9.84h-1.8zm3.09 51.61h-3.09v-21H148c7.37 0 15.33.41 15.33 10.18s-6.73 10.82-14.59 10.82zM206 43.63c-15.23 0-25.65 10.85-25.65 26S190.66 95.55 206 95.55s25.65-10.84 25.65-25.91S221.2 43.63 206 43.63zm0 39.59c-7.17 0-11.55-7-11.55-13.58C194.43 62.9 198.81 56 206 56s11.55 6.93 11.55 13.67c-.02 6.51-4.4 13.55-11.55 13.55zm79.66-38h-8.56V28.68h-13.9v16.51h-11.38V28.68h-13.89v16.51h-4.77V56.9h4.77V94h13.89V56.9h11.38V94h13.88V56.9h8.56zM309 43.63c-15.22 0-25.64 10.85-25.64 26S293.71 95.55 309 95.55s25.65-10.84 25.65-25.91S324.26 43.63 309 43.63zm0 39.59c-7.17 0-11.55-7-11.55-13.58C297.48 62.9 301.86 56 309 56s11.56 6.93 11.56 13.67c.03 6.51-4.35 13.55-11.56 13.55zm84.55-39.58a17 17 0 00-14.27 7.68c-3.18-5.18-7.94-7.68-14-7.68a14.8 14.8 0 00-12 6h-.2v-4.45h-13.85V94h13.88V70c0-5.1-.39-15.21 7.4-15.21 7.29 0 6.7 9.72 6.7 14.48V94h13.88V70.09c0-5.06-.1-15.27 7.5-15.27 6.89 0 6.6 8.82 6.6 13.59V94h13.88V63.64c0-10.64-3.07-20-15.49-20zM417 94h13.9V9.65H417zm29.4-77.62a8.24 8.24 0 108.24 8.24 8.28 8.28 0 00-8.22-8.24zM439.53 94h13.88V45.19h-13.88zm49.3-50.36c-5 0-9.88 1.7-12.76 6.09h-.21v-4.54H462V94h13.88V69.84c0-5.8.1-15 8.38-15 7.88 0 7.58 7.53 7.58 13.39V94h13.86V64.24c0-11.32-3.76-20.6-16.87-20.6zM557 70.11c0-14.67-7.16-26.48-23.18-26.48-15.82 0-23.63 11.62-23.63 26.37s9.24 25.53 24.36 25.53c10.25 0 18.8-5.48 22.18-15.21l-12.83-2.07c-1.89 3.86-4.77 6.64-9.35 6.64-7.27 0-9.65-6.94-9.65-13.08H557zm-31.73-7c.69-5 3.78-9.75 9.35-9.75 5.37 0 8.55 4.82 9.25 9.75zM94.92 30.09c-.23-8.2-7.43-11.31-7.43-11.31-10.86-5.47-23.16-1.39-27.27.28 0 0 .5 1.63-.09-6.85s-8.74-11-8.74-11a31.86 31.86 0 00-22.46 1.84c-.78.32-22.37 13.75-26.07 16.06a4.48 4.48 0 00-2.41 3.68v18.29c0 2 1 2.47 1.19 2.59C5.78 46.09 48.33 70.61 59.88 77c1.75 1 2.16 1.25 2.95 1.23s1.41-.5 3-1.42c5.18-2.93 6-3.21 14.78-8.65s14.26-10 14.26-14.08c.02-5.61.13-22.27.05-23.99zM28.37 24.6a26.34 26.34 0 0123.05-1.42l-23 13.47-10.11-5.82zM80 45.65L61.89 56l-14.48-8.38 10.76-6.35S73 31.7 88.42 39.72A39.9 39.9 0 0180 45.65z"
  }), React.createElement("path", {
    d: "M3.9 52.63c-.86-.5-1.27-.69-2.1-1.14a1.2 1.2 0 00-1.8.83V71a3.49 3.49 0 001.59 2.7s41.55 23.59 41.57 23.9-10 5.82-10 5.82a3.43 3.43 0 00-1.57 2.7v19c0 1 .7 1.41 1.56.91l28.1-16.25a15.72 15.72 0 011.62-.88 18.33 18.33 0 011.57-1l29.39-17a3.48 3.48 0 001.56-2.72V69.56c0-1-.7-1.4-1.57-.91l-29.65 17a3.51 3.51 0 01-3.14 0z"
  }));
};

var SvgBtLogo$1 = function SvgBtLogo(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$Q,
    name: "bt-logo"
  }, props));
};

var SvgIcon$R = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.4 5.3L8.7.4c-.4-.3-1-.3-1.4 0L.6 5.3c-.3.2-.4.5-.3.8.1.3.4.4.7.4h.5V13c-.6 0-1 .4-1 1v1.1c0 .5.5 1 1 1h13c.5 0 1-.4 1-.9V14c0-.6-.4-1-1-1V6.5h.5c.3.1.7-.2.7-.5.1-.3-.1-.6-.3-.7zM7.9 1.2h.2L14 5.5H2l5.9-4.3zM10.5 13h-2V6.5h2V13zm-5 0V6.5h2V13h-2zm-3-6.5h2V13h-2V6.5zm12 8.5l-13 .1V14h13v1zm-1-2h-2V6.5h2V13z"
  }));
};

var SvgBuilding = function SvgBuilding(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$R,
    name: "building"
  }, props));
};

var SvgIcon$S = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18.2 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.5 7h-1v7h1V7zm8 3.3h1V7h-1v3.3zm4-3.3h-1v3.2h1V7zm-9 0h-1v7h1V7zm3 4V7h-1v4h1zM8 0L2 4h12L8 0zM5.5 14H0v2h8.5v-2h-3zM16 5H0v1h16V5zm-7 7.4l.8-.7 2.6 2.8 5-5.1.7.8-5.7 5.7L9 12.4z"
  }));
};

var SvgBuildingCheckmark = function SvgBuildingCheckmark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$S,
    name: "building-checkmark"
  }, props));
};

var SvgIcon$T = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 16H0v-2h16v2zm0-11H0v1h16V5zm-2-1L8 0 2 4m.5 3h-1v7h1V7zm3 0h-1v7h1V7zm6 0h-1v7h1V7zm3 0h-1v7h1V7zm-6 0h-1v7h1V7z"
  }));
};

var SvgBuilding$1 = function SvgBuilding(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$T,
    name: "building"
  }, props));
};

var SvgIcon$U = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.4 5.3L8.7.4c-.4-.3-1-.3-1.4 0L.6 5.3c-.3.2-.4.5-.3.8.1.3.4.4.7.4h.5V13c-.6 0-1 .4-1 1v1.1c0 .5.5 1 1 1h13c.5 0 1-.4 1-.9V14c0-.6-.4-1-1-1V6.5h.5c.3.1.7-.2.7-.5.1-.3-.1-.6-.3-.7zM7.9 1.2h.2L14 5.5H2l5.9-4.3zM10.5 13h-2V6.5h2V13zm-5 0V6.5h2V13h-2zm-3-6.5h2V13h-2V6.5zm12 8.5l-13 .1V14h13v1zm-1-2h-2V6.5h2V13z"
  }));
};

var SvgBuildingNext = function SvgBuildingNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$U,
    name: "building-next"
  }, props));
};

var SvgIcon$V = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 13H9v-1h7v1zm-4 3V9h1v7h-1zM2.5 7h-1v7h1V7zm8 1h1V7h-1v1zm4-1h-1v1h1V7zm-9 0h-1v7h1V7zm3 4V7h-1v4h1zM8 0L2 4h12L8 0zM5.5 14H0v2h8.5v-2h-3zM16 5H0v1h16V5z"
  }));
};

var SvgBuildingPlus = function SvgBuildingPlus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$V,
    name: "building-plus"
  }, props));
};

var SvgIcon$W = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5 4H3c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5zm-.5 2h-1V5h1v1zM5 8H3c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5zm-.5 2h-1V9h1v1zm11-10h-4c-.3 0-.5.2-.5.5V6H8v-.5c0-.4-.2-.9-.4-1.2L4.7.6C4.4.2 3.8.1 3.5.4c-.1 0-.1.1-.2.2L.4 4.3c-.2.3-.4.8-.4 1.2V15c0 .6.4 1 1 1h15V.5c0-.3-.2-.5-.5-.5zM11 7v2H8V7h3zm0 3v2H8v-2h3zm-7.5 5v-2h1v2h-1zm2 0v-2.5c0-.3-.2-.5-.5-.5H3c-.3 0-.5.2-.5.5V15H1V5.5c0-.2.1-.4.2-.6L4 1.3l2.8 3.6c.1.2.2.4.2.6V15H5.5zM8 13h3v2H8v-2zm7 2h-3v-2h3v2zm0-3h-3v-2h3v2zm0-3h-3V7h3v2zm0-3h-3V4h3v2zm-3-3V1h3v2h-3z"
  }));
};

var SvgBuildings = function SvgBuildings(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$W,
    name: "buildings"
  }, props));
};

var SvgIcon$X = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 5v11h6V5h-6zm2.5 9h-1v-1h1v1zm0-2h-1v-1h1v1zm0-2h-1V9h1v1zm0-2h-1V7h1v1zm2 6h-1v-1h1v1zm0-2h-1v-1h1v1zm0-2h-1V9h1v1zm0-2h-1V7h1v1zM8 7H7V4L6 2H5V0H4v2H3L2 4v3H1L0 8v8h9V8L8 7zM5 4h1v1H5V4zM3 4h1v1H3V4zm0 10H2v-1h1v1zm0-2H2v-1h1v1zm0-2H2V9h1v1zm0-4h1v1H3V6zm2 8H4v-1h1v1zm0-2H4v-1h1v1zm0-2H4V9h1v1zm0-4h1v1H5V6zm2 8H6v-1h1v1zm0-2H6v-1h1v1zm0-2H6V9h1v1z"
  }));
};

var SvgBuildings$1 = function SvgBuildings(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$X,
    name: "buildings"
  }, props));
};

var SvgIcon$Y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5 4H3c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5zm-.5 2h-1V5h1v1zM5 8H3c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5zm-.5 2h-1V9h1v1zm11-10h-4c-.3 0-.5.2-.5.5V6H8v-.5c0-.4-.2-.9-.4-1.2L4.7.6C4.4.2 3.8.1 3.5.4c-.1 0-.1.1-.2.2L.4 4.3c-.2.3-.4.8-.4 1.2V15c0 .6.4 1 1 1h15V.5c0-.3-.2-.5-.5-.5zM11 7v2H8V7h3zm0 3v2H8v-2h3zm-7.5 5v-2h1v2h-1zm2 0v-2.5c0-.3-.2-.5-.5-.5H3c-.3 0-.5.2-.5.5V15H1V5.5c0-.2.1-.4.2-.6L4 1.3l2.8 3.6c.1.2.2.4.2.6V15H5.5zM8 13h3v2H8v-2zm7 2h-3v-2h3v2zm0-3h-3v-2h3v2zm0-3h-3V7h3v2zm0-3h-3V4h3v2zm-3-3V1h3v2h-3z"
  }));
};

var SvgBuildingsNext = function SvgBuildingsNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$Y,
    name: "buildings-next"
  }, props));
};

var SvgIcon$Z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 7.2h3v-3H2v3zm1-2h1v1H3v-1zm10.5-3.7V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.5h-4V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.5h-4V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.5H0v13h16v-13h-2.5zm1.5 12H1v-11h1.5V3c0 .3.2.5.5.5s.5-.2.5-.5v-.5h4V3c0 .3.2.5.5.5s.5-.2.5-.5v-.5h4V3c0 .3.2.5.5.5s.5-.2.5-.5v-.5H15v11zM2 11.8h3v-3H2v3zm1-2h1v1H3v-1zm8-2.6h3v-3h-3v3zm1-2h1v1h-1v-1zm-5.5 2h3v-3h-3v3zm1-2h1v1h-1v-1zm-1 6.6h3v-3h-3v3zm1-2h1v1h-1v-1zm3.5 2h3v-3h-3v3zm1-2h1v1h-1v-1z"
  }));
};

var SvgCalendar = function SvgCalendar(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$Z,
    name: "calendar"
  }, props));
};

var SvgIcon$_ = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.9 7.9h-2v-2h2v2zm0 4.9h-2v-2h2v2zm-4-4.9h-2v-2h2v2zm-4 3h-2v2h2v-2zm4 0h-2v2h2v-2zm5-9.1V0h-3v1.8h-6V0h-3v1.8H0v13.9h15.7V1.8h-1.8zm-2-1h1v2h-1v-2zm-9 .1h1v2h-1v-2zm12 14H.9v-11h14v11z"
  }));
};

var SvgCalendar$1 = function SvgCalendar(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$_,
    name: "calendar"
  }, props));
};

var SvgIcon$10 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 7.2h3v-3H2v3zm1-2h1v1H3v-1zm10.5-3.7V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.5h-4V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.5h-4V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.5H0v13h16v-13h-2.5zm1.5 12H1v-11h1.5V3c0 .3.2.5.5.5s.5-.2.5-.5v-.5h4V3c0 .3.2.5.5.5s.5-.2.5-.5v-.5h4V3c0 .3.2.5.5.5s.5-.2.5-.5v-.5H15v11zM2 11.8h3v-3H2v3zm1-2h1v1H3v-1zm8-2.6h3v-3h-3v3zm1-2h1v1h-1v-1zm-5.5 2h3v-3h-3v3zm1-2h1v1h-1v-1zm-1 6.6h3v-3h-3v3zm1-2h1v1h-1v-1zm3.5 2h3v-3h-3v3zm1-2h1v1h-1v-1z"
  }));
};

var SvgCalendarNext = function SvgCalendarNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$10,
    name: "calendar-next"
  }, props));
};

var SvgIcon$11 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
  }));
};

var SvgCamera = function SvgCamera(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$11,
    name: "camera"
  }, props));
};

var SvgIcon$12 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
  }));
};

var SvgCamera$1 = function SvgCamera(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$12,
    name: "camera"
  }, props));
};

var SvgIcon$13 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M6 0h12v16H6z"
  }), React.createElement("path", {
    fill: "#BF0A30",
    d: "M0 0h6v16H0zm18 0h6v16h-6zM8.173 7.732l-.44.15L9.78 9.678c.155.46-.054.597-.187.839l2.22-.282-.057 2.235.46-.013-.1-2.217 2.223.264c-.138-.29-.26-.445-.133-.91l2.044-1.7-.358-.13c-.292-.225.127-1.087.19-1.63 0 0-1.194.41-1.272.195l-.304-.584-1.086 1.193c-.118.029-.169-.018-.197-.119l.502-2.492-.795.446c-.066.029-.133.004-.176-.073l-.764-1.533-.788 1.592c-.06.057-.119.064-.168.025l-.757-.425.454 2.474c-.036.098-.122.125-.224.072L9.468 5.726c-.136.218-.228.573-.407.653-.18.074-.781-.151-1.184-.239.138.497.568 1.322.296 1.592z"
  })));
};

var SvgCanada = function SvgCanada(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$13,
    name: "canada"
  }, props));
};

var SvgIcon$14 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 4.6c-.2-.2-.5-.2-.7 0l-6 6-6-6c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l6 6c.4.4 1 .4 1.4 0l6-6c.2-.2.2-.5 0-.7z"
  }));
};

var SvgCaretDown = function SvgCaretDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$14,
    name: "caret-down"
  }, props));
};

var SvgIcon$15 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.6 9.2"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.8 6.4L14.1 0l1.4 1.4-7.7 7.8L0 1.4 1.4 0l6.4 6.4z"
  }));
};

var SvgCaretDown$1 = function SvgCaretDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$15,
    name: "caret-down"
  }, props));
};

var SvgIcon$16 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 4.6c-.2-.2-.5-.2-.7 0l-6 6-6-6c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l6 6c.4.4 1 .4 1.4 0l6-6c.2-.2.2-.5 0-.7z"
  }));
};

var SvgCaretDownNext = function SvgCaretDownNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$16,
    name: "caret-down-next"
  }, props));
};

var SvgIcon$17 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.3 7.3l-6-6c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l6 6-6 6c-.2.2-.2.5 0 .7.1.1.2.1.3.1.1 0 .3 0 .4-.1l6-6c.4-.4.4-1 0-1.4z"
  }));
};

var SvgCaretLeft = function SvgCaretLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$17,
    name: "caret-left"
  }, props));
};

var SvgIcon$18 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 9.2 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.8 7.8l6.4 6.4-1.4 1.4L0 7.8 7.8 0l1.4 1.4-6.4 6.4z"
  }));
};

var SvgCaretLeft$1 = function SvgCaretLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$18,
    name: "caret-left"
  }, props));
};

var SvgIcon$19 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.3 7.3l-6-6c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l6 6-6 6c-.2.2-.2.5 0 .7.1.1.2.1.3.1.1 0 .3 0 .4-.1l6-6c.4-.4.4-1 0-1.4z"
  }));
};

var SvgCaretLeftNext = function SvgCaretLeftNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$19,
    name: "caret-left-next"
  }, props));
};

var SvgIcon$1a = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 11.2 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 16H0V0h2v16zm2.8-8l6.4 6.4-1.4 1.4L2 8 9.8.2l1.4 1.4L4.8 8z"
  }));
};

var SvgCaretLineLeft = function SvgCaretLineLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1a,
    name: "caret-line-left"
  }, props));
};

var SvgIcon$1b = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 11.2 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M9.2 0h2v16h-2V0zM0 1.6L1.4.2 9.2 8l-7.8 7.8L0 14.4 6.4 8 0 1.6z"
  }));
};

var SvgCaretLineRight = function SvgCaretLineRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1b,
    name: "caret-line-right"
  }, props));
};

var SvgIcon$1c = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.4 8l6-6c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.1.1.2.1.4.1.1 0 .3 0 .4-.1.2-.2.2-.5 0-.7L5.4 8z"
  }));
};

var SvgCaretRight = function SvgCaretRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1c,
    name: "caret-right"
  }, props));
};

var SvgIcon$1d = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 9.2 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.4 7.8L0 1.4 1.4 0l7.8 7.8-7.8 7.8L0 14.1l6.4-6.3z"
  }));
};

var SvgCaretRight$1 = function SvgCaretRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1d,
    name: "caret-right"
  }, props));
};

var SvgIcon$1e = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.4 8l6-6c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.1.1.2.1.4.1.1 0 .3 0 .4-.1.2-.2.2-.5 0-.7L5.4 8z"
  }));
};

var SvgCaretRightNext = function SvgCaretRightNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1e,
    name: "caret-right-next"
  }, props));
};

var SvgIcon$1f = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 10.7l-6-6c-.4-.4-1-.4-1.4 0l-6 6c-.2.2-.2.5 0 .7s.5.2.7 0l6-6 6 6c.2.2.5.2.7 0 .2-.2.2-.5 0-.7z"
  }));
};

var SvgCaretUp = function SvgCaretUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1f,
    name: "caret-up"
  }, props));
};

var SvgIcon$1g = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.6 9.2"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.8 2.8L1.4 9.2 0 7.8 7.8 0l7.8 7.8-1.4 1.4-6.4-6.4z"
  }));
};

var SvgCaretUp$1 = function SvgCaretUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1g,
    name: "caret-up"
  }, props));
};

var SvgIcon$1h = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.7 10.7l-6-6c-.4-.4-1-.4-1.4 0l-6 6c-.2.2-.2.5 0 .7s.5.2.7 0l6-6 6 6c.2.2.5.2.7 0 .2-.2.2-.5 0-.7z"
  }));
};

var SvgCaretUpNext = function SvgCaretUpNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1h,
    name: "caret-up-next"
  }, props));
};

var SvgIcon$1i = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.4 14.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 14.9L3.5 9 5 8h4v1H6v2h5l3.5-2 .8.6-3.8 2.4H5.1l-1.6 2.9H0zM6.3 3.5l-.5-.9 2.7-1.4.5.9-2.7 1.4zm7.3 2.7l.3-.9-2.8-.9-.3.9 2.8.9zM15 1V0h-3v1h3z"
  }));
};

var SvgCashInHand = function SvgCashInHand(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1i,
    name: "cash-in-hand"
  }, props));
};

var SvgIcon$1j = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13 14h2c.3 0 .5-.2.5-.5V.5c0-.3-.2-.5-.5-.5h-2c-.3 0-.5.2-.5.5v13c0 .3.2.5.5.5zm.5-13h1v12h-1V1zM8 14h2c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5H8c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5zm.5-8h1v7h-1V6zM3 14h2c.3 0 .5-.2.5-.5v-4c0-.3-.2-.5-.5-.5H3c-.3 0-.5.2-.5.5v4c0 .3.2.5.5.5zm.5-4h1v3h-1v-3zm12 5H1V.5C1 .2.8 0 .5 0S0 .2 0 .5V16h15.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgChartBar = function SvgChartBar(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1j,
    name: "chart-bar"
  }, props));
};

var SvgIcon$1k = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 16H0V0h.9v15H16v1zM2.9 7.1v6.6h2V7.1h-2zm5 6.6h2V4.6h-2v9.1zm7-13.6h-2v13.6h2V.1z"
  }));
};

var SvgChartBar$1 = function SvgChartBar(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1k,
    name: "chart-bar"
  }, props));
};

var SvgIcon$1l = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13 14h2c.3 0 .5-.2.5-.5V.5c0-.3-.2-.5-.5-.5h-2c-.3 0-.5.2-.5.5v13c0 .3.2.5.5.5zm.5-13h1v12h-1V1zM8 14h2c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5H8c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5zm.5-8h1v7h-1V6zM3 14h2c.3 0 .5-.2.5-.5v-4c0-.3-.2-.5-.5-.5H3c-.3 0-.5.2-.5.5v4c0 .3.2.5.5.5zm.5-4h1v3h-1v-3zm12 5H1V.5C1 .2.8 0 .5 0S0 .2 0 .5V16h15.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgChartBarNext = function SvgChartBarNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1l,
    name: "chart-bar-next"
  }, props));
};

var SvgIcon$1m = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 11c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3zm3-2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm2.5 6H1V.5C1 .2.8 0 .5 0S0 .2 0 .5V16h15.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM9 7c1.9 0 3.5-1.6 3.5-3.5S10.9 0 9 0 5.5 1.6 5.5 3.5 7.1 7 9 7zm0-6c1.4 0 2.5 1.1 2.5 2.5S10.4 6 9 6 6.5 4.9 6.5 3.5 7.6 1 9 1zM4 14c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0-3c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"
  }));
};

var SvgChartCircles = function SvgChartCircles(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1m,
    name: "chart-circles"
  }, props));
};

var SvgIcon$1n = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 16H0V0h1v15h15v1zM4.7 8.7c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2 2.2-1 2.2-2.2c.1-1.2-.9-2.2-2-2.2h-.2zm7.4.6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-1.9-2-2zM10 1.8c-1.7 0-3.1 1.4-3.1 3.1 0 1.7 1.3 3.1 3 3.1h.1c1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.3-3.1-3.1-3.1z"
  }));
};

var SvgChartCircles$1 = function SvgChartCircles(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1n,
    name: "chart-circles"
  }, props));
};

var SvgIcon$1o = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 11c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3zm3-2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm2.5 6H1V.5C1 .2.8 0 .5 0S0 .2 0 .5V16h15.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM9 7c1.9 0 3.5-1.6 3.5-3.5S10.9 0 9 0 5.5 1.6 5.5 3.5 7.1 7 9 7zm0-6c1.4 0 2.5 1.1 2.5 2.5S10.4 6 9 6 6.5 4.9 6.5 3.5 7.6 1 9 1zM4 14c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0-3c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"
  }));
};

var SvgChartCirclesNext = function SvgChartCirclesNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1o,
    name: "chart-circles-next"
  }, props));
};

var SvgIcon$1p = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.7 1.5C9.1-1.1 4.1-.3 1.5 3.3s-1.8 8.6 1.8 11.2c1.4 1 3 1.5 4.7 1.5 4.4 0 8-3.6 8-8 0-2.6-1.2-5-3.3-6.5zm2.1 8.2l-2.6-.8-.3-.1c.1-.3.1-.5.1-.8 0-1.1-.5-2.2-1.3-2.9l1.8-2.4c2 1.7 2.9 4.4 2.3 7zM8.5 1c1.1.1 2.2.4 3.2 1L9.9 4.5c-.4-.2-.9-.4-1.4-.4V1zM11 8c0 1.7-1.3 3-3 3S5 9.7 5 8s1.3-3 3-3 3 1.3 3 3zm3.5 2.6C13 14.2 9 15.9 5.4 14.4S.1 8.9 1.5 5.3c1-2.5 3.3-4.1 6-4.3v3C5.3 4.3 3.8 6.3 4 8.5c.3 2.2 2.3 3.7 4.5 3.5 1.3-.2 2.5-1 3.1-2.2l2.9.8z"
  }));
};

var SvgChartDonut = function SvgChartDonut(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1p,
    name: "chart-donut"
  }, props));
};

var SvgIcon$1q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.3 3.6c-2.8 0-5 2.2-5 5s2.2 5 5 5c1.4 0 2.7-.6 3.6-1.5l1.7 1.6c-2.8 2.9-7.5 3-10.4.2S-.8 6.5 2 3.6c1.4-1.4 3.3-2.3 5.3-2.3v2.3zm4.6 7.4c.9-1 1.2-2.5.8-3.8-.2-1.1-.8-2.2-1.7-3l1.9-2.5c1.5 1.4 2.6 3.2 3 5.2.3 2.1-.2 4.3-1.3 6.1l-2.7-2zm-1.6-7.2c-.5-.4-1.1-.6-1.8-.6L8.7 0c.6.1 1.1.2 1.7.4.5.2 1 .4 1.4.7l-1.5 2.7z"
  }));
};

var SvgChartDonut$1 = function SvgChartDonut(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1q,
    name: "chart-donut"
  }, props));
};

var SvgIcon$1r = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.7 1.5C9.1-1.1 4.1-.3 1.5 3.3s-1.8 8.6 1.8 11.2c1.4 1 3 1.5 4.7 1.5 4.4 0 8-3.6 8-8 0-2.6-1.2-5-3.3-6.5zm2.1 8.2l-2.6-.8-.3-.1c.1-.3.1-.5.1-.8 0-1.1-.5-2.2-1.3-2.9l1.8-2.4c2 1.7 2.9 4.4 2.3 7zM8.5 1c1.1.1 2.2.4 3.2 1L9.9 4.5c-.4-.2-.9-.4-1.4-.4V1zM11 8c0 1.7-1.3 3-3 3S5 9.7 5 8s1.3-3 3-3 3 1.3 3 3zm3.5 2.6C13 14.2 9 15.9 5.4 14.4S.1 8.9 1.5 5.3c1-2.5 3.3-4.1 6-4.3v3C5.3 4.3 3.8 6.3 4 8.5c.3 2.2 2.3 3.7 4.5 3.5 1.3-.2 2.5-1 3.1-2.2l2.9.8z"
  }));
};

var SvgChartDonutNext = function SvgChartDonutNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1r,
    name: "chart-donut-next"
  }, props));
};

var SvgIcon$1s = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.8 13.5H3c.2 0 .4-.1.5-.3l2.4-5.5 3.9 1.8c.2.1.5 0 .6-.2L13.8 3l.1 1.6c0 .3.2.5.5.5s.5-.2.5-.5L14.7 2c0-.3-.2-.5-.4-.7-.3-.1-.5-.1-.8 0l-2.4 1.1c-.2.1-.3.4-.2.7.1.2.4.3.7.2l1.2-.6-3 5.6-4-1.8c-.1-.1-.3-.1-.4 0s-.2.2-.2.3l-2.6 6c-.2.3 0 .5.2.7zM15.5 15H1V.5C1 .2.8 0 .5 0S0 .2 0 .5V16h15.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgChartLine = function SvgChartLine(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1s,
    name: "chart-line"
  }, props));
};

var SvgIcon$1t = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 16H0V0h1v15h15v1zM13.9 5.5L11 6l1 1-3.7 3.7-2.2-2.3-3.5 3.5.7.7 2.8-2.8 2.1 2.1 4.3-4.3.9.9.5-3z"
  }));
};

var SvgChartLine$1 = function SvgChartLine(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1t,
    name: "chart-line"
  }, props));
};

var SvgIcon$1u = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.8 13.5H3c.2 0 .4-.1.5-.3l2.4-5.5 3.9 1.8c.2.1.5 0 .6-.2L13.8 3l.1 1.6c0 .3.2.5.5.5s.5-.2.5-.5L14.7 2c0-.3-.2-.5-.4-.7-.3-.1-.5-.1-.8 0l-2.4 1.1c-.2.1-.3.4-.2.7.1.2.4.3.7.2l1.2-.6-3 5.6-4-1.8c-.1-.1-.3-.1-.4 0s-.2.2-.2.3l-2.6 6c-.2.3 0 .5.2.7zM15.5 15H1V.5C1 .2.8 0 .5 0S0 .2 0 .5V16h15.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgChartLineNext = function SvgChartLineNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1u,
    name: "chart-line-next"
  }, props));
};

var SvgIcon$1v = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 7.8c0-.3 0-.6-.1-.9 0-.1 0-.2-.1-.3-.1-.3-.1-.7-.2-1l-.1-.2c-.1-.3-.2-.6-.3-.8l-.1-.2c-.2-.3-.3-.6-.5-.9-.1-.1-.1-.2-.2-.2-.2-.3-.4-.5-.7-.8 0 0 0-.1-.1-.1-.3-.3-.6-.5-.9-.8l-.1-.1C9.1-1.1 4.1-.3 1.5 3.3s-1.8 8.6 1.8 11.2c1.4 1 3 1.5 4.7 1.5.4 0 .8 0 1.1-.1h.2c.4-.1.7-.1 1.1-.3l.2-.1c.3-.1.6-.2.9-.4l.2-.1c.3-.2.6-.3.9-.5l.3-.2c.2-.2.5-.4.7-.6l.2-.2c.2-.2.4-.5.6-.8l.2-.2.6-.9c0-.1 0-.1.1-.1.2-.3.3-.7.4-1.1.1-.4.2-.7.3-1.1v-.2c-.1-.3 0-.7 0-1.1v-.2zM8.5 1c1.1.1 2.2.4 3.2 1L8.5 6.5V1zm6 9.6c-.1.3-.3.5-.4.8 0 .1-.1.2-.1.3-.1.2-.2.4-.4.5l-.3.3c-.1.2-.3.3-.4.5l-.3.3c-.1.1-.3.2-.4.4-.1.1-.2.2-.4.3l-.6.3-.3.1c-.2.1-.5.2-.8.3H10c-.3.1-.5.1-.8.2H9c-.3 0-.7.1-1 .1-3.9 0-7-3.1-7-7v-.9c0-.2 0-.3.1-.4l.1-.3c0-.1.1-.3.1-.4s.1-.2.1-.3.1-.2.1-.3l.1-.3.1-.3.3-.3.2-.3.2-.3.2-.3c.1-.1.1-.2.2-.2s.1-.2.2-.3l.2-.2.2-.2.2-.2.4-.2c.1-.1.2-.1.3-.2l.3-.2.3-.1c0-.1.1-.1.3-.2l.3-.1.3-.1.3-.1.3-.1.3-.1h.7v7.1l.1.1v.1l.2.2 6.8 2zm.5-2v.1c0 .3-.1.6-.1.9v.1l-2.6-.8-3.4-1.2 3.7-5.1.1.1.4.4.2.3c.1.2.3.3.4.5l.3.4c.1.2.2.3.3.5l.1.3c.1.2.2.3.2.5l.1.3c.1.3.1.5.2.8 0 .1 0 .2.1.3v1.6z"
  }));
};

var SvgChartPie = function SvgChartPie(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1v,
    name: "chart-pie"
  }, props));
};

var SvgIcon$1w = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.1 14.1C11.7 15.3 9.9 16 8 16c-4.4 0-8-3.6-8-8C0 3.9 3.2.4 7.3 0v8.3l5.8 5.8zM13.3 2C12 .8 10.4.1 8.7 0v6.6L13.3 2zm.9.9L9.1 8.1l5.1 5C15.4 11.7 16 9.9 16 8c0-1.9-.6-3.6-1.8-5.1z"
  }));
};

var SvgChartPie$1 = function SvgChartPie(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1w,
    name: "chart-pie"
  }, props));
};

var SvgIcon$1x = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 7.8c0-.3 0-.6-.1-.9 0-.1 0-.2-.1-.3-.1-.3-.1-.7-.2-1l-.1-.2c-.1-.3-.2-.6-.3-.8l-.1-.2c-.2-.3-.3-.6-.5-.9-.1-.1-.1-.2-.2-.2-.2-.3-.4-.5-.7-.8 0 0 0-.1-.1-.1-.3-.3-.6-.5-.9-.8l-.1-.1C9.1-1.1 4.1-.3 1.5 3.3s-1.8 8.6 1.8 11.2c1.4 1 3 1.5 4.7 1.5.4 0 .8 0 1.1-.1h.2c.4-.1.7-.1 1.1-.3l.2-.1c.3-.1.6-.2.9-.4l.2-.1c.3-.2.6-.3.9-.5l.3-.2c.2-.2.5-.4.7-.6l.2-.2c.2-.2.4-.5.6-.8l.2-.2.6-.9c0-.1 0-.1.1-.1.2-.3.3-.7.4-1.1.1-.4.2-.7.3-1.1v-.2c-.1-.3 0-.7 0-1.1v-.2zM8.5 1c1.1.1 2.2.4 3.2 1L8.5 6.5V1zm6 9.6c-.1.3-.3.5-.4.8 0 .1-.1.2-.1.3-.1.2-.2.4-.4.5l-.3.3c-.1.2-.3.3-.4.5l-.3.3c-.1.1-.3.2-.4.4-.1.1-.2.2-.4.3l-.6.3-.3.1c-.2.1-.5.2-.8.3H10c-.3.1-.5.1-.8.2H9c-.3 0-.7.1-1 .1-3.9 0-7-3.1-7-7v-.9c0-.2 0-.3.1-.4l.1-.3c0-.1.1-.3.1-.4s.1-.2.1-.3.1-.2.1-.3l.1-.3.1-.3.3-.3.2-.3.2-.3.2-.3c.1-.1.1-.2.2-.2s.1-.2.2-.3l.2-.2.2-.2.2-.2.4-.2c.1-.1.2-.1.3-.2l.3-.2.3-.1c0-.1.1-.1.3-.2l.3-.1.3-.1.3-.1.3-.1.3-.1h.7v7.1l.1.1v.1l.2.2 6.8 2zm.5-2v.1c0 .3-.1.6-.1.9v.1l-2.6-.8-3.4-1.2 3.7-5.1.1.1.4.4.2.3c.1.2.3.3.4.5l.3.4c.1.2.2.3.3.5l.1.3c.1.2.2.3.2.5l.1.3c.1.3.1.5.2.8 0 .1 0 .2.1.3v1.6z"
  }));
};

var SvgChartPieNext = function SvgChartPieNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1x,
    name: "chart-pie-next"
  }, props));
};

var SvgIcon$1y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5.9H.5c-.3 0-.5.3-.5.5v9.4c0 .3.2.5.5.5h3.6v3.2c0 .2.1.4.3.5h.2c.1 0 .3-.1.4-.2l3.3-3.6h7.3c.3 0 .5-.2.5-.5V1.4c-.1-.2-.3-.5-.6-.5zm-.5 9.4H8c-.1 0-.3.1-.4.2L5 13.3v-2.5c0-.3-.2-.5-.5-.5H1V1.9h14v8.4z"
  }));
};

var SvgChat = function SvgChat(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1y,
    name: "chat"
  }, props));
};

var SvgIcon$1z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 11H8.7L5 14v-3H1V1h14m1-1H0v12h4v4l5-4h7V0z"
  }));
};

var SvgChat$1 = function SvgChat(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1z,
    name: "chat"
  }, props));
};

var SvgIcon$1A = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5.9H.5c-.3 0-.5.3-.5.5v9.4c0 .3.2.5.5.5h3.6v3.2c0 .2.1.4.3.5h.2c.1 0 .3-.1.4-.2l3.3-3.6h7.3c.3 0 .5-.2.5-.5V1.4c-.1-.2-.3-.5-.6-.5zm-.5 9.4H8c-.1 0-.3.1-.4.2L5 13.3v-2.5c0-.3-.2-.5-.5-.5H1V1.9h14v8.4z"
  }));
};

var SvgChatNext = function SvgChatNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1A,
    name: "chat-next"
  }, props));
};

var SvgIcon$1B = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5H13V.5c0-.3-.2-.5-.5-.5H.5C.2 0 0 .2 0 .5v7c0 .3.2.5.5.5h2v4.5c0 .3.2.5.5.5h4.8v2.5c0 .2.1.4.3.5h.2c.1 0 .3-.1.4-.2l2.6-2.8h4.3c.3 0 .5-.2.5-.5v-7c-.1-.3-.3-.5-.6-.5zM1 1h11v6H9.2c-.2 0-.4.2-.4.5v1.7l-1.9-2c-.1-.1-.3-.2-.4-.2H1V1zm14 11h-4c-.1 0-.3.1-.4.2l-1.9 2.1v-1.7c0-.3-.2-.5-.5-.5H3.5V8h2.8l2.6 2.8c.1.1.2.2.3.2h.2c.2-.1.3-.3.3-.5V8h2.8c.3 0 .5-.2.5-.5V6h2v6z"
  }));
};

var SvgChats = function SvgChats(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1B,
    name: "chats"
  }, props));
};

var SvgIcon$1C = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5H13V.5c0-.3-.2-.5-.5-.5H.5C.2 0 0 .2 0 .5v7c0 .3.2.5.5.5h2v4.5c0 .3.2.5.5.5h4.8v2.5c0 .2.1.4.3.5h.2c.1 0 .3-.1.4-.2l2.6-2.8h4.3c.3 0 .5-.2.5-.5v-7c-.1-.3-.3-.5-.6-.5zM1 1h11v6H9.2c-.2 0-.4.2-.4.5v1.7l-1.9-2c-.1-.1-.3-.2-.4-.2H1V1zm14 11h-4c-.1 0-.3.1-.4.2l-1.9 2.1v-1.7c0-.3-.2-.5-.5-.5H3.5V8h2.8l2.6 2.8c.1.1.2.2.3.2h.2c.2-.1.3-.3.3-.5V8h2.8c.3 0 .5-.2.5-.5V6h2v6z"
  }));
};

var SvgChatsNext = function SvgChatsNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1C,
    name: "chats-next"
  }, props));
};

var SvgIcon$1D = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 6.5h2.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H11c-.3 0-.5.2-.5.5s.2.5.5.5zm-2 3H2.9c-.3 0-.5.2-.5.5s.2.5.5.5H9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm2-1h2.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H11c-.3 0-.5.2-.5.5s.2.5.5.5zm-8.1 0H9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H2.9c-.3 0-.5.2-.5.5s.2.5.5.5zm-2.4-5v9h15v-9H.5zm14 8h-13v-7h13v7z"
  }));
};

var SvgCheckPayment = function SvgCheckPayment(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1D,
    name: "check-payment"
  }, props));
};

var SvgIcon$1E = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.9 12.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.7.6l.4-.4c.2-.2.6-.3.9 0 .2.2.3.6 0 .9L6.9 8.2h-.1c-.1.1-.3.2-.4.2l-.8.2.2-.8c0-.1 0-.3.1-.4v-.1L10.3 3c-.1-.2 0-.5.1-.6L12 .8c.3-.2.5-.3.7-.2zm1.6 2l-1 1H15v8.2H1V3.6h6.9l1-1H0v10.2h15.9V2.6h-1.6zM9.1 9.7H2.2v1h6.9v-1z"
  }));
};

var SvgCheckPayment$1 = function SvgCheckPayment(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1E,
    name: "check-payment"
  }, props));
};

var SvgIcon$1F = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 6.5h2.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H11c-.3 0-.5.2-.5.5s.2.5.5.5zm-2 3H2.9c-.3 0-.5.2-.5.5s.2.5.5.5H9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm2-1h2.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H11c-.3 0-.5.2-.5.5s.2.5.5.5zm-8.1 0H9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H2.9c-.3 0-.5.2-.5.5s.2.5.5.5zm-2.4-5v9h15v-9H.5zm14 8h-13v-7h13v7z"
  }));
};

var SvgCheckPaymentNext = function SvgCheckPaymentNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1F,
    name: "check-payment-next"
  }, props));
};

var SvgIcon$1G = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 7H9V0h7v7zm-6-1h5V1h-5v5zM7 2.3L6 3.4V6H1V1h4.1l1-1H0v7h7V2.3zM3.5 5L7.7.7 7 0 3.5 3.6 2.2 2.3l-.8.7 2.1 2z"
  }));
};

var SvgCheckboxes = function SvgCheckboxes(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1G,
    name: "checkboxes"
  }, props));
};

var SvgIcon$1H = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.56.377a.944.944 0 00-1.296.29L5.94 13.764 1.653 9.51a.943.943 0 00-.715-.33.944.944 0 00-.939.938.942.942 0 00.34.723l4.439 4.41c.317.326.75.51 1.205.513.06.004.119.004.179 0a1.701 1.701 0 001.24-.794l8.45-13.292A.94.94 0 0015.56.377z"
  }));
};

var SvgCheckmark = function SvgCheckmark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1H,
    name: "checkmark"
  }, props));
};

var SvgIcon$1I = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 14.2"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 14.2H0v-12h10l-.8 1H1v10h10v-5l1-1v7zM1.7 4.8l.7-.7 4.3 4.3L15.2 0l.8.7-9.2 9.2-5.1-5.1z"
  }));
};

var SvgCheckmarkBox = function SvgCheckmarkBox(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1I,
    name: "checkmark-box"
  }, props));
};

var SvgIcon$1J = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm3.8-10.9c-.2-.1-.5-.1-.7.2l-4.4 7-2.3-2.4c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7L6 12c.2.2.4.3.6.3h.1c.3 0 .5-.2.7-.4l4.5-7.1c.2-.2.1-.6-.1-.7z"
  }));
};

var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1J,
    name: "checkmark-circle"
  }, props));
};

var SvgIcon$1K = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.9 7.8l.7-.7L6.5 10l5.2-5.2.7.7-5.9 5.9-3.6-3.6zm5 7.9C3.5 15.7 0 12.2 0 7.9S3.5 0 7.9 0s7.9 3.5 7.9 7.9c-.1 4.3-3.6 7.8-7.9 7.8zM7.9 1C4.1 1 1 4.1 1 7.9s3.1 6.9 6.9 6.9 6.9-3.1 6.9-6.9C14.7 4.1 11.7 1 7.9 1z"
  }));
};

var SvgCheckmarkCircle$1 = function SvgCheckmarkCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1K,
    name: "checkmark-circle"
  }, props));
};

var SvgIcon$1L = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm3.8-10.9c-.2-.1-.5-.1-.7.2l-4.4 7-2.3-2.4c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7L6 12c.2.2.4.3.6.3h.1c.3 0 .5-.2.7-.4l4.5-7.1c.2-.2.1-.6-.1-.7z"
  }));
};

var SvgCheckmarkCircleNext = function SvgCheckmarkCircleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1L,
    name: "checkmark-circle-next"
  }, props));
};

var SvgIcon$1M = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.9 0C3.5 0 0 3.5 0 7.9s3.5 7.9 7.9 7.9 7.9-3.5 7.9-7.9C15.7 3.5 12.2 0 7.9 0zm0 14.7c-3.8 0-6.9-3-6.9-6.8S4.1 1 7.9 1s6.9 3.1 6.9 6.9c-.1 3.8-3.1 6.8-6.9 6.8zM7.9 1C4.1 1 1 4.1 1 7.9s3.1 6.9 6.9 6.9 6.9-3.1 6.9-6.9C14.7 4.1 11.7 1 7.9 1zM6.6 12.9L1.9 8.2l1.7-1.7 2.9 2.9 5.2-5.2L13.4 6l-6.8 6.9z"
  }));
};

var SvgCheckmarkCircleSolid = function SvgCheckmarkCircleSolid(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1M,
    name: "checkmark-circle-solid"
  }, props));
};

var SvgIcon$1N = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14.8 9.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 4.2l.7-.7 4.9 4.9L14.1 0l.7.7-9.2 9.2L0 4.2z"
  }));
};

var SvgCheckmark$1 = function SvgCheckmark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1N,
    name: "checkmark"
  }, props));
};

var SvgIcon$1O = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 0H.5C.2 0 0 .2 0 .5v15c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5V.5c0-.3-.3-.5-.5-.5zM15 15H1V1h14v14z"
  }), React.createElement("path", {
    d: "M12 7.5H4c-.3 0-.5.2-.5.5s.2.5.5.5h8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgCheckmarkMinusSquare = function SvgCheckmarkMinusSquare(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1O,
    name: "checkmark-minus-square"
  }, props));
};

var SvgIcon$1P = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 0H.5a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V.5a.5.5 0 00-.5-.5zM15 15H1V1h14zM11.768 4.078a.5.5 0 00-.69.154l-4.433 6.976-2.283-2.266a.5.5 0 10-.761.649.493.493 0 00.061.06L6.026 12a.907.907 0 00.642.273.605.605 0 00.095 0 .906.906 0 00.661-.423l4.5-7.079a.5.5 0 00-.156-.693z"
  }));
};

var SvgCheckmarkSquare = function SvgCheckmarkSquare(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1P,
    name: "checkmark-square"
  }, props));
};

var SvgIcon$1Q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 0H.5a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V.5a.5.5 0 00-.5-.5zM15 15H1V1h14zM11.768 4.078a.5.5 0 00-.69.154l-4.433 6.976-2.283-2.266a.5.5 0 10-.761.649.493.493 0 00.061.06L6.026 12a.907.907 0 00.642.273.605.605 0 00.095 0 .906.906 0 00.661-.423l4.5-7.079a.5.5 0 00-.156-.693z"
  }));
};

var SvgCheckmarkSquareNext = function SvgCheckmarkSquareNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1Q,
    name: "checkmark-square-next"
  }, props));
};

var SvgIcon$1R = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#DE2910",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    d: "M2.589 5.944L4 1.6l1.411 4.344-3.696-2.688h4.57zM8.807 1.67l-1.484.341 1-1.148-.135 1.518-.782-1.307zm1.499 1.897l-1.5-.26 1.367-.67-.713 1.345-.215-1.508zm-.214 2.663L8.83 5.38l1.522-.054-1.2.938L9.57 4.8zM8.21 7.974l-.837-1.272 1.425.538-1.47.401.952-1.189z",
    fill: "#FFDE00"
  })));
};

var SvgChina = function SvgChina(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1R,
    name: "china"
  }, props));
};

var SvgIcon$1S = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm3.4-7.1l-2.9 2.9V4c0-.3-.2-.5-.5-.5s-.5.2-.5.5v6.8L4.6 7.9c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7L7.3 12c.2.2.4.3.7.3.3 0 .5-.1.7-.3l3.4-3.4c.2-.2.2-.5 0-.7s-.5-.2-.7 0z"
  }));
};

var SvgCircleArrowDown = function SvgCircleArrowDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1S,
    name: "circle-arrow-down"
  }, props));
};

var SvgIcon$1T = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm3.4-7.1l-2.9 2.9V4c0-.3-.2-.5-.5-.5s-.5.2-.5.5v6.8L4.6 7.9c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7L7.3 12c.2.2.4.3.7.3.3 0 .5-.1.7-.3l3.4-3.4c.2-.2.2-.5 0-.7s-.5-.2-.7 0z"
  }));
};

var SvgCircleArrowDownNext = function SvgCircleArrowDownNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1T,
    name: "circle-arrow-down-next"
  }, props));
};

var SvgIcon$1U = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 7.5H5.2l2.9-2.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0L4 7.3c-.2.2-.3.4-.3.7 0 .3.1.5.3.7l3.4 3.4c.1.1.2.1.4.1.3 0 .5-.2.5-.5 0-.1-.1-.3-.1-.3l-3-2.9H12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgCircleArrowLeft = function SvgCircleArrowLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1U,
    name: "circle-arrow-left"
  }, props));
};

var SvgIcon$1V = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 7.5H5.2l2.9-2.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0L4 7.3c-.2.2-.3.4-.3.7 0 .3.1.5.3.7l3.4 3.4c.1.1.2.1.4.1.3 0 .5-.2.5-.5 0-.1-.1-.3-.1-.3l-3-2.9H12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgCircleArrowLeftNext = function SvgCircleArrowLeftNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1V,
    name: "circle-arrow-left-next"
  }, props));
};

var SvgIcon$1W = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.6 3.9c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l2.9 2.9H4c-.3 0-.5.2-.5.5s.2.5.5.5h6.8l-2.9 2.9c-.2.2-.2.5 0 .7.1.1.2.2.3.1.1 0 .3-.1.4-.1L12 8.7c.4-.4.4-1 0-1.4L8.6 3.9zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgCircleArrowRight = function SvgCircleArrowRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1W,
    name: "circle-arrow-right"
  }, props));
};

var SvgIcon$1X = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.6 3.9c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l2.9 2.9H4c-.3 0-.5.2-.5.5s.2.5.5.5h6.8l-2.9 2.9c-.2.2-.2.5 0 .7.1.1.2.2.3.1.1 0 .3-.1.4-.1L12 8.7c.4-.4.4-1 0-1.4L8.6 3.9zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgCircleArrowRightNext = function SvgCircleArrowRightNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1X,
    name: "circle-arrow-right-next"
  }, props));
};

var SvgIcon$1Y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.7 4c-.4-.4-1-.4-1.4 0L3.9 7.4c-.2.2-.2.5 0 .7.2.2.5.2.7 0l2.9-2.9V12c0 .3.2.5.5.5s.5-.2.5-.5V5.2l2.9 2.9c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.7 4zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgCircleArrowUp = function SvgCircleArrowUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1Y,
    name: "circle-arrow-up"
  }, props));
};

var SvgIcon$1Z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.7 4c-.4-.4-1-.4-1.4 0L3.9 7.4c-.2.2-.2.5 0 .7.2.2.5.2.7 0l2.9-2.9V12c0 .3.2.5.5.5s.5-.2.5-.5V5.2l2.9 2.9c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.7 4zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgCircleArrowUpNext = function SvgCircleArrowUpNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1Z,
    name: "circle-arrow-up-next"
  }, props));
};

var SvgIcon$1_ = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7m0-1C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"
  }));
};

var SvgCircle = function SvgCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$1_,
    name: "circle"
  }, props));
};

var SvgIcon$20 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.9 9.6l-3.1 3.1c-.4.4-1 .4-1.4 0L4.2 9.6c-.2-.2-.2-.5 0-.7.1-.1.2-.1.4-.1.1 0 .3 0 .4.1l2.6 2.6v-8c-.1-.3.1-.5.4-.5.3 0 .5.2.5.5v8l2.6-2.6c.2-.2.5-.2.7 0s.3.5.1.7z"
  }));
};

var SvgCircleFillArrowDown = function SvgCircleFillArrowDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$20,
    name: "circle-fill-arrow-down"
  }, props));
};

var SvgIcon$21 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4.5 8.5h-7l2.6 2.6c.2.2.2.5 0 .7-.2.2-.5.2-.7 0L4.3 8.7c-.4-.4-.4-1 0-1.4l3.1-3.1c.2-.2.5-.2.7 0 .1.1.1.2.1.4 0 .1 0 .3-.1.4L5.5 7.5h7c.3 0 .5.2.5.5s-.2.5-.5.5z"
  }));
};

var SvgCircleFillArrowLeft = function SvgCircleFillArrowLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$21,
    name: "circle-fill-arrow-left"
  }, props));
};

var SvgIcon$22 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.7 8.7l-3.1 3.1c-.2.2-.5.2-.7 0-.1-.1-.1-.2-.1-.4 0-.1 0-.3.1-.4l2.6-2.6h-7c-.3.1-.5-.1-.5-.4 0-.3.2-.5.5-.5h7L7.9 4.8c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l3.1 3.1c.4.5.4 1.1 0 1.5z"
  }));
};

var SvgCircleFillArrowRight = function SvgCircleFillArrowRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$22,
    name: "circle-fill-arrow-right"
  }, props));
};

var SvgIcon$23 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.8 7.1c-.1.1-.2.1-.4.1-.1 0-.3 0-.4-.1L8.5 4.5v8c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-8L4.8 7.1c-.2.2-.5.2-.7 0s-.2-.5 0-.7l3.1-3.1c.4-.4 1-.4 1.4 0l3.1 3.1c.3.2.3.5.1.7z"
  }));
};

var SvgCircleFillArrowUp = function SvgCircleFillArrowUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$23,
    name: "circle-fill-arrow-up"
  }, props));
};

var SvgIcon$24 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.9 15.7C3.5 15.7 0 12.2 0 7.9S3.5 0 7.9 0s7.9 3.5 7.9 7.9c-.1 4.3-3.6 7.8-7.9 7.8zM7.9 1C4.1 1 1 4.1 1 7.9s3.1 6.9 6.9 6.9 6.9-3.1 6.9-6.9C14.7 4.1 11.7 1 7.9 1z"
  }));
};

var SvgCircle$1 = function SvgCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$24,
    name: "circle"
  }, props));
};

var SvgIcon$25 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 15.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.9 15.8l-3.1-3.5h2.1V9.7H14v2.6h2l-3.1 3.5zm2.6-10C14.3 1.6 10-.9 5.8.3S-.9 5.8.3 9.9c.9 3.4 4.1 5.8 7.6 5.8v-1c-3.8 0-6.9-3-6.9-6.8S4.1 1 7.9 1c3 0 5.7 2 6.6 4.8h1zm-4.6 2.6h-7v-1h7v1z"
  }));
};

var SvgCircleMinusArrow = function SvgCircleMinusArrow(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$25,
    name: "circle-minus-arrow"
  }, props));
};

var SvgIcon$26 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7m0-1C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"
  }));
};

var SvgCircleNext = function SvgCircleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$26,
    name: "circle-next"
  }, props));
};

var SvgIcon$27 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 1a7 7 0 11-7 7 7 7 0 017-7m0-1a8 8 0 108 8 8 8 0 00-8-8z"
  }), React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5
  }));
};

var SvgCircleSelected = function SvgCircleSelected(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$27,
    name: "circle-selected"
  }, props));
};

var SvgIcon$28 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 1a7 7 0 11-7 7 7 7 0 017-7m0-1a8 8 0 108 8 8 8 0 00-8-8z"
  }), React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5
  }));
};

var SvgCircleSelectedNext = function SvgCircleSelectedNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$28,
    name: "circle-selected-next"
  }, props));
};

var SvgIcon$29 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.9 15.7C3.5 15.7 0 12.2 0 7.9S3.5 0 7.9 0s7.9 3.5 7.9 7.9c-.1 4.3-3.6 7.8-7.9 7.8z"
  }));
};

var SvgCircleSolid = function SvgCircleSolid(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$29,
    name: "circle-solid"
  }, props));
};

var SvgIcon$2a = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13.1 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M3.6 15H1V3h11l.1 5.9h1L13 2h-3V0H3v2H0v14h3.6v-1zM4 1h5v1H4V1zm4 15l5-4.9-.7-.7L8 14.5l-2.4-2.4-.7.7L8 16z"
  }));
};

var SvgClipboardCheckmark = function SvgClipboardCheckmark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2a,
    name: "clipboard-checkmark"
  }, props));
};

var SvgIcon$2b = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4 1h5v1H4V1zm9 6.1V2h-3V0H3v2H0v14h4.5v-1H1V3h11v4l1 .1zm-5.5 6.4h4v.7h-4v-.7zm0-1h3v-.7h-3v.7zm0-1.7h2V10h-2v.8zM11.3 8H5.5v8H13V9.5L11.3 8zm.7 7H6.5V9h4.3v1.2H12V15z"
  }));
};

var SvgClipboardDocument = function SvgClipboardDocument(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2b,
    name: "clipboard-document"
  }, props));
};

var SvgIcon$2c = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 2V0H3v2H0v14h13V2h-3zM4 1h5v1H4V1zm8 12l-2 2H1V3h11v10z"
  }));
};

var SvgClipboard = function SvgClipboard(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2c,
    name: "clipboard"
  }, props));
};

var SvgIcon$2d = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 13.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.9 10.6L8.6 7.3V3.9h1.1v2.9l3 3.1-.8.7zM9.2 0C5.5 0 2.6 2.8 2.3 6.4h1.1C3.7 3.2 6.5.8 9.7 1.1s5.6 3.1 5.3 6.3c-.3 3-2.8 5.3-5.8 5.3v1.1c3.8 0 6.9-3.1 6.9-6.9S12.9 0 9.2 0zM0 6.4l3.1 3.1 3.1-3.1H0z"
  }));
};

var SvgClockArrowLeft = function SvgClockArrowLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2d,
    name: "clock-arrow-left"
  }, props));
};

var SvgIcon$2e = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.5 7.8V3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v5.2l2.7 2.6c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.5 7.8zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgClock = function SvgClock(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2e,
    name: "clock"
  }, props));
};

var SvgIcon$2f = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.8 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.3 7.4l3.2 3.1-.7.7-3.5-3.3v-4h1v3.5zm6.1-.6c-.6-3.6-4-6.1-7.6-5.5s-6.1 4-5.5 7.6c.4 2.4 2.1 4.5 4.5 5.2v1.3C1.6 14.3-.8 10 .3 5.8S5.7-.9 9.9.3c3 .8 5.3 3.4 5.7 6.5h-1.2zm-4.5 8.9l5.9-5.9-.8-.7-5.2 5.2-2.9-2.9-.7.6 3.7 3.7z"
  }));
};

var SvgClockCheckmark = function SvgClockCheckmark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2f,
    name: "clock-checkmark"
  }, props));
};

var SvgIcon$2g = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.3 7.4l3.6 3.6-.7.7-3.9-3.8v-4h1v3.5zm-.5 8.3C3.5 15.7 0 12.2 0 7.8S3.5 0 7.8 0s7.8 3.5 7.8 7.8c.1 4.4-3.4 7.9-7.8 7.9zm0-14.5c-3.7 0-6.6 3-6.6 6.6s3 6.6 6.6 6.6 6.6-3 6.6-6.6c.1-3.6-2.9-6.6-6.6-6.6z"
  }));
};

var SvgClock$1 = function SvgClock(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2g,
    name: "clock"
  }, props));
};

var SvgIcon$2h = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.4 1.9c-.9.3-2.8.7-6.1-.3-2.3-.8-4.7-.8-7-.1l-.4.1v8.1l.6-.2c.8-.2 1.5-.3 2.3-.4-.2.5-.2.9-.3 1.4C3.5 13 5.5 15 8 15s4.5-2 4.5-4.5v-.2c.7-.1 1.5-.2 2.2-.5l.3-.1v-8l-.6.2zM8.1 14c-1.9 0-3.5-1.6-3.5-3.5S6.1 7 8.1 7s3.5 1.6 3.5 3.5S10 14 8.1 14zm6-5c-.5.2-1.1.3-1.7.3-.6-2.4-3.1-3.8-5.5-3.2-1.1.3-2 1-2.6 1.9-.8 0-1.6.2-2.3.3v-6c1.9-.5 4-.4 6 .3 1.9.7 4 .8 6 .5l.1 5.9zm-5.5 1.3V7.9c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2.8l1.6 1.6c.1.1.2.1.4.1.1 0 .3-.1.4-.1.2-.2.2-.5 0-.7l-1.4-1.3z"
  }));
};

var SvgClockMoney = function SvgClockMoney(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2h,
    name: "clock-money"
  }, props));
};

var SvgIcon$2i = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.6 7.1l3.4 3.4-.7.7S7.6 7.6 7.6 7.5V3.7h1v3.4zm-.5 8c4.2 0 7.5-3.4 7.6-7.5 0-4.2-3.4-7.5-7.5-7.6-2.8 0-5.3 1.5-6.6 3.8h1.3c2-2.9 6-3.6 8.9-1.6s3.6 6 1.6 8.9a6.31 6.31 0 01-5.2 2.7l-.1 1.3zm-4.5-2.5c0-.2-.1-.5-.2-.7-.2-.2-.5-.4-.8-.5-.3-.1-.7-.3-1-.4-.3-.1-.5-.3-.7-.5-.2-.2-.3-.4-.5-.6C.3 9.6.3 9.3.3 9c0-.5.2-1.1.6-1.4.3-.4.9-.6 1.4-.7V5.8h.8V7c.6 0 1.1.3 1.5.7.4.5.5 1.1.5 1.7H3.6c0-.3-.1-.7-.3-.9-.1-.3-.4-.4-.6-.4-.3 0-.5.1-.7.3-.2.2-.2.4-.2.6 0 .2.1.5.2.6.2.2.5.4.8.5.3.1.7.3 1 .5.2.1.5.3.7.5.2.2.3.4.4.6.1.3.2.5.1.8 0 .5-.2 1-.5 1.4-.4.4-.9.6-1.5.6v1h-.8v-1c-.6 0-1.2-.3-1.6-.8-.4-.3-.6-.9-.6-1.5h1.5c0 .3.1.7.3.9.2.2.5.3.8.3.3 0 .5-.1.7-.2.2-.1.3-.4.3-.6z"
  }));
};

var SvgClockMoney$1 = function SvgClockMoney(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2i,
    name: "clock-money"
  }, props));
};

var SvgIcon$2j = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.4 1.9c-.9.3-2.8.7-6.1-.3-2.3-.8-4.7-.8-7-.1l-.4.1v8.1l.6-.2c.8-.2 1.5-.3 2.3-.4-.2.5-.2.9-.3 1.4C3.5 13 5.5 15 8 15s4.5-2 4.5-4.5v-.2c.7-.1 1.5-.2 2.2-.5l.3-.1v-8l-.6.2zM8.1 14c-1.9 0-3.5-1.6-3.5-3.5S6.1 7 8.1 7s3.5 1.6 3.5 3.5S10 14 8.1 14zm6-5c-.5.2-1.1.3-1.7.3-.6-2.4-3.1-3.8-5.5-3.2-1.1.3-2 1-2.6 1.9-.8 0-1.6.2-2.3.3v-6c1.9-.5 4-.4 6 .3 1.9.7 4 .8 6 .5l.1 5.9zm-5.5 1.3V7.9c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2.8l1.6 1.6c.1.1.2.1.4.1.1 0 .3-.1.4-.1.2-.2.2-.5 0-.7l-1.4-1.3z"
  }));
};

var SvgClockMoneyNext = function SvgClockMoneyNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2j,
    name: "clock-money-next"
  }, props));
};

var SvgIcon$2k = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.5 7.8V3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v5.2l2.7 2.6c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.5 7.8zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgClockNext = function SvgClockNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2k,
    name: "clock-next"
  }, props));
};

var SvgIcon$2l = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.7 7.9V5.2a.3.3 0 00-.6 0v2.9l1.5 1.4a.304.304 0 00.4 0 .304.304 0 000-.4zm-.3-4.4A4.5 4.5 0 1015.9 8a4.481 4.481 0 00-4.5-4.5zm0 8.4A3.905 3.905 0 017.5 8a3.971 3.971 0 013.9-3.9A3.971 3.971 0 0115.3 8a3.905 3.905 0 01-3.9 3.9zM8 4.475H.4a.375.375 0 010-.75H8a.375.375 0 110 .75zm-1.5 1.9H1.4a.375.375 0 110-.75h5.1a.375.375 0 010 .75zM8.275 11.9a.375.375 0 00-.375-.375H4.3a.375.375 0 000 .75h3.6a.375.375 0 00.375-.375zM6.981 10a.36.36 0 00-.342-.375H3.356a.377.377 0 000 .75h3.283A.36.36 0 006.981 10zm-.426-2a.384.384 0 00-.392-.375H2.4a.375.375 0 100 .75h3.764A.384.384 0 006.555 8z"
  }));
};

var SvgClockRush = function SvgClockRush(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2l,
    name: "clock-rush"
  }, props));
};

var SvgIcon$2m = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.806 14.765L1.235.194A.737.737 0 00.194 1.235l14.571 14.571a.737.737 0 001.041-1.041z"
  }), React.createElement("path", {
    d: "M1.235 15.806L15.806 1.235A.737.737 0 0014.765.194L.194 14.765a.737.737 0 001.041 1.041z"
  }));
};

var SvgCloseX = function SvgCloseX(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2m,
    name: "close-x"
  }, props));
};

var SvgIcon$2n = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M1.872 14.851l6.126-4.878 6.126 4.878a.526.526 0 00.72.012.471.471 0 00.013-.688l-.013-.012L8.72 9.285a1.054 1.054 0 00-1.442 0l-6.125 4.878a.47.47 0 00-.005.687.531.531 0 00.725.001zm0-13.702l6.126 4.878 6.126-4.878a.526.526 0 01.72-.012.471.471 0 01.013.688l-.013.012L8.72 6.715c-.399.38-1.044.38-1.442 0L1.152 1.837a.47.47 0 01-.005-.687.531.531 0 01.725-.001z"
  }));
};

var SvgCollapseAll = function SvgCollapseAll(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2n,
    name: "collapse-all"
  }, props));
};

var SvgIcon$2o = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.5 0h-9v16h13V0h-4zm-5 15h-3V1h3v14zm4 0h-3V1h3v14zm4 0h-3V1h3v14z"
  }));
};

var SvgColumns = function SvgColumns(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2o,
    name: "columns"
  }, props));
};

var SvgIcon$2p = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 0v16h16V0H0zm1 4.6h6.5V15H1V4.6zM15 15H8.5V4.6H15V15z"
  }));
};

var SvgColumns$1 = function SvgColumns(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2p,
    name: "columns"
  }, props));
};

var SvgIcon$2q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.5 0h-9v16h13V0h-4zm-5 15h-3V1h3v14zm4 0h-3V1h3v14zm4 0h-3V1h3v14z"
  }));
};

var SvgColumnsNext = function SvgColumnsNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2q,
    name: "columns-next"
  }, props));
};

var SvgIcon$2r = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.1 5.9c-.2-.2-.5-.2-.7 0L11 7.3 9.6 5.9c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L10.3 8 8.9 9.4c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3-.1.4-.1L11 8.7l1.4 1.4c.1.1.2.1.4.1.1 0 .3-.1.4-.1.2-.2.2-.5 0-.7L11.7 8l1.4-1.4c.2-.2.2-.5 0-.7zm1.4-1.5V0h-13v16h13v-4.4c2-2 2-5.1 0-7.2 0 .1 0 .1 0 0zM5.5 15h-3V1h3v14zm5-14h3v2.7c-.8-.5-1.6-.7-2.5-.7h-.5V1zm-4 0h3v2.2c-1.3.4-2.4 1.4-3 2.6V1zm3 14h-3v-4.9c.6 1.2 1.7 2.2 3 2.6V15zm4 0h-3v-2h.5c.9 0 1.7-.2 2.5-.7V15zM11 12c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }));
};

var SvgColumnsX = function SvgColumnsX(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2r,
    name: "columns-x"
  }, props));
};

var SvgIcon$2s = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 0v16h2V0H0zm5 0v16H3V0h2zm3 0v8H7v8H6V0h2zm3 0v8H9V0h2zm3 0v8h-2V0h2zm-3.5 13l-2.1-2.1.7-.7 2.1 2.1 2.1-2.1.7.7-2.1 2.1 2.1 2.1-.7.7-2.1-2.1L9 15.8l-.7-.7 2.2-2.1z"
  }));
};

var SvgColumnsX$1 = function SvgColumnsX(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2s,
    name: "columns-x"
  }, props));
};

var SvgIcon$2t = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.1 5.9c-.2-.2-.5-.2-.7 0L11 7.3 9.6 5.9c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L10.3 8 8.9 9.4c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3-.1.4-.1L11 8.7l1.4 1.4c.1.1.2.1.4.1.1 0 .3-.1.4-.1.2-.2.2-.5 0-.7L11.7 8l1.4-1.4c.2-.2.2-.5 0-.7zm1.4-1.5V0h-13v16h13v-4.4c2-2 2-5.1 0-7.2 0 .1 0 .1 0 0zM5.5 15h-3V1h3v14zm5-14h3v2.7c-.8-.5-1.6-.7-2.5-.7h-.5V1zm-4 0h3v2.2c-1.3.4-2.4 1.4-3 2.6V1zm3 14h-3v-4.9c.6 1.2 1.7 2.2 3 2.6V15zm4 0h-3v-2h.5c.9 0 1.7-.2 2.5-.7V15zM11 12c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }));
};

var SvgColumnsXNext = function SvgColumnsXNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2t,
    name: "columns-x-next"
  }, props));
};

var SvgIcon$2u = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 94 93"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    transform: "translate(-16.496 -17.004)"
  }, React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 66.764,
    y1: 95.862,
    x2: 23.625,
    y2: 52.722
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: '#ade2ff',
      stopOpacity: 0
    }
  }), React.createElement("stop", {
    offset: 0.232,
    style: {
      stopColor: '#ade2ff'
    }
  }), React.createElement("stop", {
    offset: 0.987,
    style: {
      stopColor: '#0070b9'
    }
  })), React.createElement("path", {
    d: "M26.8 49.6V99h8.9c-.8-.4-1.3-1.3-1.3-2.2V60.1c0-1.4 1.1-2.5 2.5-2.5h16.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5H39.5v34.2c0 .9-.5 1.8-1.3 2.2h25.4V49.6H26.8z",
    style: {
      fill: 'url(#a)'
    }
  })), React.createElement("path", {
    d: "M91.804 92.996h-89.4c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h89.3c1.4 0 2.5 1.1 2.5 2.5s-1 2.5-2.4 2.5zm-5.4-90.3v77.7c0 1.4-1.1 2.5-2.5 2.5h-73.6c-1.4 0-2.5-1.1-2.5-2.5v-47.8c0-1.4 1.1-2.5 2.5-2.5h34.2v-27.4c0-1.4 1.1-2.5 2.5-2.5h36.8c1.5 0 2.6 1.1 2.6 2.5zm-73.5 75.2h5.1v-34.8c0-1.4 1.1-2.5 2.5-2.5h16.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5h-14v32.2h21.5v-42.7h-31.6v42.8zm58.3-18.9h-11.4v18.8h11.4v-18.8zm10.1-53.7h-31.7v72.6h5.1v-21.4c0-1.4 1.1-2.5 2.5-2.5h16.5c1.4 0 2.5 1.1 2.5 2.5v21.4h5.1v-72.6zm-24 34.1c1.4 0 2.5-1.1 2.5-2.5v-21.5h13.9c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5h-16.4c-1.4 0-2.5 1.1-2.5 2.5v24c-.1 1.3 1.1 2.5 2.5 2.5z",
    style: {
      fill: '#036'
    }
  }));
};

var SvgCompany = function SvgCompany(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2u,
    name: "company"
  }, props));
};

var SvgIcon$2v = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.5 2.5h-13c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h13c.6 0 1-.4 1-1v-9c0-.6-.4-1-1-1zm-10.1 10l.3-1.3c.1-.3.3-.6.6-.8.2-.1.5-.2.8-.4h.1l.7-.3.7-.3-.3-.5c-.1-.1-.2-.3-.2-.4L7 8.3c-.1-.1-.1-.2-.1-.3l.1-.1V6.7c0-.1.1-.1.1-.2l.1-.2c.2-.2.5-.3.8-.3.3 0 .6.2.9.5 0 .1.1.1.1.2 0 .2.1.4.1.6v.6c0 .1 0 .2-.1.3l-.1.2c0 .2-.1.3-.2.5l-.3.4.7.3.8.4c.3.1.6.3.9.4.3.2.5.4.6.8l.3 1.3H4.4zm10.1 0h-1.9v-.1l-.3-1.4c-.1-.6-.5-1.1-1.1-1.4l-1-.5-.4-.2c.3-.3.3-.8.2-1.2v-.3c0-.4 0-.7-.1-1.1-.1-.2-.2-.3-.3-.4-.3-.5-.9-.8-1.5-.9h-.3c-.5.1-1.1.4-1.4.8-.1.2-.2.3-.3.5-.1.3-.2.7-.2 1.1v.3c-.1.4 0 .8.2 1.2V9l-.3.1h-.1l-1 .5c-.5.3-.9.8-1 1.4l-.3 1.4v.1H1.5v-9h13v9z"
  }));
};

var SvgContactCard = function SvgContactCard(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2v,
    name: "contact-card"
  }, props));
};

var SvgIcon$2w = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 11"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.8 3h-4v1h4V3zm2 2h-6v1h6V5zm-1 2h-5v1h5V7zm2.9-7v11H0V0h15.7zm-.9 10V1H.8v9h14zM5.7 4.3c0 .7-.6 1.3-1.3 1.3-.8.1-1.4-.5-1.4-1.3C3 3.6 3.6 3 4.3 3c.8 0 1.4.6 1.4 1.3m1 2.5C6.2 6.5 5.6 6.2 5 6c-.4.3-.9.3-1.3 0-.6.2-1.2.5-1.8.8-.1.4-.1.8-.1 1.2h5c.1-.4 0-.8-.1-1.2z"
  }));
};

var SvgContactCard$1 = function SvgContactCard(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2w,
    name: "contact-card"
  }, props));
};

var SvgIcon$2x = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.5 2.5h-13c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h13c.6 0 1-.4 1-1v-9c0-.6-.4-1-1-1zm-10.1 10l.3-1.3c.1-.3.3-.6.6-.8.2-.1.5-.2.8-.4h.1l.7-.3.7-.3-.3-.5c-.1-.1-.2-.3-.2-.4L7 8.3c-.1-.1-.1-.2-.1-.3l.1-.1V6.7c0-.1.1-.1.1-.2l.1-.2c.2-.2.5-.3.8-.3.3 0 .6.2.9.5 0 .1.1.1.1.2 0 .2.1.4.1.6v.6c0 .1 0 .2-.1.3l-.1.2c0 .2-.1.3-.2.5l-.3.4.7.3.8.4c.3.1.6.3.9.4.3.2.5.4.6.8l.3 1.3H4.4zm10.1 0h-1.9v-.1l-.3-1.4c-.1-.6-.5-1.1-1.1-1.4l-1-.5-.4-.2c.3-.3.3-.8.2-1.2v-.3c0-.4 0-.7-.1-1.1-.1-.2-.2-.3-.3-.4-.3-.5-.9-.8-1.5-.9h-.3c-.5.1-1.1.4-1.4.8-.1.2-.2.3-.3.5-.1.3-.2.7-.2 1.1v.3c-.1.4 0 .8.2 1.2V9l-.3.1h-.1l-1 .5c-.5.3-.9.8-1 1.4l-.3 1.4v.1H1.5v-9h13v9z"
  }));
};

var SvgContactCardNext = function SvgContactCardNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2x,
    name: "contact-card-next"
  }, props));
};

var SvgIcon$2y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.3 13.5c.4.4 1 .4 1.4 0l5.6-5.7c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-5.2 5.1V.6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v11.7L2.3 7.2c-.1-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.7 5.6zM14 15H2c-.3 0-.5.2-.5.5s.2.5.5.5h12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgContainerArrowDown = function SvgContainerArrowDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2y,
    name: "container-arrow-down"
  }, props));
};

var SvgIcon$2z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 15.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 10v5.9H0V10h1v4.9h14V10h1zm-7.9 0l4-4-.7-.7-2.9 2.9V0h-.9v8.1L4.7 5.4l-.7.7L8.1 10z"
  }));
};

var SvgContainerArrowDown$1 = function SvgContainerArrowDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2z,
    name: "container-arrow-down"
  }, props));
};

var SvgIcon$2A = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.3 13.5c.4.4 1 .4 1.4 0l5.6-5.7c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-5.2 5.1V.6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v11.7L2.3 7.2c-.1-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.7 5.6zM14 15H2c-.3 0-.5.2-.5.5s.2.5.5.5h12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgContainerArrowDownNext = function SvgContainerArrowDownNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2A,
    name: "container-arrow-down-next"
  }, props));
};

var SvgIcon$2B = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.3 6.8l5.2-5.1v11.7c0 .3.2.5.5.5s.5-.2.5-.5V1.7l5.1 5.1c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.7.5c-.4-.4-1-.4-1.4 0L1.6 6.2c-.2.2-.2.5 0 .7s.6.1.7-.1zM14 15H2c-.3 0-.5.2-.5.5s.2.5.5.5h12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgContainerArrowUp = function SvgContainerArrowUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2B,
    name: "container-arrow-up"
  }, props));
};

var SvgIcon$2C = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 15.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 10v5.9H0V10h1v4.9h14V10h1zM8.1 0l-4 4 .7.7 2.8-2.9V10h.9V1.9l2.9 2.8.7-.7-4-4z"
  }));
};

var SvgContainerArrowUp$1 = function SvgContainerArrowUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2C,
    name: "container-arrow-up"
  }, props));
};

var SvgIcon$2D = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.3 6.8l5.2-5.1v11.7c0 .3.2.5.5.5s.5-.2.5-.5V1.7l5.1 5.1c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.7.5c-.4-.4-1-.4-1.4 0L1.6 6.2c-.2.2-.2.5 0 .7s.6.1.7-.1zM14 15H2c-.3 0-.5.2-.5.5s.2.5.5.5h12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgContainerArrowUpNext = function SvgContainerArrowUpNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2D,
    name: "container-arrow-up-next"
  }, props));
};

var SvgIcon$2E = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 11h2.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H11c-.3 0-.5.2-.5.5s.2.5.5.5zm3.5-8h-13c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h13c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm0 9h-13V7.5h13V12zm0-6.5h-13V4h13v1.5z"
  }));
};

var SvgCreditCard = function SvgCreditCard(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2E,
    name: "credit-card"
  }, props));
};

var SvgIcon$2F = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 0v12h16V0H0zm15 1v1.8H1V1h14zM1 11V5.8h14V11H1zm13-1.8H6.8v-1H14v1z"
  }));
};

var SvgCreditCard$1 = function SvgCreditCard(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2F,
    name: "credit-card"
  }, props));
};

var SvgIcon$2G = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 11h2.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H11c-.3 0-.5.2-.5.5s.2.5.5.5zm3.5-8h-13c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h13c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm0 9h-13V7.5h13V12zm0-6.5h-13V4h13v1.5z"
  }));
};

var SvgCreditCardNext = function SvgCreditCardNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2G,
    name: "credit-card-next"
  }, props));
};

var SvgIcon$2H = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14 2c0 1.1-3.1 2-7 2s-7-.9-7-2 3.1-2 7-2 7 .9 7 2zM7 6c-.6 0-5-.1-7-1.4V6c0 1.1 3.1 2 7 2s7-.9 7-2V4.6C12 5.9 7.6 6 7 6zm0 4c-.6 0-5-.1-7-1.4V10c0 1.1 3.1 2 7 2s7-.9 7-2V8.6C12 9.9 7.6 10 7 10zm0 4c-.6 0-5-.1-7-1.4V14c0 1.1 3.1 2 7 2s7-.9 7-2v-1.4C12 13.9 7.6 14 7 14z"
  }));
};

var SvgCylinderStack = function SvgCylinderStack(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2H,
    name: "cylinder-stack"
  }, props));
};

var SvgIcon$2I = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#E80000",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h24v8.017H0z"
  }), React.createElement("path", {
    fill: "#00006F",
    d: "M0 0l11.967 7.989L0 15.967z"
  })));
};

var SvgCzechRepublic = function SvgCzechRepublic(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2I,
    name: "czech-republic"
  }, props));
};

var SvgIcon$2J = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#C60C30",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M6.857 0h2.286v16H6.857z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M0 6.857h24v2.286H0z"
  })));
};

var SvgDenmark = function SvgDenmark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2J,
    name: "denmark"
  }, props));
};

var SvgIcon$2K = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 6.8c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7L11.8 9H8c-.3 0-.5.2-.5.5s.2.5.5.5h3.8l-1.5 1.5c-.2.2-.2.5 0 .7.2.2.5.2.7 0l2-2c.4-.4.4-1 0-1.4l-2-2zm1.5-1.9v-.4c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1.4C15 13 16.2 10 15.1 7.5c-.5-1.1-1.4-2.1-2.6-2.6zm-1 10.1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2v.1c-.3-.1-.7-.1-1-.1-.8-.1-1.6.1-2.2.4H3c-.3 0-.5.2-.5.5s.2.5.5.5h3.9c-.3.3-.5.6-.7 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.8c-.1.3-.2.7-.2 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.6c.3 2.6 2.4 4.5 5 4.5.3 0 .7 0 1-.1l-.1.6zm-1-1.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }));
};

var SvgDocumentArrow = function SvgDocumentArrow(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2K,
    name: "document-arrow"
  }, props));
};

var SvgIcon$2L = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13.3 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.4 15H1V1h8v3h3v4h1V3l-3-3H0v16h6.5l-.1-1zm4 1l-2.9-3.5.6-.5 1.9 2.3V9h.7v5.3l1.9-2.3.6.4-2.8 3.6z"
  }));
};

var SvgDocumentArrowDown = function SvgDocumentArrowDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2L,
    name: "document-arrow-down"
  }, props));
};

var SvgIcon$2M = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4.4 15H1V1h8v3h3v4h1V3l-3-3H0v16h4.4v-1zm8.6-2.1L9.3 16l-.5-.6 2.4-2.1H5.9v-.7h5.3l-2.5-2.1.4-.6 3.9 3z"
  }));
};

var SvgDocumentArrow$1 = function SvgDocumentArrow(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2M,
    name: "document-arrow"
  }, props));
};

var SvgIcon$2N = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 6.8c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7L11.8 9H8c-.3 0-.5.2-.5.5s.2.5.5.5h3.8l-1.5 1.5c-.2.2-.2.5 0 .7.2.2.5.2.7 0l2-2c.4-.4.4-1 0-1.4l-2-2zm1.5-1.9v-.4c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1.4C15 13 16.2 10 15.1 7.5c-.5-1.1-1.4-2.1-2.6-2.6zm-1 10.1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2v.1c-.3-.1-.7-.1-1-.1-.8-.1-1.6.1-2.2.4H3c-.3 0-.5.2-.5.5s.2.5.5.5h3.9c-.3.3-.5.6-.7 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.8c-.1.3-.2.7-.2 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.6c.3 2.6 2.4 4.5 5 4.5.3 0 .7 0 1-.1l-.1.6zm-1-1.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }));
};

var SvgDocumentArrowNext = function SvgDocumentArrowNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2N,
    name: "document-arrow-next"
  }, props));
};

var SvgIcon$2O = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 9H3c-.3 0-.5.2-.5.5s.2.5.5.5h7c.3 0 .5-.2.5-.5S10.3 9 10 9zm0-2H3c-.3 0-.5.2-.5.5s.2.5.5.5h7c.3 0 .5-.2.5-.5S10.3 7 10 7zm0-2H3c-.3 0-.5.2-.5.5s.2.5.5.5h7c.3 0 .5-.2.5-.5S10.3 5 10 5zm2.1-1.4L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-11c0-.3-.1-.6-.4-.9zM11.5 15h-10V1H8l.2.1 3.3 3.3s.1.1.1.2L11.5 15z"
  }));
};

var SvgDocument = function SvgDocument(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2O,
    name: "document"
  }, props));
};

var SvgIcon$2P = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M3.5 15H1V1h8v3h3v5h1V3l-3-3H0v16h3.5v-1zM8 16l5-4.9-.7-.7L8 14.6l-2.4-2.4-.7.7L8 16z"
  }));
};

var SvgDocumentCheck = function SvgDocumentCheck(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2P,
    name: "document-check"
  }, props));
};

var SvgIcon$2Q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5 15H1V1h8v3h3v4c.4.3.7.6 1 1V3l-3-3H0v16h6c-.3-.3-.7-.6-1-1zm4 1c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.7 4-4 4zm0-7c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm.2 2.8l1.4 1.4-.5.5S8.5 12.1 8.5 12v-1.9h.8l-.1 1.7z"
  }));
};

var SvgDocumentClock = function SvgDocumentClock(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2Q,
    name: "document-clock"
  }, props));
};

var SvgIcon$2R = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5h-3v-.5c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V14h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 10h-10V1H8l.2.1 3.3 3.3s.1.1.1.2V5h-7c-.4 0-.6.2-.6.5v8c0 .3.2.5.5.5h7v1zM10 11.3c.3 0 .5-.2.5-.5 0-.4-.2-.6-.7-.9s-1.2-.8-1.2-1.6c0-.7.5-1.3 1.1-1.3h.2c.7 0 1.3.5 1.3 1.2v.4s0 .1-.1.1h-.6s-.1 0-.1-.1v-.3c0-.4-.2-.6-.5-.6s-.5.2-.5.6c0 .4.2.5.7.9.7.5 1.1.8 1.1 1.5S10.7 12 10 12h-.1c-.7 0-1.2-.5-1.3-1.1v-.3s0-.1.1-.1h.6s.1 0 .1.1v.1c.1.4.3.6.6.6zM6.8 7.7c-.3 0-.5.2-.5.5v2.6c-.1.3.1.5.4.6.3 0 .5-.2.6-.4v-.4s0-.1.1-.1H8s.1 0 .1.1v.1c.1.7-.5 1.3-1.1 1.3h-.2c-.7 0-1.3-.5-1.3-1.2V8.3c-.1-.7.4-1.2 1.1-1.3h.2c.7-.1 1.3.4 1.3 1.1v.3s0 .1-.1.1h-.7s-.1 0-.1-.1v-.1c.1-.3-.1-.6-.4-.6zm6.7 4.2s-.1.1 0 0l-.8.1s-.1 0-.1-.1l-.1-.3-.9-4.4c0-.1 0-.1.1-.1h.7s.1 0 .1.1l.1.4.5 3 .6-3.4s0-.1.1-.1h.7c.1 0 .1 0 .1.1l-1.1 4.7z"
  }));
};

var SvgDocumentCsv = function SvgDocumentCsv(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2R,
    name: "document-csv"
  }, props));
};

var SvgIcon$2S = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 0H0v16h13V3l-3-3zm2 15H1V1h8v3h3v11zm-7.8-3.6l.7.3c-.1.4-.3.8-.5 1.1-.3.2-.6.3-.9.3-.4 0-.8-.2-1.1-.5-.3-.5-.5-1.1-.5-1.7 0-.6.1-1.2.5-1.7.2-.4.6-.6 1-.6s.7.1 1 .4c.2.2.4.5.4.9l-.7.2c0-.2-.1-.4-.3-.5-.1-.2-.2-.2-.4-.2-.3 0-.5.1-.6.3-.2.3-.3.7-.2 1.1 0 .4.1.8.2 1.2.1.2.4.3.6.3.2 0 .4-.1.5-.2.1-.2.2-.4.3-.7zm1.1.2l.7-.1c.1.5.3.8.8.8.2 0 .4 0 .5-.2.1-.1.2-.3.2-.4 0-.1 0-.2-.1-.2 0-.1-.1-.1-.2-.2-.2-.1-.4-.2-.6-.2-.2-.1-.5-.2-.7-.3-.1-.1-.3-.3-.3-.4-.2-.2-.2-.4-.2-.6 0-.2.1-.4.2-.6.1-.2.2-.3.4-.4.2-.1.5-.2.7-.1.4 0 .7.1 1 .3.2.2.3.6.3.9h-.7c0-.2-.1-.4-.2-.5-.1 0-.3-.1-.4-.1-.2 0-.3 0-.4.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.3l.6.3c.3.1.5.2.8.3.2.1.3.3.4.4.1.2.1.4.1.7 0 .3-.1.7-.3.9-.3.3-.7.4-1.1.4-.8 0-1.3-.5-1.4-1.5zM9.6 13L8.4 8.7h.8l.9 3.2.9-3.2h.8L10.4 13h-.8z"
  }));
};

var SvgDocumentCsv$1 = function SvgDocumentCsv(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2S,
    name: "document-csv"
  }, props));
};

var SvgIcon$2T = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5h-3v-.5c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V14h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 10h-10V1H8l.2.1 3.3 3.3s.1.1.1.2V5h-7c-.4 0-.6.2-.6.5v8c0 .3.2.5.5.5h7v1zM10 11.3c.3 0 .5-.2.5-.5 0-.4-.2-.6-.7-.9s-1.2-.8-1.2-1.6c0-.7.5-1.3 1.1-1.3h.2c.7 0 1.3.5 1.3 1.2v.4s0 .1-.1.1h-.6s-.1 0-.1-.1v-.3c0-.4-.2-.6-.5-.6s-.5.2-.5.6c0 .4.2.5.7.9.7.5 1.1.8 1.1 1.5S10.7 12 10 12h-.1c-.7 0-1.2-.5-1.3-1.1v-.3s0-.1.1-.1h.6s.1 0 .1.1v.1c.1.4.3.6.6.6zM6.8 7.7c-.3 0-.5.2-.5.5v2.6c-.1.3.1.5.4.6.3 0 .5-.2.6-.4v-.4s0-.1.1-.1H8s.1 0 .1.1v.1c.1.7-.5 1.3-1.1 1.3h-.2c-.7 0-1.3-.5-1.3-1.2V8.3c-.1-.7.4-1.2 1.1-1.3h.2c.7-.1 1.3.4 1.3 1.1v.3s0 .1-.1.1h-.7s-.1 0-.1-.1v-.1c.1-.3-.1-.6-.4-.6zm6.7 4.2s-.1.1 0 0l-.8.1s-.1 0-.1-.1l-.1-.3-.9-4.4c0-.1 0-.1.1-.1h.7s.1 0 .1.1l.1.4.5 3 .6-3.4s0-.1.1-.1h.7c.1 0 .1 0 .1.1l-1.1 4.7z"
  }));
};

var SvgDocumentCsvNext = function SvgDocumentCsvNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2T,
    name: "document-csv-next"
  }, props));
};

var SvgIcon$2U = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16.1"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.5 15H1V1h8v3h3v4h1V3l-3-3H0v16h6.5v-1zm5.1-1.1c0-.2-.1-.4-.2-.5-.2-.2-.4-.3-.6-.3-.2-.1-.5-.2-.7-.3-.2-.1-.4-.2-.5-.3-.1-.1-.3-.3-.3-.5-.1-.2-.1-.4-.1-.6 0-.4.1-.8.4-1 .3-.3.7-.4 1.1-.5V9h.6v.8c.4 0 .8.2 1 .6.3.3.4.8.4 1.2h-1.1c0-.2 0-.5-.2-.7-.1-.1-.3-.2-.5-.2s-.3.1-.5.2c-.1.1-.2.3-.2.5s.1.3.2.5c.2.2.4.3.6.4.3.1.5.2.7.3.2.1.3.2.5.4.1.1.2.3.3.5.1.2.1.4.1.6 0 .4-.1.8-.4 1-.3.3-.7.4-1.1.5v.7h-.6v-.7c-.4 0-.9-.2-1.2-.5-.1-.6-.3-1.1-.3-1.5h1.1c0 .2.1.5.2.7.2.2.4.3.6.2.2 0 .4-.1.5-.2.2-.1.3-.3.2-.4z"
  }));
};

var SvgDocumentDollarSign = function SvgDocumentDollarSign(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2U,
    name: "document-dollar-sign"
  }, props));
};

var SvgIcon$2V = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 0H0v16h13V3l-3-3zm2 15H1V1h8v3h3v11z"
  }));
};

var SvgDocument$1 = function SvgDocument(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2V,
    name: "document"
  }, props));
};

var SvgIcon$2W = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.2 12h6v1h-6v-1zm0-2h8.4V9H2.2v1zm0-3h7V6h-7v1zm0-3h3V3h-3v1zM10 0H0v16h13V3l-3-3zm2 15H1V1h8v3h3v11z"
  }));
};

var SvgDocumentLines = function SvgDocumentLines(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2W,
    name: "document-lines"
  }, props));
};

var SvgIcon$2X = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.2 11.1l-1.4-1.4c.2-.3.4-.7.3-1.2 0-1.2-1-2.2-2.1-2.2s-2.2 1-2.2 2.1 1 2.2 2.1 2.2c.4 0 .7-.1 1.1-.3l1.4 1.4c.1.1.2.1.4.1.1 0 .3-.1.4-.1.2 0 .2-.4 0-.6zM10 9.7c-.6 0-1.2-.5-1.2-1.1 0-.6.5-1.2 1.1-1.2.6 0 1.2.5 1.2 1.1 0 .7-.5 1.2-1.1 1.2zm2.5-4.8v-.4c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1.4C15 13 16.2 10 15.1 7.5c-.5-1.1-1.4-2.1-2.6-2.6zm-1 10.1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2v.1c-.3-.1-.7-.1-1-.1-.8-.1-1.6.1-2.2.4H3c-.3 0-.5.2-.5.5s.2.5.5.5h3.9c-.3.3-.5.6-.7 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.8c-.1.3-.2.7-.2 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.6c.3 2.6 2.4 4.5 5 4.5.3 0 .7 0 1-.1l-.1.6zm-1-1.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }));
};

var SvgDocumentMagnify = function SvgDocumentMagnify(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2X,
    name: "document-magnify"
  }, props));
};

var SvgIcon$2Y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14.1 15.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4.7 14H1V1h8v3h3v3.2c.4.3.7.6 1 1V3l-3-3H0v15h5.7c-.4-.3-.7-.6-1-1zm3.8.7c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.7 4-4 4zm0-7c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm5.6 7.2l-1 1-2.2-2.2 1-1 2.2 2.2z"
  }));
};

var SvgDocumentMagnify$1 = function SvgDocumentMagnify(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2Y,
    name: "document-magnify"
  }, props));
};

var SvgIcon$2Z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.2 11.1l-1.4-1.4c.2-.3.4-.7.3-1.2 0-1.2-1-2.2-2.1-2.2s-2.2 1-2.2 2.1 1 2.2 2.1 2.2c.4 0 .7-.1 1.1-.3l1.4 1.4c.1.1.2.1.4.1.1 0 .3-.1.4-.1.2 0 .2-.4 0-.6zM10 9.7c-.6 0-1.2-.5-1.2-1.1 0-.6.5-1.2 1.1-1.2.6 0 1.2.5 1.2 1.1 0 .7-.5 1.2-1.1 1.2zm2.5-4.8v-.4c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1.4C15 13 16.2 10 15.1 7.5c-.5-1.1-1.4-2.1-2.6-2.6zm-1 10.1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2v.1c-.3-.1-.7-.1-1-.1-.8-.1-1.6.1-2.2.4H3c-.3 0-.5.2-.5.5s.2.5.5.5h3.9c-.3.3-.5.6-.7 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.8c-.1.3-.2.7-.2 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.6c.3 2.6 2.4 4.5 5 4.5.3 0 .7 0 1-.1l-.1.6zm-1-1.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }));
};

var SvgDocumentMagnifyNext = function SvgDocumentMagnifyNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2Z,
    name: "document-magnify-next"
  }, props));
};

var SvgIcon$2_ = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.5 4.9v-.4c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1.4C15 13 16.2 10 15.1 7.5c-.5-1.1-1.4-2.1-2.6-2.6zm-1 10.1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2v.1c-.3-.1-.7-.1-1-.1-.8-.1-1.6.1-2.2.4H3c-.3 0-.5.2-.5.5s.2.5.5.5h3.9c-.3.3-.5.6-.7 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.8c-.1.3-.2.7-.2 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.6c.3 2.6 2.4 4.5 5 4.5.3 0 .7 0 1-.1l-.1.6zm-1-1.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zM12.4 9H8.6c-.3 0-.5.2-.5.5s.2.5.5.5h3.8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgDocumentMinus = function SvgDocumentMinus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$2_,
    name: "document-minus"
  }, props));
};

var SvgIcon$30 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13 13H6v-1h7v1zm-7.5 2H1V1h8v3h3v4h1V3l-3-3H0v16h5.5v-1z"
  }));
};

var SvgDocumentMinus$1 = function SvgDocumentMinus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$30,
    name: "document-minus"
  }, props));
};

var SvgIcon$31 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.5 4.9v-.4c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1.4C15 13 16.2 10 15.1 7.5c-.5-1.1-1.4-2.1-2.6-2.6zm-1 10.1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2v.1c-.3-.1-.7-.1-1-.1-.8-.1-1.6.1-2.2.4H3c-.3 0-.5.2-.5.5s.2.5.5.5h3.9c-.3.3-.5.6-.7 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.8c-.1.3-.2.7-.2 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.6c.3 2.6 2.4 4.5 5 4.5.3 0 .7 0 1-.1l-.1.6zm-1-1.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zM12.4 9H8.6c-.3 0-.5.2-.5.5s.2.5.5.5h3.8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgDocumentMinusNext = function SvgDocumentMinusNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$31,
    name: "document-minus-next"
  }, props));
};

var SvgIcon$32 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 9H3c-.3 0-.5.2-.5.5s.2.5.5.5h7c.3 0 .5-.2.5-.5S10.3 9 10 9zm0-2H3c-.3 0-.5.2-.5.5s.2.5.5.5h7c.3 0 .5-.2.5-.5S10.3 7 10 7zm0-2H3c-.3 0-.5.2-.5.5s.2.5.5.5h7c.3 0 .5-.2.5-.5S10.3 5 10 5zm2.1-1.4L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-11c0-.3-.1-.6-.4-.9zM11.5 15h-10V1H8l.2.1 3.3 3.3s.1.1.1.2L11.5 15z"
  }));
};

var SvgDocumentNext = function SvgDocumentNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$32,
    name: "document-next"
  }, props));
};

var SvgIcon$33 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.7 5.3h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H2.7c-.3 0-.5.2-.5.5s.2.5.5.5zm0 1.8h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H2.7c-.3 0-.5.2-.5.5s.2.5.5.5zm12.1 1.7c-1.3.4-2.6.4-3.8.1V4c0-.3-.1-.6-.4-.8L7.8.3C7.6.1 7.3 0 7 0H1C.7 0 .5.2.5.5v13c0 .3.2.5.5.5h2.5v1.5l.6-.2c1-.3 1.9-.4 2.9-.4s2 .2 2.9.6c1.7.7 3.6.7 5.3.1l.3-.1v-7l-.7.3zm-12.1 0h.8V13h-2V1H7l.2.1L10 3.9v4.7l-.2-.1-.5-.1v-.1c0-.3-.2-.5-.5-.5H2.7c-.3 0-.5.2-.5.5s.2.5.5.5zm11.8 5.9c-1.4.4-2.9.3-4.3-.2-1-.4-2.1-.6-3.2-.6-.8 0-1.6.1-2.4.3v-5c1.7-.4 3.4-.3 5 .2s3.3.7 5 .4l-.1 4.9z"
  }));
};

var SvgDocumentPayment = function SvgDocumentPayment(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$33,
    name: "document-payment"
  }, props));
};

var SvgIcon$34 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.5 15H1V1h8v3h3v4h1V3l-3-3H0v16h2.5v-1zm9.9-5.4v5.8H4.2V9.6h8.2M13 9H3.7v7H13V9zm-7.8 1.5v4.1h6.3v-4.1H5.2zm1.4 2.3h-.9V12h.9v.8zm1.7.9c-.6 0-1.2-.5-1.2-1.2 0-.6.5-1.2 1.2-1.2s1.2.5 1.2 1.2c0 .6-.5 1.2-1.2 1.2zm2.6-.9H10V12h.9v.8z"
  }));
};

var SvgDocumentPayment$1 = function SvgDocumentPayment(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$34,
    name: "document-payment"
  }, props));
};

var SvgIcon$35 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.7 5.3h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H2.7c-.3 0-.5.2-.5.5s.2.5.5.5zm0 1.8h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H2.7c-.3 0-.5.2-.5.5s.2.5.5.5zm12.1 1.7c-1.3.4-2.6.4-3.8.1V4c0-.3-.1-.6-.4-.8L7.8.3C7.6.1 7.3 0 7 0H1C.7 0 .5.2.5.5v13c0 .3.2.5.5.5h2.5v1.5l.6-.2c1-.3 1.9-.4 2.9-.4s2 .2 2.9.6c1.7.7 3.6.7 5.3.1l.3-.1v-7l-.7.3zm-12.1 0h.8V13h-2V1H7l.2.1L10 3.9v4.7l-.2-.1-.5-.1v-.1c0-.3-.2-.5-.5-.5H2.7c-.3 0-.5.2-.5.5s.2.5.5.5zm11.8 5.9c-1.4.4-2.9.3-4.3-.2-1-.4-2.1-.6-3.2-.6-.8 0-1.6.1-2.4.3v-5c1.7-.4 3.4-.3 5 .2s3.3.7 5 .4l-.1 4.9z"
  }));
};

var SvgDocumentPaymentNext = function SvgDocumentPaymentNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$35,
    name: "document-payment-next"
  }, props));
};

var SvgIcon$36 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5h-3v-.5c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V14h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 0h-7c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h7v1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2l-.1.4zm-.1 3.4v2.2c.1.7-.4 1.3-1.1 1.4H8.9s-.1 0-.1-.1V7.2s0-.1.1-.1h1.2c.7 0 1.3.5 1.3 1.2v.1zm-3.1.1c.1.7-.4 1.3-1.1 1.4h-.7v2s0 .1-.1.1h-.7s-.1 0-.1-.1V7.1s0-.1.1-.1H7c.7 0 1.3.6 1.3 1.3v.2zm6.2-.8s0 .1 0 0c-.1.1-.1.1 0 0l-1.6.1v1.4h.9s.1 0 .1.1v.5s0 .1-.1.1h-.9v2s0 .1-.1.1h-.6s-.1 0-.1-.1V7.2s0-.1.1-.1h2.3s.1 0 .1.1l-.1.5zm-8 .1v1.5h.4c.3 0 .6-.3.6-.7s-.3-.9-.6-.9l-.4.1zm3.2 0v3.4h.4c.3 0 .5-.3.5-.7V8.4c0-.4-.2-.7-.5-.7h-.4z"
  }));
};

var SvgDocumentPdf = function SvgDocumentPdf(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$36,
    name: "document-pdf"
  }, props));
};

var SvgIcon$37 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 0H0v16h13V3l-3-3zm2 15H1V1h8v3h3v11zM1.9 13V8.7H3c.3 0 .6 0 .8.1.3 0 .5.2.6.4.1.2.2.5.2.8 0 .3-.1.5-.2.8-.1.2-.2.3-.4.4-.3.1-.6.1-.9.1h-.5V13h-.7zm.7-3.6v1.2H3c.2 0 .4 0 .5-.1.1 0 .2-.1.2-.2.1-.2.1-.5 0-.7 0 0-.1-.1-.2-.1-.2 0-.4-.1-.6-.1h-.3zm2.6-.7h1.3c.3 0 .5 0 .7.1.2.1.3.2.5.4.1.2.2.4.3.7.1.3.1.7.1 1 0 .3 0 .7-.1 1-.1.2-.2.5-.3.7-.1.2-.3.3-.5.4h-2V8.7zm.7.7v2.8h.5c.2 0 .3 0 .5-.1.1 0 .2-.1.3-.2.1-.1.1-.3.2-.4 0-.2.1-.5.1-.7 0-.3 0-.5-.1-.8 0-.2-.1-.3-.2-.4-.2 0-.3-.1-.4-.1h-.6l-.3-.1zM8.7 13V8.7h2.4v.7H9.4v1h1.5v.7H9.4V13h-.7z"
  }));
};

var SvgDocumentPdf$1 = function SvgDocumentPdf(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$37,
    name: "document-pdf"
  }, props));
};

var SvgIcon$38 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5h-3v-.5c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V14h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 0h-7c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h7v1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2l-.1.4zm-.1 3.4v2.2c.1.7-.4 1.3-1.1 1.4H8.9s-.1 0-.1-.1V7.2s0-.1.1-.1h1.2c.7 0 1.3.5 1.3 1.2v.1zm-3.1.1c.1.7-.4 1.3-1.1 1.4h-.7v2s0 .1-.1.1h-.7s-.1 0-.1-.1V7.1s0-.1.1-.1H7c.7 0 1.3.6 1.3 1.3v.2zm6.2-.8s0 .1 0 0c-.1.1-.1.1 0 0l-1.6.1v1.4h.9s.1 0 .1.1v.5s0 .1-.1.1h-.9v2s0 .1-.1.1h-.6s-.1 0-.1-.1V7.2s0-.1.1-.1h2.3s.1 0 .1.1l-.1.5zm-8 .1v1.5h.4c.3 0 .6-.3.6-.7s-.3-.9-.6-.9l-.4.1zm3.2 0v3.4h.4c.3 0 .5-.3.5-.7V8.4c0-.4-.2-.7-.5-.7h-.4z"
  }));
};

var SvgDocumentPdfNext = function SvgDocumentPdfNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$38,
    name: "document-pdf-next"
  }, props));
};

var SvgIcon$39 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4.5 15H1V1h8v3h3v4h1V3l-3-3H0v16h4.5v-1zm1.6 1l.1-.9.1-.9.8.8.9.7-1 .2-.9.1zm5.2-4.1l-3 3-.3-.3 3-3-.5-.5-3 3-.3-.3 3-3-.3-.3-3.3 3.3 1.6 1.6 3.3-3.3-.2-.2zm0-2.7l-.8.8 1.6 1.6.8-.8-1.6-1.6z"
  }));
};

var SvgDocumentPencil = function SvgDocumentPencil(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$39,
    name: "document-pencil"
  }, props));
};

var SvgIcon$3a = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.4 9H11V7.6c0-.3-.2-.5-.5-.5s-.5.3-.5.5V9H8.6c-.3 0-.5.2-.5.5s.2.5.5.5H10v1.4c0 .3.2.5.5.5s.5-.2.5-.5V10h1.4c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm.1-4.1v-.4c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1.4C15 13 16.2 10 15.1 7.5c-.5-1.1-1.4-2.1-2.6-2.6zm-1 10.1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2v.1c-.3-.1-.7-.1-1-.1-.8-.1-1.6.1-2.2.4H3c-.3 0-.5.2-.5.5s.2.5.5.5h3.9c-.3.3-.5.6-.7 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.8c-.1.3-.2.7-.2 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.6c.3 2.6 2.4 4.5 5 4.5.3 0 .7 0 1-.1l-.1.6zm-1-1.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }));
};

var SvgDocumentPlus = function SvgDocumentPlus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3a,
    name: "document-plus"
  }, props));
};

var SvgIcon$3b = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13 13H6v-1h7v1zm-4 3V9h1v7H9zm-3.5-1H1V1h8v3h3v4h1V3l-3-3H0v16h5.5v-1z"
  }));
};

var SvgDocumentPlus$1 = function SvgDocumentPlus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3b,
    name: "document-plus"
  }, props));
};

var SvgIcon$3c = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.4 9H11V7.6c0-.3-.2-.5-.5-.5s-.5.3-.5.5V9H8.6c-.3 0-.5.2-.5.5s.2.5.5.5H10v1.4c0 .3.2.5.5.5s.5-.2.5-.5V10h1.4c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm.1-4.1v-.4c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1.4C15 13 16.2 10 15.1 7.5c-.5-1.1-1.4-2.1-2.6-2.6zm-1 10.1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2v.1c-.3-.1-.7-.1-1-.1-.8-.1-1.6.1-2.2.4H3c-.3 0-.5.2-.5.5s.2.5.5.5h3.9c-.3.3-.5.6-.7 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.8c-.1.3-.2.7-.2 1H3c-.3 0-.5.2-.5.5s.2.5.5.5h2.6c.3 2.6 2.4 4.5 5 4.5.3 0 .7 0 1-.1l-.1.6zm-1-1.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }));
};

var SvgDocumentPlusNext = function SvgDocumentPlusNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3c,
    name: "document-plus-next"
  }, props));
};

var SvgIcon$3d = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    version: 1.2,
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16.5 6h-3v-.5c0-.3-.1-.6-.4-.9L9.9 1.4C9.6 1.1 9.3 1 9 1H2c-.3 0-.5.2-.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V15h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 0h-7c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h7v1h-10V2H9s.1 0 .1.1l3.3 3.3s.1.1.1.2V6zm-1.6 2.5c.2.3.3.6.3 1s-.1.7-.3 1c-.2.2-.5.4-.9.4h-.6v2s0 .1-.1.1h-.5s-.1 0-.1-.1V8.2s0-.1.1-.1H10c.4 0 .6.1.9.4zm-.5 1.6c.1-.1.1-.3.1-.6s-.1-.5-.2-.6c-.1-.1-.2-.2-.4-.2h-.5v1.6h.5c.2 0 .3 0 .5-.2zm1.7 2.6c-.2-.2-.3-.5-.3-.9V9.3c0-.4.1-.7.3-.9.2-.2.5-.4.9-.4s.7.1.9.4.3.5.3.9v2.4c0 .4-.1.7-.3.9s-.5.4-.9.4-.7-.1-.9-.3zm1.3-.4c.1-.1.2-.3.2-.5V9.3c0-.2-.1-.4-.2-.5-.1-.1-.3-.2-.4-.2-.2 0-.3.1-.4.2s-.2.3-.2.5v2.5c0 .2.1.4.2.5.1.1.3.2.4.2.2-.1.3-.1.4-.2z"
  }));
};

var SvgDocumentPo = function SvgDocumentPo(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3d,
    name: "document-po"
  }, props));
};

var SvgIcon$3e = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    version: 1.2,
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16.5 6h-3v-.5c0-.3-.1-.6-.4-.9L9.9 1.4C9.6 1.1 9.3 1 9 1H2c-.3 0-.5.2-.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V15h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 0h-7c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h7v1h-10V2H9s.1 0 .1.1l3.3 3.3s.1.1.1.2V6zm-1.6 2.5c.2.3.3.6.3 1s-.1.7-.3 1c-.2.2-.5.4-.9.4h-.6v2s0 .1-.1.1h-.5s-.1 0-.1-.1V8.2s0-.1.1-.1H10c.4 0 .6.1.9.4zm-.5 1.6c.1-.1.1-.3.1-.6s-.1-.5-.2-.6c-.1-.1-.2-.2-.4-.2h-.5v1.6h.5c.2 0 .3 0 .5-.2zm1.7 2.6c-.2-.2-.3-.5-.3-.9V9.3c0-.4.1-.7.3-.9.2-.2.5-.4.9-.4s.7.1.9.4.3.5.3.9v2.4c0 .4-.1.7-.3.9s-.5.4-.9.4-.7-.1-.9-.3zm1.3-.4c.1-.1.2-.3.2-.5V9.3c0-.2-.1-.4-.2-.5-.1-.1-.3-.2-.4-.2-.2 0-.3.1-.4.2s-.2.3-.2.5v2.5c0 .2.1.4.2.5.1.1.3.2.4.2.2-.1.3-.1.4-.2z"
  }));
};

var SvgDocumentPoNext = function SvgDocumentPoNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3e,
    name: "document-po-next"
  }, props));
};

var SvgIcon$3f = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13.2 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.6 16H0V0h10l3 3v5h-1V4H9V1H1v14h6.6v1zm4.2-2.7c.1-.2.3-.4.5-.6.3-.3.5-.6.7-.9.1-.2.2-.5.2-.8.1-1.1-.8-2-1.8-2h-.2c-.6 0-1.2.2-1.6.6-.4.5-.6 1.1-.6 1.7l1.5.2c0-.3.1-.6.2-.8.1-.1.3-.2.4-.2.1 0 .3 0 .4.1.1.1.1.3.1.4 0 .2-.1.4-.3.6-.3.3-.5.5-.7.8-.1.2-.2.3-.2.5-.1.2-.1.5-.1.8v.2h1.4c-.1-.2 0-.4.1-.6zM10.3 16h1.4v-1.4h-1.4V16z"
  }));
};

var SvgDocumentQuestion = function SvgDocumentQuestion(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3f,
    name: "document-question"
  }, props));
};

var SvgIcon$3g = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5 15H1V1h8v3h3v4c.4.3.7.6 1 1V3l-3-3H0v16h6c-.3-.3-.7-.6-1-1zm4 1c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.7 4-4 4zm0-7c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm-2.7 5.1l4.9-4.9.8.7-5 5-.7-.8z"
  }));
};

var SvgDocumentSlash = function SvgDocumentSlash(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3g,
    name: "document-slash"
  }, props));
};

var SvgIcon$3h = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5h-3v-.5c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V14h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 0h-7c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h7v1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2l-.1.4zm-1.7 6.3h1.5s.1 0 .1.1v.5s0 .1-.1.1H9s-.1 0-.1-.1V7.2s0-.1.1-.1h.6s.1 0 .1.1l.1 4.1zm-1.5.6c.1 0 0 0 0 0v.1h-.7s-.1 0-.1-.1L7 10.4l-.6 1.5-.1.1h-.7c-.1 0-.1-.1-.1-.1l1-2.3-1-2.3c0-.1 0-.1.1-.1h.7s.1 0 .1.1L7 8.8l.6-1.5s0-.1.1-.1h.7c.1 0 .1 0 .1.1l-1 2.3.8 2.3zm4.7.1c-.7 0-1.2-.5-1.3-1.2v-.3s0-.1.1-.1h.6s.1 0 .1.1v.1c0 .4.2.6.5.6s.5-.2.5-.5v-.1c0-.4-.2-.6-.7-.9s-1.1-.8-1.1-1.5.4-1.2 1.1-1.3h.2c.7 0 1.3.5 1.3 1.2v.4s0 .1-.1.1h-.6s-.1 0-.1-.1v-.2c0-.3-.2-.6-.5-.6s-.5.2-.5.6c0 .4.2.5.7.9.7.5 1.1.8 1.1 1.5s-.5 1.3-1.2 1.3H13z"
  }));
};

var SvgDocumentXls = function SvgDocumentXls(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3h,
    name: "document-xls"
  }, props));
};

var SvgIcon$3i = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 0H0v16h13V3l-3-3zm2 15H1V1h8v3h3v11zM1.7 13L3 10.8 1.9 8.7h.8l.7 1.3.7-1.3h.8l-1.1 2.1L5 13h-.8l-.8-1.5-.8 1.5h-.9zm6.8-1.4l.7-.1c.1.5.3.8.8.8.2 0 .4 0 .5-.2.1-.1.2-.3.2-.4 0-.1 0-.2-.1-.2 0-.1-.1-.1-.2-.2-.2-.1-.4-.2-.6-.2-.2-.1-.5-.2-.7-.3-.1-.1-.3-.3-.3-.4-.1-.2-.1-.4-.1-.6 0-.2.1-.4.2-.6 0-.2.2-.3.4-.4.2-.1.4-.2.7-.2.7-.1 1.3.4 1.3 1.1v.2h-.7c0-.2-.1-.4-.2-.5-.1-.1-.3-.1-.4-.1-.2 0-.3 0-.4.1-.2.1-.3.2-.3.4 0 .1 0 .2.1.3l.6.3c.3.1.5.2.8.3.2.1.3.3.4.4.1.2.1.4.1.7 0 .3-.1.7-.3.9-.3.3-.7.4-1.1.4-.8 0-1.3-.5-1.4-1.5zM5.7 13V8.7h.7v3.5h1.8v.8H5.7z"
  }));
};

var SvgDocumentXls$1 = function SvgDocumentXls(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3i,
    name: "document-xls"
  }, props));
};

var SvgIcon$3j = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5h-3v-.5c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V14h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 0h-7c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h7v1h-10V1H8l.2.1 3.3 3.3s.1.1.1.2l-.1.4zm-1.7 6.3h1.5s.1 0 .1.1v.5s0 .1-.1.1H9s-.1 0-.1-.1V7.2s0-.1.1-.1h.6s.1 0 .1.1l.1 4.1zm-1.5.6c.1 0 0 0 0 0v.1h-.7s-.1 0-.1-.1L7 10.4l-.6 1.5-.1.1h-.7c-.1 0-.1-.1-.1-.1l1-2.3-1-2.3c0-.1 0-.1.1-.1h.7s.1 0 .1.1L7 8.8l.6-1.5s0-.1.1-.1h.7c.1 0 .1 0 .1.1l-1 2.3.8 2.3zm4.7.1c-.7 0-1.2-.5-1.3-1.2v-.3s0-.1.1-.1h.6s.1 0 .1.1v.1c0 .4.2.6.5.6s.5-.2.5-.5v-.1c0-.4-.2-.6-.7-.9s-1.1-.8-1.1-1.5.4-1.2 1.1-1.3h.2c.7 0 1.3.5 1.3 1.2v.4s0 .1-.1.1h-.6s-.1 0-.1-.1v-.2c0-.3-.2-.6-.5-.6s-.5.2-.5.6c0 .4.2.5.7.9.7.5 1.1.8 1.1 1.5s-.5 1.3-1.2 1.3H13z"
  }));
};

var SvgDocumentXlsNext = function SvgDocumentXlsNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3j,
    name: "document-xls-next"
  }, props));
};

var SvgIcon$3k = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5h-3v-.5c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V14h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 10h-10V1H8l.2.1 3.3 3.3s.1.1.1.2V5h-7c-.4 0-.6.2-.6.5v8c0 .3.2.5.5.5h7v1zM8 11.9s0 .1-.1.1h-.6s-.1 0-.1-.1l-.6-1.5-.6 1.5-.1.1h-.6s-.1 0-.1-.1l1-2.3-1-2.3c0-.1 0-.1.1-.1h.8l.6 1.5.6-1.5s0-.1.1-.1h.7c.1 0 .1 0 .1.1L7 9.5l1 2.4zm3.6 0s0 .1 0 0l-.7.1s-.1 0-.1-.1v-3l-.6 1.2s0 .1-.1.1 0 0-.1-.1l-.6-1.3V12h-.8s-.1 0-.1-.1V7.2s0-.1.1-.1h.6s.1 0 .1.1l.7 1.5.7-1.5.1-.1h.6s.1 0 .1.1l.1 4.7zm3.2 0s0 .1 0 0c-.1.1-.1.1 0 0l-2.4.1s-.1 0-.1-.1V7.2s0-.1.1-.1h.6s.1 0 .1.1v4.1h1.5s.1 0 .1.1l.1.5z"
  }));
};

var SvgDocumentXml = function SvgDocumentXml(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3k,
    name: "document-xml"
  }, props));
};

var SvgIcon$3l = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10 0H0v16h13V3l-3-3zm2 15H1V1h8v3h3v11zM1.5 13l1.2-2.2-1.1-2.1h.8l.8 1.3.7-1.3h.8l-1.1 2.1L4.8 13h-.9l-.8-1.5-.7 1.5h-.9zm3.6 0V8.7h1.1l.6 2.9.6-2.9h1.1V13h-.6V9.6L7.2 13h-.7l-.7-3.4V13h-.7zm4.2 0V8.7h.7v3.5h1.8v.8H9.3z"
  }));
};

var SvgDocumentXml$1 = function SvgDocumentXml(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3l,
    name: "document-xml"
  }, props));
};

var SvgIcon$3m = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5h-3v-.5c0-.3-.1-.6-.4-.8L8.9.3C8.6.1 8.3 0 8 0H1C.7 0 .5.2.5.5v15c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V14h3c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-4 10h-10V1H8l.2.1 3.3 3.3s.1.1.1.2V5h-7c-.4 0-.6.2-.6.5v8c0 .3.2.5.5.5h7v1zM8 11.9s0 .1-.1.1h-.6s-.1 0-.1-.1l-.6-1.5-.6 1.5-.1.1h-.6s-.1 0-.1-.1l1-2.3-1-2.3c0-.1 0-.1.1-.1h.8l.6 1.5.6-1.5s0-.1.1-.1h.7c.1 0 .1 0 .1.1L7 9.5l1 2.4zm3.6 0s0 .1 0 0l-.7.1s-.1 0-.1-.1v-3l-.6 1.2s0 .1-.1.1 0 0-.1-.1l-.6-1.3V12h-.8s-.1 0-.1-.1V7.2s0-.1.1-.1h.6s.1 0 .1.1l.7 1.5.7-1.5.1-.1h.6s.1 0 .1.1l.1 4.7zm3.2 0s0 .1 0 0c-.1.1-.1.1 0 0l-2.4.1s-.1 0-.1-.1V7.2s0-.1.1-.1h.6s.1 0 .1.1v4.1h1.5s.1 0 .1.1l.1.5z"
  }));
};

var SvgDocumentXmlNext = function SvgDocumentXmlNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3m,
    name: "document-xml-next"
  }, props));
};

var SvgIcon$3n = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.3 9.8H7.2c-.3 0-.5.2-.5.5s.2.5.5.5h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm0-1.7H7.2c-.3 0-.5.2-.5.5s.2.5.5.5h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm1.9-3l-2.8-2.8c-.3-.2-.6-.3-.9-.3h-2L7.8.3C7.6.1 7.3 0 7 0H1C.7 0 .5.2.5.5v13c0 .3.2.5.5.5h4v1.5c0 .3.2.5.5.5H15c.3 0 .5-.2.5-.5V6c0-.3-.1-.6-.3-.9zM5 2.5v1.8H2.7c-.3 0-.5.2-.5.5s.2.5.5.5H5v.8H2.7c-.3 0-.5.2-.5.5s.2.5.5.5H5v.8H2.7c-.3-.1-.5.1-.5.4 0 .3.2.5.5.5H5V13H1.5V1H7l.2.1.9.9H5.5c-.3 0-.5.2-.5.5zM14.5 15H6V3h5.5l.2.1 2.8 2.8s.1.1.1.2V15zm-1.2-8.7H7.2c-.3 0-.5.2-.5.5s.2.5.5.5h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgDocuments = function SvgDocuments(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3n,
    name: "documents"
  }, props));
};

var SvgIcon$3o = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 0H3v3H0v13h11v-3h3V3l-3-3zm-1 15H1V4h2v9h7v2zm3-3H4V1h6v3h3v8z"
  }));
};

var SvgDocuments$1 = function SvgDocuments(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3o,
    name: "documents"
  }, props));
};

var SvgIcon$3p = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.3 9.8H7.2c-.3 0-.5.2-.5.5s.2.5.5.5h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm0-1.7H7.2c-.3 0-.5.2-.5.5s.2.5.5.5h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm1.9-3l-2.8-2.8c-.3-.2-.6-.3-.9-.3h-2L7.8.3C7.6.1 7.3 0 7 0H1C.7 0 .5.2.5.5v13c0 .3.2.5.5.5h4v1.5c0 .3.2.5.5.5H15c.3 0 .5-.2.5-.5V6c0-.3-.1-.6-.3-.9zM5 2.5v1.8H2.7c-.3 0-.5.2-.5.5s.2.5.5.5H5v.8H2.7c-.3 0-.5.2-.5.5s.2.5.5.5H5v.8H2.7c-.3-.1-.5.1-.5.4 0 .3.2.5.5.5H5V13H1.5V1H7l.2.1.9.9H5.5c-.3 0-.5.2-.5.5zM14.5 15H6V3h5.5l.2.1 2.8 2.8s.1.1.1.2V15zm-1.2-8.7H7.2c-.3 0-.5.2-.5.5s.2.5.5.5h6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgDocumentsNext = function SvgDocumentsNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3p,
    name: "documents-next"
  }, props));
};

var SvgIcon$3q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M.5 1.1v11H11v1H0V0h11.1v2h-1V1H.5zM5.4 16L.3 12.8V.3l5.1 3.2V16zm2-12.6h1v5.3l6-6 .6.6-6 6.1h5.3v1h-7l.1-7z"
  }));
};

var SvgDoorArrowIn = function SvgDoorArrowIn(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3q,
    name: "door-arrow-in"
  }, props));
};

var SvgIcon$3r = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M.5 1.1v11H10v-2h1v3H0V0h11.1v1.1H.5zM5.4 16L.3 12.8V.3l5.1 3.2V16zM15 9.7h-1V4.4l-6 6-.6-.6 6-6.1H8v-1h7v7z"
  }));
};

var SvgDoorArrowOut = function SvgDoorArrowOut(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3r,
    name: "door-arrow-out"
  }, props));
};

var SvgIcon$3s = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.2 15c-4 0-7.3-3.3-7.3-7.3C.9 4.8 2.6 2.2 5.3 1c.2 0 .4 0 .5.1.2.1.2.3.2.5-.2.8-.4 1.6-.4 2.4 0 3.5 2.8 6.3 6.3 6.3.8 0 1.6-.2 2.4-.5.2-.1.4 0 .5.1.1.1.2.4.1.5-1.1 2.8-3.8 4.6-6.7 4.6zM4.8 2.4C3 3.6 1.9 5.5 1.9 7.7c0 3.5 2.8 6.3 6.3 6.3 2.2 0 4.1-1.1 5.3-2.9-.5.1-1.1.2-1.6.2-4.1 0-7.3-3.2-7.3-7.3 0-.6.1-1.1.2-1.6zm8.9 3.7c0-.3-.2-.5-.5-.5h-2l2.4-3.2c.1-.2.1-.4 0-.5s-.3-.3-.4-.3h-3c-.3 0-.5.2-.5.5s.2.5.5.5h2L9.8 5.8c-.1.2-.1.4 0 .5s.3.3.4.3h3c.3 0 .5-.2.5-.5z"
  }));
};

var SvgDormant = function SvgDormant(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3s,
    name: "dormant"
  }, props));
};

var SvgIcon$3t = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 7c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM3 7c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm10 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
  }));
};

var SvgDotDotDot = function SvgDotDotDot(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3t,
    name: "dot-dot-dot"
  }, props));
};

var SvgIcon$3u = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM3 9c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm5 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm5 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  }));
};

var SvgDotDotDotCircle = function SvgDotDotDotCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3u,
    name: "dot-dot-dot-circle"
  }, props));
};

var SvgIcon$3v = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 7c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM3 7c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm10 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
  }));
};

var SvgDotDotDotNext = function SvgDotDotDotNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3v,
    name: "dot-dot-dot-next"
  }, props));
};

var SvgIcon$3w = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 10 10"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 9a1.001 1.001 0 01-2 0 1.001 1.001 0 012 0zm4 0a1.001 1.001 0 01-2 0 1.001 1.001 0 012 0zm0-4a1.001 1.001 0 01-2 0 1.001 1.001 0 012 0zm4 4a1.001 1.001 0 01-2 0 1.001 1.001 0 012 0zm0-4a1.001 1.001 0 01-2 0 1.001 1.001 0 012 0zm0-4a1.001 1.001 0 01-2 0 1.001 1.001 0 012 0z",
    fillRule: "evenodd"
  }));
};

var SvgDrag = function SvgDrag(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3w,
    name: "drag"
  }, props));
};

var SvgIcon$3x = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.9 5H12v1h1.2l1.3 3H11c0 1.7-1.3 3-3 3s-3-1.3-3-3H1.5l1.3-3H4V5H2.1L0 10v6h16v-6l-2.1-5zM4.4 6.5l.7-.7 2.4 2.3.1-8.1h.9v8.2l2.4-2.4.7.7L8.1 10 4.4 6.5z"
  }));
};

var SvgDrawerArrowDown = function SvgDrawerArrowDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3x,
    name: "drawer-arrow-down"
  }, props));
};

var SvgIcon$3y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.9 5H11v1h2.2l1.3 3H11c0 1.7-1.3 3-3 3s-3-1.3-3-3H1.5l1.3-3H5V5H2.1L0 10v6h16v-6l-2.1-5zm-2.3-1.5l-.7.7-2.4-2.3V10h-1V1.8L5.2 4.2l-.7-.7L8 0l3.6 3.5z"
  }));
};

var SvgDrawerArrowUp = function SvgDrawerArrowUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3y,
    name: "drawer-arrow-up"
  }, props));
};

var SvgIcon$3z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 11"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.9 0H2.1L0 5v6h16V5l-2.1-5zM11 4c0 1.7-1.3 3-3 3S5 5.7 5 4H1.5l1.3-3h10.4l1.3 3H11z"
  }));
};

var SvgDrawer = function SvgDrawer(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3z,
    name: "drawer"
  }, props));
};

var SvgIcon$3A = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 2.5H.5c-.3 0-.5.2-.5.5v10c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5V3c0-.3-.2-.5-.5-.5zm-1.3 1L8.1 8.8H8L1.8 3.5h12.4zm.8 9H1V4.2l6.3 5.4c.4.3 1 .3 1.4 0L15 4.2v8.3z"
  }));
};

var SvgEnvelope = function SvgEnvelope(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3A,
    name: "envelope"
  }, props));
};

var SvgIcon$3B = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.8 14.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 14.8L10.5 11l5.3-3.8v7.6zM0 7.1v7.7L5.3 11 0 7.1zm6.2 4.4l-4.6 3.3h12.7l-4.6-3.3H6.2zm7.2-2V4h-3V1h-8v7.8l-1-.7V0h10l3 3v6.5h-1z"
  }));
};

var SvgEnvelopeDocument = function SvgEnvelopeDocument(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3B,
    name: "envelope-document"
  }, props));
};

var SvgIcon$3C = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.8 7.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 7.8L10.5 4 15.8.2v7.6zM0 .1v7.7L5.3 4 0 .1zm6.2 4.4L1.5 7.9h12.7L9.6 4.5 7.9 5.8 6.2 4.5zm8-4.5H1.6l6.3 4.6L14.2 0z"
  }));
};

var SvgEnvelope$1 = function SvgEnvelope(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3C,
    name: "envelope"
  }, props));
};

var SvgIcon$3D = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 2.5H.5c-.3 0-.5.2-.5.5v10c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5V3c0-.3-.2-.5-.5-.5zm-1.3 1L8.1 8.8H8L1.8 3.5h12.4zm.8 9H1V4.2l6.3 5.4c.4.3 1 .3 1.4 0L15 4.2v8.3z"
  }));
};

var SvgEnvelopeNext = function SvgEnvelopeNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3D,
    name: "envelope-next"
  }, props));
};

var SvgIcon$3E = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.8 13.4"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 5.6v7.7l-5.3-3.8 4.4-3.2m-8.7 3.8l-4.6 3.3h12.7l-4.6-3.3H6.2zM0 5.6L7.9 0l7.9 5.6-.6.8-.3-.2-7-5-7 5H1l4.4 3.1-5.4 4"
  }));
};

var SvgEnvelopeOpen = function SvgEnvelopeOpen(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3E,
    name: "envelope-open"
  }, props));
};

var SvgIcon$3F = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#039",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    d: "M12 12.428l.193.601h.629l-.51.37.196.601-.509-.372-.507.372.194-.602-.508-.37.628.001.194-.601zm-2.587-.694l.194.597.631-.001-.513.369.192.593.002.004.001.004-.01-.01-.499-.363-.511.372.197-.6-.511-.366.633-.002.194-.597zm5.174 0l.194.597.633.002-.51.367.196.599-.511-.372-.51.37.195-.598-.512-.37.631.002.194-.597zm-7.07-1.909l.194.598.632-.002-.513.37.192.592.004.006-.002-.002v.005l-.01-.01-.498-.364-.511.372.196-.599-.51-.367.632-.001.195-.598zm8.965 0l.195.598.632.001-.51.367.196.6-.51-.373-.51.37.194-.597-.512-.37.632.002.193-.598zm.696-2.611l.194.601H18l-.508.369.194.602-.507-.372-.509.372.196-.601-.51-.37h.629l.193-.601zm-10.356 0l.193.601h.629l-.51.369.196.602-.509-.372-.507.372.194-.602L6 7.814l.628.001.194-.601zm.692-2.605l.197.6.628.001-.509.369.197.6-.51-.373-.508.37.194-.599-.511-.371.63.002.192-.6zm8.972 0l.192.599.63-.002-.511.371.194.6-.508-.37-.51.372.197-.6-.509-.369h.628l.197-.601zM9.413 2.7l.193.6.629-.003-.511.373.194.598-.508-.37-.51.373.197-.6-.51-.37h.63l.196-.6zm5.174 0l.195.602h.63l-.509.369.197.6-.51-.373-.508.37.194-.598-.51-.373.628.003.193-.6zM12 2l.193.601h.629l-.51.37.196.601-.509-.372-.507.372.194-.602-.508-.37.628.001L12 2z",
    fill: "#FC0"
  })));
};

var SvgEurope = function SvgEurope(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3F,
    name: "europe"
  }, props));
};

var SvgIcon$3G = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 9.5c.3 0 .5-.2.5-.5V3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v6c0 .3.2.5.5.5zM8 11c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3G,
    name: "exclamation-circle"
  }, props));
};

var SvgIcon$3H = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.3 13.4c-3.1-3.1-3.1-8.1 0-11.1s8.1-3.1 11.1 0 3.1 8.1 0 11.1c-3 3.1-8 3.1-11.1 0zM12.7 3C10 .3 5.7.3 3 3s-2.7 7 0 9.7 7 2.7 9.7 0c2.7-2.7 2.7-7 0-9.7zM6.8 9.8v-7h2v7h-2zm0 3.1v-2h2v2h-2z"
  }));
};

var SvgExclamationCircle$1 = function SvgExclamationCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3H,
    name: "exclamation-circle"
  }, props));
};

var SvgIcon$3I = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 9.5c.3 0 .5-.2.5-.5V3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v6c0 .3.2.5.5.5zM8 11c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgExclamationCircleNext = function SvgExclamationCircleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3I,
    name: "exclamation-circle-next"
  }, props));
};

var SvgIcon$3J = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.4 2.3C10.3-.8 5.3-.8 2.3 2.3s-3.1 8.1 0 11.1c3.1 3.1 8.1 3.1 11.1 0 3.1-3 3.1-8 0-11.1zM8.8 12.9h-2v-2h2v2zm0-3.1h-2v-7h2v7z"
  }));
};

var SvgExclamationCircleSolid = function SvgExclamationCircleSolid(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3J,
    name: "exclamation-circle-solid"
  }, props));
};

var SvgIcon$3K = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 14.4l-7.5-13c0-.1-.2-.2-.3-.2-.1 0-.2.1-.2.2l-7.5 13c-.1.2 0 .4.2.4h15c.3 0 .4-.2.3-.4zm-14-.6L8 2.9l6.3 10.9H1.8zm5.7-7.9v4c0 .3.2.5.5.5s.5-.2.5-.5v-4c0-.3-.2-.5-.5-.5s-.5.2-.5.5zm-.5 6c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1z"
  }));
};

var SvgExclamationTriangle = function SvgExclamationTriangle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3K,
    name: "exclamation-triangle"
  }, props));
};

var SvgIcon$3L = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 14.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 14.7H0L8.1 0 16 14.7zm-14.3-1h12.6L8.1 2 1.7 13.7zM8.5 12H7.4v-1.1h1.1V12zm.1-2.1H7.5V5.8h1.1v4.1z"
  }));
};

var SvgExclamationTriangle$1 = function SvgExclamationTriangle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3L,
    name: "exclamation-triangle"
  }, props));
};

var SvgIcon$3M = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 14.4l-7.5-13c0-.1-.2-.2-.3-.2-.1 0-.2.1-.2.2l-7.5 13c-.1.2 0 .4.2.4h15c.3 0 .4-.2.3-.4zm-14-.6L8 2.9l6.3 10.9H1.8zm5.7-7.9v4c0 .3.2.5.5.5s.5-.2.5-.5v-4c0-.3-.2-.5-.5-.5s-.5.2-.5.5zm-.5 6c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1z"
  }));
};

var SvgExclamationTriangleNext = function SvgExclamationTriangleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3M,
    name: "exclamation-triangle-next"
  }, props));
};

var SvgIcon$3N = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.8 14.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0L0 14.8h15.8L8 0zm1 12.2H7v-2h2v2zm-.1-3h-2v-5h2v5z"
  }));
};

var SvgExclamationTriangleSolid = function SvgExclamationTriangleSolid(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3N,
    name: "exclamation-triangle-solid"
  }, props));
};

var SvgIcon$3O = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M1.872 10.149l6.126 4.878 6.126-4.878a.526.526 0 01.72-.012.471.471 0 01.013.688l-.013.012-6.125 4.878c-.399.38-1.044.38-1.442 0l-6.125-4.878a.47.47 0 01-.005-.687.531.531 0 01.725-.001zm0-4.298L7.998.973l6.126 4.878a.526.526 0 00.72.012.471.471 0 000-.7L8.72.285a1.054 1.054 0 00-1.442 0L1.152 5.163a.47.47 0 00-.005.687.531.531 0 00.725.001z"
  }));
};

var SvgExpandAll = function SvgExpandAll(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3O,
    name: "expand-all"
  }, props));
};

var SvgIcon$3P = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.9 6.9c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.5-1-1-1zm8 .8c-.4-.5-.8-1-1.1-1.4-1.1-1.3-2.5-2.4-4-3.1-1.9-1-4.1-.9-5.9.2-2 1-3.6 2.5-4.8 4.3-.1.2-.1.4 0 .6 1.1 1.5 2.4 2.8 3.9 3.9 1.2.8 2.6 1.3 4 1.3 1.1 0 2.2-.3 3.1-.9 1.9-1.1 3.5-2.6 4.8-4.3.1-.2.1-.4 0-.6zm-5.2 4.1c-.8.5-1.7.7-2.7.7-1.2 0-2.4-.4-3.4-1.2-1.3-.9-2.5-2-3.4-3.3 1.1-1.6 2.6-2.8 4.2-3.8 1.5-.9 3.4-.9 5-.2 1.3.8 2.6 1.7 3.6 2.9.3.3.6.7.9 1.1-1.1 1.5-2.6 2.8-4.2 3.8zM7.9 4.4c-2 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zm0 6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
  }));
};

var SvgEye = function SvgEye(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3P,
    name: "eye"
  }, props));
};

var SvgIcon$3Q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 9.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 4.6v.5c3.4 5.8 9.8 6.6 14 0v-.5C10.5-1.1 4.1-2 0 4.6zm7 3.6c-1.8 0-3.2-1.5-3.2-3.3 0-1.8 1.4-3.3 3.2-3.3 1.8 0 3.3 1.4 3.3 3.2v.1C10.2 6.7 8.8 8.2 7 8.2zm1.6-3.3c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.7.9.1 1.6.8 1.6 1.7z"
  }));
};

var SvgEye$1 = function SvgEye(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3Q,
    name: "eye"
  }, props));
};

var SvgIcon$3R = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.9 8.3c.1-.2.1-.4 0-.6-.4-.5-.8-1-1.1-1.4-.7-.8-1.4-1.5-2.2-2.1l1.9-1.9c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-2 2c-.3-.2-.6-.3-.9-.5-1.9-1-4.1-.9-5.9.2-.3.1-.5.3-.6.4l-2-2c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l1.8 1.9C2.2 5.2 1 6.4.1 7.7c-.1.2-.1.4 0 .6.9 1.3 2.1 2.5 3.4 3.5l-1.9 1.9c-.2.2-.2.5 0 .7.2.2.5.2.7 0l2-2c1.1.7 2.4 1.1 3.7 1.2 1.1 0 2.2-.3 3.1-.9l.5-.3 2 2c.2.2.5.2.7 0 .2-.2.2-.5 0-.7l-1.8-1.8c1.3-1.1 2.5-2.3 3.4-3.6zM5.3 4.2c1.5-.9 3.4-.9 5-.2l.6.3-.8.8c-1.2-1-3-1.1-4.3-.1l-.7-.6c.1-.1.2-.1.2-.2zm1.6 3.4c0 .1-.1.2-.1.3 0 .1.1.3.1.4l-1 1.1c-.7-.8-.7-2-.1-2.9l1.1 1.1zm-.4-1.8c.9-.6 2-.5 2.8.1L8.3 7c-.1-.1-.3-.1-.4-.1h-.2L6.5 5.8zm1.3 3.1c.2 0 .3 0 .4-.1L9.3 10c-.8.5-1.8.6-2.7.1l1.2-1.2zm1-.8v-.3L10 6.7c.5.8.5 1.8 0 2.6L8.8 8.1zm-4.6 3C3 10.2 2 9.2 1.1 8 2 6.8 3 5.8 4.2 4.9l.9.9c-1 1.3-1 3.1.1 4.3l-1 1zm6.5.7c-.8.4-1.7.7-2.7.7-1 0-2-.3-2.9-.9l.8-.8c1.2.9 2.9.8 4.1-.1l.9.9-.2.2zm1.1-.7L10.7 10c.9-1.2.9-2.8.1-4l1-1c.8.6 1.6 1.2 2.2 2 .3.3.6.7.9 1.1-.9 1.1-1.9 2.1-3.1 3z"
  }));
};

var SvgEyeLine = function SvgEyeLine(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3R,
    name: "eye-line"
  }, props));
};

var SvgIcon$3S = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 12.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M1.3 12.7L.6 12l12-12 .7.7-12 12zm10.6-9.2L10 5.4c.1.3.1.6.1.9 0 1.8-1.4 3.3-3.2 3.3-.3 0-.7-.1-1-.2l-1.4 1.4c3.1 1.2 6.7 0 9.3-4.2v-.5c-.4-1-1.1-1.8-1.9-2.6zM3.8 6.3C3.8 4.5 5.2 3.1 7 3c.3 0 .7.1 1 .2l1.3-1.3C6.2.7 2.6 1.8 0 6.1v.5c.6 1 1.2 1.8 2 2.6l1.9-1.9c-.1-.3-.1-.6-.1-1z"
  }));
};

var SvgEyeLine$1 = function SvgEyeLine(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3S,
    name: "eye-line"
  }, props));
};

var SvgIcon$3T = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.9 8.3c.1-.2.1-.4 0-.6-.4-.5-.8-1-1.1-1.4-.7-.8-1.4-1.5-2.2-2.1l1.9-1.9c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-2 2c-.3-.2-.6-.3-.9-.5-1.9-1-4.1-.9-5.9.2-.3.1-.5.3-.6.4l-2-2c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l1.8 1.9C2.2 5.2 1 6.4.1 7.7c-.1.2-.1.4 0 .6.9 1.3 2.1 2.5 3.4 3.5l-1.9 1.9c-.2.2-.2.5 0 .7.2.2.5.2.7 0l2-2c1.1.7 2.4 1.1 3.7 1.2 1.1 0 2.2-.3 3.1-.9l.5-.3 2 2c.2.2.5.2.7 0 .2-.2.2-.5 0-.7l-1.8-1.8c1.3-1.1 2.5-2.3 3.4-3.6zM5.3 4.2c1.5-.9 3.4-.9 5-.2l.6.3-.8.8c-1.2-1-3-1.1-4.3-.1l-.7-.6c.1-.1.2-.1.2-.2zm1.6 3.4c0 .1-.1.2-.1.3 0 .1.1.3.1.4l-1 1.1c-.7-.8-.7-2-.1-2.9l1.1 1.1zm-.4-1.8c.9-.6 2-.5 2.8.1L8.3 7c-.1-.1-.3-.1-.4-.1h-.2L6.5 5.8zm1.3 3.1c.2 0 .3 0 .4-.1L9.3 10c-.8.5-1.8.6-2.7.1l1.2-1.2zm1-.8v-.3L10 6.7c.5.8.5 1.8 0 2.6L8.8 8.1zm-4.6 3C3 10.2 2 9.2 1.1 8 2 6.8 3 5.8 4.2 4.9l.9.9c-1 1.3-1 3.1.1 4.3l-1 1zm6.5.7c-.8.4-1.7.7-2.7.7-1 0-2-.3-2.9-.9l.8-.8c1.2.9 2.9.8 4.1-.1l.9.9-.2.2zm1.1-.7L10.7 10c.9-1.2.9-2.8.1-4l1-1c.8.6 1.6 1.2 2.2 2 .3.3.6.7.9 1.1-.9 1.1-1.9 2.1-3.1 3z"
  }));
};

var SvgEyeLineNext = function SvgEyeLineNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3T,
    name: "eye-line-next"
  }, props));
};

var SvgIcon$3U = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.9 6.9c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.5-1-1-1zm8 .8c-.4-.5-.8-1-1.1-1.4-1.1-1.3-2.5-2.4-4-3.1-1.9-1-4.1-.9-5.9.2-2 1-3.6 2.5-4.8 4.3-.1.2-.1.4 0 .6 1.1 1.5 2.4 2.8 3.9 3.9 1.2.8 2.6 1.3 4 1.3 1.1 0 2.2-.3 3.1-.9 1.9-1.1 3.5-2.6 4.8-4.3.1-.2.1-.4 0-.6zm-5.2 4.1c-.8.5-1.7.7-2.7.7-1.2 0-2.4-.4-3.4-1.2-1.3-.9-2.5-2-3.4-3.3 1.1-1.6 2.6-2.8 4.2-3.8 1.5-.9 3.4-.9 5-.2 1.3.8 2.6 1.7 3.6 2.9.3.3.6.7.9 1.1-1.1 1.5-2.6 2.8-4.2 3.8zM7.9 4.4c-2 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zm0 6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
  }));
};

var SvgEyeNext = function SvgEyeNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3U,
    name: "eye-next"
  }, props));
};

var SvgIcon$3V = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 89.9 89.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M87.7 63.7a2.22 2.22 0 00-2.2 2.2v9.2a10.29 10.29 0 01-10.3 10.3h-10a2.2 2.2 0 100 4.4h10a14.72 14.72 0 0014.7-14.7v-9.2a2.22 2.22 0 00-2.2-2.2zM75.2 0h-10A2.22 2.22 0 0063 2.2a2.22 2.22 0 002.2 2.2h10a10.29 10.29 0 0110.3 10.3v10.7a2.2 2.2 0 004.4 0V14.7A14.72 14.72 0 0075.2 0zM63.9 43.8a2.84 2.84 0 002.8-2.7v-7.2a2.73 2.73 0 00-2.8-2.8 2.8 2.8 0 00-2.8 2.8V41a2.8 2.8 0 002.8 2.8zm-5.2 19.4a18.88 18.88 0 01-13.3 5.6h-.8a18.7 18.7 0 01-13.3-5.6 2.19 2.19 0 00-3.1 3.1 23 23 0 0016.4 6.9h.8a22.85 22.85 0 0016.4-6.9 2.19 2.19 0 00-3.1-3.1zm-19.2-6.1h.5a8 8 0 008.1-8V33.9a2.2 2.2 0 00-4.4 0V49a3.69 3.69 0 01-3.7 3.7h-.5a2.2 2.2 0 000 4.4zm-14.8-26a2.8 2.8 0 00-2.8 2.8V41a2.8 2.8 0 002.8 2.8 2.71 2.71 0 002.8-2.7v-7.2a2.8 2.8 0 00-2.8-2.8zM2.3 27.6a2.22 2.22 0 002.2-2.2V14.7A10.29 10.29 0 0114.8 4.4h10A2.22 2.22 0 0027 2.2 2.22 2.22 0 0024.8 0h-10A14.72 14.72 0 00.1 14.7v10.7a2.22 2.22 0 002.2 2.2zm22.4 57.8h-10A10.29 10.29 0 014.4 75.1v-9.2a2.22 2.22 0 00-2.2-2.2A2.22 2.22 0 000 65.9v9.2a14.72 14.72 0 0014.7 14.7h10a2.16 2.16 0 002.2-2.2 2.22 2.22 0 00-2.2-2.2z"
  }));
};

var SvgFaceId = function SvgFaceId(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3V,
    name: "face-id"
  }, props));
};

var SvgIcon$3W = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 89.9 89.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M87.7 63.7a2.22 2.22 0 00-2.2 2.2v9.2a10.29 10.29 0 01-10.3 10.3h-10a2.2 2.2 0 100 4.4h10a14.72 14.72 0 0014.7-14.7v-9.2a2.22 2.22 0 00-2.2-2.2zM75.2 0h-10A2.22 2.22 0 0063 2.2a2.22 2.22 0 002.2 2.2h10a10.29 10.29 0 0110.3 10.3v10.7a2.2 2.2 0 004.4 0V14.7A14.72 14.72 0 0075.2 0zM63.9 43.8a2.84 2.84 0 002.8-2.7v-7.2a2.73 2.73 0 00-2.8-2.8 2.8 2.8 0 00-2.8 2.8V41a2.8 2.8 0 002.8 2.8zm-5.2 19.4a18.88 18.88 0 01-13.3 5.6h-.8a18.7 18.7 0 01-13.3-5.6 2.19 2.19 0 00-3.1 3.1 23 23 0 0016.4 6.9h.8a22.85 22.85 0 0016.4-6.9 2.19 2.19 0 00-3.1-3.1zm-19.2-6.1h.5a8 8 0 008.1-8V33.9a2.2 2.2 0 00-4.4 0V49a3.69 3.69 0 01-3.7 3.7h-.5a2.2 2.2 0 000 4.4zm-14.8-26a2.8 2.8 0 00-2.8 2.8V41a2.8 2.8 0 002.8 2.8 2.71 2.71 0 002.8-2.7v-7.2a2.8 2.8 0 00-2.8-2.8zM2.3 27.6a2.22 2.22 0 002.2-2.2V14.7A10.29 10.29 0 0114.8 4.4h10A2.22 2.22 0 0027 2.2 2.22 2.22 0 0024.8 0h-10A14.72 14.72 0 00.1 14.7v10.7a2.22 2.22 0 002.2 2.2zm22.4 57.8h-10A10.29 10.29 0 014.4 75.1v-9.2a2.22 2.22 0 00-2.2-2.2A2.22 2.22 0 000 65.9v9.2a14.72 14.72 0 0014.7 14.7h10a2.16 2.16 0 002.2-2.2 2.22 2.22 0 00-2.2-2.2z"
  }));
};

var SvgFaceId$1 = function SvgFaceId(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3W,
    name: "face-id"
  }, props));
};

var SvgIcon$3X = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.5 10.1V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v9.1c-1.1.3-1.7 1.4-1.4 2.5.2.7.7 1.2 1.4 1.4v1c0 .3.2.5.5.5s.5-.2.5-.5v-1.1c1.1-.3 1.7-1.4 1.4-2.5-.2-.6-.7-1.1-1.4-1.3zM8 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM3.5 3.1V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2.1C1.4 3.4.8 4.5 1.1 5.5c.2.7.7 1.2 1.4 1.4V15c0 .3.2.5.5.5s.5-.2.5-.5V6.9c1.1-.3 1.7-1.4 1.4-2.5-.2-.6-.7-1.1-1.4-1.3zM3 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm10.5.1V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v5.1c-1.1.3-1.7 1.4-1.4 2.5.2.7.7 1.2 1.4 1.4v5c0 .3.2.5.5.5s.5-.2.5-.5V9.9c1.1-.3 1.7-1.4 1.4-2.5-.2-.6-.7-1.1-1.4-1.3zM13 9c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  }));
};

var SvgFilter = function SvgFilter(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3X,
    name: "filter"
  }, props));
};

var SvgIcon$3Y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14 0H0l6.2 8.1V16l2-2V8.1L14 0z"
  }));
};

var SvgFilter$1 = function SvgFilter(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3Y,
    name: "filter"
  }, props));
};

var SvgIcon$3Z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.5 10.1V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v9.1c-1.1.3-1.7 1.4-1.4 2.5.2.7.7 1.2 1.4 1.4v1c0 .3.2.5.5.5s.5-.2.5-.5v-1.1c1.1-.3 1.7-1.4 1.4-2.5-.2-.6-.7-1.1-1.4-1.3zM8 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM3.5 3.1V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2.1C1.4 3.4.8 4.5 1.1 5.5c.2.7.7 1.2 1.4 1.4V15c0 .3.2.5.5.5s.5-.2.5-.5V6.9c1.1-.3 1.7-1.4 1.4-2.5-.2-.6-.7-1.1-1.4-1.3zM3 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm10.5.1V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v5.1c-1.1.3-1.7 1.4-1.4 2.5.2.7.7 1.2 1.4 1.4v5c0 .3.2.5.5.5s.5-.2.5-.5V9.9c1.1-.3 1.7-1.4 1.4-2.5-.2-.6-.7-1.1-1.4-1.3zM13 9c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  }));
};

var SvgFilterNext = function SvgFilterNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3Z,
    name: "filter-next"
  }, props));
};

var SvgIcon$3_ = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 14"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.5 2V0H16v2H5.5zM0 4v2h4.5V4H0zm16 2V4H5.5v2H16zm-3.3 4V8H5.5v2h7.2zM.5 8v2h3.9V8H.5zm.6 4v2h3.4v-2H1.1zm10.5 2v-2H5.5v2h6.1z"
  }));
};

var SvgFilterStacked = function SvgFilterStacked(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$3_,
    name: "filter-stacked"
  }, props));
};

var SvgIcon$40 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M256 4.74c-141.16 0-256 114.84-256 256 0 31.421 5.632 62.116 16.736 91.229a9.486 9.486 0 008.861 6.104 9.458 9.458 0 003.377-.625c4.891-1.866 7.345-7.345 5.479-12.238-10.278-26.947-15.491-55.366-15.491-84.47C18.963 130.036 125.296 23.703 256 23.703S493.037 130.036 493.037 260.74a9.481 9.481 0 009.481 9.481c5.236 0 9.482-4.245 9.482-9.481 0-141.16-114.84-256-256-256z"
  }), React.createElement("path", {
    d: "M256.132 52.147c-56.908 0-115.863 27.535-157.602 73.655-36.968 40.847-55.595 90.375-51.044 135.882l1.053 10.648c7.407 73.761 7.398 73.761-6.509 101.278-.968 1.917-2.002 3.958-3.099 6.148-2.34 4.685-.444 10.38 4.238 12.722a9.428 9.428 0 004.232 1.002 9.484 9.484 0 008.488-5.243c1.081-2.164 2.1-4.181 3.058-6.076 16.405-32.456 16.257-33.942 8.444-111.725l-1.067-10.643c-4.018-40.185 12.819-84.387 46.199-121.269 38.201-42.215 91.97-67.417 143.609-67.417 104.565 0 189.764 85.067 189.764 189.63v47.407c0 5.236 4.245 9.481 9.482 9.481s9.482-4.245 9.482-9.481V260.74c-.001-115.019-93.71-208.593-208.728-208.593z"
  }), React.createElement("path", {
    d: "M315.345 110.832c-18.886-7.484-38.854-11.278-59.345-11.278-43.215 0-83.683 16.551-113.951 46.604-30.459 30.245-47.234 70.937-47.234 114.581 0 24.213 2.231 45.329 4.201 63.958 5.083 48.111 7.884 74.614-28.424 98.82-4.356 2.905-5.535 8.792-2.629 13.148a9.468 9.468 0 007.898 4.222 9.432 9.432 0 005.25-1.592c45.852-30.567 41.84-68.53 36.762-116.588-1.919-18.167-4.095-38.755-4.095-61.968 0-79.75 62.472-142.222 142.222-142.222 18.09 0 35.706 3.345 52.359 9.944 4.863 1.926 10.377-.454 12.308-5.322 1.928-4.867-.454-10.379-5.322-12.307zm101.84 149.542c-.118-51.748-25.315-100.613-67.456-130.782-4.257-3.046-10.18-2.069-13.229 2.192-3.046 4.257-2.067 10.181 2.192 13.229 37.275 26.685 59.53 69.947 59.53 115.727 0 .243.009.486.028.727.093 1.217 9.139 122.623-9.227 196.086a9.484 9.484 0 009.206 11.783 9.486 9.486 0 009.192-7.185c18.79-75.159 10.426-192.935 9.764-201.777z"
  }), React.createElement("path", {
    d: "M362.91 221.716c-16.324-44.713-59.289-74.755-106.91-74.755-62.736 0-113.778 51.039-113.778 113.778 0 .393.025.787.074 1.176.093.745 9.218 75.336.021 139.706-.741 5.183 2.861 9.986 8.047 10.727.454.065.905.097 1.352.097 4.641 0 8.699-3.414 9.375-8.143 9.208-64.458 1.046-136.236.097-144.128.303-52.021 42.72-94.25 94.812-94.25 39.688 0 75.493 25.035 89.095 62.296 1.796 4.919 7.246 7.444 12.16 5.655 4.919-1.795 7.449-7.24 5.655-12.159z"
  }), React.createElement("path", {
    d: "M256.132 194.369c-36.597 0-66.435 29.773-66.435 66.37 0 .37-.014.741.03 1.106.185 1.577 17.963 158.327-26.759 220.938-3.044 4.262-2.065 10.183 2.197 13.227a9.422 9.422 0 005.5 1.766c2.956 0 5.87-1.38 7.72-3.97 47.991-67.187 31.632-221.102 30.211-233.588.28-25.903 21.572-46.887 47.539-46.887 26.141 0 47.539 21.266 47.539 47.407v66.37a9.482 9.482 0 0018.964 0v-66.37c-.001-36.596-29.909-66.369-66.506-66.369zm199.863 136.769c-5.16-.456-9.817 3.401-10.271 8.618l-5.785 66.118a9.477 9.477 0 009.456 10.308c4.861 0 9.002-3.72 9.433-8.655l5.785-66.118c.459-5.218-3.4-9.815-8.618-10.271zM147.481 432.999c-4.354-2.905-10.243-1.727-13.148 2.63l-18.963 28.444c-2.905 4.357-1.727 10.243 2.629 13.148a9.428 9.428 0 005.25 1.592 9.47 9.47 0 007.898-4.222l18.963-28.444c2.906-4.356 1.728-10.243-2.629-13.148zm222.086-174.246c-1.095-5.12-6.139-8.382-11.257-7.285-5.12 1.097-8.382 6.137-7.285 11.257.278 1.296 27.222 130.539-18.174 221.329-2.34 4.685-.442 10.38 4.241 12.722a9.484 9.484 0 0012.722-4.241c48.339-96.677 20.943-228.228 19.753-233.782z"
  }), React.createElement("path", {
    d: "M265.199 248.96c-1.273-5.083-6.431-8.164-11.498-6.9-5.081 1.271-8.169 6.419-6.901 11.498.183.734 17.979 74.12-9.278 155.889-1.655 4.968 1.03 10.336 5.997 11.993a9.478 9.478 0 003 .489c3.968 0 7.669-2.512 8.993-6.486C284.498 328.49 266 252.165 265.199 248.96zm-24.641 192.606c-4.856-1.945-10.377.416-12.324 5.282l-18.963 47.407c-1.944 4.861.419 10.38 5.282 12.324a9.43 9.43 0 003.519.681 9.486 9.486 0 008.806-5.963l18.963-47.407a9.481 9.481 0 00-5.283-12.324zm72.34-76.903h-.009c-5.229 0-9.472 4.426-9.482 9.655 0 .553-.412 56.009-27.678 119.63-2.062 4.813.167 10.435 4.982 12.498 1.218.521 2.484.791 3.729.791 3.678 0 7.178-2.141 8.72-5.738 28.879-67.384 29.211-124.773 29.211-127.176-.001-5.234-4.241-9.66-9.473-9.66z"
  }));
};

var SvgFingerprintId = function SvgFingerprintId(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$40,
    name: "fingerprint-id"
  }, props));
};

var SvgIcon$41 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M256 4.74c-141.16 0-256 114.84-256 256 0 31.421 5.632 62.116 16.736 91.229a9.486 9.486 0 008.861 6.104 9.458 9.458 0 003.377-.625c4.891-1.866 7.345-7.345 5.479-12.238-10.278-26.947-15.491-55.366-15.491-84.47C18.963 130.036 125.296 23.703 256 23.703S493.037 130.036 493.037 260.74a9.481 9.481 0 009.481 9.481c5.236 0 9.482-4.245 9.482-9.481 0-141.16-114.84-256-256-256z"
  }), React.createElement("path", {
    d: "M256.132 52.147c-56.908 0-115.863 27.535-157.602 73.655-36.968 40.847-55.595 90.375-51.044 135.882l1.053 10.648c7.407 73.761 7.398 73.761-6.509 101.278-.968 1.917-2.002 3.958-3.099 6.148-2.34 4.685-.444 10.38 4.238 12.722a9.428 9.428 0 004.232 1.002 9.484 9.484 0 008.488-5.243c1.081-2.164 2.1-4.181 3.058-6.076 16.405-32.456 16.257-33.942 8.444-111.725l-1.067-10.643c-4.018-40.185 12.819-84.387 46.199-121.269 38.201-42.215 91.97-67.417 143.609-67.417 104.565 0 189.764 85.067 189.764 189.63v47.407c0 5.236 4.245 9.481 9.482 9.481s9.482-4.245 9.482-9.481V260.74c-.001-115.019-93.71-208.593-208.728-208.593z"
  }), React.createElement("path", {
    d: "M315.345 110.832c-18.886-7.484-38.854-11.278-59.345-11.278-43.215 0-83.683 16.551-113.951 46.604-30.459 30.245-47.234 70.937-47.234 114.581 0 24.213 2.231 45.329 4.201 63.958 5.083 48.111 7.884 74.614-28.424 98.82-4.356 2.905-5.535 8.792-2.629 13.148a9.468 9.468 0 007.898 4.222 9.432 9.432 0 005.25-1.592c45.852-30.567 41.84-68.53 36.762-116.588-1.919-18.167-4.095-38.755-4.095-61.968 0-79.75 62.472-142.222 142.222-142.222 18.09 0 35.706 3.345 52.359 9.944 4.863 1.926 10.377-.454 12.308-5.322 1.928-4.867-.454-10.379-5.322-12.307zm101.84 149.542c-.118-51.748-25.315-100.613-67.456-130.782-4.257-3.046-10.18-2.069-13.229 2.192-3.046 4.257-2.067 10.181 2.192 13.229 37.275 26.685 59.53 69.947 59.53 115.727 0 .243.009.486.028.727.093 1.217 9.139 122.623-9.227 196.086a9.484 9.484 0 009.206 11.783 9.486 9.486 0 009.192-7.185c18.79-75.159 10.426-192.935 9.764-201.777z"
  }), React.createElement("path", {
    d: "M362.91 221.716c-16.324-44.713-59.289-74.755-106.91-74.755-62.736 0-113.778 51.039-113.778 113.778 0 .393.025.787.074 1.176.093.745 9.218 75.336.021 139.706-.741 5.183 2.861 9.986 8.047 10.727.454.065.905.097 1.352.097 4.641 0 8.699-3.414 9.375-8.143 9.208-64.458 1.046-136.236.097-144.128.303-52.021 42.72-94.25 94.812-94.25 39.688 0 75.493 25.035 89.095 62.296 1.796 4.919 7.246 7.444 12.16 5.655 4.919-1.795 7.449-7.24 5.655-12.159z"
  }), React.createElement("path", {
    d: "M256.132 194.369c-36.597 0-66.435 29.773-66.435 66.37 0 .37-.014.741.03 1.106.185 1.577 17.963 158.327-26.759 220.938-3.044 4.262-2.065 10.183 2.197 13.227a9.422 9.422 0 005.5 1.766c2.956 0 5.87-1.38 7.72-3.97 47.991-67.187 31.632-221.102 30.211-233.588.28-25.903 21.572-46.887 47.539-46.887 26.141 0 47.539 21.266 47.539 47.407v66.37a9.482 9.482 0 0018.964 0v-66.37c-.001-36.596-29.909-66.369-66.506-66.369zm199.863 136.769c-5.16-.456-9.817 3.401-10.271 8.618l-5.785 66.118a9.477 9.477 0 009.456 10.308c4.861 0 9.002-3.72 9.433-8.655l5.785-66.118c.459-5.218-3.4-9.815-8.618-10.271zM147.481 432.999c-4.354-2.905-10.243-1.727-13.148 2.63l-18.963 28.444c-2.905 4.357-1.727 10.243 2.629 13.148a9.428 9.428 0 005.25 1.592 9.47 9.47 0 007.898-4.222l18.963-28.444c2.906-4.356 1.728-10.243-2.629-13.148zm222.086-174.246c-1.095-5.12-6.139-8.382-11.257-7.285-5.12 1.097-8.382 6.137-7.285 11.257.278 1.296 27.222 130.539-18.174 221.329-2.34 4.685-.442 10.38 4.241 12.722a9.484 9.484 0 0012.722-4.241c48.339-96.677 20.943-228.228 19.753-233.782z"
  }), React.createElement("path", {
    d: "M265.199 248.96c-1.273-5.083-6.431-8.164-11.498-6.9-5.081 1.271-8.169 6.419-6.901 11.498.183.734 17.979 74.12-9.278 155.889-1.655 4.968 1.03 10.336 5.997 11.993a9.478 9.478 0 003 .489c3.968 0 7.669-2.512 8.993-6.486C284.498 328.49 266 252.165 265.199 248.96zm-24.641 192.606c-4.856-1.945-10.377.416-12.324 5.282l-18.963 47.407c-1.944 4.861.419 10.38 5.282 12.324a9.43 9.43 0 003.519.681 9.486 9.486 0 008.806-5.963l18.963-47.407a9.481 9.481 0 00-5.283-12.324zm72.34-76.903h-.009c-5.229 0-9.472 4.426-9.482 9.655 0 .553-.412 56.009-27.678 119.63-2.062 4.813.167 10.435 4.982 12.498 1.218.521 2.484.791 3.729.791 3.678 0 7.178-2.141 8.72-5.738 28.879-67.384 29.211-124.773 29.211-127.176-.001-5.234-4.241-9.66-9.473-9.66z"
  }));
};

var SvgFingerprintId$1 = function SvgFingerprintId(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$41,
    name: "fingerprint-id"
  }, props));
};

var SvgIcon$42 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.7 6l2.6-2.7c.1-.1.2-.4.1-.5-.1-.2-.3-.3-.5-.3H2.5v-2C2.5.2 2.3 0 2 0s-.5.2-.5.5v15c0 .3.2.5.5.5s.5-.2.5-.5v-6H14c.2 0 .4-.1.5-.3.1-.2 0-.4-.1-.5L11.7 6zM2.5 8.5v-5h10.3l-2.1 2.2c-.2.2-.2.5 0 .7l2.1 2.2H2.5z"
  }));
};

var SvgFlag = function SvgFlag(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$42,
    name: "flag"
  }, props));
};

var SvgIcon$43 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 14.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.8 0c-1.7.8-3.6.9-5.3.4C3.6-.6.8 1.7.8 1.7l-.8.6 7.9 12.4.9-.6L5 8.2C6.2 6.7 7.8 6.1 10.7 7c1.7.5 3.5.4 5-.4L11.8 0z"
  }));
};

var SvgFlag$1 = function SvgFlag(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$43,
    name: "flag"
  }, props));
};

var SvgIcon$44 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.7 6l2.6-2.7c.1-.1.2-.4.1-.5-.1-.2-.3-.3-.5-.3H2.5v-2C2.5.2 2.3 0 2 0s-.5.2-.5.5v15c0 .3.2.5.5.5s.5-.2.5-.5v-6H14c.2 0 .4-.1.5-.3.1-.2 0-.4-.1-.5L11.7 6zM2.5 8.5v-5h10.3l-2.1 2.2c-.2.2-.2.5 0 .7l2.1 2.2H2.5z"
  }));
};

var SvgFlagNext = function SvgFlagNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$44,
    name: "flag-next"
  }, props));
};

var SvgIcon$45 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 10"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.92 8.98h-1.34V7.91h1.09c1.63 0 2.96-1.3 2.96-2.9s-1.33-2.9-2.96-2.9h-5.11v1.07L7.31 1.6 10.55.02v1.07h5.4c2.22 0 4.05 1.76 4.05 3.97s-1.83 3.92-4.08 3.92zM1.37 5.03c0 1.6 1.33 2.9 2.96 2.9h5.11V6.86l3.24 1.58-3.24 1.58V8.95h-5.4C1.82 8.95 0 7.19 0 4.99s1.8-3.97 4.05-3.97H5.4v1.07H4.31c-1.62.02-2.94 1.32-2.94 2.94z"
  }));
};

var SvgFlip = function SvgFlip(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$45,
    name: "flip"
  }, props));
};

var SvgIcon$46 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 10"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.92 8.98h-1.34V7.91h1.09c1.63 0 2.96-1.3 2.96-2.9s-1.33-2.9-2.96-2.9h-5.11v1.07L7.31 1.6 10.55.02v1.07h5.4c2.22 0 4.05 1.76 4.05 3.97s-1.83 3.92-4.08 3.92zM1.37 5.03c0 1.6 1.33 2.9 2.96 2.9h5.11V6.86l3.24 1.58-3.24 1.58V8.95h-5.4C1.82 8.95 0 7.19 0 4.99s1.8-3.97 4.05-3.97H5.4v1.07H4.31c-1.62.02-2.94 1.32-2.94 2.94z"
  }));
};

var SvgFlip$1 = function SvgFlip(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$46,
    name: "flip"
  }, props));
};

var SvgIcon$47 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 14H6v-2h2v2zm8-14v14l-2 2H0V0h16zm-5 11H5v4h6v-4zm2-10H3v7h10V1z"
  }));
};

var SvgFloppyDisk = function SvgFloppyDisk(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$47,
    name: "floppy-disk"
  }, props));
};

var SvgIcon$48 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.5 11V8.6H9.4V7h3.1V0h-7v7h3.1v1.6H3.5V11H.4v7h7v-7H4.3V9.4h9.4V11h-3.1v7h7v-7h-3.1zm-7.9.7v5.5H1.2v-5.5h5.4zm-.3-5.4V.8h5.5v5.5H6.3zm10.5 5.4v5.5h-5.5v-5.5"
  }));
};

var SvgFlowchart = function SvgFlowchart(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$48,
    name: "flowchart"
  }, props));
};

var SvgIcon$49 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 12h15.7V2H7.4L4.8 0H0z"
  }));
};

var SvgFolder = function SvgFolder(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$49,
    name: "folder"
  }, props));
};

var SvgIcon$4a = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 7.9v-.8C15 6 14.1 5 12.9 5c-1.2 0-2.1.9-2.1 2.1v.7h-.7V12h5.6V7.9H15zm-.9 0h-2.4v-.8c0-.6.5-1.2 1.2-1.2.6 0 1.2.5 1.2 1.2v.8zm-6-2V12H0V0h4.1l2.8 2h8.8v2.1c-1.7-1.6-4.3-1.5-5.8.2-.4.5-.7 1-.9 1.6h-.9z"
  }));
};

var SvgFolderLock = function SvgFolderLock(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4a,
    name: "folder-lock"
  }, props));
};

var SvgIcon$4b = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.7 9H8.9V8h6.8v1zM6.9 6h8.8V2H6.9L4.1 0H0v12h15.7v-1H6.9V6z"
  }));
};

var SvgFolderMinus = function SvgFolderMinus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4b,
    name: "folder-minus"
  }, props));
};

var SvgIcon$4c = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 13"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14 13H2L0 5h16l-2 8zM1 0h4l3 2h7v1H1V0z"
  }));
};

var SvgFolderOpen = function SvgFolderOpen(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4c,
    name: "folder-open"
  }, props));
};

var SvgIcon$4d = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.7 9H8.9V8h6.8v1zm-3.8 3V5h1v7h-1zm-5-1V6h3V3h5v3h.9V2H6.9L4.1 0H0v12h9.9v-1h-3z"
  }));
};

var SvgFolderPlus = function SvgFolderPlus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4d,
    name: "folder-plus"
  }, props));
};

var SvgIcon$4e = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.9 0v1H13v10l-8.1.1v.9H14V0H6.9zm3 14v-2h-1v2l-2 1v1h5v-1l-2-1zM0 1h3.4l1.8 1.4h5.9v7.1H0V1z"
  }));
};

var SvgFolderZip = function SvgFolderZip(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4e,
    name: "folder-zip"
  }, props));
};

var SvgIcon$4f = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.7 15V7.3l-6.1-6C.4 1 .6.5 1 .5h14c.4 0 .6.5.4.8l-5.7 6v6l-2.2 2.2c-.2.2-.8-.1-.8-.5zM2 1.5l5.7 5.4v6.9l1-1V6.9L14 1.5H2z"
  }));
};

var SvgFunnel = function SvgFunnel(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4f,
    name: "funnel"
  }, props));
};

var SvgIcon$4g = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.7 15V7.3l-6.1-6C.4 1 .6.5 1 .5h14c.4 0 .6.5.4.8l-5.7 6v6l-2.2 2.2c-.2.2-.8-.1-.8-.5zM2 1.5l5.7 5.4v6.9l1-1V6.9L14 1.5H2z"
  }));
};

var SvgFunnelNext = function SvgFunnelNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4g,
    name: "funnel-next"
  }, props));
};

var SvgIcon$4h = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 13.1"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M9.7 1.2C9.1 1 8.5.9 7.9 1 4.1 1 1 4 1 7.9c0 1.5.5 3 1.4 4.2l.9 1H2l-.1-.2C-1 9.5-.5 4.6 2.9 1.8 4.9.1 7.7-.4 10.2.3l-.5.9zm3.4.8c3.2 2.8 3.5 7.6.8 10.9l-.1.2h-1.6c.2 0 1.1-1 1.2-1 .9-1.2 1.4-2.7 1.4-4.2 0-1.9-.7-3.7-2.1-4.9l.4-1zM6.9 9.4c-.9-.5-1.2-1.7-.7-2.6.5-.9 6.1-6.7 6.1-6.7S9.9 8.2 9.6 8.7c-.6.9-1.8 1.2-2.7.7z"
  }));
};

var SvgGauge = function SvgGauge(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4h,
    name: "gauge"
  }, props));
};

var SvgIcon$4i = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.7 13.5l-1.3-1.3-.7-.7-1.3-1.3c-.2-.2-.5-.3-.9-.4h-.9L8.1 7.4l3.5-3.5c.2-.2.2-.5 0-.7L8.9.3c-.1 0-.3-.1-.4-.1-.1 0-.3.1-.4.2L.3 8.2c-.2.2-.2.5 0 .7l2.8 2.8c.2.2.5.2.7 0l3.6-3.6 2.6 2.5v.9c0 .3.1.6.4.9l1.3 1.3.7.7 1.3 1.3c.1.1.2.1.4.1.1 0 .3-.1.4-.1l.4-.4.7-.7.4-.4c-.1-.2-.1-.5-.3-.7zM8.5 1.4l2.1 2.1-.7.7-2.1-2.1.7-.7zm-5 9.3L1.4 8.5l.8-.8 2.1 2.1-.8.9zM5 9.2L2.8 7.1 7 2.9 9.2 5 5 9.2zm9.6 4.7l-.7.7-.9-.9-.4-.4-.3-.3-1.3-1.3s-.1-.1-.1-.2v-.6h.6l.2.1 1.3 1.3.4.4.3.3.9.9z"
  }));
};

var SvgGavel = function SvgGavel(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4i,
    name: "gavel"
  }, props));
};

var SvgIcon$4j = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14.8 14.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M3.5 10.6l-.7.7L0 8.5l.7-.7 2.8 2.8zm3.6-9.2L1.4 7.1l2.8 2.8 5.7-5.7-2.8-2.8zM8.5 0l-.7.7 2.8 2.8.7-.7L8.5 0zm0 7.1L7.1 8.5l6.3 6.3 1.4-1.4-6.3-6.3z"
  }));
};

var SvgGavel$1 = function SvgGavel(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4j,
    name: "gavel"
  }, props));
};

var SvgIcon$4k = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.7 13.5l-1.3-1.3-.7-.7-1.3-1.3c-.2-.2-.5-.3-.9-.4h-.9L8.1 7.4l3.5-3.5c.2-.2.2-.5 0-.7L8.9.3c-.1 0-.3-.1-.4-.1-.1 0-.3.1-.4.2L.3 8.2c-.2.2-.2.5 0 .7l2.8 2.8c.2.2.5.2.7 0l3.6-3.6 2.6 2.5v.9c0 .3.1.6.4.9l1.3 1.3.7.7 1.3 1.3c.1.1.2.1.4.1.1 0 .3-.1.4-.1l.4-.4.7-.7.4-.4c-.1-.2-.1-.5-.3-.7zM8.5 1.4l2.1 2.1-.7.7-2.1-2.1.7-.7zm-5 9.3L1.4 8.5l.8-.8 2.1 2.1-.8.9zM5 9.2L2.8 7.1 7 2.9 9.2 5 5 9.2zm9.6 4.7l-.7.7-.9-.9-.4-.4-.3-.3-1.3-1.3s-.1-.1-.1-.2v-.6h.6l.2.1 1.3 1.3.4.4.3.3.9.9z"
  }));
};

var SvgGavelNext = function SvgGavelNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4k,
    name: "gavel-next"
  }, props));
};

var SvgIcon$4l = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.5 8c0-.6.4-1.2.9-1.4l.4-.2-.1-.4c-.2-.7-.5-1.4-.9-2.1l-.2-.4-.4.2c-.7.4-1.6 0-2-.7-.2-.4-.2-.9 0-1.3l.2-.4-.4-.2C11.4.7 10.7.5 9.9.3L9.6.2l-.2.4c-.3.7-1.2 1.1-1.9.8-.4-.1-.7-.5-.9-.8L6.4.2 6 .3c-.7.1-1.4.4-2.1.8l-.4.3.2.4c.4.7 0 1.6-.7 2-.4.2-.9.2-1.3 0l-.4-.2-.2.3C.7 4.6.4 5.3.3 6l-.2.4.4.2c.6.2 1 .8.9 1.4 0 .6-.4 1.2-.9 1.4l-.3.2.1.4c.2.7.5 1.4.9 2.1l.2.4.4-.2c.7-.4 1.6 0 2 .7.2.4.2.9 0 1.3l-.2.4.4.2c.7.4 1.4.7 2.1.9l.4.1.2-.4c.3-.8 1.2-1.1 1.9-.9.4.2.7.5.9.9l.2.4.4-.1c.7-.2 1.4-.5 2.1-.9l.4-.2-.2-.4c-.4-.7 0-1.6.7-2 .4-.2.9-.2 1.3 0l.4.2.2-.4c.4-.7.7-1.4.9-2.1l.1-.4-.4-.2c-.7-.2-1.1-.8-1.1-1.4zm-.3 3.2c-1.3-.3-2.7.5-3 1.9-.1.4-.1.8 0 1.1-.4.2-.7.3-1.1.5-.7-1.2-2.3-1.5-3.4-.8-.3.2-.6.5-.8.8-.4-.1-.8-.3-1.1-.5.3-1.3-.5-2.7-1.9-3-.4-.1-.8-.1-1.1 0-.2-.4-.3-.7-.5-1.1 1.2-.7 1.5-2.3.8-3.4-.2-.3-.5-.6-.8-.8.1-.4.3-.8.5-1.1.8.2 1.7-.1 2.3-.7.6-.6.9-1.5.7-2.3.4-.2.7-.3 1.1-.5.7 1.2 2.3 1.5 3.4.8.3-.2.6-.5.8-.8.4.1.8.3 1.1.5-.3 1.3.5 2.7 1.9 3 .4.1.8.1 1.1 0 .2.4.3.7.5 1.1-1.2.7-1.5 2.3-.8 3.4.2.3.5.6.8.8-.2.4-.3.8-.5 1.1zM8 5C6.3 5 5 6.3 5 8s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  }));
};

var SvgGear = function SvgGear(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4l,
    name: "gear"
  }, props));
};

var SvgIcon$4m = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.6 9V7h.3c-.1-.6-.4-1.2-.7-1.8l-.2.3-1.4-1.4.2-.2c-.6-.4-1.2-.7-1.8-.8v.3H7v-.3c-.6.1-1.2.4-1.7.7l.2.2-1.4 1.5-.3-.2c-.3.5-.5 1.1-.7 1.7h.3v2h-.3c.1.6.4 1.2.7 1.7l.2-.2L5.5 12l-.2.2c.5.4 1.1.6 1.7.7v-.3h2v.3c.6-.1 1.2-.4 1.7-.7l-.2-.2 1.4-1.4.2.2c.4-.5.6-1.1.7-1.8h-.2zM8 10.9c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9S9.6 10.9 8 10.9zM7 3.4V0h2v3.4H7zm2 9.2V16H7v-3.4h2zM12.6 7H16v2h-3.4V7zM3.4 9H0V7h3.4v2zm7.2-4.9l.2-.2L13 1.6 14.4 3l-2.2 2.2-.2.3-1.4-1.4zM5.5 12l-.2.2-2.2 2.2L1.6 13l2.2-2.2.2-.2L5.5 12zm6.5-1.5l.2.2 2.2 2.2-1.4 1.5-2.2-2.2-.3-.2 1.5-1.5zm-7.9-5l-.3-.2-2.2-2.2L3 1.7l2.2 2.2.2.2-1.3 1.4z"
  }));
};

var SvgGear$1 = function SvgGear(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4m,
    name: "gear"
  }, props));
};

var SvgIcon$4n = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.5 8c0-.6.4-1.2.9-1.4l.4-.2-.1-.4c-.2-.7-.5-1.4-.9-2.1l-.2-.4-.4.2c-.7.4-1.6 0-2-.7-.2-.4-.2-.9 0-1.3l.2-.4-.4-.2C11.4.7 10.7.5 9.9.3L9.6.2l-.2.4c-.3.7-1.2 1.1-1.9.8-.4-.1-.7-.5-.9-.8L6.4.2 6 .3c-.7.1-1.4.4-2.1.8l-.4.3.2.4c.4.7 0 1.6-.7 2-.4.2-.9.2-1.3 0l-.4-.2-.2.3C.7 4.6.4 5.3.3 6l-.2.4.4.2c.6.2 1 .8.9 1.4 0 .6-.4 1.2-.9 1.4l-.3.2.1.4c.2.7.5 1.4.9 2.1l.2.4.4-.2c.7-.4 1.6 0 2 .7.2.4.2.9 0 1.3l-.2.4.4.2c.7.4 1.4.7 2.1.9l.4.1.2-.4c.3-.8 1.2-1.1 1.9-.9.4.2.7.5.9.9l.2.4.4-.1c.7-.2 1.4-.5 2.1-.9l.4-.2-.2-.4c-.4-.7 0-1.6.7-2 .4-.2.9-.2 1.3 0l.4.2.2-.4c.4-.7.7-1.4.9-2.1l.1-.4-.4-.2c-.7-.2-1.1-.8-1.1-1.4zm-.3 3.2c-1.3-.3-2.7.5-3 1.9-.1.4-.1.8 0 1.1-.4.2-.7.3-1.1.5-.7-1.2-2.3-1.5-3.4-.8-.3.2-.6.5-.8.8-.4-.1-.8-.3-1.1-.5.3-1.3-.5-2.7-1.9-3-.4-.1-.8-.1-1.1 0-.2-.4-.3-.7-.5-1.1 1.2-.7 1.5-2.3.8-3.4-.2-.3-.5-.6-.8-.8.1-.4.3-.8.5-1.1.8.2 1.7-.1 2.3-.7.6-.6.9-1.5.7-2.3.4-.2.7-.3 1.1-.5.7 1.2 2.3 1.5 3.4.8.3-.2.6-.5.8-.8.4.1.8.3 1.1.5-.3 1.3.5 2.7 1.9 3 .4.1.8.1 1.1 0 .2.4.3.7.5 1.1-1.2.7-1.5 2.3-.8 3.4.2.3.5.6.8.8-.2.4-.3.8-.5 1.1zM8 5C6.3 5 5 6.3 5 8s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  }));
};

var SvgGearNext = function SvgGearNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4n,
    name: "gear-next"
  }, props));
};

var SvgIcon$4o = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.3 11.4V10h.2c-.1-.4-.2-.8-.5-1.1l-.1.1-1-.9.2-.2c-.4-.2-.8-.3-1.2-.4v.2H4.6v-.2c-.4 0-.8.2-1.1.4l.1.1-.9 1-.2-.1c-.2.3-.4.7-.4 1.1h.2v1.3h-.2c.1.4.2.8.5 1.1l.1-.1.9.9-.1.1c.3.2.7.4 1.1.5v-.2h1.3v.2c.4-.1.8-.2 1.1-.5l-.1-.1.9-.9.2.2c.2-.3.4-.7.5-1.2h-.2zm-3 1.2c-1.1 0-1.9-.9-1.9-1.9s.9-1.9 1.9-1.9 1.9.9 1.9 1.9c0 1-.9 1.9-1.9 1.9zm-.7-4.9V5.4h1.3v2.3H4.6zm1.3 6V16H4.6v-2.3h1.3zM8.3 10h2.3v1.3H8.3V10zm-6 1.4H0V10h2.3v1.4zm4.6-3.3l.2-.2 1.4-1.4.9.9L8 8.9l-.1.1-1-.9zm-3.3 5.2l-.1.1L2 14.9l-.9-.9 1.5-1.5.1-.1.9.9zm4.3-.9l.1.1L9.5 14l-.9.9-1.5-1.5-.1-.1.9-.9zM2.7 9l-.2-.1-1.4-1.5.9-.9 1.5 1.4.1.1-.9 1zm11.8-5.1V3h.1c-.1-.3-.2-.5-.3-.8l-.1.1-.6-.6.1-.1c-.2-.2-.5-.3-.8-.3v.1H12v-.1c-.3.1-.5.2-.8.3l.1.1-.6.6-.1-.1c-.2.2-.3.5-.3.8h.1v.9h-.1c.1.3.2.5.3.8l.1-.1.6.6-.1.1c.2.2.5.3.8.3v-.1h.9v.1c.3-.1.5-.2.8-.3l-.1-.1.6-.6.1.1c.2-.2.3-.5.3-.8h-.1zm-2 .8c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3-.1.8-.6 1.3-1.3 1.3zm-.4-3.2V0h.9v1.5h-.9zm.8 4V7H12V5.5h.9zM14.5 3H16v.9h-1.5V3zm-4 .9H9V3h1.5v.9zm3.1-2.1l.1-.1 1-1 .6.6-1 1-.1.1-.6-.6zm-2.2 3.4l-1.1 1.1-.6-.7 1-1 .1-.1.6.7zm2.8-.6l1.1 1-.6.6-1-1-.1-.1.6-.5zm-3.4-2.2L9.7 1.3l.6-.6 1 1 .1.1-.6.6z"
  }));
};

var SvgGears = function SvgGears(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4o,
    name: "gears"
  }, props));
};

var SvgIcon$4p = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-.8 0-1.7-1-2.3-2.7.8.1 1.5.2 2.3.2.8 0 1.6-.1 2.3-.2C9.7 14 8.8 15 8 15zm0-3.5c-.9 0-1.8-.1-2.6-.3-.3-1-.4-2.1-.4-3.2 0-.5 0-.9.1-1.4C6 6.9 7 7 8 7s2-.1 2.9-.4c0 .5.1.9.1 1.4 0 1.1-.1 2.2-.4 3.2-.8.2-1.7.3-2.6.3zM8 1c1.1 0 2.4 1.8 2.8 4.6-.9.3-1.9.4-2.8.4-.9 0-1.9-.1-2.8-.4C5.7 2.8 6.9 1 8 1zm3.9 5.3c.9-.3 1.7-.9 2.2-1.7.6 1.1.9 2.2.9 3.4 0 1.2-1.3 2.3-3.3 2.9.2-.9.3-1.9.3-2.9 0-.6 0-1.1-.1-1.7zm1.6-2.7c-.1.6-.7 1.2-1.7 1.6-.2-1.4-.7-2.7-1.5-3.9 1.2.5 2.3 1.3 3.2 2.3zM5.7 1.4c-.8 1.2-1.3 2.5-1.5 3.9-1-.5-1.6-1-1.7-1.6.9-1.1 2-1.9 3.2-2.3zM1.9 4.7c.5.7 1.3 1.3 2.2 1.6C4 6.9 4 7.4 4 8c0 1 .1 2 .3 2.9C2.3 10.3 1 9.2 1 8s.3-2.3.9-3.3zm-.4 5.9c.9.7 1.9 1.1 3 1.4.2.9.6 1.8 1.2 2.5-1.9-.6-3.4-2-4.2-3.9zm8.8 4c.5-.8.9-1.6 1.2-2.5 1.1-.3 2.1-.7 3-1.4-.8 1.8-2.3 3.2-4.2 3.9z"
  }));
};

var SvgGlobe = function SvgGlobe(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4p,
    name: "globe"
  }, props));
};

var SvgIcon$4q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14.7 15.5"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.2 6H5.9c0-.7.1-1.5.3-2.2h2V6zm0-2.6H6.3c.3-1 1-1.9 1.8-2.5v2.5zm5.2.4c.3.7.5 1.4.5 2.2h-2.1c0-.7-.1-1.5-.2-2.2h1.8c-.1 0-.1 0 0 0zm-1.1-1.5c.3.3.6.7.9 1.1h-1.7c-.3-.9-.7-1.7-1.3-2.4.8.3 1.5.7 2.1 1.3zM8.9 1c.8.6 1.4 1.5 1.7 2.4H8.9V1zm0 2.8h1.8c.3.7.4 1.5.4 2.2H8.9V3.8zm0 2.6H11c0 .7-.1 1.5-.4 2.2H8.9V6.4zm0 3.5V9h1.6c-.1.4-.3.7-.5 1l.6.5c.3-.5.6-1 .8-1.6h1.7c-.5.8-1.2 1.5-2.1 1.9l.6.6c1.9-1.1 3.1-3.1 3.1-5.3 0-1.6-.7-3.2-1.8-4.3C11.7.6 10.1 0 8.5 0h-.3c-.1 0-3.1 1.3-3.1 6v.9H6v-.5h2.2v2.2h-.6V9h.6v1l.7-.1zm4.4-1.3c-.1 0-.1 0 0 0h-1.8c.2-.7.3-1.5.3-2.2h2.1c-.1.8-.3 1.5-.6 2.2zM2.5 6.9c0-.3-.1-.5-.1-.8 0-2.6 1.7-5 4.2-5.8C5.1 1.8 4.3 4 4.3 6.2V7l-1.8-.1zm3 4.7v-.9h.1c-.1-.3-.2-.5-.3-.8l-.1.1-.6-.5.1-.1c-.3-.2-.5-.3-.8-.3v.1H3v-.1c-.2 0-.5.1-.7.3l.1.1-.6.6-.1-.1c-.2.2-.3.5-.3.8h.1v.9h-.1c.1.3.2.5.3.8l.1-.1.6.6h-.1c.2.2.5.3.8.3v-.1H4v.1c.3-.1.5-.2.8-.3l-.1-.1.6-.6.1.1c.2-.2.3-.5.3-.8h-.2zm-2 .8c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3 1.3.6 1.3 1.3c-.1.8-.6 1.3-1.3 1.3zM3 9.2V7.7h.9v1.5H3zm.9 4v1.5H3v-1.5h.9zm1.6-2.5H7v.9H5.5v-.9zm-4 .9H0v-.9h1.5v.9zm3.1-2.1l.1-.1 1-1 .5.6-1 1-.1.1-.5-.6zm-2.2 3.4L1.3 14l-.6-.6 1-1 .1-.1.6.6zm2.8-.6l1 1.1-.6.6-1-1-.1-.1.7-.6zm-3.4-2.2L.7 9l.6-.6 1 1 .1.1-.6.6zm8.5 3.4v-.6h.1c0-.2-.1-.3-.2-.5l-.1.1-.4-.4.1-.1c-.2-.1-.3-.2-.5-.2v.1h-.6v-.1c-.2 0-.3.1-.5.2l.1.1-.4.4-.1-.1c-.1.2-.2.3-.2.5h.1v.6h-.1c0 .2.1.3.2.5l.1-.1.4.4-.1.1c.2.1.3.2.5.2v-.1h.6v.1c.2 0 .3-.1.5-.2l-.1-.1.4-.4.1.1c.1-.2.2-.3.1-.5zM9 14c-.5 0-.8-.4-.8-.8s.4-.8.8-.8.8.4.8.8c0 .5-.3.8-.8.8zm-.3-2.1v-1h.6v1h-.6zm.6 2.6v1h-.6v-1h.6zm1-1.6h1v.6h-1v-.6zm-2.6.6h-1v-.6h1v.6zm2-1.4l.7-.7.4.4-.6.6-.1.1-.4-.4zm-1.4 2.2l-.7.7-.4-.4.6-.6.1-.1.4.4zm1.8-.4l.7.7-.4.4-.6-.6-.1-.1.4-.4zm-2.2-1.4l-.7-.7.4-.4.6.6.1.1-.4.4z"
  }));
};

var SvgGlobeGears = function SvgGlobeGears(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4q,
    name: "globe-gears"
  }, props));
};

var SvgIcon$4r = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.9 0h.2C8.3.1 12 1.6 12 7.8c0 3.5-1.3 5.6-2.3 6.7 3-.8 5-3.5 5-6.6 0-.3.2-.5.5-.5s.5.2.5.5c0 4.3-3.5 7.9-7.9 7.9C3.5 15.7 0 12.2 0 7.9 0 3.5 3.5 0 7.9 0M1.8 11.1h2.3c-.3-.9-.4-1.9-.4-2.8H1c.1.9.3 1.9.8 2.8m5.6 3.2v-2.8H5.3c.4 1.2 1.1 2.1 2.1 2.8m0-3.3V8.2H4.7c0 1 .2 1.9.5 2.8h2.2zm3.3-6.1H8.4v2.8h2.7c0-.9-.2-1.9-.4-2.8m-5.5-.5h2.2V1.3c-1.1.8-1.9 1.9-2.2 3.1m-.2.5c-.2.9-.4 1.9-.3 2.8h2.7V4.9H5zm6 3.3H8.4V11h2.2c.3-.9.4-1.8.4-2.8m-7.3-.5c0-.9.1-1.9.3-2.8H1.6c-.4.9-.6 1.8-.6 2.8h2.7zM1.9 4.4h2.2c.3-1.1.9-2.2 1.8-3.1-1.7.5-3.1 1.6-4 3.1m6.5-3.1v3.1h2.2c-.4-1.2-1.2-2.3-2.2-3.1m2 10.2h-2v2.8c.9-.7 1.6-1.7 2-2.8m-4.4 3c-.8-.8-1.4-1.8-1.8-2.9H2.1C3 13 4.4 14 6 14.5m9.7-8.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6.6-.3.6-.6m-.8-1.7c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5m-1.1-1.5c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4"
  }));
};

var SvgGlobe$1 = function SvgGlobe(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4r,
    name: "globe"
  }, props));
};

var SvgIcon$4s = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-.8 0-1.7-1-2.3-2.7.8.1 1.5.2 2.3.2.8 0 1.6-.1 2.3-.2C9.7 14 8.8 15 8 15zm0-3.5c-.9 0-1.8-.1-2.6-.3-.3-1-.4-2.1-.4-3.2 0-.5 0-.9.1-1.4C6 6.9 7 7 8 7s2-.1 2.9-.4c0 .5.1.9.1 1.4 0 1.1-.1 2.2-.4 3.2-.8.2-1.7.3-2.6.3zM8 1c1.1 0 2.4 1.8 2.8 4.6-.9.3-1.9.4-2.8.4-.9 0-1.9-.1-2.8-.4C5.7 2.8 6.9 1 8 1zm3.9 5.3c.9-.3 1.7-.9 2.2-1.7.6 1.1.9 2.2.9 3.4 0 1.2-1.3 2.3-3.3 2.9.2-.9.3-1.9.3-2.9 0-.6 0-1.1-.1-1.7zm1.6-2.7c-.1.6-.7 1.2-1.7 1.6-.2-1.4-.7-2.7-1.5-3.9 1.2.5 2.3 1.3 3.2 2.3zM5.7 1.4c-.8 1.2-1.3 2.5-1.5 3.9-1-.5-1.6-1-1.7-1.6.9-1.1 2-1.9 3.2-2.3zM1.9 4.7c.5.7 1.3 1.3 2.2 1.6C4 6.9 4 7.4 4 8c0 1 .1 2 .3 2.9C2.3 10.3 1 9.2 1 8s.3-2.3.9-3.3zm-.4 5.9c.9.7 1.9 1.1 3 1.4.2.9.6 1.8 1.2 2.5-1.9-.6-3.4-2-4.2-3.9zm8.8 4c.5-.8.9-1.6 1.2-2.5 1.1-.3 2.1-.7 3-1.4-.8 1.8-2.3 3.2-4.2 3.9z"
  }));
};

var SvgGlobeNext = function SvgGlobeNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4s,
    name: "globe-next"
  }, props));
};

var SvgIcon$4t = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }), React.createElement("path", {
    d: "M8 3C5.2 3 3 5.2 3 8s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 9c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }), React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2
  }));
};

var SvgGoal = function SvgGoal(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4t,
    name: "goal"
  }, props));
};

var SvgIcon$4u = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 12.5c0-.4-.2-.7-.5-.9V7.4c.1-.1.1-.1.1-.2.1-.2 0-.5-.2-.6L8.1 2.7h-.2L.7 2c-.2 0-.4.1-.5.3-.1.2 0 .5.2.6l3 1.7c-1.1.7-1.9 1.8-2.4 3-.1.1-.1.3 0 .5.1.1.2.2.4.2.3 0 .6 0 .8-.1.5-.1 1.1-.1 1.6 0 .6.3 1.1.7 1.6 1.2l.4.4c.1.2.2.2.3.2l.6-.1c.7-.1 1.3-.1 2 .1.5.2.9.6 1.2 1l.6.6c.1.1.2.1.3.1h.2c.2-.1.3-.2.3-.3.4-1.3.4-2.8-.1-4.1l3.1.3v4.1c-.4.3-.6.9-.3 1.3l.3.3v.1c0 .3.2.5.5.5s.5-.2.5-.5v-.1c.3-.1.5-.4.5-.8zm-5.3-2.3c-.4-.5-.9-.9-1.5-1.1-.4-.2-.8-.3-1.2-.2-.4 0-.8 0-1.2.1h-.3l-.2-.2c-.5-.7-1.2-1.2-2-1.5-.6-.2-1.2-.2-1.9-.1.5-.9 1.3-1.5 2.2-2l3.1 1.7c.1 0 .1.1.2.1l2.3.2c.5.9.7 2 .5 3zM8 6L3 3.2l4.7.4 5 2.7L8 6z"
  }));
};

var SvgGraduationCap = function SvgGraduationCap(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4u,
    name: "graduation-cap"
  }, props));
};

var SvgIcon$4v = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.8 10.2"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M9.6 9.3c-1.9-.8-3.4-1-4.4-.4L5 9v-.1c-.7-.9-.9-2-.7-3.1l4.7.5 4.2-2.4c.5 1 .7 2.1.6 3.2 0 .2-.2.2-.6.3-1.3.1-2.7.8-3.6 1.9zm-.7-3.9L0 4.5 7.8 0l8.1 1-7 4.4zM1.7 8.7h-.5V5.5l.5.1v3.1zm.3 1c0 .3-.2.5-.5.5S1 10 1 9.7s.2-.5.5-.5.5.2.5.5z"
  }));
};

var SvgGraduationCap$1 = function SvgGraduationCap(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4v,
    name: "graduation-cap"
  }, props));
};

var SvgIcon$4w = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 12.5c0-.4-.2-.7-.5-.9V7.4c.1-.1.1-.1.1-.2.1-.2 0-.5-.2-.6L8.1 2.7h-.2L.7 2c-.2 0-.4.1-.5.3-.1.2 0 .5.2.6l3 1.7c-1.1.7-1.9 1.8-2.4 3-.1.1-.1.3 0 .5.1.1.2.2.4.2.3 0 .6 0 .8-.1.5-.1 1.1-.1 1.6 0 .6.3 1.1.7 1.6 1.2l.4.4c.1.2.2.2.3.2l.6-.1c.7-.1 1.3-.1 2 .1.5.2.9.6 1.2 1l.6.6c.1.1.2.1.3.1h.2c.2-.1.3-.2.3-.3.4-1.3.4-2.8-.1-4.1l3.1.3v4.1c-.4.3-.6.9-.3 1.3l.3.3v.1c0 .3.2.5.5.5s.5-.2.5-.5v-.1c.3-.1.5-.4.5-.8zm-5.3-2.3c-.4-.5-.9-.9-1.5-1.1-.4-.2-.8-.3-1.2-.2-.4 0-.8 0-1.2.1h-.3l-.2-.2c-.5-.7-1.2-1.2-2-1.5-.6-.2-1.2-.2-1.9-.1.5-.9 1.3-1.5 2.2-2l3.1 1.7c.1 0 .1.1.2.1l2.3.2c.5.9.7 2 .5 3zM8 6L3 3.2l4.7.4 5 2.7L8 6z"
  }));
};

var SvgGraduationCapNext = function SvgGraduationCapNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4w,
    name: "graduation-cap-next"
  }, props));
};

var SvgIcon$4x = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 8.2H4C4 9 5 9.3 5 9.3h1.5V8.1h.6v1.8c-1 1.2-1.3 2.9-.8 4.4V16h4.2v-1.8c.6-1.3 1.1-2.5 1.6-3.9 0-.7 0-1.4-.1-2.1zM9.6 9.6c-.3 0-.3-.1-.4-.2V8.1h.6c0 .1 0 .7.1 1.1.1.1 0 .4-.3.4zm-.4-1.5V5.9s-.1-1.1-1.1-1.1c-.5.1-1 .6-1 1.2v2.2l2.1-.1zm-3 2c-.3.4-.6.9-.7 1.4H5s-1 0-1-.8 1-.8 1-.8h1.2v.2zM16 7h-5.3V5.9c0-1.4-1.1-2.5-2.5-2.5-1.5 0-2.6 1.2-2.6 2.6v1H0V0h16v7z"
  }));
};

var SvgHandout = function SvgHandout(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4x,
    name: "handout"
  }, props));
};

var SvgIcon$4y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    version: 1.2,
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    xmlnsDefault: "http://www.w3.org/2000/svg",
    d: "M2 13.72a.595.595 0 01-.58-.33.721.721 0 010-.67c.11-.22.34-.35.58-.33.24-.02.47.11.58.33.11.21.11.46 0 .67-.11.22-.34.35-.58.33zm15.34-.6c.18.22.29.49.32.77.03.25-.01.51-.12.74-.12.23-.3.42-.52.55-.24.15-.52.22-.8.22a.643.643 0 01-.45-.1c.01.19-.05.37-.15.53-.1.17-.22.33-.37.47-.35.34-.83.51-1.32.46a1.4 1.4 0 01-.75.88c-.36.19-.79.22-1.17.08-.35.33-.82.51-1.3.49-.91-.06-1.76-.48-2.36-1.16l-3.11-3.08a.847.847 0 00-.19-.14l-.18-.09a.739.739 0 00-.21 0H4V8.06h1.62l1.64-1.65c.43-.45 1.03-.7 1.65-.69H10c.16.01.33.03.49.06.18.04.35.1.51.19L9.19 8.09c-.8.95-.8 2.33 0 3.28.52.64 1.31 1.01 2.14 1 .84.02 1.64-.35 2.17-1l1.28-1.4.47.51.42.49.44.55.4.51.43.56.4.53zm1.66.6a2.81 2.81 0 00-.62-1.46l-.67-.88-.86-1.1-.62-.71-.6-.6a.667.667 0 00-.44-.84c-.05-.01-.1-.02-.14-.03a.738.738 0 00-.56.22l-2 2.27c-.29.34-.72.53-1.16.51-.45 0-.87-.19-1.15-.54-.18-.22-.28-.5-.28-.78-.01-.3.1-.59.3-.81l2.18-2.53c.37-.45.93-.71 1.52-.7h1.74c.68-.02 1.32.27 1.76.79L19 8.39h1v5.33h-1zm3 0a.595.595 0 01-.58-.33.721.721 0 010-.67.683.683 0 011.17 0c.11.21.11.46 0 .67-.11.22-.34.35-.58.33H22zm2-6a.683.683 0 00-.67-.67h-3.7l-.43-.5-.43-.5-.41-.44c-.14-.15-.29-.29-.45-.41l-.46-.32c-.17-.12-.35-.21-.54-.28-.19-.06-.39-.11-.59-.15-.23-.04-.47-.06-.7-.06h-1.73c-.67-.01-1.33.2-1.89.58-.55-.38-1.21-.58-1.88-.58H8.91c-.24 0-.48.02-.71.06-.22.04-.44.1-.65.2L7 4.92c-.19.11-.37.24-.53.39L6 5.72l-.49.5-.49.5H.67c-.19.01-.36.1-.47.25-.13.12-.2.29-.2.47v7c0 .18.07.35.2.47.12.13.29.2.47.2H4.4l3 2.94c.33.32.69.6 1.08.84.38.24.79.42 1.22.56.43.14.88.19 1.33.15.46-.04.91-.18 1.31-.41.46.03.92-.06 1.34-.26.43-.19.8-.48 1.09-.85.38-.08.75-.24 1.07-.47.33-.23.61-.52.84-.85.47-.07.92-.25 1.3-.54.38-.29.67-.67.85-1.11h4.52c.38-.02.67-.33.65-.71V7.72z",
    vectorEffect: "non-scaling-stroke"
  }));
};

var SvgHandshake = function SvgHandshake(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4y,
    name: "handshake"
  }, props));
};

var SvgIcon$4z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    version: 1.2,
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    xmlnsDefault: "http://www.w3.org/2000/svg",
    d: "M2 13.72a.595.595 0 01-.58-.33.721.721 0 010-.67c.11-.22.34-.35.58-.33.24-.02.47.11.58.33.11.21.11.46 0 .67-.11.22-.34.35-.58.33zm15.34-.6c.18.22.29.49.32.77.03.25-.01.51-.12.74-.12.23-.3.42-.52.55-.24.15-.52.22-.8.22a.643.643 0 01-.45-.1c.01.19-.05.37-.15.53-.1.17-.22.33-.37.47-.35.34-.83.51-1.32.46a1.4 1.4 0 01-.75.88c-.36.19-.79.22-1.17.08-.35.33-.82.51-1.3.49-.91-.06-1.76-.48-2.36-1.16l-3.11-3.08a.847.847 0 00-.19-.14l-.18-.09a.739.739 0 00-.21 0H4V8.06h1.62l1.64-1.65c.43-.45 1.03-.7 1.65-.69H10c.16.01.33.03.49.06.18.04.35.1.51.19L9.19 8.09c-.8.95-.8 2.33 0 3.28.52.64 1.31 1.01 2.14 1 .84.02 1.64-.35 2.17-1l1.28-1.4.47.51.42.49.44.55.4.51.43.56.4.53zm1.66.6a2.81 2.81 0 00-.62-1.46l-.67-.88-.86-1.1-.62-.71-.6-.6a.667.667 0 00-.44-.84c-.05-.01-.1-.02-.14-.03a.738.738 0 00-.56.22l-2 2.27c-.29.34-.72.53-1.16.51-.45 0-.87-.19-1.15-.54-.18-.22-.28-.5-.28-.78-.01-.3.1-.59.3-.81l2.18-2.53c.37-.45.93-.71 1.52-.7h1.74c.68-.02 1.32.27 1.76.79L19 8.39h1v5.33h-1zm3 0a.595.595 0 01-.58-.33.721.721 0 010-.67.683.683 0 011.17 0c.11.21.11.46 0 .67-.11.22-.34.35-.58.33H22zm2-6a.683.683 0 00-.67-.67h-3.7l-.43-.5-.43-.5-.41-.44c-.14-.15-.29-.29-.45-.41l-.46-.32c-.17-.12-.35-.21-.54-.28-.19-.06-.39-.11-.59-.15-.23-.04-.47-.06-.7-.06h-1.73c-.67-.01-1.33.2-1.89.58-.55-.38-1.21-.58-1.88-.58H8.91c-.24 0-.48.02-.71.06-.22.04-.44.1-.65.2L7 4.92c-.19.11-.37.24-.53.39L6 5.72l-.49.5-.49.5H.67c-.19.01-.36.1-.47.25-.13.12-.2.29-.2.47v7c0 .18.07.35.2.47.12.13.29.2.47.2H4.4l3 2.94c.33.32.69.6 1.08.84.38.24.79.42 1.22.56.43.14.88.19 1.33.15.46-.04.91-.18 1.31-.41.46.03.92-.06 1.34-.26.43-.19.8-.48 1.09-.85.38-.08.75-.24 1.07-.47.33-.23.61-.52.84-.85.47-.07.92-.25 1.3-.54.38-.29.67-.67.85-1.11h4.52c.38-.02.67-.33.65-.71V7.72z",
    vectorEffect: "non-scaling-stroke"
  }));
};

var SvgHandshakeNext = function SvgHandshakeNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4z,
    name: "handshake-next"
  }, props));
};

var SvgIcon$4A = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 7.1L8.7.5c-.4-.4-1-.4-1.4 0L.2 7.1c-.2.2-.2.5 0 .7.2.2.5.2.7 0l1.1-1V15c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V6.8l1.2 1.1c.1.1.2.1.3.1.1 0 .3-.1.4-.2.2-.2.1-.5-.1-.7zM9.5 15h-3v-5h3v5zm3.5 0h-2.5v-5c0-.6-.4-1-1-1h-3c-.6 0-1 .4-1 1v5H3V5.9l5-4.7 5 4.6V15z"
  }));
};

var SvgHome = function SvgHome(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4A,
    name: "home"
  }, props));
};

var SvgIcon$4B = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0L0 8h3v8h10V8h3L8 0zm2 16H6v-6h4v6z"
  }));
};

var SvgHome$1 = function SvgHome(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4B,
    name: "home"
  }, props));
};

var SvgIcon$4C = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 7.1L8.7.5c-.4-.4-1-.4-1.4 0L.2 7.1c-.2.2-.2.5 0 .7.2.2.5.2.7 0l1.1-1V15c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V6.8l1.2 1.1c.1.1.2.1.3.1.1 0 .3-.1.4-.2.2-.2.1-.5-.1-.7zM9.5 15h-3v-5h3v5zm3.5 0h-2.5v-5c0-.6-.4-1-1-1h-3c-.6 0-1 .4-1 1v5H3V5.9l5-4.7 5 4.6V15z"
  }));
};

var SvgHomeNext = function SvgHomeNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4C,
    name: "home-next"
  }, props));
};

var SvgIcon$4D = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#BA0000",
    d: "M24 16.043H0V0h24z"
  }), React.createElement("path", {
    d: "M14.515 9.366c.322.837.343 1.549-.054 2.229a4.82 4.82 0 0 1-.736.747.76.76 0 0 0 .005-.353c-.052-.206-.209-.327-.403-.422a1.665 1.665 0 0 1-.62-.468 1.148 1.148 0 0 1-.242-1.124c.076-.25.243-.438.3-.702a.885.885 0 0 0-.1-.628c-.29-.414-.442-.39-.731-.509 0 0 1.72-.373 2.58 1.23zm-2.62-1.052l.003.005.02.043.037.08c.167.397.558 1.639-.515 2.695-.713.544-1.39.764-2.155.574a4.822 4.822 0 0 1-.923-.497.76.76 0 0 0 .34-.094c.183-.108.255-.292.291-.505.034-.253.113-.48.276-.726.218-.355.604-.56 1.01-.549.263.003.489.11.758.09a.885.885 0 0 0 .576-.271c.315-.394.25-.534.282-.845zm-4.1-2.402a.76.76 0 0 0 .202.29c.162.136.36.143.573.107.25-.053.49-.053.776.018.408.088.73.384.853.771.085.248.059.497.167.745a.884.884 0 0 0 .448.452c.476.167.586.059.89-.015l-.004.005-.036.036c-.218.216-1.314 1.182-2.773.468-.75-.491-1.184-1.057-1.258-1.841a4.85 4.85 0 0 1 .162-1.036zm8.1.8c.199.292.343.608.474.935a.76.76 0 0 0-.333-.117c-.211-.016-.376.095-.527.248a1.664 1.664 0 0 1-.641.44 1.148 1.148 0 0 1-1.143-.128c-.214-.151-.338-.37-.57-.507a.885.885 0 0 0-.628-.105c-.484.143-.51.295-.714.532l.003-.027c.034-.224.321-1.746 1.982-2.03.896-.04 1.578.166 2.097.76zm-3.231-3.045a.76.76 0 0 0-.21.284c-.077.197-.02.387.082.577.13.22.208.447.233.741a1.15 1.15 0 0 1-.457 1.056c-.207.16-.452.215-.652.397a.885.885 0 0 0-.284.569c-.005.504.132.574.3.839 0 0-1.618-.697-1.386-2.501.225-.87.621-1.46 1.34-1.783a4.88 4.88 0 0 1 1.034-.18z",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M11.973 8.582c.073.397-.09.874-.41 1.292-.301.391-.695.668-1.027.71l-.014.002-.007-.067c.313-.033.699-.303.994-.686.306-.399.462-.85.4-1.223l-.002-.016.066-.012zm.24-.446c.402.042.813.332 1.124.758.291.398.447.854.394 1.184l-.002.014-.067-.012c.056-.31-.094-.756-.38-1.146-.296-.406-.685-.683-1.06-.729l-.016-.002.007-.067zm-3.047-.425c.135.285.518.56.977.71.478.156.955.154 1.287-.028l.014-.008.034.058c-.351.201-.855.206-1.356.042-.469-.154-.861-.433-1.011-.732l-.006-.012.06-.03zm2.186-2.217l.047.049c-.226.22-.363.67-.358 1.153.005.503.16.954.44 1.21l.012.01-.045.051c-.303-.268-.469-.743-.474-1.27-.005-.493.133-.955.368-1.193l.01-.01zm2.872 1.428l.013.007-.032.06c-.276-.152-.747-.152-1.208-.005-.48.152-.865.433-1.028.775l-.006.014-.062-.028c.168-.368.573-.666 1.076-.825.47-.15.951-.153 1.247.002z",
    fill: "#BA0000"
  })));
};

var SvgHongKong = function SvgHongKong(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4D,
    name: "hong-kong"
  }, props));
};

var SvgIcon$4E = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M24 16H0V0h24z"
  }), React.createElement("path", {
    fill: "#388D00",
    d: "M24 16H0v-5.333h24z"
  }), React.createElement("path", {
    fill: "#D43516",
    d: "M24 5.333H0V0h24z"
  })));
};

var SvgHungary = function SvgHungary(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4E,
    name: "hungary"
  }, props));
};

var SvgIcon$4F = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 13"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 12H1V1h14v11zm1-12H0v13h16V0zM4.7 2.2c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5zM2 11h12V6.4l-2.6-2.9-2.1 4.6L8 6.8c-.9.4-1.7.9-2.3 1.7-.4-.3-1-.3-1.4 0L2 11z"
  }));
};

var SvgImage = function SvgImage(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4F,
    name: "image"
  }, props));
};

var SvgIcon$4G = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 6.5c-.3 0-.5.2-.5.5v6c0 .3.2.5.5.5s.5-.2.5-.5V7c0-.3-.2-.5-.5-.5zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zM8 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
  }));
};

var SvgInfoCircle = function SvgInfoCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4G,
    name: "info-circle"
  }, props));
};

var SvgIcon$4H = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.9 15.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 15.9c-4.4 0-8-3.6-8-8 0-2.1.8-4.1 2.3-5.6 3.1-3.1 8.2-3.1 11.3 0 3.1 3.1 3.1 8.2 0 11.3-1.5 1.5-3.5 2.3-5.6 2.3zM8 1C4.1 1 1 4.1 1 8c0 1.8.7 3.6 2 4.9 2.7 2.7 7.1 2.7 9.9 0s2.7-7.1 0-9.9C11.6 1.7 9.8 1 8 1zM7 2.9h2v2H7v-2zm3 10H6v-2h1v-3H6v-2h3v5h1v2z"
  }));
};

var SvgInfoCircle$1 = function SvgInfoCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4H,
    name: "info-circle"
  }, props));
};

var SvgIcon$4I = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 6.5c-.3 0-.5.2-.5.5v6c0 .3.2.5.5.5s.5-.2.5-.5V7c0-.3-.2-.5-.5-.5zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zM8 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
  }));
};

var SvgInfoCircleNext = function SvgInfoCircleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4I,
    name: "info-circle-next"
  }, props));
};

var SvgIcon$4J = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.4 2.3C10.3-.8 5.3-.8 2.3 2.3s-3.1 8.1 0 11.1 8.1 3.1 11.1 0c3.1-3 3.1-8 0-11.1zm-6.5.5h2v2h-2v-2zm3 10h-4v-2h1v-3h-1v-2h3v5h1v2z"
  }));
};

var SvgInfoCircleSolid = function SvgInfoCircleSolid(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4J,
    name: "info-circle-solid"
  }, props));
};

var SvgIcon$4K = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M24 16.043H0V0h24z"
  }), React.createElement("path", {
    d: "M24.033-.033H-.033v16.109h24.066V-.034zm-.066.066V16.01H.033V.033h23.934z",
    fill: "#CCC"
  }), React.createElement("path", {
    fill: "#00C",
    d: "M24 3.61H0V1.505h24zm0 10.981H0v-2.106h24zM11.95 4.033l1.15 1.95 2.388.01-1.191 2.018 1.178 2-2.361.006-1.15 1.952-1.118-1.943-2.346.009L9.675 7.99 8.513 5.968l2.32.007 1.118-1.942zm-.638 5.915l.656 1.113.67-1.108-1.326-.005zm1.502-3.56l-1.742.012-.89 1.614.903 1.576 1.652.038 1.004-1.614-.927-1.627zm1.198 2.11l-.654 1.098 1.307.016-.653-1.114zM9.94 8.485l-.678 1.127 1.281-.004-.603-1.123zM9.273 6.4l.67 1.145.622-1.136L9.273 6.4zm5.38 0l-1.292.01.622 1.135.67-1.145zm-2.685-1.52l-.656 1.113 1.327-.005-.671-1.108z"
  })));
};

var SvgIsrael = function SvgIsrael(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4K,
    name: "israel"
  }, props));
};

var SvgIcon$4L = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    d: "M24 0v16H0V0h24zm-.067.067H.067v15.866h23.866V.067z",
    fill: "#CCC"
  }), React.createElement("circle", {
    fill: "#D30000",
    cx: 12,
    cy: 8,
    r: 4.974
  })));
};

var SvgJapan = function SvgJapan(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4L,
    name: "japan"
  }, props));
};

var SvgIcon$4M = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.9 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.6 1.3c-1.7-1.7-4.5-1.7-6.2 0-1.2 1.2-1.6 3-1 4.6L0 13.2V16h2.2l2-1.8 1 1 1.1-1-.9-1.2L7 11.5l.9.9 1.8-1.8-.9-.8L10 8.6c2.3.8 4.8-.3 5.6-2.6.6-1.7.2-3.5-1-4.7zm-1.7 2.8c-.3.3-.8.3-1.1 0s-.3-.8 0-1.1c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1z"
  }));
};

var SvgKey = function SvgKey(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4M,
    name: "key"
  }, props));
};

var SvgIcon$4N = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M0 5.332h24v5.334H0z"
  }), React.createElement("path", {
    fill: "#CF0921",
    d: "M0 10.666h24V16H0z"
  }), React.createElement("path", {
    fill: "#007B39",
    d: "M0 0h24v5.334H0z"
  }), React.createElement("path", {
    fill: "#000",
    d: "M0 0v16l7.983-5.334L8 5.329z"
  })));
};

var SvgKuwait = function SvgKuwait(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4N,
    name: "kuwait"
  }, props));
};

var SvgIcon$4O = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 0H0v16h16V0h-1zM6 1h1v1H6V1zM4 1h1v1H4V1zM2 1h1v1H2V1zm13 14H1V3h14v12zm-2-8H6V5h7v2zm0 6H6V8h7v5zm-8 0H3V5h2v8z"
  }));
};

var SvgLayoutBrowser = function SvgLayoutBrowser(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4O,
    name: "layout-browser"
  }, props));
};

var SvgIcon$4P = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 15.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4 4.7H2l-.2.9H0L2.1 0H4l2.1 5.6H4.3L4 4.7zm-.3-1.2l-.7-2-.6 2h1.3zm1.7 2.4h3.2c.5 0 .9.1 1.2.4.3.3.4.6.4 1 0 .3-.1.6-.3.9-.1.1-.3.3-.5.3.3.1.7.2.9.5.2.3.3.6.3.9 0 .3-.1.5-.2.8-.1.2-.3.4-.6.6-.2.1-.4.2-.7.2-.3 0-.5.1-.8.1h-3l.1-5.7zm1.7 2.2h.8c.2 0 .4 0 .6-.1.1-.1.2-.3.2-.4 0-.1-.1-.3-.2-.4-.2-.1-.4-.2-.6-.2h-.8v1.1zm0 2.2H8c.2 0 .4 0 .6-.2.2-.1.3-.2.2-.4 0-.2-.1-.3-.2-.4-.1-.1-.3-.1-.6-.1h-.9v1.1zm7.4 3.1l1.5.5c-.1.4-.2.8-.5 1.1-.2.3-.5.5-.8.6-.4.2-.8.2-1.2.2-.5 0-1-.1-1.5-.3-.4-.2-.8-.5-1-.9-.3-.5-.4-1.1-.4-1.7-.1-.8.2-1.6.7-2.1.6-.5 1.3-.8 2.1-.7.6 0 1.2.1 1.7.4.4.3.8.8.9 1.3l-1.5.3c0-.1-.1-.3-.2-.4-.1-.1-.2-.2-.4-.3-.5-.2-1.1-.1-1.4.4-.2.3-.3.7-.2 1.1 0 .4.1.9.3 1.3.4.4 1.1.5 1.5.1.2-.3.3-.6.4-.9z"
  }));
};

var SvgLetters = function SvgLetters(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4P,
    name: "letters"
  }, props));
};

var SvgIcon$4Q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 10 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.5 1.5c-2-2-5.1-2-7.1 0C-.1 3-.4 5.3.5 7.3c.4.6.9 1.2 1.5 1.7v6h1v1h4v-1h1V9c2.2-1.7 2.7-4.8 1-7-.1-.2-.3-.4-.5-.5zM7 14H3v-1h4v1zm0-2H3v-1h4v1zm1.6-5.2c-.3.5-.7 1-1.2 1.4l-.4.3V10H3c0-1.5-.1-1.6-.4-1.8-.5-.4-.9-.8-1.2-1.4-.8-1.5-.5-3.4.8-4.6C3.8.6 6.3.6 7.9 2.2 8.6 2.9 9 3.9 9 5c0 .6-.1 1.3-.4 1.8z"
  }));
};

var SvgLightbulb = function SvgLightbulb(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4Q,
    name: "lightbulb"
  }, props));
};

var SvgIcon$4R = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 13.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14 2.5H2v1h12v-1zM11 5H2v1h9V5zM9 7.4H2v1h7v-1zm7 .1V0H0v11h8.3l-.1-1H1V1h14v6.5h1zm-3.4 6.1l-3.1-3.5h2.1V7.5h2.1v2.6h2.1l-3.2 3.5z"
  }));
};

var SvgLinesArrowDown = function SvgLinesArrowDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4R,
    name: "lines-arrow-down"
  }, props));
};

var SvgIcon$4S = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M.5 4.5h15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H.5c-.3 0-.5.2-.5.5s.2.5.5.5zm15 3H.5c-.3 0-.5.2-.5.5s.2.5.5.5h15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm0 4H.5c-.3 0-.5.2-.5.5s.2.5.5.5h15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgLines = function SvgLines(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4S,
    name: "lines"
  }, props));
};

var SvgIcon$4T = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 2H0V0h16v2zm0 2.7H0v2h16v-2zm0 9.3H0v2h16v-2zm0-4.7H0v2h16v-2z"
  }));
};

var SvgLines$1 = function SvgLines(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4T,
    name: "lines"
  }, props));
};

var SvgIcon$4U = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M.5 4.5h15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H.5c-.3 0-.5.2-.5.5s.2.5.5.5zm15 3H.5c-.3 0-.5.2-.5.5s.2.5.5.5h15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm0 4H.5c-.3 0-.5.2-.5.5s.2.5.5.5h15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgLinesNext = function SvgLinesNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4U,
    name: "lines-next"
  }, props));
};

var SvgIcon$4V = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M9.3 6.7c.2.2.2.5 0 .7-.2.2-.5.2-.7 0-1-1-2.6-1-3.6 0l-3.4 3.4c-1 1-1 2.6 0 3.6s2.6 1 3.6 0l2.9-2.9c.2-.2.5-.2.7 0 .2.2.2.5 0 .7L5.9 15c-.7.7-1.6 1-2.5 1-.9 0-1.8-.3-2.5-1-1.4-1.4-1.4-3.6 0-4.9l3.4-3.4c1.5-1.4 3.7-1.4 5 0z"
  }), React.createElement("path", {
    d: "M15 1c1.4 1.4 1.4 3.6 0 4.9l-3.4 3.4c-.7.7-1.6 1-2.5 1-.9 0-1.8-.3-2.5-1-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0 1 1 2.6 1 3.6 0l3.4-3.4c1-1 1-2.6 0-3.6s-2.6-1-3.6 0l-2.8 3c-.2.2-.5.2-.7 0-.2-.2-.2-.5 0-.7L10.1 1C11.4-.3 13.6-.3 15 1z"
  }));
};

var SvgLinkedEdit = function SvgLinkedEdit(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4V,
    name: "linked-edit"
  }, props));
};

var SvgIcon$4W = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 10h16V6H0v4zm1-3h14v2H1V7zM0 .5v4h16v-4H0zm15 3H1v-2h14v2zm-15 12h16v-4H0v4zm1-3h14v2H1v-2z"
  }));
};

var SvgList = function SvgList(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4W,
    name: "list"
  }, props));
};

var SvgIcon$4X = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 0H0v16h16V0h-1zM6 1h1v1H6V1zM4 1h1v1H4V1zM2 1h1v1H2V1zm13 14H1V3h14v12zm-2-8H6V6h7v1zM4 7H3V6h1v1zm9 2.9H6v-1h7v1zm-9 0H3v-1h1v1zm9 3.1H6v-1h7v1zm-9 0H3v-1h1v1z"
  }));
};

var SvgListBrowser = function SvgListBrowser(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4X,
    name: "list-browser"
  }, props));
};

var SvgIcon$4Y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 2H0V0h2v2zm0 2.8H0v2h2v-2zM2 14H0v2h2v-2zM16 0H4v2h12V0zm0 4.8H4v2h12v-2zm0 9.2H4v2h12v-2zM2 9.3H0v2h2v-2zm14 0H4v2h12v-2z"
  }));
};

var SvgList$1 = function SvgList(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4Y,
    name: "list"
  }, props));
};

var SvgIcon$4Z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 10h16V6H0v4zm1-3h14v2H1V7zM0 .5v4h16v-4H0zm15 3H1v-2h14v2zm-15 12h16v-4H0v4zm1-3h14v2H1v-2z"
  }));
};

var SvgListNext = function SvgListNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4Z,
    name: "list-next"
  }, props));
};

var SvgIcon$4_ = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15 15"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.2 3.6h-.8V.7v.2l-.1.1-.1.1-.4.3L.4.9 1.6 0h.6v3.6zm.2 5.6H0v-.5l.8-.9c.2-.1.3-.2.4-.3.1-.1.2-.2.2-.3 0-.1.1-.2.1-.3 0-.1.1-.2.1-.3 0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.1-.1 0-.3 0-.4.1-.1.1-.3.2-.4.3L0 6.1c.1-.1.2-.1.2-.2.1-.1.2-.1.3-.2.1 0 .2-.1.3-.1h.4c.2 0 .3 0 .5.1.1 0 .2.1.3.2.1 0 .2.1.2.3.1.1.1.3.1.4 0 .1 0 .3-.1.4 0 .1-.1.2-.2.4 0 .1-.1.2-.2.3-.2.1-.3.3-.4.4l-.4.4h1.5v.7zm-.1 3c0 .1 0 .2-.1.3 0 .1-.1.2-.2.3 0 0-.1.1-.1.2-.1 0-.2 0-.3.1.2 0 .5.1.7.3.2.1.2.4.2.6 0 .1 0 .3-.1.4-.1.1-.1.3-.3.3-.1.1-.3.2-.4.2-.3.1-.5.1-.7.1H.5c-.2 0-.3-.1-.5-.1v-.6c.1 0 .2.1.2.1.1 0 .2.1.2.1h.7c.1 0 .2-.1.2-.1.1 0 .1-.1.1-.2v-.4c0-.1-.1-.1-.1-.1-.1 0-.2-.1-.3-.1H.6v-.5h.6c.1 0 .2-.1.2-.1.1 0 .1-.1.1-.2v-.2c0-.1 0-.2-.1-.3-.1-.1-.2-.1-.4-.1H.8c-.1 0-.1 0-.2.1-.1 0-.1 0-.2.1l-.1.1-.3-.8c.1-.1.1-.1.2-.1s.2-.1.3-.1c.1 0 .2-.1.3-.1h.3c.2 0 .3 0 .5.1.1 0 .3.1.4.2.1.1.2.2.2.3.1-.1.1.1.1.2zM15 2.5H4v-1h11v1zM15 7H4v1h11V7zm0 5.5H4v1h11v-1z"
  }));
};

var SvgListNumber = function SvgListNumber(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$4_,
    name: "list-number"
  }, props));
};

var SvgIcon$50 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 2H0V0h2v2zm0 2.3H0v3h2v-3zm-1.5.6h1v1.6h-1V4.9zM2 14H0v2h2v-2zM16 0H4v2h12V0zm0 4.3H4v3h12v-3zm-11.5.6h11v1.8h-11V4.9zM16 14H4v2h12v-2zM2 9.3H0v2h2v-2zm14 0H4v2h12v-2z"
  }));
};

var SvgListOutline = function SvgListOutline(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$50,
    name: "list-outline"
  }, props));
};

var SvgIcon$51 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 10.5 15.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.2 0C2.5-.1.1 2 0 4.8v.5c0 3.1 4.2 8.5 5.2 10.5 1.1-2 5.2-7.3 5.2-10.5.1-2.8-2-5.1-4.8-5.2 0-.1-.2-.1-.4-.1zm2.6 4.9c0 1.4-1.1 2.6-2.6 2.6S2.7 6.3 2.7 4.9c0-1.4 1.1-2.6 2.6-2.6 1.4 0 2.5 1.2 2.5 2.6z"
  }));
};

var SvgLocator = function SvgLocator(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$51,
    name: "locator"
  }, props));
};

var SvgIcon$52 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.5 10.9V13c0 .3.2.5.5.5s.5-.2.5-.5v-2.1c.5-.3.7-.9.4-1.4-.2-.5-.8-.7-1.3-.4s-.7.9-.4 1.4c.1.1.2.3.3.4zM12 6h-1V3.5c0-1.7-1.3-3-3-3s-3 1.3-3 3V6H4c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zM6 3.5c0-1.1.9-2 2-2s2 .9 2 2V6H6V3.5zM12 15H4V7h8v8z"
  }));
};

var SvgLock = function SvgLock(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$52,
    name: "lock"
  }, props));
};

var SvgIcon$53 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12 14.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.5 6V4.5C10.5 2 8.5 0 6 0S1.5 2 1.5 4.5V6H0v8.8h12V6h-1.5zm-2 0h-5V4.5C3.5 3.1 4.6 2 6 2s2.5 1.1 2.5 2.5V6z"
  }));
};

var SvgLock$1 = function SvgLock(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$53,
    name: "lock"
  }, props));
};

var SvgIcon$54 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.5 10.9V13c0 .3.2.5.5.5s.5-.2.5-.5v-2.1c.5-.3.7-.9.4-1.4-.2-.5-.8-.7-1.3-.4s-.7.9-.4 1.4c.1.1.2.3.3.4zM12 6h-1V3.5c0-1.7-1.3-3-3-3s-3 1.3-3 3V6H4c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zM6 3.5c0-1.1.9-2 2-2s2 .9 2 2V6H6V3.5zM12 15H4V7h8v8z"
  }));
};

var SvgLockNext = function SvgLockNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$54,
    name: "lock-next"
  }, props));
};

var SvgIcon$55 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.2 14.6l-3.9-3.9c1-1.1 1.6-2.5 1.6-4.1 0-3.4-2.7-6.1-6.1-6.1S.7 3.2.7 6.6s2.7 6.1 6.1 6.1c1.4 0 2.7-.5 3.7-1.3l3.9 3.9c.2.2.5.2.7 0 .3-.2.3-.5.1-.7zm-8.4-2.9c-2.8 0-5.1-2.3-5.1-5.1S4 1.5 6.8 1.5s5.1 2.3 5.1 5.1c-.1 2.8-2.3 5.1-5.1 5.1z"
  }));
};

var SvgMagnify = function SvgMagnify(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$55,
    name: "magnify"
  }, props));
};

var SvgIcon$56 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1.7-5.8c.5-.7.9-1.5.9-2.4C10.5 4.7 8.8 3 6.8 3S3 4.7 3 6.8s1.7 3.8 3.8 3.8c.8 0 1.6-.3 2.2-.7l2.5 2.5c.1.1.2.1.3.1.3 0 .5-.2.5-.5 0-.1-.1-.3-.1-.3L9.7 9.2zm-2.9.3C5.2 9.5 4 8.3 4 6.8 4 5.2 5.2 4 6.8 4c1.5 0 2.8 1.2 2.8 2.8-.1 1.5-1.3 2.7-2.8 2.7z"
  }));
};

var SvgMagnifyCircle = function SvgMagnifyCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$56,
    name: "magnify-circle"
  }, props));
};

var SvgIcon$57 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1.7-5.8c.5-.7.9-1.5.9-2.4C10.5 4.7 8.8 3 6.8 3S3 4.7 3 6.8s1.7 3.8 3.8 3.8c.8 0 1.6-.3 2.2-.7l2.5 2.5c.1.1.2.1.3.1.3 0 .5-.2.5-.5 0-.1-.1-.3-.1-.3L9.7 9.2zm-2.9.3C5.2 9.5 4 8.3 4 6.8 4 5.2 5.2 4 6.8 4c1.5 0 2.8 1.2 2.8 2.8-.1 1.5-1.3 2.7-2.8 2.7z"
  }));
};

var SvgMagnifyCircleNext = function SvgMagnifyCircleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$57,
    name: "magnify-circle-next"
  }, props));
};

var SvgIcon$58 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.6 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.8 13.6C3 13.6 0 10.5 0 6.8S3 0 6.8 0s6.8 3 6.8 6.8-3 6.8-6.8 6.8zM6.8 1C3.6 1 1 3.6 1 6.8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8C12.6 3.6 10 1 6.8 1zm8.8 13.2l-1.4 1.4-3.4-3.4 1.4-1.4 3.4 3.4z"
  }));
};

var SvgMagnify$1 = function SvgMagnify(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$58,
    name: "magnify"
  }, props));
};

var SvgIcon$59 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.6 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.8 13.6C3 13.6 0 10.5 0 6.8S3 0 6.8 0s6.8 3 6.8 6.8-3 6.8-6.8 6.8zM6.8 1C3.6 1 1 3.6 1 6.8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8C12.6 3.6 10 1 6.8 1zm8.8 13.2l-1.4 1.4-3.4-3.4 1.4-1.4 3.4 3.4zm-5.3-6.9h-7v-1h7v1z"
  }));
};

var SvgMagnifyMinus = function SvgMagnifyMinus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$59,
    name: "magnify-minus"
  }, props));
};

var SvgIcon$5a = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.2 14.6l-3.9-3.9c1-1.1 1.6-2.5 1.6-4.1 0-3.4-2.7-6.1-6.1-6.1S.7 3.2.7 6.6s2.7 6.1 6.1 6.1c1.4 0 2.7-.5 3.7-1.3l3.9 3.9c.2.2.5.2.7 0 .3-.2.3-.5.1-.7zm-8.4-2.9c-2.8 0-5.1-2.3-5.1-5.1S4 1.5 6.8 1.5s5.1 2.3 5.1 5.1c-.1 2.8-2.3 5.1-5.1 5.1z"
  }));
};

var SvgMagnifyNext = function SvgMagnifyNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5a,
    name: "magnify-next"
  }, props));
};

var SvgIcon$5b = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.6 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.8 13.6C3 13.6 0 10.5 0 6.8S3 0 6.8 0s6.8 3 6.8 6.8-3 6.8-6.8 6.8zM6.8 1C3.6 1 1 3.6 1 6.8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8C12.6 3.6 10 1 6.8 1zm8.8 13.2l-1.4 1.4-3.4-3.4 1.4-1.4 3.4 3.4zm-5.3-6.9h-7v-1h7v1zm-4.1 3v-7h1v7h-1z"
  }));
};

var SvgMagnifyPlus = function SvgMagnifyPlus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5b,
    name: "magnify-plus"
  }, props));
};

var SvgIcon$5c = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    fill: "#0B7226",
    d: "M0 0h8.036v16H0z"
  }), React.createElement("path", {
    fill: "#BC0000",
    d: "M16.01 0H24v16h-7.99z"
  })), React.createElement("path", {
    d: "M10.277 7.093a.376.376 0 0 1-.11-.027c.018.302.048.318.096.432.143.09.39.07.495.047.011.016.073.093.035.115-.04.026-.057.075-.059.156.024.027.05.004.074.021a.4.4 0 0 1 .077.133s.304-.208.254-.405c-.032-.185-.157-.248-.157-.248-.176-.088-.424-.03-.515-.063-.112-.025-.183-.122-.19-.16z",
    fill: "#9D4600"
  }), React.createElement("path", {
    d: "M9.43 6.518c.1.02.168.068.261.13.146.144.105.359.064.486-.072.139-.006.238.077.3.163.083.264.197.267.402.047.16.174.147.198.15.003 0 .22-.18.22-.183 0-.004.194.254.194.257 0 .003-.38.174-.38.174-.117.04-.263.005-.369-.154-.05-.12-.073-.272-.15-.358 0 0-.147-.09-.204-.174-.16-.217.01-.458 0-.578-.024-.215-.17-.156-.265-.244-.044-.171-.045-.158.087-.208zm1.412-.607c.19.253-.077.533-.31.694-.276.217-.425.64.061.665.176-.003.366-.019.473.119.108.137.112.39-.158.553-.027-.023-.066-.093-.096-.114-.029-.021-.048.006-.075-.017-.009-.087.134-.217-.001-.248-.174.03-.785.032-.777-.55a.897.897 0 0 1 .194-.424c.111-.148.416-.332.446-.412.047-.07-.04-.205-.108-.223-.056-.15.192-.31.35-.043zm-.617-.892a.307.307 0 0 1 .007.161c0 .002-.177.257-.177.257-.027.039-.008.127.06.103.087-.036.145-.05.227-.092.002.015.005.004.007.02-.099.048-.188.095-.287.144-.023.031-.019.078.044.089.092.006.146-.03.247-.014-.038.084-.05.142-.088.226-.229.068-.49.016-.441-.308-.084-.253.032-.312.14-.36z",
    fill: "#288800"
  }), React.createElement("path", {
    d: "M10.49 5.85c.137.051.32.12.3.523.114-.123.166-.295.022-.513-.097-.105-.239-.127-.322-.01z",
    fillOpacity: 0.994,
    fill: "#9D4600"
  }), React.createElement("path", {
    d: "M10.801 7.639l.083.006c.087.012.175.04.246.084a.176.176 0 0 1 .085.182l-.013.046-.015.007.423.127.025.01h-.019l-.172.126-.43-.147-.016.012c-.018.137-.156.09-.278-.006l-.05-.043c-.001.045-.035.046-.08.038-.013.026-.062.064-.097.055-.011.021-.029.037-.093.015-.047-.008-.223-.228-.033-.28.011-.06.049-.119.122-.109.024-.053.084-.09.16-.108a.124.124 0 0 0-.036.024c-.093.148.014.28.135.227-.014-.103-.04-.168.053-.266z",
    fill: "#F7B200"
  }), React.createElement("path", {
    d: "M14.776 8.584c.054.042.146-.437.132-.586 0-.01-.017-.328.05-.555.041-.077.043-.65-.02-.8.05-.004.11-.02.118-.082-.232.086-.287-.49-.51-.82-.218-.333-.488-.526-.77-.727a.603.603 0 0 1 .098-.162c-.345.172-.883-.453-1.676-.406-.179.017-.263.028-.309.137-.147.012-.298.046-.299.24a.14.14 0 0 0 .138.133c.13.038.235.009.323.19l.024.187s-.117-.147-.18-.172c.016-.024-.01-.041.039-.08-.06-.034-.166-.006-.166-.006s-.23-.108-.416-.079c0-.02-.036-.15-.036-.15-.033.092-.105.087-.116.174-.02-.063-.047-.14-.066-.202-.066.089-.047.185-.07.277-.026.021-.077.022-.09-.037-.007-.073-.016-.08-.015-.167-.047.082-.104.122-.123.264-.02-.053-.03-.104-.05-.157.003.184-.156.295-.306.424-.042.078.006.08.01.119l.079.04.142-.01c.023.03.004.031.066.05.165.047.372-.152.534.16-.075.062-.15.208-.126.235.03 0-.06.042.061.004a1.067 1.067 0 0 0-.211.294c-.014.034.05-.005.037.057.018-.046.03-.003.03-.003-.288.31-.01.645-.04.824.047.077.053-.001.113-.01.05.22.195.355.284.53a.34.34 0 0 0-.187.002c.004.083.08.161.139.234l-.126.04a.7.7 0 0 0-.21.164c-.042.1.199.125.315.142-.01.037-.025.082-.004.122.182.018.392-.036.392-.046 0-.01.046-.036.046-.036.024.05.078.064.102.057.034 0 .088-.137.063-.242.066.079.129.205.195.284.02.021.045.006.062-.008.056.089.134.178.19.267.03.034.023.022.063.024.037-.012.068-.017.087-.088 0 0 .013.011.03.05.044.032.076-.044.1-.068.014-.034.069.006.069-.013.02.013.033.07.052.084.03-.011.06-.078.063-.149.03.062.04.057.063.074.02-.017.026-.081.045-.098-.004-.034.238.234.248.234.024.017.161.06.19.01.067.046.251.074.281 0 .152.065.33-.007.322-.08a.629.629 0 0 0 .353.009c.025-.003.092-.068.028-.116-.459-.32-1.142-.851-1.404-.979 0-.094-.072-.436-.149-.53-.014-.048.018-.108.063-.104.179.167.244.15.338.178.102.08.14.204.242.316.048.015.105.064.09.017a1.558 1.558 0 0 0-.332-.524c.099.05.261.18.37.275.074.12.094.217.16.369.048.03.097.142.09.05-.01-.175-.133-.452-.133-.472.195.155.192.395.251.543.05.074.076.173.097.15.025-.034-.057-.454-.057-.454-.013-.053-.02-.112-.033-.165.145.083.195.401.263.782 0 .06.025.127.021.167.032.038.067.144.066.081 0 0 0-.62-.042-.762-.01-.076.018-.2.018-.2l.162.794v.188l.08.08.05-.467s-.06-.544-.06-.554v-.159c-.001-.056.05-.045.084.018.006.136.006.243.012.379.024.155.04.268.052.465.007.162.013.544.047.537zm-4.68 1.706c-.004-.058.079-.083.092-.003.009.039.009.074.018.113.109.029.056.117-.01.117-.008-.034.023.192.023.196l-.012-.005c-.003.026.014.05-.003.076l-.193.01c.015.051-.079.117-.104.006-.042.008-.071.007-.113.015-.058.005-.085-.077-.005-.092.038-.009.073-.01.112-.019.028-.11.116-.058.117.007-.026.008.109-.012.169-.02l-.069-.045-.004-.138c-.051.014-.115-.08-.005-.104-.007-.042-.005-.071-.013-.113zm-1.005-.937c.005-.059.09-.07.091.01v.114c.103.046.038.125-.027.114-.004-.034-.009.194-.01.198l-.034-.03c-.024.029.002.063-.024.092l-.192-.02c.007.053-.096.103-.104-.01-.043 0-.071-.005-.114-.004-.058-.004-.071-.09.01-.091.04-.003.074.002.113-.001.045-.104.124-.04.115.025-.034.004.194.006.198.006h-.004l-.052-.049.008-.068.01-.069c-.054.006-.102-.098.011-.104 0-.042.005-.071.005-.113zm-.494-1.14c.032-.048.114-.018.076.053-.017.037-.038.064-.055.1.069.09-.026.128-.078.088.013-.032-.1.166-.103.17l-.015-.044c-.035.015-.005.06-.043.074-.03-.021-.151-.091-.182-.113-.02.05-.134.045-.087-.058-.037-.02-.06-.038-.098-.057-.05-.032-.02-.113.051-.076.037.016.065.037.102.053.088-.07.127.024.088.077-.032-.013.168.097.171.1l-.003-.002-.023-.069.04-.056.04-.056c-.048-.02-.041-.134.06-.086.02-.037.04-.06.06-.097z",
    fill: "#9C4314"
  }), React.createElement("path", {
    d: "M13.605 9.865v.047l-.434.2c-.012.018-.016.036.004.054.062.046.18.021.195.137-.195.031-.37.078-.566.125-.046.046-.111.06-.157.105-.028.037-.026.058-.054.094 0 .002-.032.018-.032.02h-.064c-.102.001-.307.003-.499.003h-.215a4.05 4.05 0 0 1-.199-.003c-.035-.004-.113-.11-.113-.11l.082-.097 1.13-.465c.33-.013.614-.073.922-.11zm-3.467-.413c.551.325.693.278.67.134.027 0 .032.023.11-.035-.01.214.222.336.364.31.127.009.111.178.111.178.008.173-.05.242-.043.415-.002 0-.004-.02-.006-.02-.157-.038-.466-.042-.582-.067.531-.363-.41-.373-.494-.385-.063-.008-.018-.07.02-.087.292-.057-.276-.334-.26-.367-.036-.021.001-.038.001-.038.04-.025.07-.013.109-.038z",
    fill: "#42B2F3"
  }), React.createElement("path", {
    d: "M8.38 8.515h-.012c.059 0 .012.003 0-.1",
    stroke: "#000",
    strokeWidth: 0.5
  }), React.createElement("path", {
    d: "M10.88 10.643c.034.007.094.01.135.067.03.03.037.15.15.16.026-.037.002-.018-.02-.069 0-.06.1-.056.144.048.043.079.269.025.476.03.066-.01.173.047-.193.055-.102.02-.335.07-.436.274-.019.039-.172.068-.151.002.024-.034.032-.037.056-.072-.002-.043-.1-.03-.094.008a.13.13 0 0 0-.078.031c-.061.078-.165.074-.161-.009a.225.225 0 0 0 .077-.097c.012-.045-.076-.062-.105-.028-.06.032-.1.077-.171.112-.081.03-.158-.022-.088-.064.063-.03.01-.102-.02-.105-.054-.013-.271.024-.31.002-.031-.004-.087-.084-.022-.099.06-.02.16.022.185-.094.026-.196.336.1.286.018-.101-.15.04-.197.114-.126l.024.033c.024.052.142.128.176.114.065.007-.12-.163.027-.19zm-1.49-.801c.057.018.017-.067.096-.102.068-.028-.005.303.076.3.07.028.056-.18.114-.14.126-.032.065.401.12.375.09.08.1-.071.126-.055.045.001.074.003.05.103-.019.077.009.095.023.126.085.188.212.186.255.272.013.127-.01.045-.012.063-.008-.01-.066-.175-.393-.182-.046-.002-.076.01-.17.004-.053.005-.032-.06-.01-.083.035-.025-.127-.013-.183-.006-.056-.003-.094-.013-.126-.02-.098-.009-.156-.078-.084-.12.03-.029.153.005.198-.002.045-.013.039-.09-.005-.096-.062-.009-.333-.03-.311-.06-.042-.069-.03-.104.078-.091.06.036.059-.01.044-.037-.018-.052-.117-.06-.12-.105-.015-.108.055-.122.098-.104.018-.015-.08-.1.031-.14.028-.009.085-.002.104.1zM8.62 8.75c.058.018.019.079.03.164.01.056.065.043.073.014-.012-.129.114-.131.129-.088a.451.451 0 0 1 .007.2c-.008.042-.002.125.025.141.044.001.016-.009.046-.055.052-.033.132.087.038.147-.099.022.056.398.07.42-.015.015-.032-.004-.034.013-.008-.01-.204-.224-.43-.2-.042.005-.11-.096-.043-.115.042.002.01-.004.051-.003.036-.025-.028-.101-.057-.075-.003-.007-.078.016-.11.01-.098-.01-.141-.12-.07-.16.045.016.13.018.176.011.045-.013.024-.054-.02-.06-.062-.01-.313-.07-.29-.101-.042-.07-.001-.123.072-.086.06.036.067.016.052-.011-.018-.052-.035-.04-.038-.084-.004-.03.005-.055.048-.037.018-.015.048.093.16.052.02.017.038-.117.115-.097zm-.068-1.256s-.061.076-.09.104c-.015.022-.047.052.009.069l.08.01c.053.023.059.08.02.086 0 0-.041.047-.113.087-.022.018-.04.04-.02.064.04.016.027 0 .098 0 .06-.013.054.133-.054.123-.032.008-.074.004-.092.056a.976.976 0 0 0-.01.137c-.006.093.007.222.007.226.008.066-.015.043-.023.058-.059-.207-.153-.388-.374-.442-.042-.01-.071-.128-.002-.122.039.015 0-.008.04.008.038.014.099-.017.074-.083 0-.008-.074-.138-.074-.142-.014-.015.012-.1.078-.055.031.02.063.069.108.078.016-.003.027-.054.024-.094l.004-.135c-.015-.08.055-.12.11-.06.005.02 0 .02.004.039.013.026.029.03.047.004l.074-.074c.044-.017.072-.033.075.058z",
    fill: "#008D00"
  }), React.createElement("path", {
    d: "M12.737 9.675a.13.13 0 0 1 .13.129.13.13 0 0 1-.034.088c.034.182.047.347.001.503l.009-.04a.129.129 0 0 1 .023.075.13.13 0 0 1-.064.114c-.027.016-.058.02-.087.016l-.009.003-.045.006a6.261 6.261 0 0 1-1.146 0 .173.173 0 0 1-.122-.051l.023.035a.129.129 0 0 1-.083-.245 1.351 1.351 0 0 1 .01-.407l-.005.024a.13.13 0 1 1 .151-.194l.026-.003c.374-.037.764-.017 1.146 0l-.027-.001a.129.129 0 0 1 .103-.052zm-2.791-.367c.123.035.207.123.186.198-.021.074-.138.106-.262.072-.124-.035-.207-.123-.186-.198.02-.074.138-.107.262-.072z",
    fill: "#983D25"
  }), React.createElement("path", {
    d: "M10.956 9.468a.137.137 0 1 1-.274 0 .137.137 0 0 1 .274 0zm-.65.516a.13.13 0 1 1-.258 0 .13.13 0 0 1 .258 0z",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M10.29 5.192c.009.077.015.175.015.205-.01-.073-.076-.131-.1-.16a.455.455 0 0 1 .086-.045h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#BA4600",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M11.808 11.071c-.157.13-.32.213-.38.347.072-.01.1-.022.153-.015.058-.13.24-.198.347-.303l-.12-.029h0zm.42.014c.14.131.317.206.378.344-.071-.01-.1-.02-.143-.008-.058-.13-.248-.205-.355-.31.04-.009.08-.016.12-.026h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#009400"
  }), React.createElement("path", {
    d: "M12.12 11.112c.172.103.24.177.346.309a.432.432 0 0 0-.148.041c-.128-.166-.227-.225-.334-.33.04-.01.096-.01.136-.02h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M11.98 11.12c.172.103.25.2.356.332-.046.013-.062.09-.088.105-.083-.166-.219-.308-.363-.45.04-.009.055.023.095.013z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#D40000"
  }), React.createElement("path", {
    d: "M11.915 11.1a1.05 1.05 0 0 0-.337.3c.05.004.113.035.14.05.127-.166.226-.225.333-.33-.04-.009-.096-.01-.136-.02h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M12.055 11.108c-.171.103-.244.206-.35.338.086.061.065.065.082.1.083-.167.264-.304.408-.446-.04-.01-.1.018-.14.008h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#D40000"
  }), React.createElement("path", {
    d: "M11.776 10.892c-.124.09-.299.208-.422.297-.026.022.085.044.126.024.13-.09.2-.148.33-.238l.075-.042c-.053-.003-.055-.037-.109-.04h0z",
    stroke: "#005E00",
    strokeWidth: 0.5,
    fill: "#008D2B"
  }), React.createElement("path", {
    d: "M9.413 8.192c.302-.221.598.237.707.514l-.006.007.04-.03c.348-.179.69.061.85.29l.028.045a.608.608 0 0 1 .09-.126c.293-.214.936.003 1.143.228.21-.215.529-.223.769-.14.19.139.248.269.206.38.081.017.168.041.22-.021.275-.324.299-.349.542-.314.65.256-.029.848-.694.578-.049-.027-.12-.036-.183-.052l-.049-.017c-.185.112-.5.184-.869.194-.073-.04-.087-.005-.16-.045.006-.094.02-.177.042-.251-.58.161-1.05.033-1.093-.226l-.016.03c-.525.19-1.04-.088-.971-.368l-.027.042c-.417.026-.905-.429-.57-.718z",
    fill: "#008D00"
  }), React.createElement("path", {
    d: "M15.493 8.402c-.009.038-.053.058-.1.045-.045-.013-.075-.055-.067-.093.009-.038.053-.058.1-.045.045.013.076.055.067.093z",
    fill: "#6D390B"
  }), React.createElement("path", {
    fill: "#6D390B",
    d: "M15.471 8.384l.158.138-.041.048-.159-.137zm-.961.503l.035.049.12-.104-.035-.049z"
  }), React.createElement("path", {
    d: "M14.606 9.056c.01.039-.008.09-.077.108-.069.017-.133-.01-.143-.049-.01-.039.03-.095.098-.113.07-.018.111.015.122.054h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M14.376 9.048c.037.056.036.145-.063.209-.098.064-.213.056-.25 0-.036-.056-.003-.165.095-.229.099-.064.182-.036.218.02h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M14.447 8.816c.034.022.056.071.017.131-.038.06-.103.085-.138.063-.034-.022-.043-.09-.005-.15.039-.06.092-.065.126-.044z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M14.55 8.918c.023.034.022.088-.037.127-.06.039-.13.034-.152 0-.022-.034-.002-.1.057-.139.06-.039.11-.022.133.012h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M14.772 8.717c.017.026.017.066-.028.096-.045.029-.098.025-.114 0-.017-.026-.002-.076.043-.105.045-.03.083-.016.1.01h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#D90000"
  }), React.createElement("path", {
    d: "M11.936 10.778c-.088.01-.138.015-.154.079-.01.043-.002.1.005.148 0 .055.07.092.152.108h.14c.06 0 .17-.058.17-.113.008-.032.008-.083.008-.117 0-.093-.066-.1-.149-.108l-.172.003z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M13.48 10.555l.126.01c-.055.05-.08.103-.12.152.088-.014.196-.022.332-.02-.011.089-.157.201-.232.243l-.04.017a.592.592 0 0 1 .25.11c-.175 0-.458.121-.578.142-.19.048-.72-.25-.91-.293.086-.005.18 0 .276.007l-.116-.003c.115.009.208.008.286.001l.036-.034c.064-.065.123-.137.23-.206a.932.932 0 0 1 .586-.117zm1.138-.823c.006.056-.009.218-.101.291l.022-.027c.142-.113.29-.194.412-.183.02.08-.055.2-.11.269l.007-.006c.222-.12.083.049.07.14-.066.228-.127.23-.204.269-.115.105-.483.054-.654.097l.07-.047c-.04.014-.08.026-.118.037l-.015.018.005-.013-.023.005a.455.455 0 0 0 .035-.04c.06-.165.13-.398.237-.49.069-.069.283-.2.367-.32zm.976-1.112c.058.076.03.24.007.328l-.02.05.035-.044a.386.386 0 0 1 .264-.104c-.122.125-.244.431-.313.531-.099.17-.387.292-.56.392 0-.002 0-.001-.002 0 .003-.004.02-.073.049-.177l.004.077c-.01-.324-.095-.795.303-.956.045-.012.065.01.057.043a.384.384 0 0 1 .176-.14zm.182-1.106c.065.038.086.16.09.226.003.042.004.082.005.119l.007-.03c.004-.092.125-.159.173-.173-.03.18.024.265.01.339-.01.12-.232.305-.326.408l.012-.04c-.033.057-.073.12-.124.19.002-.003-.003-.052-.007-.128l-.003.016c-.02-.117-.143-.213-.176-.351a.634.634 0 0 1 .038-.408c.027.064.116.103.156.173.02-.15.064-.283.145-.341z",
    fill: "#008F00"
  }), React.createElement("path", {
    d: "M11.944 10.776l-.09.015c-.002 0-.069.043-.069.043l-.013.086.015.096.041.057.108.037.008-.334z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#009400"
  }), React.createElement("path", {
    d: "M15.802 8.517c-.016.036.008.078.053.095s.094.002.11-.034c.015-.035-.009-.078-.054-.095s-.094-.001-.11.034z",
    fill: "#6D390B"
  }), React.createElement("path", {
    fill: "#6D390B",
    d: "M15.83 8.516l-.21.02.006.08.209-.02zm-.908 1.045c-.023.036-.075.04-.116.01-.042-.03-.057-.085-.035-.12.023-.037.074-.041.116-.01.042.03.057.084.035.12z"
  }), React.createElement("path", {
    fill: "#6D390B",
    d: "M14.906 9.535l.11.201-.06.034-.11-.2zm.274.308c-.019-.038.004-.085.052-.105.047-.02.102-.005.121.033.02.037-.003.084-.051.104-.048.02-.102.005-.122-.032z"
  }), React.createElement("path", {
    fill: "#6D390B",
    d: "M15.21 9.865l-.228-.012.001-.088.229.012z"
  }), React.createElement("path", {
    d: "M12.26 10.924c.124.09.3.208.423.297.026.022-.086.045-.126.025-.131-.09-.2-.149-.33-.239l-.075-.041c.053-.004.055-.038.109-.042h0z",
    stroke: "#004500",
    strokeWidth: 0.5,
    fill: "#00602B"
  }), React.createElement("path", {
    d: "M13.906 10.465c-.036.021-.084 0-.106-.046-.022-.047-.01-.102.026-.123.037-.021.085 0 .107.046.022.047.01.102-.027.123z",
    fill: "#6D390B"
  }), React.createElement("path", {
    fill: "#6D390B",
    d: "M13.934 10.435l.002.229-.097.002-.003-.229zm.126.357c.003-.042.047-.07.098-.064.05.007.09.047.088.09-.003.042-.046.07-.097.064-.051-.007-.09-.048-.088-.09z"
  }), React.createElement("path", {
    fill: "#6D390B",
    d: "M14.087 10.807l-.192-.124.036-.058.192.124z"
  }), React.createElement("path", {
    d: "M9.054 7.898c.017-.026.057-.043.107-.015.05.028.07.077.053.102-.017.026-.073.034-.123.006-.05-.028-.055-.067-.037-.093h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M12.114 10.774l.002.328.09-.035s.037-.059.037-.062l.015-.083-.007-.093-.069-.045-.068-.01z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#D40000"
  }), React.createElement("path", {
    fill: "#6D390B",
    d: "M9.212 7.726L9.1 7.603l.038-.032.111.122z"
  }), React.createElement("path", {
    d: "M9.071 7.801c.02-.033.063-.054.117-.019.054.036.077.098.059.13-.02.034-.08.044-.135.008-.054-.035-.06-.086-.04-.119h0zm.307-.137c.032.001.067.03.065.093-.002.064-.036.113-.068.111-.032 0-.066-.05-.064-.114.002-.063.036-.092.067-.09h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M9.222 7.69c.036-.01.083.006.1.07.017.063-.008.122-.044.132-.036.01-.088-.027-.105-.09-.017-.064.013-.103.049-.113h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M9.257 7.896c.058-.04.151-.04.22.061.07.102.064.222.005.261-.058.04-.173.007-.242-.094-.07-.102-.04-.19.017-.228h0zm-.215-.462c.027-.018.07-.018.101.028.032.047.029.101.002.12-.026.017-.079.002-.11-.044-.032-.046-.019-.086.007-.104h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M11.934 10.776c-.087.01-.137.015-.154.079-.01.043-.002.1.005.148.016.08.07.092.152.108h.14c.06 0 .156-.038.171-.112.011-.037.007-.084.007-.118-.008-.086-.066-.1-.149-.108l-.172.003zm.046 0l-.008.326m.18-.326l-.009.326",
    stroke: "#000",
    strokeWidth: 0.5
  }), React.createElement("path", {
    d: "M10.7 8.532c.07.023.132.1.094.224-.038.124-.096.204-.189.176-.12-.027-.141-.139-.103-.263.038-.124.128-.159.198-.137h0zm.12-.127c.021.016.035.049.007.086-.027.037-.071.05-.094.034-.022-.015-.026-.06 0-.097.028-.038.064-.038.086-.023zm-.186-.038c.027-.006.06.007.069.052.008.046-.013.087-.04.093-.026.005-.062-.022-.07-.067-.009-.046.015-.072.041-.078h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M10.712 8.466c.026.008.05.035.035.079-.014.043-.052.07-.078.062-.026-.008-.045-.05-.03-.093.013-.044.047-.056.073-.048h0zm.039-.157c.022.006.042.026.03.06-.012.033-.045.053-.067.047-.022-.006-.037-.037-.026-.07.012-.034.04-.043.063-.037h0zm.113.2c.024.016.038.047.006.078-.031.032-.08.04-.104.023-.024-.017-.027-.058.004-.09.031-.03.07-.028.094-.011h0zm-.3-.069c.025-.003.053.012.057.054.004.042-.018.078-.042.081-.025.003-.054-.025-.058-.067-.004-.042.02-.065.043-.068h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#DC0000"
  }), React.createElement("path", {
    d: "M10.234 10.672v-.011.011z",
    stroke: "#000",
    strokeWidth: 0.5
  }), React.createElement("path", {
    d: "M13.353 9c.137.074.09.244-.008.29-.005-.112-.077-.146-.184-.172.056-.031.116-.133.192-.117h0zm-1.143-.15c-.175-.007-.227.164-.159.253.07-.094.159-.087.278-.055-.037-.055-.036-.173-.119-.198h0zm.092.222c-.137.073-.108.243-.01.289.005-.112.076-.146.183-.172-.056-.031-.098-.133-.173-.117h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M13.37 9.015a.124.124 0 0 0-.102-.122c-.068-.009-.133.038-.202-.011a1.793 1.793 0 0 1-.211-.206c-.046-.025-.14-.071-.14-.071-.057.072-.096.156-.177.205-.04.016-.056.035-.129.029-.076-.036-.16-.054-.203-.016.037.073.027.166.011.236.028.016.058-.003.09.005.102.002.076.111.114.158.107.03.161-.022.177-.11.028-.044.114-.05.176-.066.066-.013.15-.034.21 0a.23.23 0 0 1 .11.113s.08.008.16-.007c.002-.048-.007-.136.117-.137h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#F6AA00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M12.663 8.681l.004.176c.02.064.163.057.18.016l-.004-.2",
    stroke: "#000",
    strokeWidth: 0.5
  }), React.createElement("path", {
    d: "M12.71 9.06c.073-.01.1-.1.1-.1m.05.102l.024-.1m.125.097l-.035-.1m-.3.052c-.01.004-.132-.11-.093-.1m-.056.18c.01 0-.12-.113-.097-.106m.005-.048c-.008-.02-.023-.116.035-.098m.186.015c-.167.144-.324.084-.347.205m.78-.067c.017-.016.077-.1.014-.1",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), React.createElement("path", {
    d: "M9.347 6.71c.013.041-.033.019-.042.03-.048.017-.124-.041-.172-.184.023-.04.16-.125.205-.107 0 0 .087.033.097.07-.016.053-.091.196-.088.19z",
    fill: "#9F3000"
  }), React.createElement("path", {
    d: "M10.434 8.158c.05.069.14.034.157-.021-.061.004-.085-.033-.106-.088-.013.032-.064.07-.05.11z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M10.495 8.118c.049.069.138.034.156-.021-.06.004-.084-.033-.106-.088-.013.032-.064.07-.05.11h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M10.588 8.078c.05.069.139.034.157-.021-.061.004-.085-.033-.107-.088-.013.032-.064.07-.05.11h0z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M10.096 10.29c-.004-.058.079-.083.092-.003.009.039.009.074.018.113.109.029.056.117-.01.117-.008-.034.023.192.023.196l-.012-.005c-.003.026.014.05-.003.076l-.193.01c.015.051-.079.117-.104.006-.042.008-.071.007-.113.015-.058.005-.085-.077-.005-.092.038-.009.073-.01.112-.019.028-.11.116-.058.117.007-.026.008.109-.012.169-.02l-.069-.045-.004-.138c-.051.014-.115-.08-.005-.104-.007-.042-.005-.071-.013-.113zm-1.005-.937c.005-.059.09-.07.091.01v.114c.103.046.038.125-.027.114-.004-.034-.009.194-.01.198l-.034-.03c-.024.029.002.063-.024.092l-.192-.02c.007.053-.096.103-.104-.01-.043 0-.071-.005-.114-.004-.058-.004-.071-.09.01-.091.04-.003.074.002.113-.001.045-.104.124-.04.115.025-.034.004.194.006.198.006h-.004l-.052-.049.008-.068.01-.069c-.054.006-.102-.098.011-.104 0-.042.005-.071.005-.113zm-.494-1.14c.032-.048.114-.018.076.053-.017.037-.038.064-.055.1.069.09-.026.128-.078.088.013-.032-.1.166-.103.17l-.015-.044c-.035.015-.005.06-.043.074-.03-.021-.151-.091-.182-.113-.02.05-.134.045-.087-.058-.037-.02-.06-.038-.098-.057-.05-.032-.02-.113.051-.076.037.016.065.037.102.053.088-.07.127.024.088.077-.032-.013.168.097.171.1l-.003-.002-.023-.069.04-.056.04-.056c-.048-.02-.041-.134.06-.086.02-.037.04-.06.06-.097z",
    fill: "#9C4314"
  }), React.createElement("path", {
    d: "M8.543 7.396c.027.012.037.04.04.089v.02l-.021.026-.022.027-.016.02-.012.012-.01.012-.01.01-.006.006-.01.014-.002.003.004.002.017.002.066.01h.003c.067.029.088.114.032.139l-.005.001-.003.001v.001a.44.44 0 0 1-.065.055l-.01.007-.008.006-.02.012-.009.005-.005.004-.005.004a.04.04 0 0 0-.003.004l-.001.002h.007l.016-.002a.29.29 0 0 1 .043-.004h.008c.048-.008.075.037.069.086l-.001.005-.001.006a.108.108 0 0 1-.115.087h-.009l-.02.004c-.021.005-.03.01-.037.026l-.001.003-.001.005a.754.754 0 0 0-.007.072v.023l-.001.03a1.665 1.665 0 0 0 .003.167l.004.054a.158.158 0 0 1 0 .045l.075.321h.003l.017-.032.001-.003c.027-.048.06-.073.108-.064l.006.002h.001c.043.013.055.034.054.083v.013l-.002.014-.001.017-.001.016c-.001.017 0 .03.001.045.002.011.004.013.007.014h.002l.002-.001h.001v-.007c-.001-.057.023-.1.064-.12l.006-.002.005-.002c.046-.017.1-.001.113.039a.48.48 0 0 1 .009.217.241.241 0 0 0 0 .073l.002.01v.002l.006-.01.004-.006.007-.012.006-.004c.043-.028.095.002.117.052.023.05.01.107-.04.143l-.006.004-.005.003-.006.001c-.007.002-.01.018-.008.046v.012l.001.006.002.014.003.014c0 .006.001.01.003.016l.003.017.007.027.005.02.007.024.008.025.006.017.008.026.01.024.008.023.008.02.007.018.006.013.003.007.001.002.001.002.008.013.125.158.009-.002h.004l-.003-.01L9.2 9.81c-.002-.047.023-.078.075-.097a.094.094 0 0 1 .102.03l.024.038.003.007.001-.003.003-.006a.123.123 0 0 1 .065-.067c.03-.012.05 0 .062.026l.009.03v.007l.002.009v.009l.001.01v.012l.001.028v.055l.001.018v.008l.001.015.001.013.001.013.002.02.002.014.001.004.002.006h.007l.006.002.007-.012.004-.01.003-.01.004-.012.01-.035.004-.012a.126.126 0 0 1 .015-.031.052.052 0 0 1 .037-.025l.023.004a.074.074 0 0 1 .066.029l.02.036.013.044.008.05.003.021.002.024v.013l.003.026.003.068.002.016v.013l.002.016v.004l.002.009.001.006.015.013.015.01.009.002.009-.007.01-.017.013-.024a.1.1 0 0 1 .01-.014l.018-.015.022-.002h.003l.033.004.018.007.014.012c.021.028.02.062.007.118-.007.028-.007.044-.002.06l.011.024.004.007.014.028c.023.047.05.083.082.113l.022.019.026.019.047.032a.248.248 0 0 1 .055.048l.017.027.023-.01a.194.194 0 0 1 .111.023l.028.014.03.017.01.006c-.01-.043-.003-.079.02-.103l.028-.02a.14.14 0 0 1 .153.037l.026.036a.262.262 0 0 0 .08.074l.041.022h.001l-.01-.022a.183.183 0 0 1-.026-.084c0-.033.017-.058.048-.072l.035-.012h.012l.035.007a.24.24 0 0 1 .048.015l.038.023.031.034.008.01.008.013.002.006.021.047.02.033.024.023-.001-.001-.003-.006-.004-.01c0-.056.043-.084.093-.074.045.01.087.048.109.101l.008.01.012.007.006.002.007.002.009.002h.003l.008.002h.01l.011.002h.089l.019-.001.03-.002.1-.006.046-.002.048-.002h.071l.024.003c.04.011.063.035.039.067a.07.07 0 0 1-.033.02l-.028.008-.013.003-.007.001-.007.001-.015.002h-.004l-.004.001-.017.002-.018.002-.02.001-.02.002h-.022l-.023.002h-.025l-.023.001-.026.006c-.147.032-.256.08-.332.168l-.05.074-.005.01c-.014.03-.064.052-.114.057a.12.12 0 0 1-.066-.008.053.053 0 0 1-.03-.042l.003-.028.001-.004.01-.015-.027-.006h.002a.173.173 0 0 0-.02.005.092.092 0 0 0-.03.015.163.163 0 0 1-.13.068.085.085 0 0 1-.08-.058l-.005-.039v-.014l.012-.009a.184.184 0 0 0 .05-.051l.015-.03-.002-.003-.007-.002-.027-.002-.015.007-.004.004-.011.006-.025.016-.03.021-.021.016-.018.013a.477.477 0 0 1-.075.045c-.046.017-.097.013-.128-.01-.043-.029-.036-.08.016-.11.013-.007.015-.013.01-.024l-.01-.016-.009-.007-.005-.001h-.004l-.007-.002h-.039l-.033.002-.1.007-.026.002h-.022l-.02.001h-.025l-.012-.002H10.1l-.013-.004-.006-.002a.105.105 0 0 1-.047-.034l-.015-.024c-.021-.048-.006-.09.041-.1l.015-.004.017-.002.011-.001h.007l.028-.002c.042-.002.063-.009.076-.032l.003-.012-.004-.006-.002-.003-.006-.01-.003-.007-.008-.012a.235.235 0 0 0-.05-.052.423.423 0 0 0-.204-.077l-.096-.007h-.035l-.033.004-.049.002-.053-.002c-.027 0-.046-.01-.055-.028l-.008-.03.002-.019.007-.021h-.035l-.021.002-.021.001-.021.002h-.01l-.018.002-.008.001-.054-.004-.048-.008-.03-.007c-.056-.005-.104-.028-.128-.06a.07.07 0 0 1 .001-.092l.03-.025c.013-.012.032-.017.061-.017l.053.004h.009l.043.005.015.002h.025c.007-.004.009-.016.007-.025l-.007-.01h-.005l-.018-.003-.11-.012-.039-.005-.023-.003-.021-.003-.01-.002-.018-.003a.602.602 0 0 1-.032-.006.172.172 0 0 1-.04-.014l-.019-.015-.007-.02c-.039-.073-.018-.121.056-.128h.051l.015.002.005.004-.013-.016-.025-.016-.028-.015c-.037-.02-.054-.036-.055-.064a.163.163 0 0 1 .009-.091l-.11-.124v.007l-.045-.058a.116.116 0 0 0-.005-.006l-.007-.007-.013-.013-.01-.01a.722.722 0 0 0-.006-.005l-.012-.01a.829.829 0 0 0-.007-.006l-.014-.01a.835.835 0 0 0-.007-.006l-.045-.033a.432.432 0 0 0-.265-.084l-.011.001c-.036.005-.074-.026-.094-.065-.02-.04-.016-.08.019-.1l.005-.003.003-.002-.008-.021-.024.004-.011.002a.168.168 0 0 1-.056.002c-.12-.011-.182-.153-.087-.214l.005-.003.013-.008.014.006a.42.42 0 0 0 .131.013h.01l.007-.002h-.004l-.004-.001-.007-.001-.015-.003-.018-.004-.02-.004-.022-.005-.022-.006-.045-.011-.022-.007-.01-.003a.674.674 0 0 1-.092-.032c-.028-.014-.048-.028-.048-.047v-.008c-.04-.083.018-.153.106-.12l.005.003.005.002-.007-.01a.087.087 0 0 1-.018-.052c-.003-.024 0-.045.014-.06.014-.016.032-.02.054-.016h.005l.004.002c.01-.002.02.003.03.01l.004.004.003.003.019.02.004.004.003.001-.05-.21v.004l-.022-.075c-.069-.243-.17-.377-.352-.421-.035-.008-.06-.05-.066-.093-.007-.05.017-.091.067-.09h.011l.007.003h.012c.004 0 .009.002.014.004l.01.003c.023.008.045-.01.037-.039l-.002-.004-.002-.005-.002-.005-.012-.023-.05-.093-.005-.011L8 7.745c-.01-.02-.007-.048.006-.07l.006-.01c.026-.034.068-.041.11-.013a.187.187 0 0 1 .024.02l.027.024a.204.204 0 0 0 .023.02l.005.002.002.001v-.003a.174.174 0 0 0 .005-.035v-.02l.004-.132c-.017-.105.083-.161.159-.088l.004.005.006.006.002.009a.103.103 0 0 1 .002.02v.004l.075-.076.023-.008.008-.003.008-.002a.063.063 0 0 1 .043 0zm7.232.093l.012.007c.062.036.093.133.1.243l.001.015a.267.267 0 0 1 .094-.089l.056-.026.008-.002.03-.01-.005.032a.582.582 0 0 0-.008.145l.01.074.005.039.004.023v.009l.001.008v.03a.268.268 0 0 1-.05.123l-.053.069-.017.019-.018.02-.018.02-.02.02-.011.011-.011.011-.018.018-.092.091-.011.012-.01.01-.038.04-.043.068-.018.024-.031.072c.037.059.04.152.022.256l-.008.028a.414.414 0 0 1 .158-.07l.078-.007h.008l.06.004-.042.043a.647.647 0 0 0-.08.105l-.044.074-.015.026-.007.014-.016.03-.02.037-.067.132-.01.02-.013.024-.011.022-.01.018-.007.01-.002.003-.001.002-.006.009a.601.601 0 0 1-.193.188l-.102.063-.03.018-.02.01-.16.086-.043.023-.008.023-.001-.018-.006.004-.012.006-.036.033a.339.339 0 0 1-.063.19l-.046.018c.056-.027.09-.034.11-.019.018.015.02.033.008.066l-.004.011a.486.486 0 0 1-.002.006l-.006.013-.015.037-.005.011a.266.266 0 0 0-.018.059l-.007.024a1.358 1.358 0 0 1-.004.011l-.007.022-.003.01-.007.02c-.036.094-.073.137-.133.169l-.02.009-.029.014-.003.001-.002.002c-.04.034-.098.053-.19.064l-.024.003-.024.002-.026.002-.027.001-.028.002-.153.005-.04.002h-.02l-.032.003-.014.001-.02.002-.012.002-.034.006-.01.002-.028.007-.078.048-.029.032.006-.017-.107.069a.514.514 0 0 1-.162.175l-.06.036.008-.003a.618.618 0 0 1 .16.07l.033.025.004.005.039.045h-.06a.678.678 0 0 0-.144.019l-.092.024-.012.003-.007.002-.006.002-.027.008-.044.013-.126.04-.03.01-.018.005-.017.004-.016.004-.014.004-.012.002a.32.32 0 0 1-.126.002l-.078-.017-.022-.006-.022-.006-.006-.002-.006-.002-.024-.008-.025-.008-.025-.01-.007-.002-.007-.002-.027-.01-.028-.01-.03-.012-.03-.013-.027-.011-.041-.017-.03-.012-.113-.049-.027.003.015-.008-.007-.004-.064-.026-.04-.017-.023-.009-.02-.008-.02-.007-.018-.006-.016-.005-.015-.005-.01-.002-.01-.003-.194-.043.199-.01.036-.002h.086l.027.001.029.001.03.002.033.002.06.005.028.003c.041 0 .079-.001.115-.004l.039-.041.02-.02.036-.04a1.08 1.08 0 0 1 .066-.062l.046-.037.05-.035.016-.009a.948.948 0 0 1 .458-.12l.127.01.047.006-.035.032a.357.357 0 0 0-.048.052l-.025.035-.01.014c.055-.006.113-.01.178-.01l.077-.002.19-.133.017-.02.056-.157.012-.031a2.5 2.5 0 0 1 .005-.015l.012-.03a.64.64 0 0 1 .15-.247l.008-.008.009-.008.01-.009.011-.01.013-.01.015-.011.12-.092.006-.005a1.28 1.28 0 0 0 .126-.11.485.485 0 0 0 .04-.046l.007-.01.034-.047.006.058a.426.426 0 0 1-.024.18c.127-.088.24-.131.337-.122h-.05l.095-.089.023-.086.006-.022-.004-.063-.003-.072-.002-.033v-.015l-.001-.03v-.023c-.004-.303.06-.504.246-.618l.088-.044c.036-.01.062-.004.078.01a.442.442 0 0 1 .103-.084l.04-.019.029-.072-.006-.098-.005-.018-.015-.035-.021-.039-.008-.012-.013-.021-.038-.056a.605.605 0 0 1-.057-.106l-.016-.05-.002-.014-.006-.033a.591.591 0 0 1 .04-.351l.004-.01.004-.008.015-.029.012.03a.14.14 0 0 0 .031.043l.028.027.029.025a.502.502 0 0 1 .04.039.575.575 0 0 1 .106-.276l.041-.038.011-.008zm-4.894 3.185c-.022.006-.027.013-.028.024l.003.019.01.026.006.013.014.027.004.01c.005.01.007.016.008.024.003.017-.003.032-.015.04l-.023.008c-.047.008-.13-.04-.178-.089l-.029-.037c-.022-.045-.067-.062-.097-.05-.028.011-.032.046.01.108a.074.074 0 0 1 .008.017c.005.015.002.032-.016.041-.011.005-.018.006-.028.002l-.017-.008-.005-.004-.066-.04-.015-.008a.544.544 0 0 0-.041-.021c-.033-.015-.059-.021-.075-.018-.015.002-.023.013-.027.043-.015.065-.046.095-.1.106l-.043.005-.027.001h-.006l-.01.002-.011.001-.011.003-.006.002v.003a.096.096 0 0 0 .019.03l.005.004h.006l.007.004.003.001.006.001h.075l.026-.002.075-.006.031-.002h.067l.012.001.004.001a.087.087 0 0 1 .049.03l.017.025c.019.045.006.086-.036.107l-.003.001-.002.002-.004.002h-.003a.09.09 0 0 0 .071.005l.036-.02.038-.026.045-.033.019-.014.018-.011.01-.006a.102.102 0 0 1 .057-.023l.03.001c.036.008.062.028.067.054v.03a.298.298 0 0 1-.046.073l-.028.028-.002.002.008.014.014.005c.03.002.06-.014.086-.046l.033-.023.039-.014h.003a.072.072 0 0 1 .036-.03l.024-.007c.036-.004.068.005.082.028l.008.027v.01l-.01.016-.015.018-.02.025-.009.01-.001.002h.02l.036-.006a.09.09 0 0 0 .036-.017.477.477 0 0 1 .275-.24l.1-.032.007-.002-.034.001h-.071c-.053-.003-.084-.012-.105-.033l-.018-.025c-.018-.042-.045-.066-.069-.07l-.012-.002-.006.004.007.012.003.003.012.013c.01.014.012.026.006.04l-.013.023-.01.015-.018-.002a.151.151 0 0 1-.112-.06l-.025-.04-.005-.01-.006-.014-.013-.029-.006-.011-.002-.004-.024-.026-.025-.015-.007-.003-.007-.003h-.002l-.008-.003h-.003l-.009-.002-.028-.006zM9.314 9.77h-.018c-.028.01-.035.02-.035.031l.003.013.007.018.008.016.003.007c.005.014.007.026.003.036l-.011.014-.015.013-.017-.008c-.037-.016-.065.004-.055.074v.002l.003.002.004.003h.001l.006.005.017.01.021.01a.157.157 0 0 1 .053.04l.013.025-.001-.003.01.034-.002.03c-.012.023-.03.032-.051.03l-.034-.012-.005-.003-.017-.001h-.002l-.003-.001h-.009c-.02-.001-.029.002-.03.009l.005.014.003.006.004.007.01.017.004.001.009.003.012.003h.003l.004.001.015.003.009.002.018.003h.005l.005.001.021.003.04.005.028.003.097.011.017.002c.064.01.08.095.04.137l-.03.019h-.006l-.006.001H9.44l-.063-.006-.02-.002H9.35l-.014-.002h-.025l-.012.001-.005.002-.003.003c-.022.014-.023.02-.016.03a.096.096 0 0 0 .049.028l.038.008.028.006.024.004.034.005.034.003h.005l.023-.003.02-.001.02-.002.023-.001h.021a.46.46 0 0 1 .058 0 .062.062 0 0 1 .035.011c.014.011.016.025.012.037l-.011.016-.002.002-.009.014-.004.014v.003l.059.002.05-.003.024-.002.02-.001h.037a.775.775 0 0 1 .146.019l.06.018h.003a.43.43 0 0 1-.07-.083l-.029-.05-.008-.017-.001-.003-.002-.004-.008-.013a.135.135 0 0 1-.02-.075l.008-.049.003-.013.002-.012v-.003l.001-.003.002-.009v-.018l-.002-.004h-.003l-.007-.001-.009-.001-.01.02-.006.01a.093.093 0 0 1-.045.043.069.069 0 0 1-.05 0l-.025-.012a.045.045 0 0 1-.038-.028l-.01-.027v-.005l-.002-.008-.001-.013-.002-.01v-.011l-.002-.02-.005-.093-.002-.02v-.01l-.003-.021a.392.392 0 0 0-.017-.086c-.006-.018-.011-.027-.017-.03h-.01l-.014.003-.004-.002-.001.004-.003.008-.005.015-.005.02-.005.015a.187.187 0 0 1-.021.05.065.065 0 0 1-.04.03l-.025-.001-.005-.001a.059.059 0 0 1-.047-.033l-.011-.032-.005-.03-.002-.014v-.008l-.001-.016V9.92l-.001-.03v-.06l-.001-.018v-.01l-.001-.008-.002-.014v-.005l-.012.012-.006.01-.003.005-.009.028c-.008.024-.02.04-.04.043L9.38 9.87l-.017-.005-.004-.018a.132.132 0 0 0-.027-.067l-.018-.011zm5.637.285h-.001l-.005.002-.006.002-.007.002a.282.282 0 0 0-.004.002l-.01.004-.01.004-.013.006-.013.007-.004.002-.013.005-.016.024c-.173.2-.385.328-.663.428l.015-.001.033-.002.037-.001.102-.003.028-.001.026-.002.025-.001.023-.002h.011l.022-.003.02-.002.02-.003a.699.699 0 0 0 .035-.005l.016-.004a.223.223 0 0 0 .096-.041l.004-.004.005-.003.006-.003.03-.014.012-.006c.051-.026.083-.06.114-.138l.006-.017.007-.02.006-.02a1.35 1.35 0 0 0 .004-.01l.007-.023a.265.265 0 0 1 .017-.058l.003-.009.008-.019.012-.029.005-.012a.196.196 0 0 0 .008-.024l.002-.007zm-.04-.217a.608.608 0 0 0-.288.127 1.544 1.544 0 0 0-.073.056.06.06 0 0 1-.012.013l-.006.005-.097.105-.342.376.037-.012.02-.016.03-.02.034-.02.067-.042.105-.066.166-.1.077-.049.056-.035.04-.026.036-.024.018-.012h-.018l.06-.033c.063-.079.107-.162.108-.221l-.003.012-.004-.004-.014.01.009-.015zM8.61 8.78c-.016-.002-.028.008-.043.034l-.018.035c-.012.022-.022.032-.041.031H8.5a.132.132 0 0 1-.126-.025l-.006-.004-.015-.015-.009-.01-.012-.005-.004-.001v.005l.001.004c0 .011.002.015.005.02l.002.003.004.006a.15.15 0 0 1 .022.039l.003.008c.012.023.014.046-.005.06l-.004.004-.004.002c-.021.012-.047.004-.082-.018-.042-.02-.059-.003-.035.038l.002.005.007.012.008.003a.344.344 0 0 0 .026.011l.017.006a.833.833 0 0 0 .009.003l.02.007.01.003.042.012.022.005.032.008.02.005.019.004.017.004.014.002.006.001c.031.005.058.022.067.047.013.03-.004.06-.037.072l-.006.002h-.004a.514.514 0 0 1-.16-.005l-.012-.003h-.002c-.026.028 0 .083.058.095l.006.001.006.001h.026l.034-.006.019-.003.006-.001.006-.001h.006l.002-.001c.024-.01.052 0 .074.023l.004.004.003.004c.02.025.028.054.019.077l-.008.01.001.004H8.61l-.005.007-.004.003-.009.006h-.027l-.01.003h-.018c-.004.002-.004.006 0 .014v.004l.003.003c.005.01.012.02.02.026.006.005.01.007.012.007a.482.482 0 0 1 .317.092c.03.02.059.042.083.063l.01.01v-.002a1.937 1.937 0 0 1-.042-.122L8.935 9.5l-.006-.02-.005-.02-.005-.019-.004-.018-.003-.018c-.016-.084-.008-.139.036-.157l.005-.002h.003l.001-.002c.022-.016.029-.037.023-.058l-.002-.004-.001-.005c-.007-.014-.015-.022-.022-.025h-.004l-.001.002-.002.005-.003.01-.001.006c-.006.027-.022.036-.054.037h-.014l-.007-.005c-.038-.024-.05-.112-.039-.172a.425.425 0 0 0-.006-.185c-.001-.003-.018-.008-.035-.002-.023.008-.037.03-.035.07v.007l.001.006-.001.005a.067.067 0 0 1-.066.048c-.034 0-.06-.025-.067-.066a.321.321 0 0 1-.001-.074l.003-.033v-.015c0-.01-.002-.013-.008-.016H8.61zm6.972-.126a.408.408 0 0 0-.142.117l-.002.016-.307.77.317-.422.1-.136a.33.33 0 0 1 .012-.02l.008-.019.006-.018a.64.64 0 0 0 .024-.228l-.014-.054-.002-.006zm.194-1.113c-.056.052-.093.14-.117.26l-.01.065v-.004l.015.039a.156.156 0 0 1 .001.043l-.01.048.002.124v.072l-.001.022-.01.116-.012.075v-.002l.002.029v.012l.02.026c.028-.04.05-.077.071-.112l.013-.06.081-.32.024-.095.004-.02-.001-.039-.003-.078a.425.425 0 0 0-.041-.166l-.025-.033-.003-.003zm-7.26-.086l-.022.008-.07.07c-.028.037-.067.034-.09-.003l-.003-.005-.002-.005-.003-.007-.002-.011v-.02c-.03-.025-.057-.01-.053.03v.005l.001.005v.007l-.003.132c.004.056-.01.115-.046.125l-.01.002-.006-.001a.155.155 0 0 1-.075-.044L8.1 7.71l-.005-.004-.004-.003c-.016-.01-.022-.01-.028-.002a.035.035 0 0 0-.005.011l-.001.005.003.004v.005l.058.108.008.015.006.014.001.003v.003l.001.001a.09.09 0 0 1-.106.12l-.005-.002-.005-.002h-.015a.06.06 0 0 1-.012-.003l-.005-.002h-.003c-.004 0-.006.003-.005.012v.008a.095.095 0 0 0 .011.031c.004.007.008.01.009.01.166.04.272.145.345.317l.006.013.003.008-.001-.021-.002-.042v-.052l.001-.019.001-.016v-.033a.91.91 0 0 1 .009-.101l.001-.009.001-.004a.1.1 0 0 1 .079-.069l.014-.003.017-.003.01-.002h.004c.032.003.052-.013.057-.038a.054.054 0 0 0 .002-.021v-.002h-.008c-.016 0-.027 0-.037.002l-.021.004h-.006a.088.088 0 0 1-.039-.006l-.007-.003-.008-.003-.005-.006c-.03-.037-.015-.071.021-.103l.005-.003.004-.003a.44.44 0 0 0 .085-.062l.016-.015.004-.004.007-.009.012-.002c.002 0 0-.013-.022-.024h-.002l-.072-.01h-.004l-.005-.002c-.049-.014-.065-.048-.045-.085a.127.127 0 0 1 .009-.015l.01-.015.005-.005.003-.003.008-.008a.573.573 0 0 0 .004-.005l.01-.01.015-.019.022-.025.018-.022v-.003a.164.164 0 0 0-.003-.02l-.001-.004v-.003z",
    fill: "#286726",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M12.108 10.756l.019.003a.377.377 0 0 1 .057.011c.049.011.075.03.085.069l.004.044v.029l.052.038.295.206.074.053c.016.013.011.031-.005.042a.122.122 0 0 1-.04.014.213.213 0 0 1-.073.003l-.029-.009-.023-.016-.027-.02-.021-.014-.038-.028-.099-.073-.05-.037-.039-.027h-.002l-.004.004-.02.021.008-.002.006.006c.026.024.054.047.087.072l.022.016.097.07c.091.069.143.12.174.183l.016.036-.035-.005-.062-.01a.24.24 0 0 0-.04-.002l.002.002-.032.002h-.003l-.01.003-.047.008-.042.013h-.006l-.024.011.01-.004-.019.008-.014.015-.014.022-.008.015-.009.015-.014.019-.01.01-.016.008-.013-.026-.052-.09-.064-.088-.017-.022-.019-.021-.02-.023-.02-.023-.008-.01-.037.037-.019.019-.033.034-.016.016-.02.024-.004.003-.003.004-.013.015-.017.022-.016.022-.01.014-.01.014-.008.015-.012.022-.008.015-.014.029-.018-.036-.004-.01-.004-.013-.006-.012-.012-.013-.006-.006-.008-.007-.01-.007-.011-.009-.018-.014a.398.398 0 0 0-.078-.031l-.031-.007.01.002v.002l-.013-.002a.21.21 0 0 0-.048 0l-.014.001-.063.01-.012.002-.01.002-.03.004.012-.027a.512.512 0 0 1 .17-.19l.147-.11.032-.024.009-.007.013-.01-.008-.031-.002-.009-.002-.005v-.005l-.028.021-.036.026-.074.056-.043.032-.044.031-.027.02-.034.022a.173.173 0 0 1-.098.005.122.122 0 0 1-.041-.015c-.01-.007-.017-.017-.014-.027l.01-.016.016-.011.032-.023.298-.208.068-.05.006-.032c.01-.04.029-.06.068-.074l.046-.01.016-.003.019-.003.02-.002h.001l.174-.003zm-2.3-3.014l-.005-.005-.004-.004-.018-.011-.014-.01a1.132 1.132 0 0 1-.079-.058l-.045-.04-.035-.038-.014-.018-.008-.012a.36.36 0 0 1-.048-.1.429.429 0 0 1-.004-.222l.023-.093.009-.028.01-.039.008-.028.003-.013.002-.008.002-.013V6.98l-.001-.013-.008-.048a.262.262 0 0 0-.005-.014l.004.013a.18.18 0 0 0-.015-.04l.011.027a.15.15 0 0 0-.02-.04l.009.013a.121.121 0 0 0-.025-.033l.017.02a.124.124 0 0 0-.03-.03l.013.01a.163.163 0 0 0-.038-.024l-.01-.006-.045-.016-.026-.01a.328.328 0 0 1-.062-.028l-.013-.01-.009.002h-.021l-.003.002c-.058.021-.124-.03-.171-.128l-.026-.064-.003-.008a.36.36 0 0 1 .191-.12h.04l.004.002.011.005a.382.382 0 0 1 .035.018.12.12 0 0 1 .052.046L9.43 6.5a.452.452 0 0 1 .106.033l.044.023a.704.704 0 0 1 .006.003l.013.008.013.008.003.002h.001l.013.01h.003l.01.007.049.033.013.009a.36.36 0 0 1 .052.065l-.052-.065a.356.356 0 0 1 .107.234.504.504 0 0 1-.01.154.817.817 0 0 1-.018.075l-.007.032a.013.013 0 0 0-.004.006l-.001.003c-.059.114-.026.207.07.279.152.078.24.178.267.323l.009.093v-.003a.234.234 0 0 0 .046.087l.03.024a.17.17 0 0 0 .062.022l.01.001v-.005l.005-.03a.1.1 0 0 1 .041-.054l.038-.018.005-.002c.013-.053.041-.092.081-.107l.044-.007h.002a.178.178 0 0 1 .039-.046.297.297 0 0 1 .11-.056.243.243 0 0 1 .032-.014l-.026.013a.137.137 0 0 1 .035-.015l.03-.005h.075l-.004-.01.003-.002a.043.043 0 0 0-.023-.024l-.019-.007.002.001-.01.002a.967.967 0 0 1-.326-.012l-.109-.03-.016-.007a.63.63 0 0 1-.07-.033l.07.033a.6.6 0 0 1-.172-.105h-.047v-.05a.505.505 0 0 1-.105-.253.756.756 0 0 1-.006-.113c.013-.13.081-.278.197-.432a.66.66 0 0 1 .07-.077l.048-.044v-.002l.015-.01.017-.016.02-.016.003-.003.009-.006.054-.044.124-.1.025-.022.022-.018.024-.025.003-.003.004-.008V6.18l.005-.01v-.004l.011-.035a.122.122 0 0 0-.006-.043l.005.022a.182.182 0 0 0-.013-.042l.008.02a.22.22 0 0 0-.024-.051l.016.03a.23.23 0 0 0-.025-.044l.01.014a.209.209 0 0 0-.031-.04l.021.026a.185.185 0 0 0-.033-.036l.012.01a.15.15 0 0 0-.017-.013l.02.057.037.066.012.018-.021.007c-.157.048-.28-.064-.303-.202l-.03.008-.036.006-.01.004a.637.637 0 0 1-.011.001l-.018.003-.025.002a.513.513 0 0 1-.038.002l.063-.004a.498.498 0 0 1-.168-.009.3.3 0 0 1-.083-.038.228.228 0 0 1-.09-.123.292.292 0 0 1-.014-.096v-.008l.005-.073-.006-.018-.005-.022-.013-.053V5.51l.018.077a.54.54 0 0 1-.022-.104.21.21 0 0 1 .032-.15l.01-.012a.182.182 0 0 1 .029-.03l.012-.01a.317.317 0 0 1 .013-.009l.018-.01.007-.005.027-.014.015-.007.013-.006.26-.224.013-.004.012.008c.005.01.009.025.012.043l-.012-.043c.006.012.01.03.013.053a.405.405 0 0 1 .003.061l-.008.06-.002.004-.005.008c.015-.011.022-.014.03-.014l.01.002.006.006.001.02.004.07.003.077.001.039c0 .011-.03.012-.032 0l-.011-.053-.025-.054-.006-.01-.02-.029-.134.195a.067.067 0 0 0-.003.06c.005.012.013.02.025.021l.02-.003.025-.01.027-.01.072-.026a.898.898 0 0 0 .1-.044.016.016 0 0 1 .02.003l.004.009v.001l.005.007.001.006v.014l-.008.008-.037.019-.17.085-.076.039-.007.024v.003a.03.03 0 0 0 .01.019l.026.012.048.001.051-.006.023-.004a.45.45 0 0 1 .09-.007l.042.004h.001l.022-.018a.174.174 0 0 1 .068-.116l.02-.01-.004-.008c-.015-.022-.02-.04-.014-.064l.016-.04.004-.005.011-.01.056-.047.022-.019.02-.018.02-.017.005-.004.004-.005.018-.016.046-.047.013-.014a.31.31 0 0 0 .082-.157l.004-.057c.002-.014.013-.018.022-.016l.01.009v.002l.01.026.002.01.005.015.01.04.014-.032.014-.032.039-.064.026-.038a.556.556 0 0 0 .023-.036.016.016 0 0 1 .024-.005l.006.013v.03l.002.025.002.022.002.016.004.028.003.019.002.023c.005.024.019.036.034.038l.023-.005.003-.002.004-.022.003-.017.002-.018.005-.054a.31.31 0 0 1 .056-.166.016.016 0 0 1 .022-.005l.007.01.01.03.041.123a.175.175 0 0 1 .03-.036c-.004.003-.002 0 0-.003h.002l.005-.003.013-.012.01-.01a.155.155 0 0 0 .04-.062.016.016 0 0 1 .023-.01l.009.012.018.068.006.026.006.022.002.013.002.007.014-.002.024-.001h.041c.07.004.143.019.217.043l.042.014.04.015.017.007.008.004.01-.002.012-.002a.354.354 0 0 1 .08-.005.16.16 0 0 1 .07.019c.011.005.012.02.003.027-.015.011-.021.018-.024.027l-.002.014v.011l-.001.003-.001.003.028.02.024.02.008.007.017.016.017.018.028.03.013.015-.016-.128c-.043-.086-.081-.122-.151-.143l-.06-.014-.026-.005-.032-.006-.015-.003-.01-.003-.008-.002-.008-.002a.16.16 0 0 1-.142-.103l-.009-.04c0-.15.072-.22.214-.25l.077-.011h.005v-.003h.008l.004-.007.002-.005.006-.01a.16.16 0 0 1 .088-.076l.048-.015.02-.004h.004l.018-.004.018-.003.02-.002.02-.003.023-.003.048-.005c.26-.015.49.033.768.144l.174.074.236.11.03.013.028.013.027.01.025.011.07.026c.132.044.23.048.312.007.015-.008.03.011.02.025l-.048.066-.036.065-.006.015.065.047.039.028.037.027.036.027.035.026.033.026.016.013.016.012.031.025.03.025.015.012.056.048c.108.096.195.188.275.295l.079.112.008.012c.034.052.065.11.096.18l.048.115.007.018.087.227.011.028.01.022.009.021.002.005.002.005.01.02.026.052c.056.101.108.134.174.11a.017.017 0 0 1 .023.017.1.1 0 0 1-.068.083l-.043.01-.002.001.003.01.013.06.011.075.003.028v.007l.001.007.003.029.002.03.002.03.002.03.001.031v.016l.002.031v.183L15 7.25v.014l-.002.026-.002.025a.749.749 0 0 1-.014.1l-.01.031v.003l-.005.015-.014.06-.011.066-.003.02c-.011.08-.016.16-.018.24l.001.118.001.028a.78.78 0 0 1-.004.134l-.002.025-.001.007-.001.007-.003.027-.013.084-.005.029-.002.007v.007l-.007.029-.002.014-.002.007-.001.007-.006.027-.002.007-.002.006-.006.025a.859.859 0 0 1-.028.092.19.19 0 0 1-.026.05l-.019.015h-.02V8.6c-.01-.001-.017-.008-.022-.021l-.007-.025-.002-.013v-.004l-.001-.003-.002-.016-.003-.016-.002-.02-.002-.02-.001-.023-.003-.038-.003-.056-.002-.037-.003-.078-.006-.183-.004-.052-.002-.033-.004-.047-.003-.03-.003-.03-.003-.03-.005-.045-.004-.032-.007-.05-.005-.037-.012-.08-.001-.032-.003-.058-.003-.125-.003-.09-.003-.069-.02-.028-.019-.013c-.006-.002-.01 0-.01.005l-.002.013v.16l.06.552V7.9l-.05.466a.016.016 0 0 1-.017.015l-.011-.005-.08-.08-.003-.005-.001-.006V8.1l-.009-.045-.137-.659v.008l-.002.015v.014a.356.356 0 0 0 0 .065l.001.006.002.005.003.013.002.014.003.016.002.017.003.019.002.02.004.044.003.037.002.026.002.028.002.043.002.046.004.099.003.104v.075l.002.049v.11c0 .012-.001.02-.006.025-.011.015-.024.008-.033-.004l-.004-.005-.004-.007-.005-.01-.018-.035-.007-.012a.193.193 0 0 0-.017-.027l-.003-.005-.001-.025-.001-.007-.001-.008-.003-.015-.008-.044-.003-.014-.003-.024-.002-.02V8.02l-.024-.132-.013-.074-.01-.05-.01-.047-.009-.045-.006-.028-.006-.027-.006-.026-.006-.025-.006-.024-.007-.023-.003-.01-.003-.012-.006-.02-.007-.02-.006-.02-.007-.017-.006-.017a.446.446 0 0 0-.05-.094l-.029-.033-.002-.002v.003l.012.062.004.024.004.015.004.02.008.04.009.05.007.041.007.04.006.038.005.031.006.036.004.033.003.02.003.027v.009l.002.016.001.015.001.013c.001.03-.002.05-.008.058-.011.012-.026.012-.037.001l-.01-.01-.01-.018-.037-.075-.007-.013-.011-.02-.012-.017-.004-.01-.002-.007-.005-.014-.005-.015-.005-.016-.001-.005-.001-.004-.005-.02-.006-.02-.02-.085-.006-.022a1.14 1.14 0 0 0-.02-.068.616.616 0 0 0-.07-.149l-.049-.06-.002-.002.016.044.02.058.01.028c.014.04.026.08.036.116.012.043.02.083.026.119l.005.05v.005c.001.043-.01.062-.037.044l-.009-.008-.011-.013-.012-.015-.016-.019a.147.147 0 0 0-.03-.028.017.017 0 0 1-.006-.008l-.02-.048-.02-.05-.041-.108-.008-.02-.008-.019-.008-.018-.025-.052-.029-.05-.01-.008-.033-.03a3.613 3.613 0 0 0-.152-.121l-.068-.05-.01-.006.081.104c.05.069.089.136.125.21l.051.116.008.019c.008.027-.003.046-.029.04l-.01-.003-.012-.005-.031-.016-.01-.005a.196.196 0 0 0-.02-.007.732.732 0 0 1-.064-.076l-.006-.01-.02-.03-.008-.012-.02-.032-.026-.04a.584.584 0 0 0-.067-.088l-.033-.03-.013-.003-.014-.003-.034-.007a.444.444 0 0 1-.187-.087l-.071-.06-.012-.012a.035.035 0 0 1-.01-.002c-.017.003-.031.021-.037.043v.036c.02.026.038.066.056.114l.026.076.008.027.008.027.007.028.006.021.005.02.006.029.009.04.009.051.006.047.002.023h.006v.025l.015.008.017.01.026.014.02.012.02.012.015.01.023.013.041.026.026.017.018.012.048.032.062.043.081.057.076.054.098.07.125.09.28.205.183.133.089.063.068.049.064.044c.034.027.04.063.023.097a.112.112 0 0 1-.038.041l-.022.008a.646.646 0 0 1-.272.013l-.068-.015c-.024.068-.144.11-.26.095l-.068-.016h-.002c-.04.045-.14.05-.223.025l-.057-.022-.006-.004c-.035.025-.103.02-.154.004l-.043-.019-.003-.001-.003-.002-.004-.003-.025-.025-.117-.12-.028-.028-.02-.02-.013-.012-.01-.009-.003-.002h-.016v.006l-.004.009-.008.025-.004.01a.068.068 0 0 1-.02.033.017.017 0 0 1-.02 0l-.003-.002-.004-.002-.01-.007-.015-.012-.01-.01v-.002a.228.228 0 0 1-.038.088l.006.008.009.01.008.01.008.008.012.013.037.036.013.013.02.02.033.029.03.026.02.018.022.015.005-.003c.022 0 .037.005.046.012h.024l.041-.008a.214.214 0 0 1 .063-.003.141.141 0 0 1 .112.1l.005.035.002-.006c.09.07.082.201.006.271l-.043.029-.022.01-.001-.024c-.003-.06-.024-.097-.074-.123l-.017.002c.032.061.04.121.024.178h.005l.02.005.01.001.017.003c.053.008.086.006.11-.01l.023-.02.058-.067.034-.04.025-.027.015-.017.022-.024.013-.015.014-.014.013-.013.003-.003.015-.015.012-.01.012-.011.003-.002.002-.003.012-.009.03-.021.028-.016.01-.005a.24.24 0 0 1 .087-.02l-.016.003c-.002-.007 0-.011.001-.014l.084-.085a.016.016 0 0 1 .026.021l-.075.075h.005l.018.001.014.001.014.001.03.004.023.003.025.003c.039.015.07.03.098.046l.047-.04a.21.21 0 0 1 .14-.038c-.014-.033-.008-.083.02-.125.038-.061.1-.078.146-.048.025.016.04.04.044.067l.023.007.09-.078a.096.096 0 0 1 .024-.074l.03-.027c.047-.03.094-.022.116.013.024.036.014.082-.032.111a.125.125 0 0 1-.096.02l-.086.075a.094.094 0 0 1 .006.078l.024.017.017.024.002.004.004.012c.014.055-.018.109-.088.127a.168.168 0 0 1-.128-.015.177.177 0 0 1-.083.107.305.305 0 0 1-.04.022.235.235 0 0 1-.048.15l.092.02c.009.002.016.02.015.041-.001.019-.007.033-.015.034h-.003l-.116-.025c-.006-.001-.011-.01-.013-.023l-.035.034a.591.591 0 0 1-.08.058l-.062.03h.03v.001l-.003.003a.016.016 0 0 1 .024-.001.017.017 0 0 1 .001.023c-.003.004-.005.005-.01.006h-.077l.047.035a.017.017 0 0 1 .005.021l-.002.003a.016.016 0 0 1-.02.005l-.003-.002-.08-.058a.93.93 0 0 1-.499.013l-.007.063c-.001.009-.021.016-.045.015-.021 0-.038-.006-.04-.014v-.003l.01-.087-.048-.017-.005-.002-.026-.011-.024-.008-.014-.004-.015-.003-.017-.004-.059-.013-.025-.006-.015-.004-.003-.001-.016-.005a.362.362 0 0 1-.007-.002 1.126 1.126 0 0 1-.276.11.15.15 0 0 1 .092.132v.031h-.002v.005a.153.153 0 0 1-.028.064l-.001.001.003.018.006.032.017-.003.037-.004.038-.004.04-.005.057-.007.046-.006.083-.012.315-.045.076-.01.044-.005v.076l-.439.201c-.007.013-.006.02.003.029l.013.008.018.008.01.003.013.004.03.008.004.001a.14.14 0 0 1 .114-.057.145.145 0 1 1-.13.213l-.066.012-.05.011-.05.012-.011.002-.191.045v.031l-.002.006a.153.153 0 0 1-.06.096l-.006.004-.007.004a.153.153 0 0 1-.092.02.21.21 0 0 1-.059.01l-.032.002-.012.023-.013.018-.002.002-.002.002-.004.003-.02.012v.007l-.102.001-.336.002h-.478l-.036-.001-.033-.001h-.01c-.017-.003-.036-.016-.059-.039l-.01-.01-.022-.023a.197.197 0 0 1-.063-.018.153.153 0 0 1-.207-.142l-.006-.002-.025-.003-.04-.004-.044-.004-.03-.003-.13-.01-.055-.005a.296.296 0 0 1-.141.121c-.11.048-.224.033-.256-.038-.031-.072.036-.166.145-.214.082-.036.167-.037.218-.004.055-.057.06-.101.027-.137a.329.329 0 0 0-.149-.07l-.077-.018-.027-.005-.041-.007-.02-.002-.022-.003-.023-.003-.026-.002-.043-.005-.054-.005-.077-.006a.153.153 0 0 1-.149.127.146.146 0 1 1 .103-.25c.073-.015.086-.036.064-.072a.301.301 0 0 0-.06-.066l-.05-.04-.02-.014-.02-.015-.014-.009-.11-.074a.32.32 0 0 1-.205.004c-.13-.037-.221-.133-.197-.218.024-.086.15-.121.282-.084.092.026.163.08.19.14l.02.013.042.024.027.016.052.028.025.014.024.013.023.012.056.028.042.02.02.01.038.016.036.014.017.006.016.006.03.01.015.004.014.004.013.003.012.002.003.001h.003l.012.002.011.002c.07.006.103-.019.102-.07a.138.138 0 0 1-.127-.142.153.153 0 1 1 .272.097c-.002.173.187.307.34.28l-.042.002a.153.153 0 0 1 .262-.143l.016-.001.021-.002.09-.007.094-.006.047-.002.049-.002h.05l.05-.002h.114l.002-.017c.006-.076.017-.146.034-.21a1.793 1.793 0 0 1-.473.065v.003l-.001.002-.076.088a.016.016 0 0 1-.027-.019l.002-.002.063-.072a1.018 1.018 0 0 1-.314-.055l-.031-.015-.002.003-.076.087a.016.016 0 0 1-.026-.019l.001-.002.07-.083-.02-.009a.37.37 0 0 1-.142-.126l-.024-.05-.019.007a1.054 1.054 0 0 1-.452.052l.003.014c0 .018-.004.035-.012.04l-.003.001-.115.024c-.01.002-.018-.014-.018-.035-.001-.018.004-.035.012-.04l.003-.001.064-.012a.823.823 0 0 1-.214-.069l-.083-.048-.004.011a.015.015 0 0 1-.005.006l-.003.002-.116.023c-.009.002-.017-.013-.018-.034 0-.019.005-.035.013-.04l.002-.002.07-.014a.3.3 0 0 1-.109-.21.605.605 0 0 1-.139-.007l-.005.007-.002.002-.118.054c-.008.004-.018-.002-.02-.014-.003-.01 0-.022.007-.028l.003-.001.074-.032a.802.802 0 0 1-.21-.087l.001.01c0 .022-.007.04-.016.04l-.034-.003-.131-.016c-.01-.001-.016-.02-.016-.042 0-.023.008-.04.017-.039l.128.016a.717.717 0 0 1-.121-.106.538.538 0 0 1-.075-.104l-.024-.053-.002.011a.013.013 0 0 1-.005.006l-.093.001c-.009 0-.016-.022-.016-.05 0-.024.006-.044.013-.048h.003l.082-.001a.301.301 0 0 1 .116-.263l-.073.048a.29.29 0 0 1-.103-.094.235.235 0 0 1-.043-.116.135.135 0 0 1-.098-.015c-.05-.029-.066-.075-.041-.11a.078.078 0 0 1 .012-.016.084.084 0 0 1-.008-.055l.01-.027.028-.048v.018a.088.088 0 0 1 .067-.013l.026.01-.024-.01.006-.024.01-.02.003-.003H9.11l.066-.018-.075-.083a.154.154 0 0 1-.076-.058c-.032-.047-.025-.097.012-.121.037-.025.085-.016.117.031.025.037.032.082.019.112l-.018.022.078.084h.008l.02.001h.065a.067.067 0 0 1 .054-.024c.045.002.079.043.077.107-.001.05-.022.095-.05.115.03.013.06.039.086.076a.294.294 0 0 1 .053.173.28.28 0 0 1 .178.034v-.111c0-.005.012-.009.026-.009.013 0 .023.003.026.007v.12c0 .004-.011.008-.026.008.032.02.067.047.101.08.06.058.117.133.168.215l.032-.019.05-.03c.008-.004.017 0 .022.01.004.01 0 .02-.008.026l-.038.023-.039.023.054.1.036.084.007-.006.002-.002.008-.006a.567.567 0 0 1 .125-.047l-.08-.079a.016.016 0 0 1 .021-.025l.084.084c.005.004.006.01.005.016a.517.517 0 0 1 .207-.004.175.175 0 0 1 .025-.04.097.097 0 0 1-.03-.063c-.004-.049.023-.084.061-.089h.01v.028c-.01-.05.014-.09.053-.101l.005-.001.025-.006v.004l.016.005.002-.01a.071.071 0 0 1 .048-.047h.033c.025.008.04.025.044.046l-.001.008.003.015a.035.035 0 0 1-.003.013.073.073 0 0 1 .034.013c.03.021.041.058.025.095l.02.008c.039.027.047.074.01.111a.13.13 0 0 1-.067.035l.005.05-.01.063.071.057.017.016c.04.04.078.083.11.13l.019.03.034-.05.043-.052a.162.162 0 0 1 .012-.01l-.068-.068a.016.016 0 0 1 .018-.027l.003.002.002.001.074.075a.525.525 0 0 1 .186-.06l-.008-.009-.025-.03-.012-.015-.008-.008h.007a.017.017 0 0 1 0-.034l.006.001.008.006.007.007.009.011.018.022.016.02-.003-.089c0-.008.006-.015.013-.016h.003c.009 0 .015.005.017.012v.003l.003.114c.08-.006.169 0 .261.017l.129.03-.047-.011-.02-.025-.011-.012.005-.001a.016.016 0 1 1 0-.033c.006 0 .008.001.013.005l.004.004.007.008.01.012.021.026.01.01-.003-.087c0-.008.005-.015.013-.017h.003c.008 0 .015.005.016.013v.003l.004.113c.079.024.155.054.224.088a.182.182 0 0 1 .113-.091l.053-.009V8.82l.004-.009c.035-.03.09-.033.154-.013l.064.024.014.001a.05.05 0 0 1 .03-.002h.003l.034-.01.005-.002.02-.01.01-.003a.255.255 0 0 0 .063-.052l.031-.039c-.003-.005-.01-.008-.017-.013l-.003-.003-.002-.004-.006-.012a.134.134 0 0 1-.044.04l-.03.014-.017.005h-.043l-.015-.006-.011-.01-.006-.006-.008-.009-.013-.02-.007-.01-.007-.011-.012-.017-.019-.025-.07-.094-.02-.028-.013-.018-.011-.017-.008-.012c-.017.01-.032.014-.047.01l-.02-.011-.004-.004-.01-.012-.009-.012-.01-.013-.01-.014-.01-.015-.01-.017-.02-.029-.04-.064-.018-.028-.01-.017-.012-.017c-.001.077-.026.156-.058.187l-.024.014h-.001a.106.106 0 0 1-.077-.018l-.032-.03-.002-.002a.335.335 0 0 0-.015.01l-.003.002-.004.004-.002.001c0 .004-.009.01-.025.017l-.028.01-.013.003-.014.004-.015.003-.016.003-.035.006-.018.003-.018.003-.029.003-.02.002-.019.001-.02.002h-.01l-.02.001h-.084l-.017-.002c-.015-.001-.02-.004-.022-.01a.113.113 0 0 1-.013-.054l.003-.03.008-.031-.055-.008-.024-.004-.023-.003-.024-.005a.493.493 0 0 1-.135-.041c-.035-.02-.055-.043-.055-.072l.006-.03a.345.345 0 0 1 .021-.024l-.055-.02-.008-.003-.004.004c-.01.046-.03.074-.062.086l-.034.006-.04-.005a.425.425 0 0 1-.124-.059l-.008-.006-.026-.019-.034.016a.1.1 0 0 1-.038.002.092.092 0 0 1-.06.04.097.097 0 0 1-.125.03l-.039.017-.088.04c-.136.046-.285-.009-.388-.163l-.002-.005-.001-.004-.007-.017-.002-.005-.002-.004-.007-.02-.004-.013-.01-.032-.008-.023-.01-.03-.004-.014-.01-.03-.007-.019-.006-.018-.007-.016a.671.671 0 0 0-.004-.01v-.001l-.002-.004-.006-.014-.006-.013-.007-.012-.006-.01-.005-.009-.006-.007-.007-.01-.004-.005zm3.014 2.24l-.03.003-.072.004-.034.002-1.123.462-.071.085.003.002.023.004c.273.03.575.033.898.016l.202-.014.008-.011-.007-.006a.152.152 0 0 1-.035-.099.153.153 0 0 1 .244-.122.975.975 0 0 0 0-.289l-.006-.037zm-.747-.25h-.209a4.321 4.321 0 0 0-.348.02.072.072 0 0 1 .018.052.153.153 0 0 1-.132.151l.006.04v.126l-.013.085-.006.03-.01.041.042.008c.06.02.105.078.105.145l-.003.016.018-.02 1.133-.467h.006l.037-.002a.141.141 0 0 1-.06-.019.153.153 0 0 1-.075-.134c0-.02.004-.039.01-.056l-.2-.007-.072-.002-.114.006h-.005l-.023-.011h-.05l-.055-.002zm-1.926-.254l-.001.032a.112.112 0 0 1-.043.06l.108.075.032.023.02.015a.44.44 0 0 1 .109.107c.029.047.016.086-.036.108l-.037.01.016.036.003.023.034.004.09.007.052.005.08.01.02.002.029.005c.14.023.238.056.286.106.048.05.04.112-.028.184l.012.018a.1.1 0 0 1 .006.059l.037.004.118.009.1.009.04.004.025.003h.006l.003-.014a.153.153 0 0 1 .076-.088 1.698 1.698 0 0 1-.005-.271l.01-.084a.154.154 0 0 1-.06-.057c-.158.009-.336-.123-.35-.296a.103.103 0 0 1-.082.035c.005.051-.023.084-.078.091l-.046.001-.067-.012-.071-.021-.02-.008-.045-.017a1.594 1.594 0 0 1-.023-.01l-.024-.01-.012-.006-.025-.012-.026-.012-.026-.013-.007-.004-.007-.003-.028-.015-.029-.015-.03-.016-.007-.004-.007-.004-.063-.036-.008-.004-.008-.005-.013-.008zm3.44.406l-.017.002-.06.007-.078.011-.207.03-.104.015-.062.009-.057.007-.053.006-.038.004-.037.004c.015.12.018.221.005.316l-.012.059a.152.152 0 0 1 .016.036l.134-.031.09-.021.11-.024.027-.006-.005-.034c0-.022.005-.042.013-.06l-.017-.004-.016-.005-.013-.004a.153.153 0 0 1-.044-.023c-.016-.015-.022-.031-.018-.049l.011-.027.003-.004.428-.197v-.017zm-.68-.84l-.024.001-.014.003h-.02l-.016.003-.014.003-.043.008-.01.002-.014.004-.046.01-.013.003-.011.002-.015.004a.137.137 0 0 0-.045.021l-.011.012-.018.053a.123.123 0 0 1-.113.074l-.057-.007c-.011-.003-.014-.005-.017-.008a.092.092 0 0 1-.002-.003l-.038.018.018.033-.028-.026a.116.116 0 0 0-.043.063l-.007.045-.001.024-.022-.01a.156.156 0 0 1-.069-.062l-.025.033-.03.036-.016.019-.014.016-.012.014-.013.013a.915.915 0 0 0-.034.155l-.007.073a.117.117 0 0 0 .025.01l.07.001.059.002.06.001h.014l.001-.007.007-.05.002-.023c0-.005.001-.008.005-.003a.017.017 0 1 1 .024-.023c.005.005.005.007.005.013v.013l-.003.02-.005.039-.003.023.105-.055a.017.017 0 0 1 .021.004l.002.002a.017.017 0 0 1-.005.021l-.002.002-.054.029.036.001h.016l.087-.009c.202-.028.374-.078.498-.144l.003-.003-.011-.006v-.02c.004-.123.044-.173.125-.177l.054.003.015.002.012.002a.208.208 0 0 0-.026-.166l-.022.002h-.074l-.014-.001a.017.017 0 0 1-.014-.01.214.214 0 0 0-.102-.105l-.03-.012-.036-.005zm.984-.013h-.045a.207.207 0 0 0-.073.02l-.036.02-.01.007-.01.008-.011.009-.006.004-.01.01-.055.054-.02.022-.014.016-.023.025-.032.037-.079.092c-.028.032-.061.044-.112.042L13.3 9.39l-.02-.003-.03-.006a.347.347 0 0 1-.106.128.568.568 0 0 1-.03.022h.002l.015.004.017.004.05.01.026.007.008.002.014.003.013.004.012.004.01.003.01.004a.224.224 0 0 1 .023.011l.042.016c-.003-.006.017-.013.04-.012.022 0 .038.006.041.014v.003l-.001.019c.264.066.537.01.7-.129.073-.061.11-.128.112-.193-.083.027-.165.013-.198-.039-.032-.049-.019-.123.027-.185l-.061-.03-.019-.009-.037-.005-.021-.002-.02-.003h-.013l-.013-.001zm-2.506-.219c0 .013-.013.02-.023.016a.509.509 0 0 0-.166.04l-.066.038h.001l-.006.007-.043.054-.032.05v.002l.006.007.007.011-.01.01a.078.078 0 0 0-.022.041l-.003.032-.002.034a.182.182 0 0 1-.011.058c.01.054.04.101.09.142l.056.038.009.005c.202.11.548.12.92.016l-.017.003a.773.773 0 0 1 .127-.253.182.182 0 0 1 .028-.052.457.457 0 0 0-.072-.061.132.132 0 0 0-.066.033l-.027.03-.014.019-.014-.019a.163.163 0 0 1-.027-.15l-.103-.046-.112-.038-.01.006a.015.015 0 0 1-.013-.006l-.007-.01a1.2 1.2 0 0 0-.307-.048l-.07-.009zm-1.144-.148l-.08.034a.593.593 0 0 0-.042.032l-.095.143c-.019.076.007.153.075.222l.038.031h.001l.008.004.004.009h.002-.001v.002l.006.004.008.006c.197.138.514.175.807.07 0-.005.004-.009.007-.013a.298.298 0 0 1 .032-.189.83.83 0 0 0-.21-.235c-.044.132-.11.194-.202.166-.103-.024-.146-.106-.132-.217l.015-.07.008-.017a.537.537 0 0 0-.249.018zm-.65-.514l-.052.005a.122.122 0 0 1-.049.078.136.136 0 0 1-.107.014c-.088.102-.087.224-.01.344l.045.06.008.007a.75.75 0 0 0 .453.233l.092.003.02-.032a.315.315 0 0 1 .095-.148l.013-.011a1.482 1.482 0 0 0-.093-.19c-.005 0-.008-.001-.01-.004a.022.022 0 0 1-.005-.019 1.15 1.15 0 0 0-.1-.144l-.054-.06-.012-.012c-.078-.076-.157-.119-.234-.124zm3.414-.044l.021.213.442.402-.016.017c.06.04.176.055.23.032l.028-.024c.006-.009.014-.012.022-.009h-.008l-.719-.63zm.01-.235l-.004.036-.004.03-.003.01.001.007h-.002l-.002.021-.003.018-.005.024-.001.008-.003.013-.003.013-.007.02h.005l.015-.015.757.665-.017.02c.129.05.298-.003.292-.067-.001-.007.004-.014.01-.017l-1.026-.786zm.027-.257l-.002.03-.002.032-.002.023-.005.048-.004.037-.003.024-.006.038.008-.009 1.037.795-.02.024.01.001a.451.451 0 0 0 .14.028h.082l.046-.004.04-.006.012-.002.007-.001.01-.003.003-.003h.003c.01-.002.028-.017.037-.034.007-.013.008-.025.001-.037l-.015-.017-.053-.037-.115-.082-.108-.078-.34-.248-.157-.114-.085-.061-.09-.065-.06-.041-.054-.039-.051-.034-.047-.032-.035-.023-.041-.027-.03-.02-.029-.017-.027-.015-.012-.008-.019-.01-.024-.013zm1.055-1.36l.001.066.001.036.002.059v.078L14.1 6.5v.005l-.002.005-.001.005-.002.003-.003.005-.005.006c-.026.021-.088.025-.144.006l-.008-.003-.005-.003-.023-.02.001.017.001.013v.047l-.002.007V6.6l-.002.006-.002.006-.001.003a.08.08 0 0 0-.003.01c-.01.035-.066.036-.131.013l-.008-.003-.005-.003-.04-.037-.06-.055-.056-.052-.054-.05-.02-.02.003.13-.001.081v.007l-.001.002-.001.005v.003c-.007.023-.023.032-.06.031h-.024l-.014-.002-.016-.002h-.009a.471.471 0 0 1-.167-.08l-.001.049v.02l-.002.017v.009l-.001.016-.002.015a.313.313 0 0 1-.01.05l-.004.011a.262.262 0 0 1-.009.022c-.015.03-.067.039-.138.03a.302.302 0 0 1-.057-.018l-.016.147c0 .004-.004.008-.01.01a.503.503 0 0 0 .178.114l.061.016.019.004.014.004.025.006a.396.396 0 0 1 .078.077l.037.053.015.023.029.046.026.04.01.013.026.036.026.031-.001-.001.004.001.009.004.035.017.015.007-.005-.01a1.47 1.47 0 0 0-.205-.364l-.101-.12-.015-.017c-.013-.014.003-.034.019-.026l.034.019.038.023.02.014.011.007.045.032.023.017.006.005.006.004.024.019.012.01.025.02.026.02.026.021.052.044.026.023.033.056.026.055.008.018.008.02.008.02.01.022.04.106.015.04.014.033.016.013.012.012.006.007.005.007.022.026-.001-.015-.01-.063-.016-.073-.004-.015-.016-.056-.019-.059-.005-.014-.05-.14-.009-.028-.006-.01a1.074 1.074 0 0 0-.141-.216l-.02-.023-.01-.012-.02-.025-.067-.077a.016.016 0 1 1 .024-.022l.056.064.022.026.02.025.02.024c.044.053.08.103.108.151l.037.069c.086.068.14.155.178.269l.012.04.013.045.005.023.017.069.008.03.005.017.004.016.005.014.005.014.003.011.006.008.012.02.008.014.013.025.028.058.005.009v-.02l-.001-.012-.001-.014-.003-.023-.004-.035-.002-.02-.005-.031-.005-.033-.007-.048-.003-.019-.022-.12-.009-.05-.003-.01-.003-.015-.004-.022-.011-.062-.006-.03-.005-.02-.002-.002a.668.668 0 0 0-.122-.215.017.017 0 0 1 .025-.022.69.69 0 0 1 .124.214c.032.02.06.046.084.084l.034.066.007.017.009.022.008.023.007.02.002.005.001.005.009.027.001.006.007.023.006.024.006.025.007.026.001.006.002.007.006.028.006.028.01.046.006.032.01.05.01.052.007.039.023.135.002.031v.003l.001.002.002.012.002.012.01.051.003.017.001.012.001.007v.015l.003.003.01.016.007.013.004.007.008.016v-.082l-.001-.053-.003-.112-.001-.055-.002-.05-.002-.063-.002-.03-.002-.043-.003-.04-.002-.037-.003-.035-.003-.021-.002-.02-.002-.018-.003-.017-.002-.016-.003-.014a.3.3 0 0 0-.006-.023.368.368 0 0 1 0-.075.824.824 0 0 1 .009-.076l.003-.02.004-.02.001-.008-.009-.026a2.718 2.718 0 0 0-.005-.015l-.01-.028a.775.775 0 0 0-.143-.262l-.013-.014a.627.627 0 0 0-.035-.033.016.016 0 1 1 .023-.025c.059.054.103.11.143.192l.01.02c.012.026.024.053.036.084l.01.027.01.028.011.03.004.012.003.004.009.045.153.752v.181l.05.05.046-.43-.026-.235-.028-.265-.006-.054v-.163c.001-.034.02-.054.049-.047a.07.07 0 0 1 .028.013l.01.047c-.026-.163-.086-.274-.162-.33a.016.016 0 1 1 .02-.026c.083.06.147.18.174.351l-.002.012v.002l.002.032.002.058.003.125.003.09.003.071.001.01.002.011.009.059.007.053.004.033.008.063.007.06.003.03.002.031.003.032.002.033.004.052.004.135.004.093.002.055.002.044.003.04.002.024.001.022.003.03.002.018.003.017.002.015.002.012.003.01.002.005v.003h.003a.182.182 0 0 0 .022-.044l.01-.03.011-.036.006-.023.005-.018.01-.045.003-.013.006-.028.003-.015.005-.028.005-.028.004-.028.004-.027.003-.027.004-.026V8.14l.003-.024a.955.955 0 0 0 .004-.086v-.032l-.002-.026v-.033a2.222 2.222 0 0 1 .017-.334l.015-.088.02-.079.01-.029.007-.04.002-.02.001-.006v-.005l.003-.023.001-.024v-.006l.001-.006.001-.026.001-.027v-.014l.002-.043v-.106l-.001-.015-.001-.031V7l-.002-.03-.002-.03-.001-.03-.003-.03-.002-.029-.003-.027-.003-.027-.003-.025a.781.781 0 0 0-.017-.092l-.01-.023-.054.002a.494.494 0 0 1-.2-.064.775.775 0 0 1-.244-.219l-.008-.037c.012.049.014.08.007.099-.01.024-.025.028-.057.025l-.021-.003h-.027l-.015-.012-.019-.016-.02-.019-.011-.01-.022-.02-.024-.023-.037-.036-.072-.07zm-1.98 1.277l-.01-.053c.021.09.027.14.024.238l-.001.031v.006l.047.086c.114.192.273.367.394.413l.006.003v-.029l-.003-.09a2.965 2.965 0 0 1-.096-.14l-.015-.023-.014-.024a1.251 1.251 0 0 1-.123-.277.73.73 0 0 1-.148-.088l-.06-.053zm.233-.114c.013.083.015.16.007.231l-.002.004.024.076c.011.03.024.06.039.09l.012.025.003.006.016.031.013.024.014.025.014.023.029.047a.728.728 0 0 0 .184.207l.007.004v-.002a.456.456 0 0 0 .024-.165l-.037-.077-.009-.022-.018-.045-.018-.05-.002-.007-.012-.034-.009-.028-.008-.029-.01-.031-.017-.064-.012-.046-.017-.067-.01-.038-.035-.008a.861.861 0 0 1-.14-.063l-.03-.017zm.24-.126c0 .066.004.13.003.187l-.001.017-.002.012.016.063.014.056.01.04.011.038.008.028.012.04.005.014.01.028.008.028.01.026.009.024.01.024c.038.096.079.16.12.187l.003.002.002-.001c.016-.023.026-.06.025-.118v-.01l.016.002a.835.835 0 0 1-.017-.041l-.007-.02-.007-.022-.008-.023a1.728 1.728 0 0 1-.003-.012l-.007-.024-.008-.026-.007-.027-.003-.014-.008-.029-.007-.03-.007-.03-.009-.037-.032-.154-.029-.134-.01-.05-.003-.01h-.051a.85.85 0 0 1-.066-.004zm.22-.176v.035l-.07.005a.787.787 0 0 1 .005.11v.015l-.001.015h-.003l.005.024.033.154.033.155.006.029.011.047.008.03.007.03.007.027.008.026.003.013.008.024.003.012.008.023.001.005.01.026a.957.957 0 0 0 .007.02l.007.018a.352.352 0 0 0 .048.086l.001.003.003-.01.002-.012.004-.022.003-.017.004-.029.001-.003a1.983 1.983 0 0 0-.1-.696l-.062-.143zm-1.889-.989l-.004.027a.362.362 0 0 1-.035.107.41.41 0 0 1-.04.07.563.563 0 0 1-.015.022l-.009.012a.771.771 0 0 1-.015.02l-.017.017-.02.026-.024.024-.016.017-.026.024-.018.016-.017.013-.002.003-.019.016-.05.04-.015.01-.015.01-.013.01-.011.008c-.138.109-.238.265-.249.392-.01.122.06.205.215.234l.071.007a.109.109 0 0 1 .004-.003l.004.004.006.002.077-.002h.092c.157.005.248.037.317.126a.344.344 0 0 1 .073.203v.012l.001.004a.234.234 0 0 1-.015.096l-.007.018h.002l.048.04a.19.19 0 0 1 .051.156l-.01.04-.002.008.057.018.004-.001.101-.032-.025-.031-.015-.019c-.058-.073-.083-.12-.086-.176 0-.007.003-.013.01-.016a.274.274 0 0 1 .102-.015l.057.004h.003l-.006-.009-.01-.017-.002-.004-.003-.004-.01-.018-.013-.02-.02-.031-.052-.076-.017-.026-.017-.025a.973.973 0 0 1-.088-.167l-.023-.068-.001-.004v.002l-.005-.006-.006-.007-.007.005-.006.004-.01.01a.095.095 0 0 1-.016.012c-.025.013-.046 0-.069-.037l-.002-.005v-.01l.002-.014v-.04l-.002-.01-.002-.009-.004-.021-.005-.019-.004-.014-.008-.032L11.014 7l-.017-.058-.002-.008-.003-.007-.007-.029c-.046-.174-.046-.29.018-.418l.024-.042.029-.041.008-.011-.007-.006-.002-.009v-.003l-.022-.021-.01-.008c-.008-.008-.009-.02-.004-.032v.002l.003-.01.005-.01.005-.012.001-.003.002-.003.007-.013.008-.014.003-.003.002-.004.01-.015.01-.016.006-.009.011-.017.013-.017.012-.018.014-.017.003-.005.004-.004.014-.018.014-.018.003-.004.004-.004.015-.017.005-.006c-.018.001-.029-.002-.029-.018v-.006l.003-.004.002-.002c-.017-.036.024-.128.078-.197l.042-.047h.001l-.008-.016a.376.376 0 0 0-.067-.089l-.003.007-.008.018V5.7l-.002.003-.003.01-.003.007a.103.103 0 0 1-.08.071l-.036.005h-.036l-.01.004-.015.009a.66.66 0 0 0-.064.04.332.332 0 0 0-.064.058l-.018.025.015.026.005.008.007.013.013.044.003.01.005.02a.302.302 0 0 1 .003.036v.037zm.676.895l-.009.235.038.062c.116.17.325.354.465.404l.006.003v-.008a.74.74 0 0 0-.019-.22l-.003-.012a1.18 1.18 0 0 1-.132-.2l-.015-.029-.052-.102h-.006a.412.412 0 0 1-.273-.133zm.342-.132l-.003.053a.922.922 0 0 1-.034.19l.04.08.031.059.015.027.015.026a.708.708 0 0 0 .307.304l.015.007V7.63c.019-.185-.04-.426-.168-.665a.59.59 0 0 1-.218-.077zm.26-.214a1.39 1.39 0 0 1-.014.245l-.004.025.058.115c.049.108.083.214.103.315.082.049.16.086.215.099h.003V7.46a1.712 1.712 0 0 0-.206-.761.363.363 0 0 1-.154-.024zm.191-.103c0 .03-.004.064-.011.101l-.002.003.072.141c.06.14.105.296.127.44a.99.99 0 0 0 .11.006h.026V7.25c0-.19-.077-.417-.224-.676h-.036l-.04-.001-.022-.002zm-.578-.215a.508.508 0 0 1-.135.226l-.008.007-.005.004h-.006a.116.116 0 0 1-.064-.017c-.021.074-.01.156.028.265.003.009-.008.018-.024.02-.017.001-.032-.005-.036-.014-.046-.133-.054-.228-.011-.321a.357.357 0 0 1-.016-.036l-.005-.014-.005-.016a.743.743 0 0 1-.005-.016l-.004-.018-.002-.005-.006-.024-.004-.02a.23.23 0 0 1-.074.072l.012.006a.467.467 0 0 0-.048.336l.003.012-.038.008a.507.507 0 0 1 .031-.343l-.027.017-.011.005-.007.001-.039-.007-.03-.019-.026.053a.585.585 0 0 0 .022.451l.006.013.001.004c0 .004.002.007.004.012l.005.013c.007.015.01.027.009.036l.008.007.03.03.027.028.03.032.031.034.055.06h.08l.008-.27h.021l.004-.002.002.002h.005v.005l.049.048a.37.37 0 0 0 .216.098h.008l.003-.006c.043-.148.049-.411.005-.666l-.003-.012-.008-.009-.028-.037a.46.46 0 0 0-.028-.033zm-.567-.035l-.005.003a.341.341 0 0 1-.108.046h-.016a.604.604 0 0 0-.086.124.449.449 0 0 0-.036.3l.02.094.008.029.009.03.013.043.012.046.007.023.003.014.005.019.002.01.004.02v.01l.001.043v.007l-.002.006.01.012.006.006.004.002.005-.003.006-.004.012-.01.025-.018-.002-.001.015-.023c.037-.055.06-.081.101-.102.005-.003.007-.005.004-.014l-.003-.006-.003-.008A.145.145 0 0 1 11.25 7l-.001-.005-.005-.01c-.09-.202-.074-.412.01-.543a.293.293 0 0 1-.008-.114l.001-.006zm.812-.012l-.02.048a.353.353 0 0 1-.072.11l-.005.004-.005.005-.007-.001-.018-.004-.016-.007.015.106c.011.098.015.194.012.282a.62.62 0 0 0 .2.078l.01.002.002-.018.004-.033c.027-.23.007-.375-.1-.572zm.944.067a.287.287 0 0 1-.1.044l-.067.013v.002c.013.05.01.095-.01.132l.01.013.022.026.026.032.072.092a.071.071 0 0 1 .028-.005c.019 0 .034.007.036.015v.003l-.005.034a.24.24 0 0 0 .06.02c.056.008.096 0 .103-.012a.22.22 0 0 0 .007-.019l.003-.01a.287.287 0 0 0 .01-.046v-.014l.002-.015v-.016l.002-.094c-.036-.033-.081-.073-.13-.123l-.023-.023a2.632 2.632 0 0 1-.023-.024l-.023-.025zm.197-.288a.325.325 0 0 1-.153.1l-.005.003.006.014c.02.05.017.095-.008.132l-.014.015.023.025.012.012.022.024c.13.132.23.203.326.225l.015.001.013.002h.011l.01.001h.016c.013 0 .018-.003.02-.007v-.008l.001-.006v-.148l-.003-.089-.03-.028-.031-.031-.046-.045-.043-.043-.041-.042-.026-.027-.05-.052a4.292 4.292 0 0 1-.012-.013l-.013-.015zm.571-1.059l.022-.02c-.042.06-.182.112-.243.112l-.019-.003.001.001.002.016v.016l.001.016v.017l.014.015.291.317.061.067.027.03.019.021.037.042.017.02.03.035.026.03.024.028.023.029.022.027.021.027.02.025.02.026.036.048.008.011.016.023.015.022.007.01.014.021a.812.812 0 0 1 .059.109l.026.055.03.053a.78.78 0 0 0 .287.291c.103.057.208.075.254.054l.005-.002a.12.12 0 0 0 .067-.014l.02-.018v-.002c-.066.01-.118-.025-.167-.105l-.038-.068-.01-.02-.004-.01-.005-.012-.01-.022-.02-.048-.091-.238-.012-.03a1.894 1.894 0 0 0-.093-.203l-.049-.08-.01-.014a1.864 1.864 0 0 0-.274-.328l-.115-.103-.06-.049-.016-.013-.016-.012-.033-.026-.009-.006-.008-.007-.035-.026-.009-.007-.009-.007-.037-.027-.038-.028-.02-.014-.02-.015-.052-.037zm-.424.836a.265.265 0 0 1-.12.083.153.153 0 0 1-.01.11l.044.048.025.026.026.027.142.143.031.03.067.064.052.05.037.033.057.053.06.055.018.016.004.002c.046.016.083.016.088.01v-.001l.001-.003.002-.006.002-.006.001-.004v-.002l.002-.005v-.006l.001-.013v-.033l-.001-.019-.002-.022-.003-.02-.056-.051a4.11 4.11 0 0 1-.46-.545l-.008-.014zM11.3 5.568h-.032l-.037.074a.44.44 0 0 1 .095.131.017.017 0 0 1-.004.02.501.501 0 0 0-.12.177l-.006.03.009.005.003.008.014-.004.02-.006c.017-.005.03.016.017.028l-.023.022-.003.004-.012.014-.013.014-.038.046-.012.015-.011.016-.022.03-.025.036-.013.02-.011.017-.01.016-.005.01-.004.007-.004.01v.005h-.001l.02.007.012.01.002.002.015.003.003.004.033-.003a.308.308 0 0 0 .082-.035l.008-.005c.02-.012.032-.03.044-.065l.004-.014.004-.016.008-.034.006-.022.005-.02a.403.403 0 0 1 .086-.175.524.524 0 0 1 .103-.096l.02.027a.491.491 0 0 0-.145.161l-.022.055a.635.635 0 0 0-.002.008l-.005.018-.003.01-.005.02-.006.022-.006.025a.42.42 0 0 1-.02.067c-.03.11-.014.186.05.19h.002l.007-.002.019-.009c.09-.044.118-.085.142-.183l.013-.056.007-.029.007-.027.007-.025.006-.023a.851.851 0 0 1 .062-.155l.01-.021.013-.023.013-.023.015-.026.029.017-.015.025-.013.023-.012.022a.842.842 0 0 0-.057.129l-.007.02a1.04 1.04 0 0 0-.003.011l-.007.023a1.44 1.44 0 0 0-.003.011l-.006.025-.007.026-.007.028-.013.056-.005.018-.013.035h.002l.007.034.005.02.005.02.004.018.005.016.004.016.005.014.013.031a.057.057 0 0 1 .027-.002c.016.003.025.012.02.02l-.013.032a.07.07 0 0 0 .042.016h.002l.003-.002c.135-.12.191-.385.147-.64a.588.588 0 0 1-.1-.146l-.009-.016-.063-.134-.015-.029-.001.01-.005.004-.014.014a.063.063 0 0 1-.03.018h-.002c-.013.01-.027.012-.05.013h-.1l-.013-.01-.015-.012-.016-.013-.003.019a.2.2 0 0 0-.002.022v.05h-.034v-.042c0-.021.003-.04.01-.065l.002-.006.002-.01a.033.033 0 0 0-.016-.013h-.002l-.014-.002-.015-.002zm.573-.966c-.182.018-.265.074-.265.222 0 .044.032.091.081.109l.04.007h.004l.01.003.012.003.014.004.022.004.04.007c.1.02.154.045.201.116l.035.062.002.005.023.187a.016.016 0 0 1-.017.018l-.012-.006-.023-.027-.026-.03-.027-.03h-.002l.049.076c.099.171.155.375.115.47l-.003.006-.005.009h-.015l.01.08a.97.97 0 0 1-.015.186l-.02.093.006.005.011.012.003.003.018.017.015.015.016.015.016.016.035.031.053.048.026.022.006.006.013.016.001-.003-.007-.016a.108.108 0 0 1-.023-.071v-.033h.056v.024a.1.1 0 0 0 .02.069l.014.031.004.01.004.01v.003c.002.007.003.012-.002.017-.007.01-.018.012-.03.011a.2.2 0 0 1 .036.106h.027l.029.002h.03c.006 0 .01 0 .014-.002h.002v-.003a.124.124 0 0 0-.005-.047l-.002-.008-.008-.02a1.118 1.118 0 0 1-.085-.173l-.02-.054a.454.454 0 0 1-.03-.122.181.181 0 0 1 .05-.148c.155-.124.19-.377.087-.752-.013-.105-.06-.165-.175-.232l-.02-.01-.02-.011-.02-.011-.011-.006-.023-.011-.055-.026-.056-.028-.02-.011-.02-.011-.066-.043h-.003a.722.722 0 0 0-.139-.012l-.042.003-.012.001-.01.002-.01.001a.321.321 0 0 0-.066.019.048.048 0 0 0-.008.005l-.008.007v.001c0 .011-.008.02-.017.02-.01 0-.017-.009-.017-.02 0-.019.017-.04.038-.05a.346.346 0 0 1 .073-.022l.016-.002.011-.002.051-.004c.033 0 .062.002.09.004a.259.259 0 0 1-.069-.162zm1.557.902a.306.306 0 0 1-.102.124l-.004.001.008.01a.232.232 0 0 1 .047.151l-.013.046a3.9 3.9 0 0 0 .536.624l.003-.002a.17.17 0 0 0 .03.03l.016.014.004.002c.045.014.092.013.11.002l.002-.002.001-.003.001-.004v-.002l.001-.006v-.08l-.002-.089v-.099l-.005-.005-.03-.03-.043-.046-.045-.047-.045-.049-.046-.049-.06-.065-.044-.05-.058-.064-.042-.048-.027-.03-.026-.03-.038-.045-.023-.028-.023-.027-.021-.025-.02-.025-.019-.023-.004-.006-.019-.025zm-1.471.264v-.043c.008.11-.012.22-.041.238l-.003.001-.005.003-.006-.002-.034-.013-.03-.016.01.077a.948.948 0 0 1-.03.326l.012-.012c.01.01.02.021.03.034l.034.044c.017.021.03.032.048.036h.004l.003-.002c.086-.087.178-.409.145-.613l-.002-.01.038.001a.272.272 0 0 1-.123-.019l-.05-.03zm1.58-.532a.094.094 0 0 1-.008.048.104.104 0 0 1-.07.07.067.067 0 0 1-.032.007l.012.032a.17.17 0 0 1 .001.07l-.001.001.014.02.008.01.018.022.018.024.02.025.022.026.023.027.024.028.038.045.04.046.056.064.044.049.03.032.045.05.046.05.091.098.03.032.045.046.029.03.029.03.041.042.027.026.05.05.024.022.023.021.021.02.01.009.02.016.003.003h.014l.014.002.012.002c.018.002.022 0 .024-.005a.069.069 0 0 0 .001-.03l-.001-.01-.001-.006-.003-.012a.47.47 0 0 0-.001-.007l-.004-.014-.006-.024-.006-.018a.8.8 0 0 0-.132-.25l-.013-.021a1.766 1.766 0 0 0-.008-.01L14.203 6l-.016-.023a2.503 2.503 0 0 0-.009-.012l-.018-.024-.02-.025-.02-.025-.02-.026-.022-.027-.023-.028-.012-.014-.05-.058-.017-.02-.035-.041-.043-.048-.05-.056-.31-.338zm-1.192-.776l-.146.002-.035.004-.022.002-.02.002-.028.004h-.004l-.005.002-.016.002-.016.003-.014.003-.013.003-.024.007-.02.008a.155.155 0 0 0-.05.037l-.015.022-.005.01-.008.016.005.046c.017.082.067.136.17.195l.037.021.01.005.022.011.022.011.054.026.023.011.022.012.021.01.02.012c.132.073.186.14.202.26.104.383.068.65-.098.782a.148.148 0 0 0-.039.121c.002.03.01.063.023.1l.006.017.019.05.041.092h.009l.037-.003.01-.001.007-.001.005-.001V6.36l.002-.008v-.054l-.004-.058v-.01l-.01-.003a.017.017 0 1 1 .012-.03l.023.008.013.005.01.003.01.003a.093.093 0 0 0 .035.004.105.105 0 0 0 .06-.03c.032-.029.032-.11-.027-.15h-.003a.017.017 0 0 1 .003-.032h-.001.01l.003.001.002.001.038.01c.026.005.05.003.07-.004l-.001-.002a.082.082 0 0 0 .052-.05.194.194 0 0 0 .004-.11c-.007-.027-.018-.043-.035-.049h-.036c-.01-.002-.018-.01-.017-.019 0-.009.008-.016.017-.015h.022a.154.154 0 0 0 .06-.008l-.005-.005.025-.008c.017-.018.02-.046.018-.088-.004-.063-.036-.107-.084-.117a.098.098 0 0 1-.043.003l-.01-.001h-.01l-.008-.006c.004.003 0 0-.002-.004v-.002l-.002-.009a.017.017 0 0 1 .02-.013h.006l.035-.003.014.001a.068.068 0 0 0 .058-.04.23.23 0 0 0 .012-.128c-.013-.099-.08-.146-.167-.124a.017.017 0 0 1-.008-.032l.048-.006.043.006a.186.186 0 0 1 .096-.027l-.002-.004-.009-.015-.008-.016-.028-.054-.018-.038-.013-.026-.007-.017-.006-.015-.006-.013-.004-.011a.179.179 0 0 1-.022-.015h-.002a.267.267 0 0 0-.099-.046l-.04-.012a1.25 1.25 0 0 0-.022-.005l-.044-.01-.012-.003-.023-.004-.011-.003-.023-.003-.011-.002-.066-.009a.933.933 0 0 0-.02-.002l-.02-.001a.383.383 0 0 0-.065.001l-.007.001h-.03v-.033h.028a.635.635 0 0 1 .17.008l.05.008.05.01c.048.01.093.023.131.036l-.002-.002-.034-.043a1.377 1.377 0 0 0-.022-.027l-.014-.016c-.047-.054-.082-.08-.125-.088a.016.016 0 0 1 .003-.032h.003c.06.011.103.047.166.123l.045.057.011.014c.042.05.073.076.105.08.042.007.06 0 .064-.013.005-.014-.003-.04-.022-.074a.539.539 0 0 0-.035-.053l-.012-.016a.845.845 0 0 0-.012-.015l-.024-.028-.01-.012a.226.226 0 0 0-.032-.03.017.017 0 0 1 .018-.026c.014.01.037.032.06.059l.013.015.006.008.013.017a.6.6 0 0 1 .044.064l.015.033c.01.018.018.031.032.049.042.051.084.063.13.017.013-.016.016-.025.016-.05a.183.183 0 0 0-.003-.03l-.003-.01-.003-.008-.005-.015c-.018-.05-.036-.07-.075-.077a.016.016 0 0 1 .003-.032h.003c.056.01.08.039.103.105l.004.014.002.001.002.013.006.018.004.015.002.006c.024.071.057.111.125.134.06.02.077.002.069-.05a.248.248 0 0 0-.055-.118l-.003-.003a.016.016 0 1 1 .019-.027c.028.02.063.089.072.143a.11.11 0 0 1-.006.063l.005.004a.318.318 0 0 0 .192.065c.05 0 .172-.046.213-.093l.004-.005.024-.047.03-.048.005-.009a.405.405 0 0 1-.193-.001l-.075-.02-.014-.005-.046-.017-.05-.02-.014-.005-.028-.012-.029-.013-.031-.014-.197-.092-.047-.02a2.242 2.242 0 0 0-.612-.195l-.144-.013zm-1.88 1.45a.158.158 0 0 1 .015-.063l.005-.005.005-.012a.162.162 0 0 1 .013-.018l-.018.03a.16.16 0 0 1 .095-.081.182.182 0 0 1 .05-.01l-.05.01a.18.18 0 0 1 .135.007l.032.012.038-.037c.089-.072.225-.084.282.009l.004.006.002.004h.01l.024-.003c.03-.007.049-.021.055-.045l.003-.007.007-.02.003-.006.006-.013.007-.016a.223.223 0 0 0-.144-.033l-.07.008-.009.001-.03.006-.02.003-.02.003a.274.274 0 0 1-.124-.003.176.176 0 0 1-.047-.02l-.008-.007-.006-.009-.006-.01-.002-.003-.133.009h-.003l.01-.016c-.037.07-.09.095-.17.094h-.002l-.024.019a.262.262 0 0 0-.022.02l-.002.006-.004.007-.001.004v.002l-.006.013-.008.023-.027.074-.001.002-.013.035a.994.994 0 0 1-.005.013c.002.107.076.206.18.217l.056-.002.006-.001-.035-.068a.342.342 0 0 1-.022-.076l-.001-.004-.009-.038v-.01zm.506-.623l-.016.013-.017.014a1.316 1.316 0 0 0-.008.008l-.017.015-.017.016-.022.021.053.002.04.007v-.002h.12a.066.066 0 0 0 .039-.012l.005-.004.014-.01.003-.002.01-.006.006-.005.008-.006.015-.012.006-.004.012-.009.016-.01.018-.009.006-.001a.21.21 0 0 1 .07.01l.028.014.025.016.003.001a.12.12 0 0 0 .038.006h.055c.012 0 .022.002.03.004a.245.245 0 0 1 .072.016.15.15 0 0 1 .03.023l.012.013.008.009.004.004c0 .012.001.017.003.023l.002.01c.002.013.004.02.004.03v.025a.13.13 0 0 1-.003.039l-.001.003v.006l-.002.022.014-.007.015.032.073.154.001.002c.05.102.095.153.169.182l.008.003a.077.077 0 0 0 .006-.017l.003-.01.005-.023v-.007l.003-.015v-.007l.002-.016.002-.017a.664.664 0 0 0 0-.082v-.01a.681.681 0 0 0-.167-.397.204.204 0 0 1-.134.02l-.01-.001-.005-.002-.024-.015-.046-.028-.022-.013-.021-.012-.021-.012-.02-.01a1.26 1.26 0 0 0-.01-.005l-.02-.01a1.016 1.016 0 0 0-.009-.005l-.019-.008-.018-.008c-.158-.066-.266-.047-.407.066zm1.93.172l-.005.003-.011.024a.11.11 0 0 1-.04.045c.04.021.067.069.07.13.002.03 0 .056-.007.077.092-.012.207.042.274.13a.271.271 0 0 1 .032.05c.162-.062.167-.182.049-.312-.11-.119-.279-.19-.362-.147zm-1.59-.566l-.015.019-.013.014-.01.009-.009.006.004.002c-.051.07-.061.108-.052.2a.659.659 0 0 1 .201.06l.04.018.01.006.02.01.022.012.011.007.046.026.011.007.024.015.022.013.006.001a.178.178 0 0 0 .106-.013l.001-.001c.009-.027.002-.057-.017-.088l-.003-.004-.01-.007c-.136-.095-.24-.125-.37-.11l-.012.002-.004-.033c.14-.02.251.01.391.105l.027.018.004.004c.023.034.035.07.03.105.11.121.171.272.184.425a.197.197 0 0 0 .153.064h.009l.001-.003c.041-.119-.074-.424-.229-.59l-.008-.009-.005-.016.003-.015.003-.006V5.14l.001-.012.005-.02.01-.019.003-.003-.013-.003-.013-.002h-.043l-.038.004-.01.002-.008.002-.011.002-.006-.002-.01-.004-.035-.014a.823.823 0 0 0-.272-.063.444.444 0 0 0-.09.003l-.013-.003-.006-.013v-.003l-.001-.006-.003-.012-.003-.015-.006-.026-.01-.041zm1.552.3l-.038.012a.18.18 0 0 1 .075.134l.004.045-.002.041.024-.008c.104-.019.257.054.361.167l.015.02.051-.044a.225.225 0 0 0 .052-.088l-.006-.006.009-.006a.119.119 0 0 0-.031-.114.88.88 0 0 0-.514-.152zm.252-.267a.096.096 0 0 1-.016.024c-.062.063-.125.047-.178-.016-.008.029-.043.04-.1.032l-.002-.002.005.01.016.036.016.033.012.025.016.03.01.02.006.012.006.01.005.01.003.003.004.006c.154.004.378.076.48.162l.012.004.016.003c.006 0 .01 0 .02-.005.03-.01.04-.021.053-.052a.07.07 0 0 0 .005-.034v-.012l-.002-.018V5.19a.56.56 0 0 0 0-.025l-.002-.019v-.01L13.5 5.12v-.004a.411.411 0 0 1-.117-.037l-.012-.006a.2.2 0 0 1-.042-.03c-.018.012-.046.013-.082 0a.205.205 0 0 1-.13-.117z",
    fill: "#000",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M10.499 5.531c-.069.02-.099.077-.105.131-.253.178-.07.528.166.455-.174-.26 0-.408.193-.316.059.043.1.132.105.127.037-.08.183-.15.183-.15s.117.016.138-.06c.014-.048.121-.249.121-.249l-.375-.077-.26-.006-.138.06c-.019.03-.01.056-.028.085z",
    fill: "#FFBA00"
  }), React.createElement("path", {
    d: "M10.665 5.37l-.007.001-.143.063-.002.004a.105.105 0 0 0-.015.041l-.003.013a.09.09 0 0 1-.007.024v.002h-.001a.158.158 0 0 0-.107.127l-.001.008-.01.007c-.234.184-.067.554.196.473l.02-.007-.011-.018c-.152-.228-.026-.386.172-.292.014.01.03.026.046.047l.006.01.007.008.006.01.012.017.013.02.003.005a.04.04 0 0 0 .007.007c.006.006.015.008.024 0l.003-.005a.248.248 0 0 1 .082-.086.66.66 0 0 1 .064-.04l.015-.009.01-.005h.002a.24.24 0 0 0 .07-.004c.037-.009.065-.029.077-.062l.003-.009.002-.007.006-.013.007-.017.009-.019.018-.038.013-.026.017-.033.036-.069.021-.04-.397-.082-.263-.006zm.003.033l.256.005.352.073-.012.02a6.114 6.114 0 0 0-.025.05l-.023.045-.013.027-.012.024-.007.015-.006.013-.005.012-.004.01-.003.01a.129.129 0 0 0-.003.007c-.006.024-.026.038-.055.045a.197.197 0 0 1-.06.004h-.005l-.005-.001-.013.006a.698.698 0 0 0-.09.054l-.009.007a.328.328 0 0 0-.065.063l-.005.007-.014-.022-.01-.015a.473.473 0 0 0-.004-.005l-.007-.01a.281.281 0 0 0-.058-.06l-.007-.003c-.222-.1-.369.079-.224.32l.002.003h-.006c-.215.039-.342-.279-.125-.431l.007-.004v-.008c.007-.057.039-.102.093-.117l.006-.001.004-.006a.105.105 0 0 0 .015-.04l.002-.014a.09.09 0 0 1 .007-.024l.001-.002.13-.057z",
    fillOpacity: 0.772,
    fill: "#000",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M10.602 5.538c.01-.08.082-.168.162-.214.038-.02.064.005.081.013.021.034.009.099 0 .124-.021.043-.064.077-.14.107-.04-.017-.064-.013-.103-.03z",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M10.756 5.31a.348.348 0 0 0-.17.226v.012l.01.005a.23.23 0 0 0 .044.014l.019.004a.197.197 0 0 1 .039.012l.006.003.006-.003c.079-.03.126-.066.15-.114.016-.049.02-.107-.001-.14l-.002-.004-.005-.003-.014-.008c-.028-.017-.052-.02-.082-.004zm.06.03l.017.01-.002-.004c.014.023.01.073-.002.11l-.003.005c-.019.034-.056.062-.117.087l-.005.002.007.003a.23.23 0 0 0-.045-.014l-.02-.004-.008-.002a.2.2 0 0 1-.015-.004l-.003-.002.001-.004a.33.33 0 0 1 .151-.184c.016-.01.028-.008.044 0z",
    fillOpacity: 0.772,
    fill: "#000",
    fillRule: "nonzero"
  })));
};

var SvgMexico = function SvgMexico(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5c,
    name: "mexico"
  }, props));
};

var SvgIcon$5d = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13 8c0-.3-.2-.5-.5-.5s-.5.2-.5.5c0 2.2-1.8 4-4 4s-4-1.8-4-4c0-.3-.2-.5-.5-.5S3 7.7 3 8c0 2.6 1.9 4.7 4.5 5v2.1H5c-.3 0-.5.2-.5.5 0 .2.2.4.5.4h6c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H8.5v-2.1C11 12.7 13 10.6 13 8zm-5 3c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3S5 1.3 5 3v5c0 1.7 1.3 3 3 3zM6 3c0-1.1.9-2 2-2s2 .9 2 2v5c0 1.1-.9 2-2 2s-2-.9-2-2V3z"
  }));
};

var SvgMicrophone = function SvgMicrophone(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5d,
    name: "microphone"
  }, props));
};

var SvgIcon$5e = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 10.3 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.1 10.8c-1.5 0-2.7-1.2-2.7-2.7V2.7C2.5 1.2 3.7 0 5.1 0c1.5 0 2.7 1.2 2.7 2.7v5.4c0 1.4-1.2 2.6-2.7 2.7zm5.2-2.3h-1c-.2 2.3-2.3 4-4.6 3.7C2.8 12 1.2 10.5 1 8.5H0C.2 11 2.2 13 4.6 13.2V15H3.1v1h4.2v-1H5.6v-1.8c2.5-.2 4.5-2.2 4.7-4.7z"
  }));
};

var SvgMicrophone$1 = function SvgMicrophone(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5e,
    name: "microphone"
  }, props));
};

var SvgIcon$5f = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13 8c0-.3-.2-.5-.5-.5s-.5.2-.5.5c0 2.2-1.8 4-4 4s-4-1.8-4-4c0-.3-.2-.5-.5-.5S3 7.7 3 8c0 2.6 1.9 4.7 4.5 5v2.1H5c-.3 0-.5.2-.5.5 0 .2.2.4.5.4h6c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H8.5v-2.1C11 12.7 13 10.6 13 8zm-5 3c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3S5 1.3 5 3v5c0 1.7 1.3 3 3 3zM6 3c0-1.1.9-2 2-2s2 .9 2 2v5c0 1.1-.9 2-2 2s-2-.9-2-2V3z"
  }));
};

var SvgMicrophoneNext = function SvgMicrophoneNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5f,
    name: "microphone-next"
  }, props));
};

var SvgIcon$5g = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 11c1.7 0 3-1.3 3-3V5.7l3.4-3.4c.2-.2.2-.5 0-.7s-.5-.2-.7 0L11 4.3V3c0-1.7-1.3-3-3-3S5 1.3 5 3v5c0 .6.2 1.2.6 1.7l-.7.7C4.3 9.7 4 8.9 4 8c0-.3-.2-.5-.5-.5S3 7.7 3 8c0 1.2.4 2.3 1.2 3.1l-2.5 2.5c-.2.2-.2.5 0 .7.2.2.5.2.7 0l2.5-2.5c.8.6 1.7 1 2.7 1.2v2.1H5c-.3 0-.5.2-.5.5 0 .2.2.4.5.4h6c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H8.5v-2.1C11 12.7 13 10.6 13 8c0-.3-.2-.5-.5-.5s-.5.2-.5.5c0 2.2-1.8 4-4 4-.9 0-1.7-.3-2.4-.8l.7-.7c.5.3 1.1.5 1.7.5zm2-3c0 1.1-.9 2-2 2-.4 0-.7-.1-1-.3l3-3V8zM6 3c0-1.1.9-2 2-2s2 .9 2 2v2.3L6.3 9c-.2-.3-.3-.6-.3-1V3z"
  }));
};

var SvgMicrophoneSlash = function SvgMicrophoneSlash(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5g,
    name: "microphone-slash"
  }, props));
};

var SvgIcon$5h = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.3 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4.8 3.1v-.4C4.8 1.2 6.1 0 7.5.1c1.4 0 2.6 1.2 2.6 2.6v5.8L4.8 3.1zm7.3 7.3c.3-.6.5-1.2.6-1.9h-1c0 .4-.1.8-.3 1.1l.7.8zm-.5.8l-.7-.7-1.1-1-5-5L.7.4l-.7.7 4.8 4.8V8c0 1.5 1.2 2.7 2.7 2.7.6 0 1.1-.2 1.6-.5l1.1 1.1c-.7.6-1.7 1-2.7 1-2.1 0-3.9-1.6-4.1-3.7h-1C2.6 11 4.5 13 7 13.2V15H5.4v1h4.2v-1H8v-1.8c1.1-.1 2-.5 2.8-1.2l3.8 3.8.7-.7-3.7-3.9z"
  }));
};

var SvgMicrophoneSlash$1 = function SvgMicrophoneSlash(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5h,
    name: "microphone-slash"
  }, props));
};

var SvgIcon$5i = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 11c1.7 0 3-1.3 3-3V5.7l3.4-3.4c.2-.2.2-.5 0-.7s-.5-.2-.7 0L11 4.3V3c0-1.7-1.3-3-3-3S5 1.3 5 3v5c0 .6.2 1.2.6 1.7l-.7.7C4.3 9.7 4 8.9 4 8c0-.3-.2-.5-.5-.5S3 7.7 3 8c0 1.2.4 2.3 1.2 3.1l-2.5 2.5c-.2.2-.2.5 0 .7.2.2.5.2.7 0l2.5-2.5c.8.6 1.7 1 2.7 1.2v2.1H5c-.3 0-.5.2-.5.5 0 .2.2.4.5.4h6c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H8.5v-2.1C11 12.7 13 10.6 13 8c0-.3-.2-.5-.5-.5s-.5.2-.5.5c0 2.2-1.8 4-4 4-.9 0-1.7-.3-2.4-.8l.7-.7c.5.3 1.1.5 1.7.5zm2-3c0 1.1-.9 2-2 2-.4 0-.7-.1-1-.3l3-3V8zM6 3c0-1.1.9-2 2-2s2 .9 2 2v2.3L6.3 9c-.2-.3-.3-.6-.3-1V3z"
  }));
};

var SvgMicrophoneSlashNext = function SvgMicrophoneSlashNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5i,
    name: "microphone-slash-next"
  }, props));
};

var SvgIcon$5j = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm4-7.5H4c-.3 0-.5.2-.5.5s.2.5.5.5h8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgMinusCircle = function SvgMinusCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5j,
    name: "minus-circle"
  }, props));
};

var SvgIcon$5k = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.3 13.4c-3.1-3.1-3.1-8.1 0-11.1s8.1-3.1 11.1 0 3.1 8.1 0 11.1c-3 3.1-8 3.1-11.1 0zM12.7 3C10 .3 5.7.3 3 3s-2.7 7 0 9.7 7 2.7 9.7 0c2.7-2.7 2.7-7 0-9.7zm-.8 5.4h-8v-1h8v1z"
  }));
};

var SvgMinusCircle$1 = function SvgMinusCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5k,
    name: "minus-circle"
  }, props));
};

var SvgIcon$5l = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm4-7.5H4c-.3 0-.5.2-.5.5s.2.5.5.5h8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgMinusCircleNext = function SvgMinusCircleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5l,
    name: "minus-circle-next"
  }, props));
};

var SvgIcon$5m = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.4 2.3C10.3-.8 5.3-.8 2.3 2.3s-3.1 8.1 0 11.1 8.1 3.1 11.1 0c3.1-3 3.1-8 0-11.1zm-.6 6.6h-10v-2h10v2z"
  }));
};

var SvgMinusCircleSolid = function SvgMinusCircleSolid(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5m,
    name: "minus-circle-solid"
  }, props));
};

var SvgIcon$5n = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 -5.5 12 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 1V0h12v1H0z"
  }));
};

var SvgMinus = function SvgMinus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5n,
    name: "minus"
  }, props));
};

var SvgIcon$5o = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 12V0H0v12h7v3H4v1h8v-1H9v-3h7zM1 11V1h14v10H1z"
  }));
};

var SvgMonitor = function SvgMonitor(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5o,
    name: "monitor"
  }, props));
};

var SvgIcon$5p = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 15"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 12.8H9.9V15H6v-2.2H0v-2h16v2zM9 10H7V8.8H3V0h9v8.8H9V10zM5 6.8H4v1h1v-1zm2 0H6v1h1v-1zm3.9-1V1H4v4.8h6.9z"
  }));
};

var SvgNetworkBranch = function SvgNetworkBranch(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5p,
    name: "network-branch"
  }, props));
};

var SvgIcon$5q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13 10V7H9V6h3V0H5v6h3v1H3v3H0v6h7v-6H4V8h8v2H9v6h7v-6h-3zm-7 1v1H1v-1h5zm0-9V1h5v1H6zm9 10h-5v-1h5v1z"
  }));
};

var SvgNetwork = function SvgNetwork(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5q,
    name: "network"
  }, props));
};

var SvgIcon$5r = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#00006A",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M0 0l10.633 10.145h2.18L2.412.005z"
  }), React.createElement("path", {
    fill: "red",
    d: "M12.017 10.144L1.607 0l-.81.012L11.25 10.144h.766z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M12.814 0L2.181 10.145H.001L10.402.005 12.814 0z"
  }), React.createElement("path", {
    fill: "red",
    d: "M12.015 0L1.608 10.144h-.81L11.249 0h.767z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M5.382 0h2.05v10.145h-2.05z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M0 4.058h12.814v2.029H0z"
  }), React.createElement("path", {
    fill: "red",
    d: "M5.83 0h1.154v10.145H5.83z"
  }), React.createElement("path", {
    fill: "red",
    d: "M0 4.565h12.814V5.58H0z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M18.7 5.978l-.652-.483-.677.448.255-.773-.633-.509.81.005.286-.762.246.776.809.038-.658.474z"
  }), React.createElement("path", {
    fill: "red",
    d: "M18.439 5.587l-.386-.279-.395.267.145-.455-.375-.295.476-.002.163-.45.15.454.474.018-.383.283z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M16.196 10.135l-.653-.482-.676.447.255-.773-.633-.508.81.004.286-.762.246.776.808.038-.657.475z"
  }), React.createElement("path", {
    fill: "red",
    d: "M15.934 9.744l-.386-.279-.394.267.145-.455-.375-.295.476-.002.163-.45.149.455.475.017-.383.283z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M21.321 9.725l-.652-.482-.677.447.255-.772-.633-.509.81.005.286-.762.246.775.809.038-.658.475z"
  }), React.createElement("path", {
    fill: "red",
    d: "M21.06 9.335l-.387-.28-.394.267.145-.455-.375-.295.476-.002.163-.449.15.454.474.017-.383.283z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M18.642 15.64l-.653-.483-.676.447.255-.773-.633-.508.81.004.286-.761.246.775.808.038-.657.475z"
  }), React.createElement("path", {
    fill: "red",
    d: "M18.38 15.249l-.386-.28-.394.267.145-.455-.375-.295.476-.002.163-.449.149.454.475.017-.383.283z"
  })));
};

var SvgNewZealand = function SvgNewZealand(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5r,
    name: "new-zealand"
  }, props));
};

var SvgIcon$5s = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#EF2B2D",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M6 0h4v16H6z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M0 6h24v4H0z"
  }), React.createElement("path", {
    fill: "#002868",
    d: "M7 0h2v16H7z"
  }), React.createElement("path", {
    fill: "#002868",
    d: "M0 7h24v2H0z"
  })));
};

var SvgNorway = function SvgNorway(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5s,
    name: "norway"
  }, props));
};

var SvgIcon$5t = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.25 12.865l.036.463A2.477 2.477 0 017.82 16a2.477 2.477 0 01-2.467-2.672l.035-.463h4.863zm-.995 1H6.384c.154.65.739 1.135 1.436 1.135.696 0 1.28-.485 1.435-1.135zM7.819 0c.567 0 1.27.508 1.507 1.196 1.805.488 3.041 2.13 3.26 4.367.003.023.008.09.01.178.007.085.012.2.013.317.085 1.857.557 3.077 1.401 3.609.098.061.18.123.25.19.241.212.378.519.378.846v.184c0 .613-.484 1.113-1.079 1.113H2.08C1.484 12 1 11.5 1 10.887v-.184c0-.368.176-.712.473-.921a1.18 1.18 0 01.162-.116C2.482 9.133 2.94 7.98 3.032 6.14a5.386 5.386 0 01.021-.575c.218-2.238 1.454-3.881 3.26-4.369C6.547.508 7.252 0 7.818 0zm0 1c-.13.005-.563.281-.587.647l-.026.387-.38.07c-1.55.289-2.589 1.618-2.777 3.556-.013.138-.02.278-.02.42l.001.109c-.109 2.19-.72 3.605-1.864 4.324l-.119.088a.125.125 0 00-.047.102v.184c0 .064.043.113.08.113h11.48c.035 0 .078-.049.078-.113v-.184a.126.126 0 00-.04-.097l-.028-.025c-.009-.008-.034-.032-.09-.067-1.14-.718-1.769-2.207-1.87-4.429a4.339 4.339 0 00-.013-.298l-.008-.127c-.188-1.938-1.226-3.267-2.776-3.556l-.38-.07-.027-.387c-.025-.366-.456-.642-.588-.647z"
  }));
};

var SvgNotification = function SvgNotification(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5t,
    name: "notification"
  }, props));
};

var SvgIcon$5u = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.9 7.3c-.2-.2-.5-.1-.7.1l-4.3 6.2c-1 1.5-3 2-4.5 1s-2-3-1-4.5c0-.1.1-.2.1-.2L9.1 2c.7-1 2-1.2 3-.5.5.3.8.8.9 1.4.1.6 0 1.2-.4 1.6l-4.9 7c-.3.5-1 .6-1.5.3-.2-.2-.4-.4-.5-.7-.1-.3 0-.6.2-.8L9.6 5c.2-.2.1-.5-.1-.7s-.5-.2-.7 0L5.1 9.6c-.3.5-.5 1-.3 1.6.1.6.4 1 .9 1.4 1 .7 2.3.4 2.9-.5l4.9-7c1-1.4.7-3.4-.7-4.5h-.1c-1.4-1-3.4-.7-4.4.8L2.7 9.3c-1.3 1.9-.9 4.6 1 5.9.8.5 1.6.8 2.5.8 1.4 0 2.7-.7 3.5-1.8L14 8c.2-.2.1-.5-.1-.7z"
  }));
};

var SvgPaperClip = function SvgPaperClip(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5u,
    name: "paper-clip"
  }, props));
};

var SvgIcon$5v = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 10.7 14.2"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M9.9 5.4l-3.8 5.8c-.6 1.1-1.9 1.5-3 .9-1.1-.7-1.5-2-.9-3.1.1-.1.1-.2.2-.3l3-4.6.8.6-3 4.6c-1 1.6 1 2.9 2 1.3L9 4.8c2-3-1.7-5.4-3.7-2.4L1.7 8c-1.1 1.4-.9 3.4.5 4.5.1 0 .1.1.2.1 1.6 1.1 3.5.4 4.5-1.2L9.8 7l.8.6L7.7 12C6.6 14 4 14.8 2 13.6c-.1 0-.1-.1-.2-.1C-.1 12.2-.6 9.6.7 7.6c0-.1.1-.1.1-.2l3.7-5.6c2.7-4.1 8.1-.6 5.4 3.6z"
  }));
};

var SvgPaperClip$1 = function SvgPaperClip(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5v,
    name: "paper-clip"
  }, props));
};

var SvgIcon$5w = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.9 7.3c-.2-.2-.5-.1-.7.1l-4.3 6.2c-1 1.5-3 2-4.5 1s-2-3-1-4.5c0-.1.1-.2.1-.2L9.1 2c.7-1 2-1.2 3-.5.5.3.8.8.9 1.4.1.6 0 1.2-.4 1.6l-4.9 7c-.3.5-1 .6-1.5.3-.2-.2-.4-.4-.5-.7-.1-.3 0-.6.2-.8L9.6 5c.2-.2.1-.5-.1-.7s-.5-.2-.7 0L5.1 9.6c-.3.5-.5 1-.3 1.6.1.6.4 1 .9 1.4 1 .7 2.3.4 2.9-.5l4.9-7c1-1.4.7-3.4-.7-4.5h-.1c-1.4-1-3.4-.7-4.4.8L2.7 9.3c-1.3 1.9-.9 4.6 1 5.9.8.5 1.6.8 2.5.8 1.4 0 2.7-.7 3.5-1.8L14 8c.2-.2.1-.5-.1-.7z"
  }));
};

var SvgPaperClipNext = function SvgPaperClipNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5w,
    name: "paper-clip-next"
  }, props));
};

var SvgIcon$5x = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.992 1a7 7 0 11-7 7 7.008 7.008 0 017-7m0-1a8 8 0 108 8 8 8 0 00-8-8z"
  }), React.createElement("path", {
    d: "M6.25 12a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5zm3.5 0a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5z"
  }));
};

var SvgPause = function SvgPause(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5x,
    name: "pause"
  }, props));
};

var SvgIcon$5y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.992 1a7 7 0 11-7 7 7.008 7.008 0 017-7m0-1a8 8 0 108 8 8 8 0 00-8-8z"
  }), React.createElement("path", {
    d: "M6.25 12a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5zm3.5 0a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5z"
  }));
};

var SvgPauseNext = function SvgPauseNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5y,
    name: "pause-next"
  }, props));
};

var SvgIcon$5z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.3 5.4l-1.2.3V2.8l-.6.2c-.9.3-2.8.7-6.1-.3-2.3-.8-4.8-.8-7.1-.1l-.3.1v8.1l.6-.2c.3-.1.8-.2 1.2-.3v2.8l.7-.1c1.1-.3 2.2-.5 3.4-.5 1.2 0 2.4.2 3.5.7 1 .4 2.2.7 3.3.7 1 0 2-.2 3-.5l.3-.1v-8l-.7.1zM2.2 5l-.3.1v4.2l-.9.2V3.4c2-.5 4.1-.4 6.1.3 1.9.7 4 .8 6 .5v1.6c-1.3 0-2.6-.2-3.9-.6-2.2-.9-4.7-.9-7-.2zM15 12.5c-1.7.5-3.6.5-5.2-.2-1.2-.5-2.6-.8-3.9-.7-1 0-2 .1-3 .4V5.8c2-.5 4.1-.4 6.1.3 1.9.7 4 .8 6 .4v6z"
  }));
};

var SvgPayment = function SvgPayment(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5z,
    name: "payment"
  }, props));
};

var SvgIcon$5A = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 1v10H1V1h14m1-1H0v12h16V0zM2 2v8h12V2H2zm3 4.9H3V5.1h2v1.8zM8 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5-1.1h-2V5.1h2v1.8z"
  }));
};

var SvgPayment$1 = function SvgPayment(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5A,
    name: "payment"
  }, props));
};

var SvgIcon$5B = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 13.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 5.1v5.4H7.8V5.1h7.7m.5-.5H7.3v6.5H16V4.6zm-7.6 1V10h6.5V5.6H8.4zM10 8.3H8.9v-1H10v1zm1.7.6c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1c.6 0 1.1.5 1.1 1.1-.1.6-.5 1.1-1.1 1.1zm2.7-.6h-1.1v-1h1.1v1zM9.2 0C5.5 0 2.6 2.8 2.3 6.4h1.1C3.7 3.2 6.5.8 9.7 1.1c1.5.1 2.9.8 3.9 2h1.3C13.6 1.1 11.4 0 9.2 0zM0 6.4l2.9 2.9 2.8-2.9H0zm9.2 6.3v1.1c1.4 0 2.7-.4 3.8-1.2h-2.8c-.4.1-.7.1-1 .1z"
  }));
};

var SvgPaymentLeftArrow = function SvgPaymentLeftArrow(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5B,
    name: "payment-left-arrow"
  }, props));
};

var SvgIcon$5C = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.3 5.4l-1.2.3V2.8l-.6.2c-.9.3-2.8.7-6.1-.3-2.3-.8-4.8-.8-7.1-.1l-.3.1v8.1l.6-.2c.3-.1.8-.2 1.2-.3v2.8l.7-.1c1.1-.3 2.2-.5 3.4-.5 1.2 0 2.4.2 3.5.7 1 .4 2.2.7 3.3.7 1 0 2-.2 3-.5l.3-.1v-8l-.7.1zM2.2 5l-.3.1v4.2l-.9.2V3.4c2-.5 4.1-.4 6.1.3 1.9.7 4 .8 6 .5v1.6c-1.3 0-2.6-.2-3.9-.6-2.2-.9-4.7-.9-7-.2zM15 12.5c-1.7.5-3.6.5-5.2-.2-1.2-.5-2.6-.8-3.9-.7-1 0-2 .1-3 .4V5.8c2-.5 4.1-.4 6.1.3 1.9.7 4 .8 6 .4v6z"
  }));
};

var SvgPaymentNext = function SvgPaymentNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5C,
    name: "payment-next"
  }, props));
};

var SvgIcon$5D = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.6 8.1"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.8.7l-1.1 6.7H4.3L5.4.7h9.4m.8-.7H4.8l-.1.3-1 6.8-.2 1h10.8l.2-1L15.6.4V0zM5.9 1.3l-.8 5.4h8.1l.8-5.4H5.9zm1.5 3.3H6.1l.2-1.2h1.3l-.2 1.2zm1.9.8c-.6 0-1.1-.5-1.2-1.1V4c.2-.7.9-1.3 1.6-1.3.6 0 1.1.5 1.2 1.1v.3c-.2.7-.8 1.3-1.6 1.3zm3.5-.8h-1.3l.2-1.2H13l-.2 1.2zM.6 2.1h3.2l.1-.8H.7l-.1.8zM.3 3.9h3.1l.1-.8H.4l-.1.8zM0 5.7h3.1l.1-.8H.1l-.1.8z"
  }));
};

var SvgPaymentQuick = function SvgPaymentQuick(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5D,
    name: "payment-quick"
  }, props));
};

var SvgIcon$5E = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4 12.7L10.7 6l-.7-.7L3.3 12l.7.7zM12.3.4l-.7.7 3.3 3.3.7-.7L12.3.4zm-1.9 1.8l3.4 3.3.7-.7-3.4-3.4-.7.8zM.6 12l-.4 3.8 3.8-.4L13.4 6 10 2.5.6 12zm.7 2.7l.2-1.9 1.7 1.7-1.9.2zm2.8-.7L2 11.9 10 4l2 2.1L4.1 14z"
  }));
};

var SvgPencil = function SvgPencil(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5E,
    name: "pencil"
  }, props));
};

var SvgIcon$5F = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 16l.3-2.2.3-2.2 1.9 1.9 1.9 1.9-2.2.3L0 16zm12.3-9.8l-7.1 7.1-.6-.6 7.1-7.1-1.3-1.3-7.1 7.1-.6-.6 7.1-7.1-.7-.7-7.9 7.9L5 14.7l7.9-7.9-.6-.6zm0-6.2l-2 2 3.8 3.8 1.9-2L12.3 0z"
  }));
};

var SvgPencil$1 = function SvgPencil(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5F,
    name: "pencil"
  }, props));
};

var SvgIcon$5G = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4 12.7L10.7 6l-.7-.7L3.3 12l.7.7zM12.3.4l-.7.7 3.3 3.3.7-.7L12.3.4zm-1.9 1.8l3.4 3.3.7-.7-3.4-3.4-.7.8zM.6 12l-.4 3.8 3.8-.4L13.4 6 10 2.5.6 12zm.7 2.7l.2-1.9 1.7 1.7-1.9.2zm2.8-.7L2 11.9 10 4l2 2.1L4.1 14z"
  }));
};

var SvgPencilNext = function SvgPencilNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5G,
    name: "pencil-next"
  }, props));
};

var SvgIcon$5H = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 12.6l-.4-1.9c-.2-.8-.7-1.4-1.4-1.8-.3-.2-.8-.4-1.3-.6l-.7-.3c0-.1.1-.2.1-.2.3-.4.4-1 .2-1.5v-.5c0-.5-.1-.9-.2-1.3-.1-.2-.2-.4-.3-.5-.5-.6-1.2-1-1.9-1.1h-.2c-.7.1-1.4.4-1.9 1-.2.1-.3.3-.4.5-.1.5-.2 1-.2 1.4v.4c-.2.6-.1 1.1.3 1.6l.1.2-.1.1-.9-.4-.4-.2v-.1c.3-.3.3-.8.2-1.2v-.3c0-.4 0-.7-.1-1.1-.1-.1-.2-.3-.3-.4-.3-.5-.9-.8-1.5-.8h-.2c-.6 0-1.1.3-1.5.8-.1.1-.2.3-.3.5-.1.3-.2.7-.2 1v.3c-.1.4 0 .9.3 1.2v.1l-.4.1-.1.1c-.4.1-.7.3-1 .4-.5.3-.9.9-1 1.5L0 10.9c0 .3.1.5.4.6.3.1.5-.1.6-.4l.3-1.4c.1-.3.3-.5.6-.7.2-.1.5-.2.8-.4l.2-.1.7-.3.7-.3-.4-.4c-.1-.2-.2-.3-.2-.5l-.1-.2c-.1-.1-.1-.2-.1-.2l.1-.2v-.5c0-.2 0-.5.1-.7V5l.2-.2c.2-.2.4-.3.7-.3h.1c.3.1.6.2.8.5 0 .1.1.1.1.2.1.2.1.4.1.7v.5l.1.2s0 .2-.1.3l-.2.1c0 .2-.1.3-.2.5l-.3.4.7.3c.2.1.5.2.8.3-.3.2-.6.3-.8.4-.7.4-1.2 1.1-1.3 1.8L4 12.6c0 .3.1.5.4.6.3.1.5-.1.6-.4l.4-1.9c.1-.5.4-.9.9-1.1.3-.1.7-.3 1.2-.5l.2-.1.9-.4.7-.4-.4-.4c-.1-.2-.2-.4-.3-.7l-.1-.1s-.3-.4-.1-.6l.1-.2v-.2c0-.1 0-.3-.1-.4 0-.3 0-.7.1-1 0-.1.1-.2.2-.3l.3-.2c.2-.3.6-.5 1-.5.5.1 1 .3 1.3.7.1.1.1.2.2.3.1.3.2.6.1.9 0 .2 0 .3-.1.5v.2l.1.2c.1.2-.1.5-.1.6l-.1.2-.3.6-.3.5.7.4c.3.2.7.3 1 .5s.9.4 1.2.6c.4.2.7.6.9 1.1L15 13c.1.2.3.4.5.4h.1c.3-.3.5-.5.4-.8z"
  }));
};

var SvgPeople = function SvgPeople(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5H,
    name: "people"
  }, props));
};

var SvgIcon$5I = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14.7 11.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M9 3.1c0 1.7-1.4 3.1-3.1 3.2-1.7 0-3.1-1.4-3.2-3.1C2.7 1.4 4.1 0 5.9 0 7.6 0 9 1.4 9 3.1m2.5 6c-.4-.5-4.2-1.9-4.2-1.9-.9.6-2.1.6-3 0 0 0-3.8 1.4-4.2 1.9-.1.8-.2 1.8-.1 2.7h11.7c.1-.9 0-1.9-.2-2.7zm3.2.9h-2c0-.5-.1-1.1-.4-1.5-.1-.2-.5-.7-3.9-2l.3-.3c.7.4 1.6.3 2.3-.1 0 0 3.2 1.2 3.5 1.6.2.8.3 1.5.2 2.3zM10 3.1c0 .8-.2 1.5-.6 2.2 1.5.2 2.8-.8 3-2.3.2-1.5-.8-2.8-2.3-3h-.4c-.3 0-.7.1-1 .2C9.6 1 10 2 10 3.1z"
  }));
};

var SvgPeople$1 = function SvgPeople(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5I,
    name: "people"
  }, props));
};

var SvgIcon$5J = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 12.6l-.4-1.9c-.2-.8-.7-1.4-1.4-1.8-.3-.2-.8-.4-1.3-.6l-.7-.3c0-.1.1-.2.1-.2.3-.4.4-1 .2-1.5v-.5c0-.5-.1-.9-.2-1.3-.1-.2-.2-.4-.3-.5-.5-.6-1.2-1-1.9-1.1h-.2c-.7.1-1.4.4-1.9 1-.2.1-.3.3-.4.5-.1.5-.2 1-.2 1.4v.4c-.2.6-.1 1.1.3 1.6l.1.2-.1.1-.9-.4-.4-.2v-.1c.3-.3.3-.8.2-1.2v-.3c0-.4 0-.7-.1-1.1-.1-.1-.2-.3-.3-.4-.3-.5-.9-.8-1.5-.8h-.2c-.6 0-1.1.3-1.5.8-.1.1-.2.3-.3.5-.1.3-.2.7-.2 1v.3c-.1.4 0 .9.3 1.2v.1l-.4.1-.1.1c-.4.1-.7.3-1 .4-.5.3-.9.9-1 1.5L0 10.9c0 .3.1.5.4.6.3.1.5-.1.6-.4l.3-1.4c.1-.3.3-.5.6-.7.2-.1.5-.2.8-.4l.2-.1.7-.3.7-.3-.4-.4c-.1-.2-.2-.3-.2-.5l-.1-.2c-.1-.1-.1-.2-.1-.2l.1-.2v-.5c0-.2 0-.5.1-.7V5l.2-.2c.2-.2.4-.3.7-.3h.1c.3.1.6.2.8.5 0 .1.1.1.1.2.1.2.1.4.1.7v.5l.1.2s0 .2-.1.3l-.2.1c0 .2-.1.3-.2.5l-.3.4.7.3c.2.1.5.2.8.3-.3.2-.6.3-.8.4-.7.4-1.2 1.1-1.3 1.8L4 12.6c0 .3.1.5.4.6.3.1.5-.1.6-.4l.4-1.9c.1-.5.4-.9.9-1.1.3-.1.7-.3 1.2-.5l.2-.1.9-.4.7-.4-.4-.4c-.1-.2-.2-.4-.3-.7l-.1-.1s-.3-.4-.1-.6l.1-.2v-.2c0-.1 0-.3-.1-.4 0-.3 0-.7.1-1 0-.1.1-.2.2-.3l.3-.2c.2-.3.6-.5 1-.5.5.1 1 .3 1.3.7.1.1.1.2.2.3.1.3.2.6.1.9 0 .2 0 .3-.1.5v.2l.1.2c.1.2-.1.5-.1.6l-.1.2-.3.6-.3.5.7.4c.3.2.7.3 1 .5s.9.4 1.2.6c.4.2.7.6.9 1.1L15 13c.1.2.3.4.5.4h.1c.3-.3.5-.5.4-.8z"
  }));
};

var SvgPeopleNext = function SvgPeopleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5J,
    name: "people-next"
  }, props));
};

var SvgIcon$5K = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14 13.6c-.2 0-.4-.2-.5-.4l-.4-2c-.1-.5-.5-1-1-1.2-.4-.2-.9-.4-1.3-.6l-1.1-.6-.7-.3.2-.5c.1-.2.2-.5.3-.7l.1-.1c.1-.1.4-.5.2-.7l-.1-.2v-.2c0-.2.1-.4.1-.6 0-.3 0-.7-.2-1 0-.1-.1-.2-.2-.3-.3-.4-.8-.7-1.4-.8h-.1c-.4 0-.8.2-1.1.5l-.2.3c-.1.1-.2.2-.2.3-.2.4-.2.7-.2 1.1 0 .2 0 .3.1.5v.2l-.1.2c-.2.2.1.6.1.7l.1.1c.1.3.2.5.4.7l.2.5-.7.3c-.4.2-.7.3-1 .5l-.2.1c-.5.2-1 .4-1.3.6-.5.3-.9.7-1 1.2l-.4 2c-.1.3-.3.5-.6.4-.3-.1-.5-.3-.4-.6l.4-2c.2-.9.8-1.6 1.6-1.9.3-.2.8-.4 1.3-.6h.1l.9-.5c0-.1-.1-.2-.1-.3-.4-.5-.5-1.1-.3-1.6v-.5c0-.5.1-1 .2-1.5.1-.2.2-.5.4-.7.5-.6 1.2-1 2-1.1h.3c.8.2 1.5.6 2 1.2.1.2.3.4.4.6.2.5.3 1 .2 1.5v.5c.2.5.1 1.2-.3 1.6l-.2.3.8.4c.6.2 1.1.5 1.4.7.7.4 1.3 1.1 1.5 1.9l.4 2c.1.3-.1.5-.4.6.1 0 .1 0 0 0z"
  }));
};

var SvgPerson = function SvgPerson(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5K,
    name: "person"
  }, props));
};

var SvgIcon$5L = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 95.8 91.3"
  }, props), React.createElement("title", null, title), React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 83.683,
    y1: 100.917,
    x2: 12.037,
    y2: 29.271
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#ADE2FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.232,
    stopColor: "#ADE2FF"
  }), React.createElement("stop", {
    offset: 0.987,
    stopColor: "#0070B9"
  })), React.createElement("path", {
    fill: "url(#a)",
    d: "M93.4 91.2s0-9.8-3.2-14.2-21.8-10.9-26.8-13.3c-5-2.4-4.3-8.9-4.3-8.9 5.3-5 7.2-12.4 7.2-12.4s3.3-1.9 4.1-8.2c.5-2.3-.4-4.7-2.4-6.1 0 0 2.9-25.6-20.2-25.6S27.7 28.2 27.7 28.2c-1.9 1.4-2.8 3.8-2.2 6.1.8 6.3 4 8.2 4 8.2s1.9 7.4 7.2 12.4c0 0 .6 6.4-4.3 8.9-4.9 2.5-23.5 8.9-26.7 13.3S2.5 91.3 2.5 91.3l90.9-.1z"
  }), React.createElement("path", {
    fill: "#036",
    d: "M93.3 91.3c-1.4 0-2.5-1.1-2.5-2.5 0-1.8-.5-7.2-2.7-10.3-2-2.7-13.4-7.4-19.6-9.9-2.6-1.1-4.8-2-6.2-2.6-6.5-3.1-5.8-11-5.8-11.4.1-.6.3-1.2.8-1.6 3.1-3.1 5.3-7 6.5-11.2.2-.7.6-1.2 1.2-1.6 0 0 2.3-1.5 2.9-6.3v-.2c.3-1.3-.2-2.7-1.3-3.5-.7-.6-1.1-1.5-1-2.4 0-.1 1.2-11.2-4.7-17.8-3-3.3-7.3-5-12.9-5s-10 1.7-12.9 5c-6 6.7-4.8 17.8-4.8 17.9.1.9-.3 1.8-1 2.3-1.1.8-1.6 2.2-1.3 3.5v.2c.6 4.8 2.8 6.3 2.9 6.4.6.3.9.9 1.1 1.5 1.2 4.2 3.4 8.1 6.5 11.2.4.4.7 1 .8 1.6 0 .3.7 8.2-5.8 11.4-1.4.7-3.6 1.6-6.2 2.6-6.1 2.5-17.6 7.2-19.6 9.9-2.2 3-2.7 8.4-2.7 10.3 0 1.4-1.1 2.5-2.5 2.5S0 90.2 0 88.8c0-.3 0-8.3 3.7-13.3 2.6-3.5 11.4-7.3 21.7-11.6 2.5-1 4.7-1.9 5.9-2.5 2.5-1.2 2.9-4 2.9-5.5-3.2-3.4-5.5-7.5-6.9-12-1.3-1.2-3.6-3.9-4.3-9.3-.5-2.7.2-5.5 2.1-7.5-.2-3.6-.1-13.5 6.1-20.4 4-4.4 9.6-6.7 16.7-6.7s12.8 2.2 16.7 6.7c6.1 6.8 6.3 16.7 6.1 20.4 1.9 2 2.8 4.9 2.2 7.6-.7 5.4-3.1 8.1-4.4 9.3-1.4 4.4-3.8 8.5-6.9 11.9 0 1.4.5 4.3 2.9 5.5 1.2.6 3.4 1.5 5.9 2.5 10.3 4.2 19.1 8 21.7 11.6 3.7 5 3.7 12.9 3.7 13.3 0 1.4-1.1 2.5-2.5 2.5z"
  }));
};

var SvgPerson$1 = function SvgPerson(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5L,
    name: "person"
  }, props));
};

var SvgIcon$5M = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.5 15.5"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.9 4.2c0 2.3-1.9 4.2-4.1 4.2s-4.2-2-4.2-4.2S5.5 0 7.7 0c2.3 0 4.2 1.8 4.2 4.2 0-.1 0-.1 0 0m3.3 7.7c-.5-.7-5.5-2.5-5.5-2.5-1.2.8-2.7.8-3.9 0 0 0-5 1.9-5.5 2.5-.4.7-.3 3.6-.3 3.6h15.4c.1 0 .2-2.9-.2-3.6z"
  }));
};

var SvgPerson$2 = function SvgPerson(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5M,
    name: "person"
  }, props));
};

var SvgIcon$5N = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 7c-1.1 0-2.2.5-3 1.4h-.1L8.2 8c0-.1.1-.2.1-.2.3-.4.4-1 .2-1.5v-.5c0-.5-.1-.9-.2-1.4 0-.2-.2-.3-.3-.5-.5-.6-1.1-1-1.9-1.1h-.2c-.8.1-1.5.4-1.9 1-.2.2-.3.4-.4.6-.1.5-.2.9-.2 1.4v.4c-.2.6-.1 1.1.3 1.6 0 .1.1.2.1.2l-.6.3-.2.1c-.5.2-.9.4-1.2.5-.7.4-1.2 1-1.4 1.8L0 12.6c0 .3.1.5.4.6.3.1.5-.1.6-.4l.4-1.9c.1-.5.4-.9.9-1.1.3-.1.7-.3 1.1-.5l.2-.1.9-.4.7-.4-.3-.4c-.1-.2-.2-.4-.3-.7l-.1-.1c0-.1-.3-.4-.2-.6l.1-.2v-.6c0-.3 0-.7.2-1 0-.1.1-.2.2-.3l.2-.3c.3-.2.7-.4 1-.4h.1c.5.1 1 .3 1.3.7.1.1.1.2.2.3.1.3.2.6.1.9v.7l.1.2c.2.2-.1.5-.1.6l-.1.1c-.2.3-.3.5-.5.7l-.3.5.7.4.9.3c-.2.6-.4 1.2-.4 1.8 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4zm0 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm2-3.5h-4c-.3 0-.5.2-.5.5s.2.5.5.5h4c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgPersonMinus = function SvgPersonMinus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5N,
    name: "person-minus"
  }, props));
};

var SvgIcon$5O = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.5 15.5"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.3 12.4H8.5v-1h6.8v1zM7.7 8.3c2.3 0 4.2-1.9 4.2-4.1S10 0 7.8 0 3.6 1.9 3.6 4.1c0 2.3 1.9 4.2 4.1 4.2zM7 9.9c-.4-.2-.8-.3-1.2-.5 0 0-5 1.9-5.5 2.5-.4.7-.3 3.6-.3 3.6h15.4v-1.6H7v-4z"
  }));
};

var SvgPersonMinus$1 = function SvgPersonMinus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5O,
    name: "person-minus"
  }, props));
};

var SvgIcon$5P = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 7c-1.1 0-2.2.5-3 1.4h-.1L8.2 8c0-.1.1-.2.1-.2.3-.4.4-1 .2-1.5v-.5c0-.5-.1-.9-.2-1.4 0-.2-.2-.3-.3-.5-.5-.6-1.1-1-1.9-1.1h-.2c-.8.1-1.5.4-1.9 1-.2.2-.3.4-.4.6-.1.5-.2.9-.2 1.4v.4c-.2.6-.1 1.1.3 1.6 0 .1.1.2.1.2l-.6.3-.2.1c-.5.2-.9.4-1.2.5-.7.4-1.2 1-1.4 1.8L0 12.6c0 .3.1.5.4.6.3.1.5-.1.6-.4l.4-1.9c.1-.5.4-.9.9-1.1.3-.1.7-.3 1.1-.5l.2-.1.9-.4.7-.4-.3-.4c-.1-.2-.2-.4-.3-.7l-.1-.1c0-.1-.3-.4-.2-.6l.1-.2v-.6c0-.3 0-.7.2-1 0-.1.1-.2.2-.3l.2-.3c.3-.2.7-.4 1-.4h.1c.5.1 1 .3 1.3.7.1.1.1.2.2.3.1.3.2.6.1.9v.7l.1.2c.2.2-.1.5-.1.6l-.1.1c-.2.3-.3.5-.5.7l-.3.5.7.4.9.3c-.2.6-.4 1.2-.4 1.8 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4zm0 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm2-3.5h-4c-.3 0-.5.2-.5.5s.2.5.5.5h4c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgPersonMinusNext = function SvgPersonMinusNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5P,
    name: "person-minus-next"
  }, props));
};

var SvgIcon$5Q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M3.7 12.6v.6H.6v-.6h3.1zm5.9.6H6.5v-.6h3.1v.6zm-1.3-3.1V5.6h-.6v4.5H1.9V12H0v3.7h4.3V12H2.5v-1.2h5.2V12H5.8v3.7h4.3V12H8.3v-1.2h5.2V12h-1.9v3.7H16V12h-1.9v-1.9H8.3zm7.1 3.1h-3.1v-.6h3.1v.6zM8.9 1.6c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6S6.3 0 7.2 0s1.7.7 1.7 1.6m1.3 3.1c-.7-.4-1.4-.7-2.2-1-.5.3-1.1.3-1.6 0-.7.3-1.4.6-2.1 1-.1.5-.2 1-.2 1.5h6.1c.1-.5.1-1 0-1.5zm1.7.5h-1.1c0-.3-.1-.6-.2-.8-.1-.1-.3-.4-2.1-1.1.1 0 .1-.1.2-.1.4.2.8.2 1.2-.1.6.2 1.3.5 1.9.9.1.4.1.8.1 1.2zM9.4 1.6c0 .4-.1.8-.3 1.1.8.1 1.5-.5 1.6-1.2.1-.8-.5-1.5-1.2-1.6-.2.1-.2.1-.3.1-.1 0-.3 0-.5.1.5.4.7 1 .7 1.5z"
  }));
};

var SvgPersonNetwork = function SvgPersonNetwork(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5Q,
    name: "person-network"
  }, props));
};

var SvgIcon$5R = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14 13.6c-.2 0-.4-.2-.5-.4l-.4-2c-.1-.5-.5-1-1-1.2-.4-.2-.9-.4-1.3-.6l-1.1-.6-.7-.3.2-.5c.1-.2.2-.5.3-.7l.1-.1c.1-.1.4-.5.2-.7l-.1-.2v-.2c0-.2.1-.4.1-.6 0-.3 0-.7-.2-1 0-.1-.1-.2-.2-.3-.3-.4-.8-.7-1.4-.8h-.1c-.4 0-.8.2-1.1.5l-.2.3c-.1.1-.2.2-.2.3-.2.4-.2.7-.2 1.1 0 .2 0 .3.1.5v.2l-.1.2c-.2.2.1.6.1.7l.1.1c.1.3.2.5.4.7l.2.5-.7.3c-.4.2-.7.3-1 .5l-.2.1c-.5.2-1 .4-1.3.6-.5.3-.9.7-1 1.2l-.4 2c-.1.3-.3.5-.6.4-.3-.1-.5-.3-.4-.6l.4-2c.2-.9.8-1.6 1.6-1.9.3-.2.8-.4 1.3-.6h.1l.9-.5c0-.1-.1-.2-.1-.3-.4-.5-.5-1.1-.3-1.6v-.5c0-.5.1-1 .2-1.5.1-.2.2-.5.4-.7.5-.6 1.2-1 2-1.1h.3c.8.2 1.5.6 2 1.2.1.2.3.4.4.6.2.5.3 1 .2 1.5v.5c.2.5.1 1.2-.3 1.6l-.2.3.8.4c.6.2 1.1.5 1.4.7.7.4 1.3 1.1 1.5 1.9l.4 2c.1.3-.1.5-.4.6.1 0 .1 0 0 0z"
  }));
};

var SvgPersonNext = function SvgPersonNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5R,
    name: "person-next"
  }, props));
};

var SvgIcon$5S = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 7c-1.1 0-2.2.5-3 1.4h-.1L8.2 8c0-.1.1-.2.1-.2.3-.4.4-1 .2-1.5v-.5c0-.5-.1-.9-.2-1.4 0-.2-.2-.3-.3-.5-.5-.6-1.1-1-1.9-1.1h-.2c-.8.1-1.5.4-1.9 1-.2.2-.3.4-.4.6-.1.5-.2.9-.2 1.4v.4c-.2.6-.1 1.1.3 1.6 0 .1.1.2.1.2l-.6.3-.2.1c-.5.2-.9.4-1.2.5-.7.4-1.2 1-1.4 1.8L0 12.6c0 .3.1.5.4.6.3.1.5-.1.6-.4l.4-1.9c.1-.5.4-.9.9-1.1.3-.1.7-.3 1.1-.5l.2-.1.9-.4.7-.4-.3-.4c-.1-.2-.2-.4-.3-.7l-.1-.1c0-.1-.3-.4-.2-.6l.1-.2v-.6c0-.3 0-.7.2-1 0-.1.1-.2.2-.3l.2-.3c.3-.2.7-.4 1-.4h.1c.5.1 1 .3 1.3.7.1.1.1.2.2.3.1.3.2.6.1.9v.7l.1.2c.2.2-.1.5-.1.6l-.1.1c-.2.3-.3.5-.5.7l-.3.5.7.4.9.3c-.2.6-.4 1.2-.4 1.8 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4zm0 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm2-3.5h-1.5V9c0-.3-.2-.5-.5-.5s-.5.2-.5.5v1.5H10c-.3 0-.5.2-.5.5s.2.5.5.5h1.5V13c0 .3.2.5.5.5s.5-.2.5-.5v-1.5H14c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgPersonPlus = function SvgPersonPlus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5S,
    name: "person-plus"
  }, props));
};

var SvgIcon$5T = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.4 15.5"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.4 12.4H8.5v-1h6.8l.1 1zm-3.9 3.1v-7h1v7h-1zM10.8 7c1.5-1.7 1.4-4.3-.3-5.8s-4.3-1.5-5.8.2-1.4 4.3.3 5.8c1.4 1.3 3.4 1.4 5 .4V7h.8zM7 13.9v-4c-.4-.2-.8-.3-1.2-.5 0 0-5 1.9-5.5 2.5-.4.7-.3 3.6-.3 3.6h10v-1.6H7zM10.8 7H10v.7c.3-.3.6-.5.8-.7z"
  }));
};

var SvgPersonPlus$1 = function SvgPersonPlus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5T,
    name: "person-plus"
  }, props));
};

var SvgIcon$5U = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 7c-1.1 0-2.2.5-3 1.4h-.1L8.2 8c0-.1.1-.2.1-.2.3-.4.4-1 .2-1.5v-.5c0-.5-.1-.9-.2-1.4 0-.2-.2-.3-.3-.5-.5-.6-1.1-1-1.9-1.1h-.2c-.8.1-1.5.4-1.9 1-.2.2-.3.4-.4.6-.1.5-.2.9-.2 1.4v.4c-.2.6-.1 1.1.3 1.6 0 .1.1.2.1.2l-.6.3-.2.1c-.5.2-.9.4-1.2.5-.7.4-1.2 1-1.4 1.8L0 12.6c0 .3.1.5.4.6.3.1.5-.1.6-.4l.4-1.9c.1-.5.4-.9.9-1.1.3-.1.7-.3 1.1-.5l.2-.1.9-.4.7-.4-.3-.4c-.1-.2-.2-.4-.3-.7l-.1-.1c0-.1-.3-.4-.2-.6l.1-.2v-.6c0-.3 0-.7.2-1 0-.1.1-.2.2-.3l.2-.3c.3-.2.7-.4 1-.4h.1c.5.1 1 .3 1.3.7.1.1.1.2.2.3.1.3.2.6.1.9v.7l.1.2c.2.2-.1.5-.1.6l-.1.1c-.2.3-.3.5-.5.7l-.3.5.7.4.9.3c-.2.6-.4 1.2-.4 1.8 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4zm0 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm2-3.5h-1.5V9c0-.3-.2-.5-.5-.5s-.5.2-.5.5v1.5H10c-.3 0-.5.2-.5.5s.2.5.5.5h1.5V13c0 .3.2.5.5.5s.5-.2.5-.5v-1.5H14c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }));
};

var SvgPersonPlusNext = function SvgPersonPlusNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5U,
    name: "person-plus-next"
  }, props));
};

var SvgIcon$5V = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.6 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.1 12.7L10 10.6l.7-.7 2.1 2.1 2.1-2.1.7.7-2.1 2.1 2 2-.7.7-2-2-2.1 2.1-.7-.7 2.1-2.1zm-2.2 0l-2.1-2.1.8-.8c-1 .2-2 0-2.8-.5 0 0-5 1.9-5.5 2.5-.4.8-.3 3.7-.3 3.7h8.4l-.6-.6 2.1-2.2zM7.7 8.3c2.3 0 4.2-1.9 4.2-4.1S10 0 7.8 0 3.6 1.9 3.6 4.1c0 2.3 1.9 4.2 4.1 4.2z"
  }));
};

var SvgPersonX = function SvgPersonX(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5V,
    name: "person-x"
  }, props));
};

var SvgIcon$5W = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.5 0h-7C3.7 0 3 .7 3 1.5v13c0 .8.7 1.5 1.5 1.5h7c.8 0 1.5-.7 1.5-1.5v-13c0-.8-.7-1.5-1.5-1.5zm.5 14.5c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5v-1h8v1zm0-2H4v-9h8v9zm0-10H4v-1c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v1z"
  }));
};

var SvgPhone = function SvgPhone(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5W,
    name: "phone"
  }, props));
};

var SvgIcon$5X = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14.3 15.5"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.3 0c-.2.1-.3.1-.4.2C1.2.6.6 1.2.2 1.9c-.3.5-.4 5.4 3.2 9.5 2.1 2.6 5.3 4.1 8.7 4.1h.1c.8-.3 1.4-.9 1.9-1.5.4-.6.3-1.3-.1-1.8 0-.1-.1-.1-.1-.2-.2-.6-3.2-1.4-3.4-1.4h-.2c-.4.1-.8.5-1.8 1.3-1.2-.7-2.3-1.5-3.2-2.6-.8-1-1.5-2.1-2-3.3 1.1-1 1.5-1.4 1.6-1.9 0-.2-.5-3.3-1-3.6 0 0-.1-.1-.2-.1C3.3.1 2.8 0 2.3 0z"
  }));
};

var SvgPhone$1 = function SvgPhone(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5X,
    name: "phone"
  }, props));
};

var SvgIcon$5Y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 9 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 2V0H1v2H0v14h9V2H2zm0 12H1v-1h1v1zm0-2H1v-1h1v1zm0-2H1V9h1v1zm2 4H3v-1h1v1zm0-2H3v-1h1v1zm0-2H3V9h1v1zm2 4H5v-1h1v1zm0-2H5v-1h1v1zm0-2H5V9h1v1zm2 4H7v-1h1v1zm0-2H7v-1h1v1zm0-2H7V9h1v1zm0-2H1V3h7v5z"
  }));
};

var SvgPhoneMobile = function SvgPhoneMobile(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5Y,
    name: "phone-mobile"
  }, props));
};

var SvgIcon$5Z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.5 0h-7C3.7 0 3 .7 3 1.5v13c0 .8.7 1.5 1.5 1.5h7c.8 0 1.5-.7 1.5-1.5v-13c0-.8-.7-1.5-1.5-1.5zm.5 14.5c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5v-1h8v1zm0-2H4v-9h8v9zm0-10H4v-1c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v1z"
  }));
};

var SvgPhoneNext = function SvgPhoneNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5Z,
    name: "phone-next"
  }, props));
};

var SvgIcon$5_ = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 10 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 0v16h10V0H0zm3 1h4v1H3V1zm2 14.3c-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8s.8.3.8.8-.4.8-.8.8zM9 13H1V3h8v10z"
  }));
};

var SvgPhoneTouchScreen = function SvgPhoneTouchScreen(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$5_,
    name: "phone-touch-screen"
  }, props));
};

var SvgIcon$60 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    version: 1.2,
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 16.9c-.2 0-.4-.1-.6-.3-.3-.3-.3-.8 0-1.2 0 0 .2-.2.9-1.1.8-1 2-2.2 2-2.2L6.4 10 4.1 8c-.3-.3-.3-.9 0-1.2.8-.8 2-.9 2.9-.4l3.8-3.3c0-.2-.1-.3-.1-.5 0-.5.2-.9.5-1.3.4-.4.9-.3 1.2 0l4.2 4.2c.2.2.2.4.2.6 0 .2-.1.4-.2.6-.5.5-1.2.7-1.8.5L11.5 11c.2.4.3.8.3 1.2 0 .6-.2 1.2-.7 1.6-.4.4-.9.3-1.2 0l-2-2-2.1 2.1s-1.2 1.2-2.2 2c-.9.7-1 .8-1.1.9-.1 0-.3.1-.5.1zm.1-.8zm2.7-8.7l2.8 2.8L4.8 13s-1.2 1.2-1.9 2.1c-.2.2-.3.4-.4.5.1-.1.3-.2.5-.4.9-.8 2.1-1.9 2.1-1.9l2.7-2.7 2.6 2.6c.2-.3.4-.6.4-.9 0-.3-.1-.7-.3-.9l-.2-.4 4.2-5 .3.2c.3.2.7.1 1-.1l-4-4c-.2.2-.2.4-.2.6 0 .2 0 .3.1.4l.2.3L7 7.6l-.3-.2c-.5-.5-1.4-.5-1.9 0z",
    vectorEffect: "non-scaling-stroke"
  }));
};

var SvgPin = function SvgPin(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$60,
    name: "pin"
  }, props));
};

var SvgIcon$61 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    version: 1.2,
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 16.9c-.2 0-.4-.1-.6-.3-.3-.3-.3-.8 0-1.2 0 0 .2-.2.9-1.1.8-1 2-2.2 2-2.2L6.4 10 4.1 8c-.3-.3-.3-.9 0-1.2.8-.8 2-.9 2.9-.4l3.8-3.3c0-.2-.1-.3-.1-.5 0-.5.2-.9.5-1.3.4-.4.9-.3 1.2 0l4.2 4.2c.2.2.2.4.2.6 0 .2-.1.4-.2.6-.5.5-1.2.7-1.8.5L11.5 11c.2.4.3.8.3 1.2 0 .6-.2 1.2-.7 1.6-.4.4-.9.3-1.2 0l-2-2-2.1 2.1s-1.2 1.2-2.2 2c-.9.7-1 .8-1.1.9-.1 0-.3.1-.5.1zm.1-.8zm2.7-8.7l2.8 2.8L4.8 13s-1.2 1.2-1.9 2.1c-.2.2-.3.4-.4.5.1-.1.3-.2.5-.4.9-.8 2.1-1.9 2.1-1.9l2.7-2.7 2.6 2.6c.2-.3.4-.6.4-.9 0-.3-.1-.7-.3-.9l-.2-.4 4.2-5 .3.2c.3.2.7.1 1-.1l-4-4c-.2.2-.2.4-.2.6 0 .2 0 .3.1.4l.2.3L7 7.6l-.3-.2c-.5-.5-1.4-.5-1.9 0z",
    vectorEffect: "non-scaling-stroke"
  }));
};

var SvgPin$1 = function SvgPin(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$61,
    name: "pin"
  }, props));
};

var SvgIcon$62 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    version: 1.2,
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2 16.9c-.2 0-.4-.1-.6-.3-.3-.3-.3-.8 0-1.2 0 0 .2-.2.9-1.1.8-1 2-2.2 2-2.2L6.4 10 4.1 8c-.3-.3-.3-.9 0-1.2.8-.8 2-.9 2.9-.4l3.8-3.3c0-.2-.1-.3-.1-.5 0-.5.2-.9.5-1.3.4-.4.9-.3 1.2 0l4.2 4.2c.2.2.2.4.2.6 0 .2-.1.4-.2.6-.5.5-1.2.7-1.8.5L11.5 11c.2.4.3.8.3 1.2 0 .6-.2 1.2-.7 1.6-.4.4-.9.3-1.2 0l-2-2-2.1 2.1s-1.2 1.2-2.2 2c-.9.7-1 .8-1.1.9-.1 0-.3.1-.5.1zm.1-.8zm2.7-8.7l2.8 2.8L4.8 13s-1.2 1.2-1.9 2.1c-.2.2-.3.4-.4.5.1-.1.3-.2.5-.4.9-.8 2.1-1.9 2.1-1.9l2.7-2.7 2.6 2.6c.2-.3.4-.6.4-.9 0-.3-.1-.7-.3-.9l-.2-.4 4.2-5 .3.2c.3.2.7.1 1-.1l-4-4c-.2.2-.2.4-.2.6 0 .2 0 .3.1.4l.2.3L7 7.6l-.3-.2c-.5-.5-1.4-.5-1.9 0z",
    vectorEffect: "non-scaling-stroke"
  }));
};

var SvgPinNext = function SvgPinNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$62,
    name: "pin-next"
  }, props));
};

var SvgIcon$63 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7m0-1C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"
  }), React.createElement("path", {
    d: "M5.7 12.5c-.1 0-.2 0-.4-.1-.2-.2-.3-.4-.3-.7V4.3c0-.4.3-.8.7-.8.2 0 .3 0 .5.1l6.1 3.7c.4.2.5.7.3 1-.1.1-.2.3-.3.3l-6.1 3.7c-.2.1-.3.2-.5.2zM6 4.7v6.6L11.5 8 6 4.7z"
  }));
};

var SvgPlay = function SvgPlay(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$63,
    name: "play"
  }, props));
};

var SvgIcon$64 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7m0-1C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"
  }), React.createElement("path", {
    d: "M5.7 12.5c-.1 0-.2 0-.4-.1-.2-.2-.3-.4-.3-.7V4.3c0-.4.3-.8.7-.8.2 0 .3 0 .5.1l6.1 3.7c.4.2.5.7.3 1-.1.1-.2.3-.3.3l-6.1 3.7c-.2.1-.3.2-.5.2zM6 4.7v6.6L11.5 8 6 4.7z"
  }));
};

var SvgPlayNext = function SvgPlayNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$64,
    name: "play-next"
  }, props));
};

var SvgIcon$65 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 7.5H8.5V4c0-.3-.2-.5-.5-.5s-.5.2-.5.5v3.5H4c-.3 0-.5.2-.5.5s.2.5.5.5h3.5V12c0 .3.2.5.5.5s.5-.2.5-.5V8.5H12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgPlusCircle = function SvgPlusCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$65,
    name: "plus-circle"
  }, props));
};

var SvgIcon$66 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 8.6H8.6V12c0 .3-.3.6-.6.6s-.6-.3-.6-.6V8.6H4c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h3.4V4c0-.3.3-.6.6-.6s.6.3.6.6v3.4H12c.3 0 .6.3.6.6s-.3.6-.6.6z"
  }));
};

var SvgPlusCircleFill = function SvgPlusCircleFill(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$66,
    name: "plus-circle-fill"
  }, props));
};

var SvgIcon$67 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.3 13.4c-3.1-3.1-3.1-8.1 0-11.1s8.1-3.1 11.1 0 3.1 8.1 0 11.1c-3 3.1-8 3.1-11.1 0zM12.7 3C10 .3 5.7.3 3 3s-2.7 7 0 9.7 7 2.7 9.7 0c2.7-2.7 2.7-7 0-9.7zm-.8 5.4h-8v-1h8v1zm-4.5 3.5v-8h1v8h-1z"
  }));
};

var SvgPlusCircle$1 = function SvgPlusCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$67,
    name: "plus-circle"
  }, props));
};

var SvgIcon$68 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 7.5H8.5V4c0-.3-.2-.5-.5-.5s-.5.2-.5.5v3.5H4c-.3 0-.5.2-.5.5s.2.5.5.5h3.5V12c0 .3.2.5.5.5s.5-.2.5-.5V8.5H12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgPlusCircleNext = function SvgPlusCircleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$68,
    name: "plus-circle-next"
  }, props));
};

var SvgIcon$69 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.4 2.3C10.3-.8 5.3-.8 2.3 2.3s-3.1 8.1 0 11.1 8.1 3.1 11.1 0c3.1-3 3.1-8 0-11.1zm-.5 6.6h-4v4h-2v-4h-4v-2h4v-4h2v4h4v2z"
  }));
};

var SvgPlusCircleSolid = function SvgPlusCircleSolid(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$69,
    name: "plus-circle-solid"
  }, props));
};

var SvgIcon$6a = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12 11.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.4 11.9V0h1v11.9h-1zM0 5.5h12v1H0v-1z"
  }));
};

var SvgPlus = function SvgPlus(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6a,
    name: "plus"
  }, props));
};

var SvgIcon$6b = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M24 16H0V0h24z"
  }), React.createElement("path", {
    d: "M24 0v16H0V0h24zm-.067.067H.067v15.866h23.866V.067z",
    fill: "#CCC"
  }), React.createElement("path", {
    fill: "#DC143C",
    d: "M24 16H0V8h24z"
  })));
};

var SvgPoland = function SvgPoland(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6b,
    name: "poland"
  }, props));
};

var SvgIcon$6c = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0H7v10h1V0zm1.5 2.3c3.4 1.1 5.3 4.7 4.2 8.2S9 15.8 5.5 14.7.2 9.9 1.3 6.5c.6-2 2.2-3.5 4.2-4.2v-1C1.5 2.4-.8 6.5.3 10.5s5.2 6.3 9.2 5.2 6.3-5.2 5.2-9.2C14 4 12 2 9.5 1.3v1z"
  }));
};

var SvgPower = function SvgPower(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6c,
    name: "power"
  }, props));
};

var SvgIcon$6d = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 7h-.5V5c0-.6-.4-1-1-1h-.9V1H3.4v3h-.9c-.6 0-1 .4-1 1v2H1c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1h2.4v1h9.2v-1H15c.6 0 1-.4 1-1V8c0-.6-.4-1-1-1zm-2.4-2h.9v2h-.9V5zM4.4 2h7.2v5H4.4V2zM2.5 5h.9v2h-.9V5zm9.1 9H4.4v-3h7.2v3zm3.4-1h-2.4v-1.3l.8-.9c.1-.1.2-.4.1-.5-.1-.2-.3-.3-.5-.3H3c-.2 0-.4.1-.5.3-.1.2 0 .4.1.5l.8.9V13H1V8h14v5zm-9.5-1h5v1h-5v-1z"
  }));
};

var SvgPrinter = function SvgPrinter(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6d,
    name: "printer"
  }, props));
};

var SvgIcon$6e = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.8 15.6"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.8 4h-2.9V1.8l-2-1.8h-8v4H0v6.8h2.9v4.8h10v-4.8h2.9V4zM1.9 6h-1V5h1v1zm10 3v5.6h-8V8.8h8V9zm0-5h-8V1h6v1.8h2V4z"
  }));
};

var SvgPrinter$1 = function SvgPrinter(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6e,
    name: "printer"
  }, props));
};

var SvgIcon$6f = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 7h-.5V5c0-.6-.4-1-1-1h-.9V1H3.4v3h-.9c-.6 0-1 .4-1 1v2H1c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1h2.4v1h9.2v-1H15c.6 0 1-.4 1-1V8c0-.6-.4-1-1-1zm-2.4-2h.9v2h-.9V5zM4.4 2h7.2v5H4.4V2zM2.5 5h.9v2h-.9V5zm9.1 9H4.4v-3h7.2v3zm3.4-1h-2.4v-1.3l.8-.9c.1-.1.2-.4.1-.5-.1-.2-.3-.3-.5-.3H3c-.2 0-.4.1-.5.3-.1.2 0 .4.1.5l.8.9V13H1V8h14v5zm-9.5-1h5v1h-5v-1z"
  }));
};

var SvgPrinterNext = function SvgPrinterNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6f,
    name: "printer-next"
  }, props));
};

var SvgIcon$6g = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14.6 11.4"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M14.6 8.2c0 1.8-3.3 3.2-7.3 3.2S0 9.9 0 8.2V4.1c.3.8 1 1.5 1.9 1.8C3.6 6.6 5.5 7 7.3 7c1.1 0 2.2-.1 3.2-.3h.2c2-.5 3.5-1.3 3.8-2.3v3.9c.1-.2.1-.1.1-.1zm-.1-5c0 1.8-3.2 3.2-7.2 3.2S.1 4.9.1 3.2 3.3 0 7.3 0s7.2 1.4 7.2 3.2zm-9 .3l2.2-.9-.4-1.3-2.3.9-.3-.7c-.1-.2-.2-.2-.2-.1l-.5.9c-.1.1-.2.3-.3.4l-.4.8c-.1.1 0 .2.1.3h.1l.9.3.5.1.9.3c.1 0 .2-.1.1-.2l-.4-.8zm5.7-.6l-.9-.3-.5-.1-.9-.3c-.1 0-.2.1-.1.2l.3.7-2.3.8.5 1.3 2.4-.8.3.7c.1.2.2.2.2.1l.5-.9c.1-.1.2-.3.2-.4l.5-.9c0 .1 0-.1-.2-.1.1 0 .1 0 0 0z"
  }));
};

var SvgPuck = function SvgPuck(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6g,
    name: "puck"
  }, props));
};

var SvgIcon$6h = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zM8 2.6c-1.7 0-3 1.3-3 3 0 .3.2.5.5.5s.5-.3.5-.5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2h-.5v2.3c0 .3.2.5.5.5s.5-.2.5-.5V8.5C9.9 8.3 11 7 11 5.6c0-1.7-1.3-3-3-3zM8 11c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"
  }));
};

var SvgQuestionCircle = function SvgQuestionCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6h,
    name: "question-circle"
  }, props));
};

var SvgIcon$6i = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M2.3 13.4c-3.1-3.1-3.1-8.1 0-11.1s8.1-3.1 11.1 0 3.1 8.1 0 11.1c-3 3.1-8 3.1-11.1 0zM12.7 3C10 .3 5.7.3 3 3s-2.7 7 0 9.7 7 2.7 9.7 0c2.7-2.7 2.7-7 0-9.7zM8.9 9.9H6.8v-.3c0-.4 0-.7.1-1.1.1-.2.2-.5.4-.7.3-.4.7-.8 1.1-1.2.2-.2.4-.5.4-.8 0-.2 0-.4-.2-.6-.1-.2-.3-.2-.5-.2-.3 0-.5.1-.6.3-.3.3-.4.7-.4 1.1L5 6.1c0-.9.3-1.7.8-2.4.6-.6 1.4-1 2.2-.9.8 0 1.5.2 2 .7.7.6 1 1.4 1 2.2 0 .4-.1.8-.3 1.1-.3.5-.6.9-1 1.3-.3.3-.5.6-.7.9-.1.3-.1.6-.1.9zm-2 1h2v2h-2v-2z"
  }));
};

var SvgQuestionCircle$1 = function SvgQuestionCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6i,
    name: "question-circle"
  }, props));
};

var SvgIcon$6j = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zM8 2.6c-1.7 0-3 1.3-3 3 0 .3.2.5.5.5s.5-.3.5-.5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2h-.5v2.3c0 .3.2.5.5.5s.5-.2.5-.5V8.5C9.9 8.3 11 7 11 5.6c0-1.7-1.3-3-3-3zM8 11c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"
  }));
};

var SvgQuestionCircleNext = function SvgQuestionCircleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6j,
    name: "question-circle-next"
  }, props));
};

var SvgIcon$6k = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.4 2.3C10.3-.8 5.3-.8 2.3 2.3s-3.1 8.1 0 11.1 8.1 3.1 11.1 0c3.1-3 3.1-8 0-11.1zM8.9 12.8h-2v-2h2v2zm1.9-6c-.3.5-.6.9-1 1.3-.4.3-.6.6-.8.9-.1.3-.1.6-.1.9H6.8v-.3c0-.4 0-.7.1-1.1.1-.2.2-.5.4-.7.3-.4.7-.8 1.1-1.2.2-.2.4-.5.4-.8 0-.2 0-.4-.2-.6-.1-.2-.3-.2-.5-.2-.3 0-.5.1-.7.3-.2.3-.3.7-.3 1.1L5 6.1c0-.9.3-1.7.8-2.4.6-.6 1.4-1 2.2-.9.8 0 1.5.2 2 .7.7.6 1 1.4 1 2.2 0 .4-.1.8-.2 1.1z"
  }));
};

var SvgQuestionCircleSolid = function SvgQuestionCircleSolid(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6k,
    name: "question-circle-solid"
  }, props));
};

var SvgIcon$6l = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M9 10.3H6.6V10c0-.4 0-.9.1-1.3.1-.3.3-.6.5-.9.4-.5.8-1 1.3-1.4.3-.3.5-.6.5-1 0-.2-.1-.5-.2-.7-.2-.2-.5-.3-.7-.3-.3 0-.6.1-.8.4-.2.4-.3.9-.3 1.3l-2.5-.4c0-1 .4-2 1-2.8.7-.8 1.7-1.1 2.7-1.1.8 0 1.6.2 2.3.7.8.7 1.2 1.7 1.2 2.7 0 .5-.1.9-.3 1.3-.4.7-.9 1.2-1.4 1.7-.3.3-.6.7-.8 1-.1.4-.2.7-.2 1.1zm-2.3 1.1h2.4v2.4H6.7v-2.4z"
  }));
};

var SvgQuestionMark = function SvgQuestionMark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6l,
    name: "question-mark"
  }, props));
};

var SvgIcon$6m = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 11.4 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8.2 6c0 1.4-1.1 2.5-2.5 2.5S3.2 7.4 3.2 6s1.1-2.5 2.5-2.5S8.2 4.6 8.2 6zm2.4 1l.8.9-1.2.2c-.2.6-.6 1.1-1.1 1.6l-.2.1.8 6.2-4-4-4 4 .8-6.2-.2-.1c-.5-.4-.9-1-1.1-1.6L0 7.9.8 7C.7 6.4.7 5.7.8 5L0 4.1l1.2-.2c.3-.6.7-1.1 1.1-1.6l-.1-1.2 1.1.5c.6-.3 1.2-.5 1.8-.6l.6-1 .6 1.1c.6.1 1.3.3 1.8.6l1.1-.5-.1 1.1c.5.4.9 1 1.1 1.6l1.2.2-.8.9c.1.7.1 1.3 0 2zM9.2 6c0-1.9-1.6-3.5-3.5-3.5S2.2 4.1 2.2 6s1.6 3.5 3.5 3.5S9.2 7.9 9.2 6z"
  }));
};

var SvgRibbonAward = function SvgRibbonAward(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6m,
    name: "ribbon-award"
  }, props));
};

var SvgIcon$6n = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 127.2 127.2",
    style: {
      enableBackground: 'new 0 0 127.2 127.2'
    }
  }, props), React.createElement("title", null, title), React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 125.621,
    y1: 93.583,
    x2: 89.83,
    y2: 57.792
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: '#ade2ff',
      stopOpacity: 0
    }
  }), React.createElement("stop", {
    offset: 0.232,
    style: {
      stopColor: '#ade2ff'
    }
  }), React.createElement("stop", {
    offset: 0.987,
    style: {
      stopColor: '#0070b9'
    }
  })), React.createElement("path", {
    d: "M85.7 83.4c3.4-1.9 9.3-4 11.2-5 2.5-1.2 2.2-4.5 2.2-4.5-2.7-2.5-3.7-6.3-3.7-6.3s-1.7-1-2.1-4.1c-.3-2.2 1.2-3.1 1.2-3.1S93 47.5 104.7 47.5s10.2 12.9 10.2 12.9 1.5.9 1.1 3.1c-.4 3.2-2 4.1-2 4.1s-1 3.7-3.7 6.3c0 0-.3 3.3 2.2 4.5 2.5 1.2 11.9 4.5 13.5 6.7s1.2 6.9 1.2 6.9H99.1l-13.4-8.6z",
    style: {
      fill: 'url(#a)'
    }
  }), React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 34.458,
    y1: 90.438,
    x2: 4.728,
    y2: 60.708
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: '#ade2ff',
      stopOpacity: 0
    }
  }), React.createElement("stop", {
    offset: 0.232,
    style: {
      stopColor: '#ade2ff'
    }
  }), React.createElement("stop", {
    offset: 0.987,
    style: {
      stopColor: '#0070b9'
    }
  })), React.createElement("path", {
    d: "M41.5 83.4c-3.4-1.9-9.3-4-11.2-5-2.5-1.2-2.2-4.5-2.2-4.5 2.7-2.5 3.7-6.3 3.7-6.3s1.7-1 2.1-4.1c.3-2.2-1.2-3.1-1.2-3.1s1.5-12.9-10.2-12.9-10.2 12.9-10.2 12.9-1.5.9-1.1 3.1c.4 3.2 2 4.1 2 4.1s1 3.7 3.7 6.3c0 0 .3 3.3-2.2 4.5-2.5 1.2-11.9 4.5-13.5 6.7s-1.6 6-1.6 6h28l13.9-7.7z",
    style: {
      fill: 'url(#b)'
    }
  }), React.createElement("path", {
    d: "M129.4 90.8c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5c0-.7-.2-3.2-1.1-4.4-.9-1.1-6.7-3.5-9.2-4.5-1.4-.6-2.5-1-3.2-1.4-3.2-1.6-3.8-5.1-3.6-7 .1-.6.3-1.2.8-1.6 2.1-1.9 2.9-5 2.9-5 .2-.7.4-1.2 1.1-1.5.2-.2.7-.8.9-2.3 0-.2.1-.6.1-.6-.8-.5-1.3-1.5-1.2-2.4 0 0 .5-5.1-2.1-7.9-1.2-1.4-3-2.1-5.5-2.1s-4.3.7-5.5 2.1c-2.5 2.8-2.1 7.8-2 7.9.1 1.1-.1 2-1.1 2.4-.1.1-.1.3-.1.5.2 1.5.7 2.2.9 2.3.7.3.9.8 1.1 1.5 0 0 .8 3 2.9 5 .4.4.7 1 .8 1.6.2 1.9-.4 5.4-3.6 7-.7.3-1.8.8-3.2 1.4-1.2.5-2.7 1.1-4.1 1.7 8.4 3.5 15.3 6.8 17.5 9.8 3.7 5 3.7 12.9 3.7 13.3 0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5c0-1.8-.5-7.2-2.7-10.3-2-2.7-13.4-7.4-19.5-9.9-2.6-1.1-4.8-2-6.2-2.6-6.5-3.1-5.8-11-5.8-11.4.1-.6.3-1.2.8-1.6 4.7-4.4 6.5-11.1 6.5-11.2.2-.7.6-1.2 1.2-1.6 0 0 2.3-1.5 2.9-6.3.4-2.6-1.1-3.6-1.1-3.6-.9-.5-1.3-1.5-1.2-2.5 0-.1 1.2-11.2-4.7-17.8-3-3.3-7.3-5-12.9-5-5.6 0-10 1.7-12.9 5-5.9 6.6-4.7 17.7-4.7 17.8.1 1-.3 1.9-1.2 2.4-.1.1-1.4 1.1-1.1 3.5.6 4.8 2.8 6.4 2.9 6.4.6.3.9.9 1.1 1.5 0 .1 1.8 6.8 6.5 11.2.4.4.7 1 .8 1.6 0 .3.7 8.2-5.8 11.4-1.4.7-3.6 1.6-6.2 2.6-6.1 2.5-17.6 7.2-19.6 9.9-2.2 3-2.7 8.4-2.7 10.3 0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5c0-.3 0-8.3 3.7-13.3 2.2-3 9.1-6.3 17.5-9.8-1.4-.6-2.8-1.2-4-1.7-1.4-.6-2.5-1-3.2-1.4-3.2-1.6-3.8-5.1-3.6-7 .1-.6.3-1.2.8-1.6 2.1-1.9 2.9-5 2.9-5 .2-.7.4-1.2 1.1-1.5.2-.2.7-.8.9-2.3v-.5c-.9-.5-1.3-1.5-1.2-2.5 0 0 .5-5.1-2.1-7.9-1.2-1.4-3-2.1-5.5-2.1s-4.3.7-5.5 2.1c-2.6 2.9-2.1 7.9-2.1 7.9.1 1.1-.1 2-1.1 2.4 0 .1-.1.2-.1.5.2 1.5.7 2.2.9 2.3.7.3.9.8 1.1 1.5 0 0 .8 3 2.9 5 .4.4.7 1 .8 1.6.2 1.9-.4 5.4-3.6 7-.7.3-1.8.8-3.2 1.4-2.5 1-8.3 3.4-9.2 4.5-.8 1.1-1.1 3.4-1.1 4.4 0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5c0-.5.1-4.6 2.1-7.4 1.5-2 5.7-3.9 11.4-6.2 1.2-.5 2.3-.9 2.9-1.2.4-.2.6-.7.7-1.1-1.8-2.1-2.8-4.5-3.2-5.7-.8-.8-2-2.4-2.3-5.2-.3-1.9.3-3.3 1-4.3 0-2.3.3-7.1 3.4-10.6 2.2-2.5 5.4-3.8 9.3-3.8 3.9 0 7.1 1.3 9.3 3.8 3.1 3.5 3.4 8.3 3.4 10.6.8 1 1.4 2.5 1.1 4.4-.4 2.8-1.5 4.4-2.4 5.2-.4 1.2-1.4 3.6-3.2 5.7.1.4.3.9.7 1.1.6.3 1.6.7 2.9 1.2 2.6 1.1 5.9 2.4 8.3 3.8 0 0 .1 0 .1.1 1.6-.7 3-1.2 3.9-1.7 2.5-1.2 2.9-4 2.9-5.5-4.2-4.3-6.3-9.9-6.9-12-1.3-1.2-3.6-3.9-4.3-9.4-.5-3.5.8-6 2.1-7.5-.2-3.6 0-13.5 6.1-20.4 4-4.4 9.6-6.7 16.7-6.7s12.8 2.2 16.7 6.7c6.1 6.8 6.2 16.7 6.1 20.3 1.4 1.5 2.8 4 2.2 7.6-.7 5.4-3.1 8.2-4.4 9.3-.7 2.1-2.7 7.6-6.9 11.9 0 1.4.5 4.3 2.9 5.5.9.4 2.2 1 3.9 1.7l.1-.1c2.4-1.3 5.6-2.7 8.3-3.8 1.2-.5 2.3-1 2.9-1.2.4-.2.6-.7.7-1.2-1.8-2.1-2.8-4.5-3.2-5.7-.9-.8-2-2.5-2.4-5.3-.3-1.9.3-3.4 1.1-4.4 0-2.3.3-7.1 3.4-10.6 2.2-2.5 5.4-3.8 9.3-3.8 3.9 0 7.1 1.3 9.3 3.8 3.1 3.5 3.4 8.3 3.4 10.6.7 1 1.3 2.5 1 4.4-.4 2.7-1.5 4.3-2.3 5.2-.4 1.2-1.4 3.6-3.2 5.7.1.4.3.9.7 1.1.6.3 1.7.7 2.9 1.2 5.7 2.3 9.9 4.2 11.4 6.2 1.4 3.4 1.4 7.6 1.4 8.1z",
    style: {
      fill: '#036'
    }
  }));
};

var SvgRole = function SvgRole(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6n,
    name: "role"
  }, props));
};

var SvgIcon$6o = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 9.5v-.1l-2.2-4.2H15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H9.9c-.2-.7-.7-1.2-1.4-1.4V.5C8.5.2 8.3 0 8 0s-.5.2-.5.5v2.3c-.7.2-1.2.7-1.4 1.4H1c-.3 0-.5.2-.5.5s.2.5.5.5h1.2L.1 9.4v.1H0v.5c-.1 1.7 1.3 3.2 3 3.2 1.7-.1 3.1-1.5 3-3.2v-.6L3.8 5.2h2.3c.2.8.7 1.3 1.4 1.5V15h-4c-.3 0-.5.2-.5.5s.2.5.5.5h9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-4V6.7c.7-.2 1.2-.7 1.4-1.5h2.2L10 9.4v.6c-.1 1.7 1.3 3.2 3 3.2 1.7-.1 3-1.5 2.9-3.2v-.5h.1zM3 12.2c-1 0-1.8-.8-2-1.7h4c-.2 1-1 1.7-2 1.7zm1.9-2.7H1.1L3 5.8l1.9 3.7zM8 5.8c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm5 0l1.9 3.7h-3.8L13 5.8zm0 6.4c-1 0-1.8-.8-1.9-1.7H15c-.2 1-1 1.7-2 1.7z"
  }));
};

var SvgScales = function SvgScales(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6o,
    name: "scales"
  }, props));
};

var SvgIcon$6p = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14.8 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4.1 3h2.7v12H5.3v1h4v-1H7.8V3h3.7l-3.2 8.1s1 2.4 3.3 2.4 3.3-2.4 3.3-2.4L11.5 3h1.3V2h-5V0h-1v2h-5v1M3 3l-3 8.1s.8 2.4 3.1 2.4S6.4 11 6.4 11L3 3m2.5 7.8H1l2.1-6 2.4 6zm3.6.2l2.4-5.9 2.4 5.9H9.1z"
  }));
};

var SvgScales$1 = function SvgScales(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6p,
    name: "scales"
  }, props));
};

var SvgIcon$6q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M16 9.5v-.1l-2.2-4.2H15c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H9.9c-.2-.7-.7-1.2-1.4-1.4V.5C8.5.2 8.3 0 8 0s-.5.2-.5.5v2.3c-.7.2-1.2.7-1.4 1.4H1c-.3 0-.5.2-.5.5s.2.5.5.5h1.2L.1 9.4v.1H0v.5c-.1 1.7 1.3 3.2 3 3.2 1.7-.1 3.1-1.5 3-3.2v-.6L3.8 5.2h2.3c.2.8.7 1.3 1.4 1.5V15h-4c-.3 0-.5.2-.5.5s.2.5.5.5h9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-4V6.7c.7-.2 1.2-.7 1.4-1.5h2.2L10 9.4v.6c-.1 1.7 1.3 3.2 3 3.2 1.7-.1 3-1.5 2.9-3.2v-.5h.1zM3 12.2c-1 0-1.8-.8-2-1.7h4c-.2 1-1 1.7-2 1.7zm1.9-2.7H1.1L3 5.8l1.9 3.7zM8 5.8c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm5 0l1.9 3.7h-3.8L13 5.8zm0 6.4c-1 0-1.8-.8-1.9-1.7H15c-.2 1-1 1.7-2 1.7z"
  }));
};

var SvgScalesNext = function SvgScalesNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6q,
    name: "scales-next"
  }, props));
};

var SvgIcon$6r = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 11"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 11h5V0H0v11zm3.4-1.1H1.6c-.1 0-.1-.1-.1-.2s.1-.1.1-.1h1.8c.1 0 .1.1.1.2 0 0 0 .1-.1.1m0-1.2H1.6c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.8c.1 0 .1.1.1.1.1 0 0 .1-.1.1M2 6.8c0-.3.2-.6.5-.6.3.1.5.4.5.7 0 .3-.2.5-.5.5S2 7.1 2 6.8M4 2H1V1h3v1zm4.8 3.2V4c-.3 0-2.5-.4-3 1.2 0-.3 0-2.4 3.1-2.2V1.8l1.4 1.7-1.5 1.7zm-1.6-.1v1.2c.3 0 2.6.4 3.1-1.2 0 .3 0 2.4-3.1 2.2v1.2L5.8 6.8l1.4-1.7zM11 11h5V0h-5v11zm3.4-1.1h-1.8c-.1 0-.1-.1-.1-.2s.1-.1.1-.1h1.8c.1 0 .1.1.1.2 0 0 0 .1-.1.1m0-1.2h-1.8c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.8c.1 0 .1.1.1.1.1 0 0 .1-.1.1M13 6.8c0-.3.3-.5.6-.5s.5.3.5.6-.2.5-.5.5c-.4 0-.6-.3-.6-.6M15 2h-3V1h3v1z"
  }));
};

var SvgServers = function SvgServers(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6r,
    name: "servers"
  }, props));
};

var SvgIcon$6s = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 16h16l-.1-16H0v16zm15-1H1V1h14v14zM2 4h1V3h1v1h1v1H4v8H3V5H2V4zm4.5 4h1v5h1V8h1V7h-1V3h-1v4h-1v1zM11 6h1v7h1V6h1V5h-1V3h-1v2h-1v1z"
  }));
};

var SvgSettings = function SvgSettings(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6s,
    name: "settings"
  }, props));
};

var SvgIcon$6t = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.3 8c-.1-.2-.4-.2-.6 0-.2.2-.2.5 0 .7l1.8 1.8c.2.2.4.3.7.3h.1c.3 0 .5-.2.7-.4l3.5-5.6c.1-.2.1-.5-.1-.7-.4-.2-.7-.1-.8.1L7.1 9.7 5.3 8zm9.8-6.6L8.1 0h-.2l-7 1.5c-.2 0-.4.3-.4.5 0 .9.4 6 1.1 7.5.7 1.2 1.5 2.3 2.5 3.3C5.2 14 6.4 15 7.7 15.9c.2.1.4.1.6 0 1.3-.9 2.5-1.9 3.6-3.1 1-1 1.8-2.1 2.5-3.4.8-1.5 1.1-6.7 1.1-7.6 0-.2-.2-.4-.4-.4zM13.5 9c-.6 1.1-1.4 2.2-2.3 3.1-1 1-2 1.9-3.2 2.7-1.1-.8-2.2-1.7-3.2-2.8-.9-.9-1.7-2-2.3-3.1-.5-.9-.9-4.7-1-6.5L8 1l6.5 1.3c-.1 1.9-.5 5.7-1 6.7z"
  }));
};

var SvgShield = function SvgShield(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6t,
    name: "shield"
  }, props));
};

var SvgIcon$6u = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 15"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7 0L0 1v5c0 3 2 7 7 9 5-2 7-6 7-9V1L7 0zm6 6c-.1 3.5-2.4 6-6 8-3.4-1.7-5.7-4.1-6-8V1.7L7 1l6 .7V6zm-6.9 4.4L12 4.5l-.7-.7L6.1 9 3.2 6.1l-.7.7 3.6 3.6z"
  }));
};

var SvgShieldCheckmark = function SvgShieldCheckmark(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6u,
    name: "shield-checkmark"
  }, props));
};

var SvgIcon$6v = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 15"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7 0L0 1v5c0 3 2 7 7 9 5-2 7-6 7-9V1L7 0zm6 6c-.1 3.5-2.4 6-6 8-3.4-1.7-5.7-4.1-6-8V1.7L7 1l6 .7V6zM7.8 8.9c0-.2-.1-.4-.2-.6-.2-.2-.5-.3-.7-.4-.3-.1-.6-.3-.9-.4-.2-.1-.4-.3-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.8 0-.5.2-.9.5-1.3.4-.3.8-.5 1.3-.6v-1h.7v1c.5.2.9.4 1.3.8.3.4.4.9.4 1.4H7.8c0-.3-.1-.6-.2-.8-.2-.2-.4-.3-.6-.2-.2-.1-.5 0-.6.2-.2.1-.2.3-.2.6 0 .2.1.4.2.6.2.2.5.3.7.4.3.1.6.2.9.4.2.1.4.3.6.4.2.1.3.3.4.5.1.2.1.5.1.7 0 .5-.2.9-.5 1.3-.4.3-.8.5-1.3.6v.9h-.7v-.9c-.5 0-1.1-.3-1.4-.7-.4-.4-.5-1-.5-1.5H6c0 .3.1.6.3.8.2.2.5.3.7.3.2 0 .5-.1.6-.2.1-.1.2-.3.2-.5z"
  }));
};

var SvgShieldDollar = function SvgShieldDollar(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6v,
    name: "shield-dollar"
  }, props));
};

var SvgIcon$6w = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 15"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7 0L0 1v5c0 3 2 7 7 9 5-2 7-6 7-9V1L7 0zm6 6c-.1 3.5-2.4 6-6 8-3.4-1.7-5.7-4.1-6-8V1.7L7 1l6 .7V6zm-1-3.5V6c0 3.1-1.8 5.4-5 6.9V2l5 .5z"
  }));
};

var SvgShield$1 = function SvgShield(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6w,
    name: "shield"
  }, props));
};

var SvgIcon$6x = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.3 8c-.1-.2-.4-.2-.6 0-.2.2-.2.5 0 .7l1.8 1.8c.2.2.4.3.7.3h.1c.3 0 .5-.2.7-.4l3.5-5.6c.1-.2.1-.5-.1-.7-.4-.2-.7-.1-.8.1L7.1 9.7 5.3 8zm9.8-6.6L8.1 0h-.2l-7 1.5c-.2 0-.4.3-.4.5 0 .9.4 6 1.1 7.5.7 1.2 1.5 2.3 2.5 3.3C5.2 14 6.4 15 7.7 15.9c.2.1.4.1.6 0 1.3-.9 2.5-1.9 3.6-3.1 1-1 1.8-2.1 2.5-3.4.8-1.5 1.1-6.7 1.1-7.6 0-.2-.2-.4-.4-.4zM13.5 9c-.6 1.1-1.4 2.2-2.3 3.1-1 1-2 1.9-3.2 2.7-1.1-.8-2.2-1.7-3.2-2.8-.9-.9-1.7-2-2.3-3.1-.5-.9-.9-4.7-1-6.5L8 1l6.5 1.3c-.1 1.9-.5 5.7-1 6.7z"
  }));
};

var SvgShieldNext = function SvgShieldNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6x,
    name: "shield-next"
  }, props));
};

var SvgIcon$6y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    d: "M24.017-.017H-.017v16.034h24.034V-.017zm-.034.034v15.966H.017V.017h23.966z",
    fill: "#CCC"
  }), React.createElement("path", {
    fill: "#DF0000",
    d: "M0 0h24v8H0z"
  }), React.createElement("path", {
    d: "M5.535 1.34c-1.108.255-1.931 1.075-2.164 2.19-.317 1.517.67 3 2.19 3.317a2.868 2.868 0 0 1-3.554-1.964 2.865 2.865 0 0 1 1.969-3.539 2.738 2.738 0 0 1 1.56-.003zm-.122 3.243l.168.502h.53l-.426.315.163.504-.431-.307-.43.31.16-.505-.428-.311.53-.005.164-.503zM7.36 4.57l.168.502.53.001-.426.315.163.504-.43-.308-.43.31.16-.504-.428-.312.53-.004.163-.504zm.581-1.721l.168.502.53.001-.426.315.163.504-.43-.308-.43.31.16-.504-.428-.312.529-.005.164-.503zm-3.114 0l.168.5.53.001-.426.315.163.504-.43-.308-.43.311.16-.505-.428-.312.53-.004.163-.503zM6.4 1.706l.167.502.53.001-.426.315.163.504-.43-.308-.43.31.16-.504-.428-.312.53-.005.164-.503z",
    fill: "#FFF"
  })));
};

var SvgSingapore = function SvgSingapore(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6y,
    name: "singapore"
  }, props));
};

var SvgIcon$6z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.9 15.7C3.5 15.7 0 12.2 0 7.9S3.5 0 7.9 0s7.9 3.5 7.9 7.9c-.1 4.3-3.6 7.8-7.9 7.8zM7.9 1C4.1 1 1 4.1 1 7.9s3.1 6.9 6.9 6.9 6.9-3.1 6.9-6.9C14.7 4.1 11.7 1 7.9 1zM2.7 13.7L2 13 13 2l.7.7-11 11z"
  }));
};

var SvgSlashCircle = function SvgSlashCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6z,
    name: "slash-circle"
  }, props));
};

var SvgIcon$6A = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.1 10c-.1-.3-.3-.4-.6-.4l-1.9.5-1.5-.9 1.9-.5V7.3l-1.9-.5 1.5-.9 1.9.5h.1c.2 0 .4-.2.5-.4.1-.3-.1-.5-.4-.6l-.9-.2.9-.5c.3-.2.4-.5.2-.7-.1-.2-.4-.3-.7-.2l-.9.5.2-.9c.1-.3-.1-.5-.4-.6-.3-.1-.5.1-.6.4L12 5l-1.5.9.5-1.8-1.1-.7-1.4 1.3V3l1.4-1.4c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-.7.6v-1C8.5.2 8.3 0 8 0s-.5.2-.5.5v1L6.8.9c-.2-.2-.5-.2-.7 0-.1.2-.2.5 0 .7L7.5 3v1.7L6.1 3.4l-1.2.7.5 1.8-1.5-.8-.5-1.9c-.1-.3-.4-.4-.6-.4-.3.1-.5.4-.4.7l.2.9-.8-.6c-.3-.1-.6 0-.7.2-.2.2-.1.5.1.7l.9.5-.8.2c-.3.1-.4.4-.4.6.1.3.3.4.5.4h.1l1.9-.5 1.5.9-1.8.5v1.4l1.8.5-1.5.9-1.9-.5c-.2-.1-.5.1-.6.4-.1.3.1.5.4.6l.9.2-.9.5c-.3.2-.4.5-.2.7.1.2.3.2.4.2.1 0 .2 0 .2-.1l.9-.5-.2.9c-.1.3.1.5.4.6h.1c.2 0 .4-.1.5-.4l.5-1.7 1.5-.9-.5 1.9 1.2.7 1.4-1.4V13l-1.3 1.4c-.2.2-.2.5 0 .7s.5.2.7 0l.7-.6v1c-.1.2.1.5.4.5.3 0 .5-.2.5-.5v-1l.6.6c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.5 13v-1.7l1.4 1.4 1.2-.7-.5-1.9 1.5.9.5 1.9c.1.2.3.4.5.4h.1c.3-.1.4-.3.4-.6l-.2-.9.9.5c.1 0 .2.1.2.1.2 0 .3-.1.4-.2.1-.2.1-.5-.2-.7l-.9-.5.9-.2c.3-.3.4-.5.4-.8zM9.2 8.7l.7 2.5L8 9.4l-1.8 1.8.7-2.5L4.3 8l2.5-.7-.6-2.5L8 6.7l1.9-1.8-.7 2.4 2.5.7-2.5.7z"
  }));
};

var SvgSnowflake = function SvgSnowflake(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6A,
    name: "snowflake"
  }, props));
};

var SvgIcon$6B = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13.8 15"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M1.3 5.9C.6 5.7 0 5 0 4.3c0-1 .7-1.8 1.7-1.8.9 0 1.7.7 1.7 1.7.4 1 1.5 1.6 2.5 1.3.7-.2.7-.9.7-1.3-.2-.9-1.2-1-1.4-2.2C5 1.2 5.4.3 6.3.1c.2-.1.4-.1.6-.1.9-.1 1.6.6 1.7 1.4 0 .2 0 .4-.1.6-.1 1.2-1.1 1.3-1.3 2.2 0 .4.1 1.1.7 1.3 1 .3 2.2-.2 2.5-1.3 0-.9.7-1.7 1.7-1.7.9.1 1.7.9 1.7 1.8 0 .8-.5 1.5-1.2 1.7-.5 0-3.4-.9-3.4 1.4S12 8.8 12.5 9c.7.2 1.2.9 1.2 1.7 0 .9-.7 1.7-1.7 1.8-.9 0-1.7-.7-1.7-1.7 0-.8-1-1.2-2-1.2-.9 0-1.3.4-1.2 1.3s1.1 1.1 1.2 2.2c.2.8-.2 1.7-1 1.9h-.5c-1.2 0-1.8-.7-1.6-1.9.2-1.1 1.2-1.3 1.4-2.2 0-.5 0-1.1-.7-1.3-1-.4-2.2.2-2.5 1.2 0 .9-.7 1.7-1.7 1.7-1-.1-1.7-.8-1.7-1.8C0 9.9.6 9.2 1.3 9c.4-.1 3.2.9 3.2-1.5S1.7 6.1 1.3 5.9zm4.4 1.6c-.1.6.4 1.2 1.1 1.3h.1c.7 0 1.3-.6 1.2-1.3 0-.7-.6-1.2-1.3-1.2-.6 0-1.1.5-1.1 1.2z"
  }));
};

var SvgSnowflake$1 = function SvgSnowflake(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6B,
    name: "snowflake"
  }, props));
};

var SvgIcon$6C = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.1 10c-.1-.3-.3-.4-.6-.4l-1.9.5-1.5-.9 1.9-.5V7.3l-1.9-.5 1.5-.9 1.9.5h.1c.2 0 .4-.2.5-.4.1-.3-.1-.5-.4-.6l-.9-.2.9-.5c.3-.2.4-.5.2-.7-.1-.2-.4-.3-.7-.2l-.9.5.2-.9c.1-.3-.1-.5-.4-.6-.3-.1-.5.1-.6.4L12 5l-1.5.9.5-1.8-1.1-.7-1.4 1.3V3l1.4-1.4c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-.7.6v-1C8.5.2 8.3 0 8 0s-.5.2-.5.5v1L6.8.9c-.2-.2-.5-.2-.7 0-.1.2-.2.5 0 .7L7.5 3v1.7L6.1 3.4l-1.2.7.5 1.8-1.5-.8-.5-1.9c-.1-.3-.4-.4-.6-.4-.3.1-.5.4-.4.7l.2.9-.8-.6c-.3-.1-.6 0-.7.2-.2.2-.1.5.1.7l.9.5-.8.2c-.3.1-.4.4-.4.6.1.3.3.4.5.4h.1l1.9-.5 1.5.9-1.8.5v1.4l1.8.5-1.5.9-1.9-.5c-.2-.1-.5.1-.6.4-.1.3.1.5.4.6l.9.2-.9.5c-.3.2-.4.5-.2.7.1.2.3.2.4.2.1 0 .2 0 .2-.1l.9-.5-.2.9c-.1.3.1.5.4.6h.1c.2 0 .4-.1.5-.4l.5-1.7 1.5-.9-.5 1.9 1.2.7 1.4-1.4V13l-1.3 1.4c-.2.2-.2.5 0 .7s.5.2.7 0l.7-.6v1c-.1.2.1.5.4.5.3 0 .5-.2.5-.5v-1l.6.6c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.5 13v-1.7l1.4 1.4 1.2-.7-.5-1.9 1.5.9.5 1.9c.1.2.3.4.5.4h.1c.3-.1.4-.3.4-.6l-.2-.9.9.5c.1 0 .2.1.2.1.2 0 .3-.1.4-.2.1-.2.1-.5-.2-.7l-.9-.5.9-.2c.3-.3.4-.5.4-.8zM9.2 8.7l.7 2.5L8 9.4l-1.8 1.8.7-2.5L4.3 8l2.5-.7-.6-2.5L8 6.7l1.9-1.8-.7 2.4 2.5.7-2.5.7z"
  }));
};

var SvgSnowflakeNext = function SvgSnowflakeNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6C,
    name: "snowflake-next"
  }, props));
};

var SvgIcon$6D = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "a",
    d: "M0 0h24v16H0z"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#a"
  })), React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#b)"
  }, React.createElement("path", {
    fill: "#000",
    d: "M-.004 12.745v-9.48l7.057 4.737-7.057 4.744z"
  }), React.createElement("path", {
    fill: "#00C",
    d: "M4.811 16.004l7.923-5.332h11.261v5.332z"
  }), React.createElement("path", {
    d: "M4.302.003h19.693v5.333H12.733S4.407-.05 4.302.003z",
    fill: "red"
  }), React.createElement("path", {
    fill: "#FC0",
    d: "M-.004 2.003v1.26l7.057 4.739-7.057 4.743v1.26l8.888-6.003z"
  }), React.createElement("path", {
    fill: "#093",
    d: "M-.004 2.003v-2H2.96l9.416 6.37h11.618v3.259H12.377l-9.416 6.37H-.004v-1.997l8.888-6.003z"
  }), React.createElement("path", {
    d: "M2.96.003h1.85l7.924 5.333h11.26v1.038H12.378L2.961.003zm0 16.001h1.85l7.924-5.332h11.26V9.634H12.378l-9.416 6.37z",
    fill: "#FFF"
  }))));
};

var SvgSouthAfrica = function SvgSouthAfrica(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6D,
    name: "south-africa"
  }, props));
};

var SvgIcon$6E = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 0H.5C.2 0 0 .2 0 .5v15c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5V.5c0-.3-.2-.5-.5-.5zM15 15H1V1h14v14z"
  }));
};

var SvgSquare = function SvgSquare(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6E,
    name: "square"
  }, props));
};

var SvgIcon$6F = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 0H.5C.2 0 0 .2 0 .5v15c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5V.5c0-.3-.2-.5-.5-.5zM15 15H1V1h14v14z"
  }));
};

var SvgSquareNext = function SvgSquareNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6F,
    name: "square-next"
  }, props));
};

var SvgIcon$6G = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M.5 15.5h6v-6h-6v6zm1-5h4v4h-4v-4zm8 5h6v-6h-6v6zm1-5h4v4h-4v-4zm-1-10v6h6v-6h-6zm5 5h-4v-4h4v4zm-14 1h6v-6h-6v6zm1-5h4v4h-4v-4z"
  }));
};

var SvgSquaresFour = function SvgSquaresFour(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6G,
    name: "squares-four"
  }, props));
};

var SvgIcon$6H = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7 7H0V0h7v7zm0 2H0v7h7V9zm9 0H9v7h7V9zm0-9H9v7h7V0z"
  }));
};

var SvgSquaresFour$1 = function SvgSquaresFour(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6H,
    name: "squares-four"
  }, props));
};

var SvgIcon$6I = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M.5 15.5h6v-6h-6v6zm1-5h4v4h-4v-4zm8 5h6v-6h-6v6zm1-5h4v4h-4v-4zm-1-10v6h6v-6h-6zm5 5h-4v-4h4v4zm-14 1h6v-6h-6v6zm1-5h4v4h-4v-4z"
  }));
};

var SvgSquaresFourNext = function SvgSquaresFourNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6I,
    name: "squares-four-next"
  }, props));
};

var SvgIcon$6J = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M4 4H0V0h4v4zm0 2H0v4h4V6zm0 6H0v4h4v-4zm6-12H6v4h4V0zm0 6H6v4h4V6zm0 6H6v4h4v-4zm6-12h-4v4h4V0zm0 6h-4v4h4V6zm0 6h-4v4h4v-4z"
  }));
};

var SvgSquaresNine = function SvgSquaresNine(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6J,
    name: "squares-nine"
  }, props));
};

var SvgIcon$6K = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0l8 4-8 4-8-4 8-4zm0 9.5L3.1 7 0 8l8 4 8-4-2.8-1.1L8 9.5zm0 4L3.1 11 0 12l8 4 8-4-2.8-1.1L8 13.5z"
  }));
};

var SvgSquaresStacked = function SvgSquaresStacked(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6K,
    name: "squares-stacked"
  }, props));
};

var SvgIcon$6L = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.5 15.6c-.1 0-.3 0-.4-.1l-3.9-2c-.1-.1-.3-.1-.4 0l-3.9 2c-.3.2-.6.2-.8 0-.2-.2-.3-.5-.3-.8l.8-4.4c0-.1 0-.3-.1-.4l-3.2-3c-.3-.2-.4-.5-.3-.8.1-.3.4-.5.6-.5L5 5c.1 0 .3-.1.3-.2l2-4c.2-.4.6-.5 1-.3.2.1.3.2.4.4l1.9 4c.1 0 .3.1.4.1l4.4.6c.3 0 .5.2.7.5.1.3 0 .6-.2.8L12.6 10c-.1.1-.1.3-.1.4l.8 4.4c.1.3 0 .6-.3.8h-.5zM8 12.4c.2 0 .5 0 .7.1l3.4 1.8-.7-3.8c-.1-.5.1-.9.4-1.3l2.8-2.7-3.8-.5c-.4-.1-.8-.4-1.1-.8L8 1.7 6.3 5.2c-.3.4-.7.7-1.1.8l-3.9.6 2.8 2.7c.3.3.5.8.4 1.3l-.7 3.8 3.5-1.8c.2-.1.5-.2.7-.2zM7.8 1l.5.2-.5-.2z"
  }));
};

var SvgStar = function SvgStar(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6L,
    name: "star"
  }, props));
};

var SvgIcon$6M = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 15.2"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 0l2 5.7 6 .1-4.8 3.6 1.7 5.8L8 11.8l-4.9 3.4 1.7-5.8L0 5.8l6-.1L8 0z"
  }));
};

var SvgStar$1 = function SvgStar(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6M,
    name: "star"
  }, props));
};

var SvgIcon$6N = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12.5 15.6c-.1 0-.3 0-.4-.1l-3.9-2c-.1-.1-.3-.1-.4 0l-3.9 2c-.3.2-.6.2-.8 0-.2-.2-.3-.5-.3-.8l.8-4.4c0-.1 0-.3-.1-.4l-3.2-3c-.3-.2-.4-.5-.3-.8.1-.3.4-.5.6-.5L5 5c.1 0 .3-.1.3-.2l2-4c.2-.4.6-.5 1-.3.2.1.3.2.4.4l1.9 4c.1 0 .3.1.4.1l4.4.6c.3 0 .5.2.7.5.1.3 0 .6-.2.8L12.6 10c-.1.1-.1.3-.1.4l.8 4.4c.1.3 0 .6-.3.8h-.5zM8 12.4c.2 0 .5 0 .7.1l3.4 1.8-.7-3.8c-.1-.5.1-.9.4-1.3l2.8-2.7-3.8-.5c-.4-.1-.8-.4-1.1-.8L8 1.7 6.3 5.2c-.3.4-.7.7-1.1.8l-3.9.6 2.8 2.7c.3.3.5.8.4 1.3l-.7 3.8 3.5-1.8c.2-.1.5-.2.7-.2zM7.8 1l.5.2-.5-.2z"
  }));
};

var SvgStarNext = function SvgStarNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6N,
    name: "star-next"
  }, props));
};

var SvgIcon$6O = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#006AA7",
    d: "M0-.001h24v16H0z"
  }), React.createElement("path", {
    d: "M10.5 0v6.4H24v3.2H10.5V16h-3V9.6H0V6.4h7.5V0h3z",
    fill: "#FECC00"
  })));
};

var SvgSweden = function SvgSweden(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6O,
    name: "sweden"
  }, props));
};

var SvgIcon$6P = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#D52B1E",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    d: "M13.5 3l-.001 3.5h3.5v3l-3.5-.001v3.5H10.5V9.5H7v-3h3.5V3h3z",
    fill: "#FFF"
  })));
};

var SvgSwitzerland = function SvgSwitzerland(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6P,
    name: "switzerland"
  }, props));
};

var SvgIcon$6Q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 1.5v13h16v-13H0zm4.5 12H1v-3h3.5v3zm0-4H1v-3h3.5v3zm0-4H1v-3h3.5v3zm10.5 8H5.5v-3H15v3zm0-4H5.5v-3H15v3zm0-4H5.5v-3H15v3z"
  }));
};

var SvgTable = function SvgTable(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6Q,
    name: "table"
  }, props));
};

var SvgIcon$6R = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 0v16h16V0H0zm11.5 4.4v1.5H8.3V4.4h3.2zM4 15v-1.4h3.8V15H4zm3.8-6.9v1.5H4V8.1h3.8zM4 7.8V6.3h3.8v1.5H4zm3.8 2.1v1.5H4V9.9h3.8zm0 1.9v1.5H4.1v-1.5h3.7zm.5 3.2v-1.4h3.2V15H8.3zm0-1.7v-1.5h3.2v1.5H8.3zm0-1.8V9.9h3.2v1.5l-3.2.1zm0-1.9V8.1h3.2v1.5H8.3zm0-1.8V6.3h3.2v1.5H8.3zm-.5-3.4v1.5H4V4.4h3.8zm-4.2 0v1.5H1V4.4h2.6zm0 1.9v1.5H1V6.3h2.6zm0 1.8v1.5H1V8.1h2.6zm0 1.8v1.5H1V9.9h2.6zm0 1.9v1.5H1v-1.5h2.6zm0 1.8V15H1v-1.4h2.6zM12 15v-1.4h3V15h-3zm0-1.7v-1.5h3v1.5h-3zm0-1.8V9.9h3v1.5l-3 .1zm0-1.9V8.1h3v1.5h-3zm0-1.8V6.3h3v1.5h-3zm0-1.9V4.4h3v1.5h-3z"
  }));
};

var SvgTable$1 = function SvgTable(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6R,
    name: "table"
  }, props));
};

var SvgIcon$6S = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 1.5v13h16v-13H0zm4.5 12H1v-3h3.5v3zm0-4H1v-3h3.5v3zm0-4H1v-3h3.5v3zm10.5 8H5.5v-3H15v3zm0-4H5.5v-3H15v3zm0-4H5.5v-3H15v3z"
  }));
};

var SvgTableNext = function SvgTableNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6S,
    name: "table-next"
  }, props));
};

var SvgIcon$6T = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 0v16h16V0H0zm11 4.4v1.5H7.5V4.4H11zM7.5 15v-1.4H11V15H7.5zm0-1.7v-1.4H11v1.4H7.5zm0-1.8V9.9H11v1.5l-3.5.1zm0-1.9V8.2H11v1.4H7.5zm0-1.8V6.3H11v1.5H7.5zM7 4.4v1.5H3.7V4.4H7zm0 1.9v1.5H3.7V6.3H7zm0 1.8v1.5H3.7V8.1H7zm0 1.8v1.5H3.7V9.9H7zm0 1.9v1.5H3.7v-1.5H7zm0 1.8V15H3.7v-1.4H7zm4.4 1.4v-1.4H15V15h-3.6zm0-1.7v-1.4H15v1.4h-3.6zm0-1.8V9.9H15v1.5l-3.6.1zm0-1.9V8.2H15v1.4h-3.6zm0-1.8V6.3H15v1.5h-3.6zm0-1.9V4.4H15v1.5h-3.6z"
  }));
};

var SvgTablePivot = function SvgTablePivot(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6T,
    name: "table-pivot"
  }, props));
};

var SvgIcon$6U = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.8 6.9c.5.8.8 1.7.8 2.7 0 2.9-2.4 5.2-5.2 5.2-2.9 0-5.2-2.4-5.2-5.2 0-2.9 2.4-5.2 5.2-5.2 1 0 1.9.3 2.7.8l.8-.8c-1-.7-2.2-1.1-3.5-1.1C2.8 3.3 0 6.1 0 9.6S2.8 16 6.3 16s6.3-2.8 6.3-6.3c0-1.3-.4-2.5-1.1-3.5l-.7.7z"
  }), React.createElement("path", {
    d: "M8.1 6.1c-.5-.3-1.1-.4-1.8-.4-2.2 0-3.9 1.8-3.9 3.9 0 2.2 1.8 3.9 3.9 3.9 2.2 0 3.9-1.8 3.9-3.9 0-.6-.2-1.2-.4-1.8l-.8.9c.1.3.2.6.2.9 0 1.6-1.3 2.8-2.8 2.8-1.6 0-2.8-1.3-2.8-2.8 0-1.6 1.3-2.8 2.8-2.8.3 0 .6.1.9.2l.8-.9z"
  }), React.createElement("path", {
    d: "M6.7 8c-.1-.1-.2-.1-.4-.1-.9 0-1.7.8-1.7 1.7 0 .9.8 1.7 1.7 1.7.9 0 1.7-.8 1.7-1.7v-.4h-.1l-.9.9c-.2.2-.4.3-.6.3-.2 0-.5-.1-.6-.3-.3-.3-.3-.9 0-1.3l.9-.8z"
  }), React.createElement("path", {
    d: "M16 2.4c0-.1-.1-.1-.2-.1L14 2 13.7.2c0-.1-.1-.1-.1-.2h-.1c-.1 0-.1 0-.1.1l-2 1.9s-.1.1-.1.2l.2 1.3-4.1 4.1c-.1.2-.2.4-.1.6L6.2 9.3c-.1.1-.1.3 0 .5.1.1.2.1.2.1.1 0 .2 0 .2-.1l1.1-1.1h.2c.2 0 .3-.1.5-.2l4.1-4.1 1.3.2c.1 0 .1 0 .1-.1l1.9-1.9c.2-.1.2-.2.2-.2z"
  }));
};

var SvgTarget = function SvgTarget(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6U,
    name: "target"
  }, props));
};

var SvgIcon$6V = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    fill: "#001B9A",
    d: "M0 5.433h24v5.334H0z"
  }), React.createElement("path", {
    d: "M0 0h24v2.75H0V0zm0 13.333h24V16H0v-2.667z",
    fill: "#E70000"
  })));
};

var SvgThailand = function SvgThailand(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6V,
    name: "thailand"
  }, props));
};

var SvgIcon$6W = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16.1"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.9 2.2c.4 1.5-.6 3.1-2.1 3.4-1.5.4-3.1-.6-3.4-2.1C10 2 11 .4 12.5.1c.4-.1.9-.1 1.3 0l-2 2 .3 1.8 1.8.4 2-2.1zM7.3 8l-2.8 2.8.7.7L8 8.7l2.6 2.6-.7.7.9.9.5-.4 3.6 3.5 1.2-1.2-3.6-3.5.4-.5-.9-.8-.7.7L8.7 8l2.8-2.8-.4-.3-.3-.4L8 7.3 3.6 3 3 1.8 2.1.9.4 0 0 .4l.9 1.7.9.9 1.1.7L7.3 8zm-2.4 3.1C3.8 10 2 10 .9 11.1c-.7.7-1 1.7-.8 2.7l2-2 1.8.4.3 1.8-2.1 2.1c1.5.4 3.1-.6 3.4-2.1.4-1.2.1-2.2-.6-2.9z"
  }));
};

var SvgTools = function SvgTools(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6W,
    name: "tools"
  }, props));
};

var SvgIcon$6X = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.38 4.16c-.894 0-2.019-.12-3.395-.478-3.77-.977-6.214-.03-6.214-.03L.35 3.8V2.745s2.734-1.106 6.885-.03c3.716.963 5.599-.186 5.599-.186l.514-.303v1.16s-1.148.774-2.97.774zm2.97 1.381V4.393l-.515.29s-1.883.91-5.599-.053C3.085 3.554.35 4.66.35 4.66v1.095l.42-.187s2.444-.946 6.215.03c1.376.357 2.501.478 3.395.478 1.821 0 2.97-.535 2.97-.535zm-1 4.147V7.763c-.906.25-2.644.466-5.365-.24-2.975-.77-4.931-.348-5.635-.132v5.182a12.962 12.962 0 012.915-.346c1.002 0 2.108.133 3.17.532a7.21 7.21 0 001.537.389l.06 1.019a8.298 8.298 0 01-1.948-.473c-2.774-1.039-6.046-.002-6.08.008a.5.5 0 01-.654-.476V7.04a.5.5 0 01.289-.453c.098-.045 2.446-1.106 6.597-.03 3.72.963 5.342.062 5.359.053.156-.09.35-.09.502-.002a.5.5 0 01.253.432v2.67l-1-.022zm-.35.462a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm.01 1.094c-.086 0-.262.07-.262.156v1.094h-1.094c-.086 0-.156.164-.156.25 0 .087.07.247.156.247h1.094v1.098c0 .086.176.156.262.156.086 0 .238-.07.238-.156V12.99h1.099c.086 0 .156-.16.156-.247s-.07-.25-.156-.25h-1.099V11.4c0-.086-.152-.156-.238-.156z"
  }));
};

var SvgTransactionAdd = function SvgTransactionAdd(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6X,
    name: "transaction-add"
  }, props));
};

var SvgIcon$6Y = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.38 3.16c-.894 0-2.019-.12-3.395-.478-3.77-.977-6.214-.03-6.214-.03L.35 2.8V1.745S3.084.64 7.235 1.715c3.716.963 5.599-.186 5.599-.186l.514-.303v1.16s-1.148.774-2.97.774zm2.97 1.381V3.393l-.515.29s-1.883.91-5.599-.053C3.085 2.554.35 3.66.35 3.66v1.095l.42-.187s2.444-.946 6.215.03c1.376.357 2.501.478 3.395.478 1.821 0 2.97-.535 2.97-.535zm-1 4.147V6.763c-.906.25-2.644.466-5.365-.24-2.975-.77-4.931-.348-5.635-.132v5.182a12.962 12.962 0 012.915-.346c1.002 0 2.108.133 3.17.532a7.21 7.21 0 001.537.389l.06 1.019a8.298 8.298 0 01-1.948-.473c-2.774-1.039-6.046-.002-6.08.008a.5.5 0 01-.654-.476V6.04a.5.5 0 01.289-.453c.098-.045 2.446-1.106 6.597-.03 3.72.963 5.342.062 5.359.053.156-.09.35-.09.502-.002a.5.5 0 01.253.432v2.67l-1-.022zM12 9.15a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm.331 1.236c-.06.06-.122.22-.06.281l.755.766h-2.432c-.087 0-.156.131-.156.218 0 .086.07.208.156.208h2.432l-.756.775a.156.156 0 00-.046.11c0 .04.077.141.107.172.061.06.188.089.249.028l1.07-1.085c.119-.118.096-.309-.022-.426l-1.05-1.073c-.061-.061-.186-.035-.247.026z"
  }));
};

var SvgTransactionNext = function SvgTransactionNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6Y,
    name: "transaction-next"
  }, props));
};

var SvgIcon$6Z = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.38 3.16c-.894 0-2.019-.12-3.395-.478-3.77-.977-6.214-.03-6.214-.03L.35 2.8V1.745S3.084.64 7.235 1.715c3.716.963 5.599-.186 5.599-.186l.514-.303v1.16s-1.148.774-2.97.774zm2.97 1.381V3.393l-.515.29s-1.883.91-5.599-.053C3.085 2.554.35 3.66.35 3.66v1.095l.42-.187s2.444-.946 6.215.03c1.376.357 2.501.478 3.395.478 1.821 0 2.97-.535 2.97-.535zm-1 4.147V6.763c-.906.25-2.644.466-5.365-.24-2.975-.77-4.931-.348-5.635-.132v5.182a12.962 12.962 0 012.915-.346c1.002 0 2.108.133 3.17.532a7.21 7.21 0 001.537.389l.06 1.019a8.298 8.298 0 01-1.948-.473c-2.774-1.039-6.046-.002-6.08.008a.5.5 0 01-.654-.476V6.04a.5.5 0 01.289-.453c.098-.045 2.446-1.106 6.597-.03 3.72.963 5.342.062 5.359.053.156-.09.35-.09.502-.002a.5.5 0 01.253.432v2.67l-1-.022zm1.418 1.195a2.5 2.5 0 11-3.536 3.535 2.5 2.5 0 013.536-3.535zm-.767.78c-.06-.061-.234-.136-.295-.075l-.774.773-.773-.773c-.061-.061-.227.006-.288.067-.06.06-.125.224-.064.285l.773.773-.775.776c-.061.06.014.235.075.296.06.06.218.119.278.058l.776-.776.777.777c.06.06.224-.004.285-.065.061-.06.128-.226.067-.287l-.777-.777.773-.773c.061-.061.003-.218-.058-.28z"
  }));
};

var SvgTransactionRemove = function SvgTransactionRemove(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6Z,
    name: "transaction-remove"
  }, props));
};

var SvgIcon$6_ = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M10.38 4.16c-.894 0-2.019-.12-3.395-.478-3.77-.977-6.214-.03-6.214-.03L.35 3.8V2.745s2.734-1.106 6.885-.03c3.716.963 5.599-.186 5.599-.186l.514-.303v1.16s-1.148.774-2.97.774zm2.97 1.381V4.393l-.515.29s-1.883.91-5.599-.053C3.085 3.554.35 4.66.35 4.66v1.095l.42-.187s2.444-.946 6.215.03c1.376.357 2.501.478 3.395.478 1.821 0 2.97-.535 2.97-.535zm-1 4.147V7.763c-.906.25-2.644.466-5.365-.24-2.975-.77-4.931-.348-5.635-.132v5.182a12.962 12.962 0 012.915-.346c1.002 0 2.108.133 3.17.532a7.21 7.21 0 001.537.389l.06 1.019a8.298 8.298 0 01-1.948-.473c-2.774-1.039-6.046-.002-6.08.008a.5.5 0 01-.654-.476V7.04a.5.5 0 01.289-.453c.098-.045 2.446-1.106 6.597-.03 3.72.963 5.342.062 5.359.053.156-.09.35-.09.502-.002a.5.5 0 01.253.432v2.67l-1-.022zm1.72 2.962c0-.195.118-.37.3-.442l.13-.052-.035-.135a2.533 2.533 0 00-.276-.669l-.072-.12-.127.055a.478.478 0 01-.626-.626l.055-.127-.12-.072a2.533 2.533 0 00-.668-.276l-.136-.035-.052.13a.477.477 0 01-.886 0l-.051-.13-.136.034c-.234.06-.46.153-.668.277l-.12.072.055.127a.477.477 0 01-.626.627l-.127-.055-.071.12a2.533 2.533 0 00-.277.668l-.035.135.13.052a.474.474 0 010 .885l-.13.052.034.135c.06.235.153.46.277.669l.071.12.127-.055a.476.476 0 01.626.626l-.055.127.12.071c.209.124.434.217.669.277l.135.035.051-.13a.477.477 0 01.886 0l.052.13.135-.035c.235-.06.46-.153.668-.277l.12-.071-.055-.127a.476.476 0 01.626-.626l.128.055.07-.12c.125-.209.218-.434.277-.669l.035-.135-.13-.052a.476.476 0 01-.299-.443zm-.324.906a.701.701 0 00-.84.84c-.1.052-.204.095-.312.13a.701.701 0 00-1.188 0 1.943 1.943 0 01-.312-.13.701.701 0 00-.84-.84 1.987 1.987 0 01-.129-.312.698.698 0 00.328-.594.699.699 0 00-.328-.594c.034-.107.077-.211.13-.311a.703.703 0 00.84-.84c.1-.052.204-.095.311-.13a.702.702 0 001.188 0c.107.035.212.078.312.13a.703.703 0 00.84.84c.052.1.095.204.13.311a.702.702 0 000 1.188 1.986 1.986 0 01-.13.312zM12 11.696a.955.955 0 100 1.91.955.955 0 000-1.91zm0 1.454a.5.5 0 110-1 .5.5 0 010 1z"
  }));
};

var SvgTransactionUpdate = function SvgTransactionUpdate(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$6_,
    name: "transaction-update"
  }, props));
};

var SvgIcon$70 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.79 3.38h-4.9a.4.4 0 00-.4.4.39.39 0 00.4.4h4.9a.39.39 0 00.4-.4.39.39 0 00-.4-.4zm3.31-1.59H8.39a.4.4 0 100 .8h1.71a.4.4 0 000-.8z"
  }), React.createElement("path", {
    d: "M10.07 7.38h.5l-.86.87c-.08.07 0 .26.14.42s.35.22.42.14l1.49-1.48.06-.06a.19.19 0 00.06-.07l.12-.08A.16.16 0 0012 7a.14.14 0 000-.13l-.09-.09-.06-.06a.17.17 0 00-.06-.06l-1.5-1.51c-.08-.07-.27 0-.43.15s-.22.34-.14.42l.88.88H.8V1h10.39v4H12V.19H0v7.19z"
  }), React.createElement("path", {
    d: "M10.1 3.38H8.39a.4.4 0 00-.4.4.39.39 0 00.4.4h1.71a.39.39 0 00.4-.4.4.4 0 00-.4-.4zM6.79 5h-4.9a.4.4 0 100 .8h4.9a.4.4 0 100-.8zm4.8 4.53h-10l.87-.86c.07-.08 0-.27-.15-.42S1.94 8 1.86 8.1L.38 9.59l-.07.06-.06.06-.08.09a.14.14 0 000 .13.16.16 0 000 .14l.08.08.06.07.07.06 1.5 1.5c.07.08.26 0 .42-.14s.22-.35.14-.43l-.88-.88h10a.4.4 0 000-.8z"
  }));
};

var SvgTransfer = function SvgTransfer(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$70,
    name: "transfer"
  }, props));
};

var SvgIcon$71 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12 12"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M6.79 3.38h-4.9a.4.4 0 00-.4.4.39.39 0 00.4.4h4.9a.39.39 0 00.4-.4.39.39 0 00-.4-.4zm3.31-1.59H8.39a.4.4 0 100 .8h1.71a.4.4 0 000-.8z"
  }), React.createElement("path", {
    d: "M10.07 7.38h.5l-.86.87c-.08.07 0 .26.14.42s.35.22.42.14l1.49-1.48.06-.06a.19.19 0 00.06-.07l.12-.08A.16.16 0 0012 7a.14.14 0 000-.13l-.09-.09-.06-.06a.17.17 0 00-.06-.06l-1.5-1.51c-.08-.07-.27 0-.43.15s-.22.34-.14.42l.88.88H.8V1h10.39v4H12V.19H0v7.19z"
  }), React.createElement("path", {
    d: "M10.1 3.38H8.39a.4.4 0 00-.4.4.39.39 0 00.4.4h1.71a.39.39 0 00.4-.4.4.4 0 00-.4-.4zM6.79 5h-4.9a.4.4 0 100 .8h4.9a.4.4 0 100-.8zm4.8 4.53h-10l.87-.86c.07-.08 0-.27-.15-.42S1.94 8 1.86 8.1L.38 9.59l-.07.06-.06.06-.08.09a.14.14 0 000 .13.16.16 0 000 .14l.08.08.06.07.07.06 1.5 1.5c.07.08.26 0 .42-.14s.22-.35.14-.43l-.88-.88h10a.4.4 0 000-.8z"
  }));
};

var SvgTransferNext = function SvgTransferNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$71,
    name: "transfer-next"
  }, props));
};

var SvgIcon$72 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5 6.5c-.3 0-.5.2-.5.5v6c0 .3.2.5.5.5s.5-.2.5-.5V7c0-.3-.2-.5-.5-.5zm2.5.5v6c0 .3.2.5.5.5s.5-.2.5-.5V7c0-.3-.2-.5-.5-.5s-.5.2-.5.5zm3.5 6.5c.3 0 .5-.2.5-.5V7c0-.3-.2-.5-.5-.5s-.5.2-.5.5v6c0 .3.2.5.5.5zm3.4-11.1C14 2.1 13.5 2 13 2h-1.5c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2H3c-.5 0-1 .1-1.4.4-.4.3-.6.7-.6 1.1v1c0 .3.2.5.5.5H2v10.5c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V5h.5c.3 0 .5-.2.5-.5v-1c0-.4-.2-.8-.6-1.1zM6.5 1h3c.6 0 1 .4 1 1h-5c0-.6.4-1 1-1zM13 15H3V5h10v10zm1-11H2v-.5c0-.1.1-.2.3-.3.2-.1.4-.2.7-.2h10c.3 0 .5.1.7.2.2.1.3.2.3.3V4z"
  }));
};

var SvgTrashCan = function SvgTrashCan(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$72,
    name: "trash-can"
  }, props));
};

var SvgIcon$73 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 3V0H3v3H0v2h2v11h10V5h2V3h-3zM4 1h6v1H4V1zm.5 12.2c0 .3-.2.5-.5.5s-.5-.2-.5-.5V5.8c0-.3.2-.5.5-.5s.5.2.5.5v7.4zm3 0c0 .3-.2.5-.5.5s-.5-.2-.5-.5V5.8c0-.3.2-.5.5-.5s.5.2.5.5v7.4zm3 0c0 .3-.2.5-.5.5s-.5-.2-.5-.5V5.8c0-.3.2-.5.5-.5s.5.2.5.5v7.4z"
  }));
};

var SvgTrashCan$1 = function SvgTrashCan(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$73,
    name: "trash-can"
  }, props));
};

var SvgIcon$74 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5 6.5c-.3 0-.5.2-.5.5v6c0 .3.2.5.5.5s.5-.2.5-.5V7c0-.3-.2-.5-.5-.5zm2.5.5v6c0 .3.2.5.5.5s.5-.2.5-.5V7c0-.3-.2-.5-.5-.5s-.5.2-.5.5zm3.5 6.5c.3 0 .5-.2.5-.5V7c0-.3-.2-.5-.5-.5s-.5.2-.5.5v6c0 .3.2.5.5.5zm3.4-11.1C14 2.1 13.5 2 13 2h-1.5c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2H3c-.5 0-1 .1-1.4.4-.4.3-.6.7-.6 1.1v1c0 .3.2.5.5.5H2v10.5c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V5h.5c.3 0 .5-.2.5-.5v-1c0-.4-.2-.8-.6-1.1zM6.5 1h3c.6 0 1 .4 1 1h-5c0-.6.4-1 1-1zM13 15H3V5h10v10zm1-11H2v-.5c0-.1.1-.2.3-.3.2-.1.4-.2.7-.2h10c.3 0 .5.1.7.2.2.1.3.2.3.3V4z"
  }));
};

var SvgTrashCanNext = function SvgTrashCanNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$74,
    name: "trash-can-next"
  }, props));
};

var SvgIcon$75 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 2.9l6.3 10.9H1.7L8 2.9m0-1.7c-.1 0-.2.1-.2.2l-7.5 13c-.1.2 0 .4.2.4h15c.3 0 .4-.2.2-.4l-7.5-13c0-.1-.1-.2-.2-.2z"
  }));
};

var SvgTriangle = function SvgTriangle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$75,
    name: "triangle"
  }, props));
};

var SvgIcon$76 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 11 5.5"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.5 5.5L0 0h11L5.5 5.5z"
  }));
};

var SvgTriangleDown = function SvgTriangleDown(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$76,
    name: "triangle-down"
  }, props));
};

var SvgIcon$77 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 5.5 11"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 5.5L5.5 0v11L0 5.5z"
  }));
};

var SvgTriangleLeft = function SvgTriangleLeft(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$77,
    name: "triangle-left"
  }, props));
};

var SvgIcon$78 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M8 2.9l6.3 10.9H1.7L8 2.9m0-1.7c-.1 0-.2.1-.2.2l-7.5 13c-.1.2 0 .4.2.4h15c.3 0 .4-.2.2-.4l-7.5-13c0-.1-.1-.2-.2-.2z"
  }));
};

var SvgTriangleNext = function SvgTriangleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$78,
    name: "triangle-next"
  }, props));
};

var SvgIcon$79 = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 5.5 11"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.5 5.5L0 11V0l5.5 5.5z"
  }));
};

var SvgTriangleRight = function SvgTriangleRight(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$79,
    name: "triangle-right"
  }, props));
};

var SvgIcon$7a = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 11 5.5"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M5.5 0L11 5.5H0L5.5 0z"
  }));
};

var SvgTriangleUp = function SvgTriangleUp(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7a,
    name: "triangle-up"
  }, props));
};

var SvgIcon$7b = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#F31930",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    d: "M10.466 4.267a4.08 4.08 0 0 1 3.439 1.863 3.267 3.267 0 0 0-2.423-1.064c-1.796 0-3.252 1.431-3.252 3.197 0 1.765 1.456 3.197 3.252 3.197a3.27 3.27 0 0 0 2.422-1.063 4.08 4.08 0 0 1-3.438 1.862C8.22 12.26 6.4 10.47 6.4 8.263s1.82-3.996 4.066-3.996zm4.857 2.13l.86 1.231 1.45-.4-.945 1.13.774 1.135-1.338-.465-.886 1.058.032-1.355-1.358-.483 1.378-.375.033-1.477z",
    fill: "#FFF"
  })));
};

var SvgTurkey = function SvgTurkey(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7b,
    name: "turkey"
  }, props));
};

var SvgIcon$7c = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 6.6c-.8-1.8-2.2-3.2-4-3.9l.4-1.2c.1-.3 0-.5-.3-.6-.3-.1-.5 0-.6.3L10 2.3C6 1.1 1.7 3.3.3 7.2c-.1.2 0 .4.1.5.1.1.3.2.5.2.8-.2 1.6-.2 2.4-.1.7.4 1.3 1 1.8 1.6.1.2.3.2.5.2.6-.1 1.3-.2 1.9-.2L6 13.6c-.2.5-.8.8-1.3.6-.3-.1-.5-.3-.6-.5-.1-.2-.1-.5 0-.8.1-.3 0-.5-.3-.6-.3-.1-.5 0-.6.3-.2.5-.2 1 .1 1.5.2.5.6.8 1.1 1 .2.1.5.1.7.1.3 0 .6-.1.8-.2.5-.2.8-.6 1-1.1l1.5-4.2c.5.4 1 .9 1.4 1.4.1.2.3.2.5.2.8-.2 1.6-.2 2.4-.1.7.4 1.3 1 1.8 1.6.1.1.2.2.4.2h.1c.2 0 .3-.1.4-.3.6-2 .5-4.2-.4-6.1zM5.3 8.1c-.5-.5-1-1-1.7-1.3-.7-.2-1.3-.2-2-.1 1.3-2.5 4.1-4 6.9-3.7l-.9.9c-1 1.3-1.8 2.7-2.3 4.2zm4.6 1.7c-.5-.5-1-1-1.6-1.3-.7-.1-1.4-.2-2.1 0 .5-1.5 1.2-2.8 2.2-4 .9-1 1.5-1.3 1.8-1.2s.6.7.6 2.1c-.1 1.5-.3 3-.9 4.4zm4.7 1.7c-.4-.5-1-.9-1.6-1.2-.3-.1-.7-.2-1.1-.1-.3 0-.7 0-1 .1.6-1.5.9-3.1.9-4.7 0-.4 0-.9-.1-1.3 2.4 1.5 3.6 4.4 2.9 7.2z"
  }));
};

var SvgUmbrella = function SvgUmbrella(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7c,
    name: "umbrella"
  }, props));
};

var SvgIcon$7d = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.5 15.9"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.5 8.1c-.8-.2-1.6-.6-2.3-1.1l-2.8 1.6-2-1.4v5.7c0 2.9-4.2 4.7-4.9.2h1c.5 3.1 2.9 1.4 2.8-.4V7.1L5 8.4 2.8 6.9S1.1 8.2 0 8.1c-.3 0 2.7-6.5 7.3-7 0-.4.1-.7 0-1.1h1v1.1c5 .6 7.5 7 7.2 7z"
  }));
};

var SvgUmbrella$1 = function SvgUmbrella(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7d,
    name: "umbrella"
  }, props));
};

var SvgIcon$7e = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 6.6c-.8-1.8-2.2-3.2-4-3.9l.4-1.2c.1-.3 0-.5-.3-.6-.3-.1-.5 0-.6.3L10 2.3C6 1.1 1.7 3.3.3 7.2c-.1.2 0 .4.1.5.1.1.3.2.5.2.8-.2 1.6-.2 2.4-.1.7.4 1.3 1 1.8 1.6.1.2.3.2.5.2.6-.1 1.3-.2 1.9-.2L6 13.6c-.2.5-.8.8-1.3.6-.3-.1-.5-.3-.6-.5-.1-.2-.1-.5 0-.8.1-.3 0-.5-.3-.6-.3-.1-.5 0-.6.3-.2.5-.2 1 .1 1.5.2.5.6.8 1.1 1 .2.1.5.1.7.1.3 0 .6-.1.8-.2.5-.2.8-.6 1-1.1l1.5-4.2c.5.4 1 .9 1.4 1.4.1.2.3.2.5.2.8-.2 1.6-.2 2.4-.1.7.4 1.3 1 1.8 1.6.1.1.2.2.4.2h.1c.2 0 .3-.1.4-.3.6-2 .5-4.2-.4-6.1zM5.3 8.1c-.5-.5-1-1-1.7-1.3-.7-.2-1.3-.2-2-.1 1.3-2.5 4.1-4 6.9-3.7l-.9.9c-1 1.3-1.8 2.7-2.3 4.2zm4.6 1.7c-.5-.5-1-1-1.6-1.3-.7-.1-1.4-.2-2.1 0 .5-1.5 1.2-2.8 2.2-4 .9-1 1.5-1.3 1.8-1.2s.6.7.6 2.1c-.1 1.5-.3 3-.9 4.4zm4.7 1.7c-.4-.5-1-.9-1.6-1.2-.3-.1-.7-.2-1.1-.1-.3 0-.7 0-1 .1.6-1.5.9-3.1.9-4.7 0-.4 0-.9-.1-1.3 2.4 1.5 3.6 4.4 2.9 7.2z"
  }));
};

var SvgUmbrellaNext = function SvgUmbrellaNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7e,
    name: "umbrella-next"
  }, props));
};

var SvgIcon$7f = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#00732F",
    d: "M0 0h24v5.333H0z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M0 5.333h24v5.334H0z"
  }), React.createElement("path", {
    fill: "#000",
    d: "M0 10.667h24V16H0z"
  }), React.createElement("path", {
    fill: "red",
    d: "M0 0h7.333v16H0z"
  })));
};

var SvgUnitedArabEmirates = function SvgUnitedArabEmirates(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7f,
    name: "united-arab-emirates"
  }, props));
};

var SvgIcon$7g = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    fill: "#006",
    d: "M0 0h24v16H0z"
  }), React.createElement("path", {
    d: "M0 0v1.789L21.317 16H24v-1.789L2.683 0H0zm24 0v1.789L2.683 15.999H0v-1.788L21.317 0H24z",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M10 0v16h4V0h-4zM0 5.333v5.334h24V5.333H0z",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M0 6.4v3.2h24V6.4H0zM10.8 0v16h2.4V0h-2.4zM0 16l8-5.333h1.789l-8 5.333H0zM0 0l8 5.333H6.211L0 1.193V0zm14.211 5.333l8-5.333H24l-8 5.333h-1.789zM24 16l-8-5.333h1.789L24 14.807V16z",
    fill: "#C00"
  })));
};

var SvgUnitedKingdom = function SvgUnitedKingdom(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7g,
    name: "united-kingdom"
  }, props));
};

var SvgIcon$7h = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 16"
  }, props), React.createElement("title", null, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h24v16H0z"
  }), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M24 14.933V16H0v-1.067h24zm0-2.1V13.9H0v-1.067h24zm0-2.133v1.067H0V10.7h24zm0-2.167V9.6H0V8.533h24zm0-2.1V7.5H0V6.433h24zM24 4.3v1.067H0V4.3h24zm0-2.167V3.2H0V2.133h24zM24 0v1.067H0V0h24z",
    fill: "#BD3D44"
  }), React.createElement("path", {
    fill: "#192F5D",
    d: "M0 0h10.567v7.467H0z"
  }), React.createElement("path", {
    d: "M9.705 6.32l.097.297h.31l-.251.182.096.296-.252-.183-.251.183.096-.296-.252-.182h.311l.096-.296zm-1.76 0l.096.297h.311l-.252.182.096.296-.251-.183-.252.183.096-.296-.251-.182h.31l.097-.296zm-1.76 0l.095.297h.311l-.251.182.096.296-.252-.183-.251.183.096-.296-.252-.182h.311l.096-.296zm-1.761 0l.096.297h.31l-.25.182.095.296-.251-.183-.252.183.096-.296-.251-.182h.31l.097-.296zm-1.761 0l.096.297h.311l-.251.182.096.296-.252-.183-.252.183.097-.296-.252-.182h.31l.097-.296zm-1.76 0l.096.297h.31l-.251.182.096.296-.252-.183-.251.183.096-.296-.252-.182h.311l.096-.296zm7.922-.748l.096.296h.311l-.251.183.096.296-.252-.183-.252.183.097-.296-.252-.183h.311l.096-.296zm-7.042 0l.096.296h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm1.76 0l.096.296h.311l-.25.182.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm1.761 0l.096.296h.311l-.252.183.097.296-.252-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm1.76 0l.097.296h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.252-.183h.311l.097-.296zm2.641-.75l.097.297h.31l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm-1.76 0l.096.297h.311l-.252.183.096.296-.251-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm-1.76 0l.095.297h.311l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm-1.761 0l.096.297h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm-1.761 0l.096.297h.311l-.251.183.096.296-.252-.183-.252.183.097-.296-.252-.183h.31l.097-.296zm-1.76 0l.096.297h.31l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm7.922-.748l.096.296h.311l-.251.183.096.296-.252-.183-.252.183.097-.296-.252-.183h.311l.096-.296zm-7.042 0l.096.296h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm1.76 0l.096.296h.311l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm1.761 0l.096.296h.311l-.252.183.097.296-.252-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm1.76 0l.097.296h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.252-.183h.311l.097-.296zm2.641-.749l.097.296h.31l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm-1.76 0l.096.296h.311l-.252.183.096.296-.251-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm-1.76 0l.095.296h.311l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm-1.761 0l.096.296h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm-1.761 0l.096.296h.311l-.251.183.096.296-.252-.183-.252.183.097-.296-.252-.183h.31l.097-.296zm-1.76 0l.096.296h.31l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm4.401-.749l.096.296h.311l-.252.183.097.296-.252-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm3.521 0l.096.296h.311l-.251.183.096.296-.252-.183-.252.183.097-.296-.252-.183h.311l.096-.296zm-7.042 0l.096.296h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm1.76 0l.096.296h.311l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm3.522 0l.096.296h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.252-.183h.311l.097-.296zm-4.402-.748l.096.296h.311l-.251.183.096.295-.252-.182-.252.182.097-.295-.252-.183h.31l.097-.296zm1.76 0l.097.296h.31l-.25.183.095.295-.251-.182-.252.182.096-.295-.251-.183h.31l.097-.296zm1.761 0l.096.296h.311l-.251.183.096.295-.252-.182-.251.182.096-.295-.252-.183h.311l.096-.296zm1.76 0l.097.296h.311l-.252.183.096.295-.251-.182-.252.182.096-.295-.251-.183h.31l.097-.296zm1.761 0l.097.296h.31l-.251.183.096.295-.252-.182-.251.182.096-.295-.252-.183h.311l.096-.296zm-8.803 0L1 2.124h.31l-.251.183.096.295-.252-.182-.251.182.096-.295-.252-.183h.311l.096-.296zm7.923-.75l.096.297h.311l-.251.183.096.296-.252-.183-.252.183.097-.296-.252-.183h.311l.096-.296zm-7.042 0l.096.297h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm1.76 0l.096.297h.311l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311l.096-.296zm1.761 0l.096.297h.311l-.252.183.097.296-.252-.183-.252.183.096-.296-.251-.183h.31l.097-.296zm1.76 0l.097.297h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.252-.183h.312l.096-.296zM9.706.33l.097.296h.31l-.251.183.096.296-.252-.183-.251.183.096-.296-.252-.183h.311L9.705.33zm-1.76 0l.096.296h.311L8.1.809l.096.296-.251-.183-.252.183.096-.296-.251-.183h.31L7.946.33zm-1.76 0l.095.296h.311L6.34.809l.096.296-.252-.183-.251.183.096-.296-.252-.183h.311L6.184.33zm-1.761 0l.096.296h.31l-.25.183.095.296-.251-.183-.252.183.096-.296-.251-.183h.31L4.425.33zm-1.761 0l.096.296h.311L2.82.809l.096.296-.252-.183-.252.183.097-.296-.252-.183h.31L2.664.33zm-1.76 0L1 .626h.31l-.251.183.096.296L.902.922l-.251.183.096-.296L.495.626h.311L.902.33z",
    fill: "#FFF"
  }))));
};

var SvgUnitedStates = function SvgUnitedStates(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7h,
    name: "united-states"
  }, props));
};

var SvgIcon$7i = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 6H6V3c0-1.7-1.3-3-3-3S0 1.3 0 3v2.5c0 .3.2.5.5.5s.5-.2.5-.5V3c0-1.1.9-2 2-2s2 .9 2 2v3H4c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zm0 9H4V7h8v8zm-4.5-4.1V13c0 .3.2.5.5.5s.5-.2.5-.5v-2.1c.5-.3.7-.9.4-1.4-.2-.5-.8-.7-1.3-.4s-.7.9-.4 1.4c.1.1.2.3.3.4z"
  }));
};

var SvgUnlock = function SvgUnlock(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7i,
    name: "unlock"
  }, props));
};

var SvgIcon$7j = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.5 14.8"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11 0C8.5 0 6.5 2 6.5 4.5V6H0v8.8h10.8V6H8.5V4.5C8.5 3.1 9.6 2 11 2s2.5 1.1 2.5 2.5V6h2V4.5C15.5 2 13.5 0 11 0z"
  }));
};

var SvgUnlock$1 = function SvgUnlock(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7j,
    name: "unlock"
  }, props));
};

var SvgIcon$7k = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M12 6H6V3c0-1.7-1.3-3-3-3S0 1.3 0 3v2.5c0 .3.2.5.5.5s.5-.2.5-.5V3c0-1.1.9-2 2-2s2 .9 2 2v3H4c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zm0 9H4V7h8v8zm-4.5-4.1V13c0 .3.2.5.5.5s.5-.2.5-.5v-2.1c.5-.3.7-.9.4-1.4-.2-.5-.8-.7-1.3-.4s-.7.9-.4 1.4c.1.1.2.3.3.4z"
  }));
};

var SvgUnlockNext = function SvgUnlockNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7k,
    name: "unlock-next"
  }, props));
};

var SvgIcon$7l = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.6 4.5L11.4.3c-.3-.3-.8-.4-1.2 0-.3.4-.5.8-.5 1.3 0 .2.1.3.1.5L6 5.4c-.9-.5-2.1-.4-2.9.4-.3.3-.3.9 0 1.2l2.3 2-2.1 2.1s-1.2 1.2-2 2.2c-.7.9-.9 1.1-.9 1.1-.3.4-.3.9 0 1.2.2.2.4.3.6.3s.4-.1.5-.1c.1-.1.2-.2 1.1-.9 1-.8 2.2-2 2.2-2l2.1-2.1.1.1c0-.3.1-.6.2-.9l-.4-.4-2.7 2.7S2.9 13.4 2 14.2c-.2.2-.4.3-.5.4.1-.1.2-.3.4-.5.7-.9 1.9-2.1 1.9-2.1l2.8-2.8-2.8-2.8c.5-.5 1.4-.5 1.9 0l.3.2 4.9-4.2-.2-.3c-.1-.1-.1-.2-.1-.4s0-.4.2-.6l4 4c-.3.2-.7.3-1 .1l-.3-.2-2.2 2.6c.3.1.7.2 1 .3l1.5-1.8c.6.2 1.3 0 1.8-.5.1-.2.2-.4.2-.6 0-.1 0-.3-.2-.5z"
  }), React.createElement("path", {
    d: "M13 8.8c-1.3-1.3-3.5-1.3-4.8 0-1.3 1.3-1.3 3.5 0 4.8 1.3 1.3 3.5 1.3 4.8 0 1.3-1.3 1.3-3.5 0-4.8zm-1 3.9c-.1.1-.3.2-.4.1l-1.1-1.1-1 1c-.1.1-.3 0-.4-.1s-.2-.2-.1-.2l1-1-1-1c-.1-.2 0-.4.1-.5s.3-.2.4-.1l1 1 1-1c.1-.1.3 0 .4.1.1.1.2.3.1.4l-1 1 1.1 1.1s0 .3-.1.3z"
  }));
};

var SvgUnpin = function SvgUnpin(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7l,
    name: "unpin"
  }, props));
};

var SvgIcon$7m = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 8.705V4.333l-.663.229a5.701 5.701 0 01-1.087.238V2.1l-.663.23c-.809.279-2.614.615-5.65-.268a10.646 10.646 0 00-6.61-.129L0 2.055v7.612l.634-.177c.3-.083.69-.165 1.116-.24v2.65l.635-.177a11.92 11.92 0 013.153-.44c.493.002.985.042 1.471.12 0 .034-.01.065-.01.1a4.5 4.5 0 009 0A4.456 4.456 0 0015 8.705zM2.077 4.165l-.327.121v3.939c-.267.044-.522.092-.75.143v-5.6a10.144 10.144 0 015.657.258c1.798.613 3.721.764 5.593.438v1.4a12.82 12.82 0 01-3.563-.567 10.639 10.639 0 00-6.61-.132zm3.461 6.117c-.938.004-1.873.11-2.788.318V5a10.126 10.126 0 015.657.257A11.35 11.35 0 0014 5.693V7.76a4.485 4.485 0 00-6.854 2.653 10.432 10.432 0 00-1.608-.131zm9.419 1.634a3.485 3.485 0 01-6.946-.3c0-.04-.012-.078-.012-.119a3.5 3.5 0 117 0c-.005.14-.019.28-.042.419zm-2.964-2.647a.5.5 0 00-.709.705L12.3 11H9.5a.5.5 0 000 1h2.8l-1.014 1.022a.5.5 0 00.709.705L13.5 12.2a1 1 0 00.001-1.414l-.001-.001-1.507-1.516z"
  }));
};

var SvgUseFunds = function SvgUseFunds(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7m,
    name: "use-funds"
  }, props));
};

var SvgIcon$7n = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 8.705V4.333l-.663.229a5.701 5.701 0 01-1.087.238V2.1l-.663.23c-.809.279-2.614.615-5.65-.268a10.646 10.646 0 00-6.61-.129L0 2.055v7.612l.634-.177c.3-.083.69-.165 1.116-.24v2.65l.635-.177a11.92 11.92 0 013.153-.44c.493.002.985.042 1.471.12 0 .034-.01.065-.01.1a4.5 4.5 0 009 0A4.456 4.456 0 0015 8.705zM2.077 4.165l-.327.121v3.939c-.267.044-.522.092-.75.143v-5.6a10.144 10.144 0 015.657.258c1.798.613 3.721.764 5.593.438v1.4a12.82 12.82 0 01-3.563-.567 10.639 10.639 0 00-6.61-.132zm3.461 6.117c-.938.004-1.873.11-2.788.318V5a10.126 10.126 0 015.657.257A11.35 11.35 0 0014 5.693V7.76a4.485 4.485 0 00-6.854 2.653 10.432 10.432 0 00-1.608-.131zm9.419 1.634a3.485 3.485 0 01-6.946-.3c0-.04-.012-.078-.012-.119a3.5 3.5 0 117 0c-.005.14-.019.28-.042.419zm-2.964-2.647a.5.5 0 00-.709.705L12.3 11H9.5a.5.5 0 000 1h2.8l-1.014 1.022a.5.5 0 00.709.705L13.5 12.2a1 1 0 00.001-1.414l-.001-.001-1.507-1.516z"
  }));
};

var SvgUseFundsNext = function SvgUseFundsNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7n,
    name: "use-funds-next"
  }, props));
};

var SvgIcon$7o = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 11"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.7 3.8c-.4.2-.7 0-.7-.6V0H0v11h11V7.8c0-.6.3-.8.7-.6S16 9.7 16 9.7V1.2l-4.3 2.6z"
  }));
};

var SvgVideoCamera = function SvgVideoCamera(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7o,
    name: "video-camera"
  }, props));
};

var SvgIcon$7p = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.5 12.3"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M7.8 12.3s-2.3-3-2.6-3.4c2.9-2.9 5.3 0 5.3 0l-2.7 3.4zm5-6.4C10 3.1 5.5 3.1 2.7 5.8l1.4 1.4c2.1-2 5.3-2 7.4 0-.1 0 1.3-1.3 1.3-1.3zm2.7-2.7C11.2-1.1 4.3-1.1 0 3.2l1.4 1.4c3.6-3.5 9.2-3.5 12.8 0l1.3-1.4z"
  }));
};

var SvgWifi = function SvgWifi(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7p,
    name: "wifi"
  }, props));
};

var SvgIcon$7q = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15 5.6c-1.3 1.3-3.4 1.3-4.7 0S9 2.2 10.3.9c.8-.8 2-1.1 3.1-.9L11 2.4l.4 2 2.1.4 2.4-2.4c.3 1.3-.1 2.4-.9 3.2zm-4.3.4l-.7-.7-10 10 .7.7 10-10z"
  }));
};

var SvgWrench = function SvgWrench(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7q,
    name: "wrench"
  }, props));
};

var SvgIcon$7r = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.2 4.8c-.2-.2-.5-.2-.7 0L8 7.3 5.5 4.8c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7L7.3 8l-2.5 2.5c-.2.2-.2.5 0 .7.1.1.2.1.3.1.1 0 .3-.1.4-.1L8 8.7l2.5 2.5c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.7 8l2.5-2.5c.2-.2.2-.5 0-.7zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgXCircle = function SvgXCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7r,
    name: "x-circle"
  }, props));
};

var SvgIcon$7s = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M13.7 2.3C10.6-.8 5.5-.8 2.4 2.3s-3.1 8.2 0 11.3 8.2 3.1 11.3 0 3.1-8.1 0-11.3zm-2.4 8.1c.2.2.2.6 0 .9-.2.2-.6.2-.9 0L8 8.9l-2.4 2.4c-.2.2-.6.2-.9 0-.2-.2-.2-.6 0-.9L7.1 8 4.7 5.6c-.2-.2-.2-.6 0-.9.2-.2.6-.2.9 0L8 7.1l2.4-2.4c.2-.2.6-.2.9 0 .2.2.2.6 0 .9L8.9 8l2.4 2.4z"
  }));
};

var SvgXCircleFill = function SvgXCircleFill(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7s,
    name: "x-circle-fill"
  }, props));
};

var SvgIcon$7t = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 7.9C0 3.5 3.5 0 7.9 0s7.9 3.5 7.9 7.9-3.5 7.9-7.9 7.9C3.5 15.7 0 12.2 0 7.9zm14.7 0c0-3.8-3.1-6.9-6.9-6.9C4.1 1 1 4.1 1 7.9c0 3.8 3.1 6.9 6.9 6.9 3.8-.1 6.8-3.1 6.8-6.9zm-4.4 3.2L4.7 5.5l.7-.7 5.6 5.6-.7.7zm-5.6-.7l5.7-5.7.6.7-5.7 5.7-.6-.7z"
  }));
};

var SvgXCircle$1 = function SvgXCircle(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7t,
    name: "x-circle"
  }, props));
};

var SvgIcon$7u = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M11.2 4.8c-.2-.2-.5-.2-.7 0L8 7.3 5.5 4.8c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7L7.3 8l-2.5 2.5c-.2.2-.2.5 0 .7.1.1.2.1.3.1.1 0 .3-.1.4-.1L8 8.7l2.5 2.5c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.7 8l2.5-2.5c.2-.2.2-.5 0-.7zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
  }));
};

var SvgXCircleNext = function SvgXCircleNext(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7u,
    name: "x-circle-next"
  }, props));
};

var SvgIcon$7v = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.7 15.7"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M15.7 7.9c0-4.3-3.5-7.9-7.9-7.9S0 3.5 0 7.9c0 4.3 3.5 7.9 7.9 7.9 4.3-.1 7.8-3.6 7.8-7.9zm-5 4.2L7.9 9.3 5 12.1l-1.4-1.4 2.8-2.8-2.8-2.8L5 3.6l2.8 2.8 2.8-2.8L12 5 9.3 7.9l2.8 2.8-1.4 1.4z"
  }));
};

var SvgXCircleSolid = function SvgXCircleSolid(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7v,
    name: "x-circle-solid"
  }, props));
};

var SvgIcon$7w = function SvgIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12.1 12.2"
  }, props), React.createElement("title", null, title), React.createElement("path", {
    d: "M0 11.3L11.4 0l.7.7L.7 12l-.7-.7zM.7 0l11.4 11.4-.7.7L0 .7.7 0z"
  }));
};

var SvgX = function SvgX(props) {
  return React.createElement(StyledIcon, _extends({
    SvgIcon: SvgIcon$7w,
    name: "x"
  }, props));
};

export { SvgAddBank as AddBankAshIcon, SvgAddBankNext as AddBankNextIcon, SvgAddressBook as AddressBookIcon, SvgAlarmClock as AlarmClockIcon, SvgArrowCircleLeft as ArrowCircleLeftIcon, SvgArrowCircles as ArrowCirclesAshIcon, SvgArrowCirclesNext as ArrowCirclesNextIcon, SvgArrowCurvedLeft as ArrowCurvedLeftIcon, SvgArrowCurvedRight as ArrowCurvedRightIcon, SvgArrowDashes as ArrowDashesIcon, SvgArrowDown as ArrowDownAshIcon, SvgArrowDown$1 as ArrowDownIcon, SvgArrowDownNext as ArrowDownNextIcon, SvgArrowLeft as ArrowLeftAshIcon, SvgArrowLeft$1 as ArrowLeftIcon, SvgArrowLeftNext as ArrowLeftNextIcon, SvgArrowRight as ArrowRightAshIcon, SvgArrowRight$1 as ArrowRightIcon, SvgArrowRightNext as ArrowRightNextIcon, SvgArrowUp as ArrowUpAshIcon, SvgArrowUp$1 as ArrowUpIcon, SvgArrowUpNext as ArrowUpNextIcon, SvgArrowsCircles as ArrowsCirclesIcon, SvgArrowsCornersIn as ArrowsCornersInAshIcon, SvgArrowsCornersIn$1 as ArrowsCornersInIcon, SvgArrowsCornersInNext as ArrowsCornersInNextIcon, SvgArrowsCornersOut as ArrowsCornersOutAshIcon, SvgArrowsCornersOut$1 as ArrowsCornersOutIcon, SvgArrowsCornersOutNext as ArrowsCornersOutNextIcon, SvgArrowsDouble as ArrowsDoubleAshIcon, SvgArrowsDoubleNext as ArrowsDoubleNextIcon, SvgAustralia as AustraliaFlag, SvgBadgeCheckmark as BadgeCheckmarkIcon, SvgBlocks as BlocksIcon, SvgBook as BookIcon, SvgBookmark as BookmarkIcon, SvgBoxArrowOut as BoxArrowOutAshIcon, SvgBoxArrowOut$1 as BoxArrowOutIcon, SvgBoxArrowOutNext as BoxArrowOutNextIcon, SvgBoxArrowRight as BoxArrowRightIcon, SvgBoxesColumns as BoxesColumnsAshIcon, SvgBoxesColumns$1 as BoxesColumnsIcon, SvgBoxesColumnsNext as BoxesColumnsNextIcon, SvgBoxesRows as BoxesRowsAshIcon, SvgBoxesRowsNext as BoxesRowsNextIcon, SvgBrazil as BrazilFlag, SvgBriefcase as BriefcaseAshIcon, SvgBriefcase$1 as BriefcaseIcon, SvgBriefcaseNext as BriefcaseNextIcon, SvgBriefcasePaperclip as BriefcasePaperclipIcon, SvgBriefcasePlus as BriefcasePlusIcon, SvgBtLogo as BtLogoFilled, SvgBtLogo$1 as BtLogoUnfilled, SvgBuilding as BuildingAshIcon, SvgBuildingCheckmark as BuildingCheckmarkIcon, SvgBuilding$1 as BuildingIcon, SvgBuildingNext as BuildingNextIcon, SvgBuildingPlus as BuildingPlusIcon, SvgBuildings as BuildingsAshIcon, SvgBuildings$1 as BuildingsIcon, SvgBuildingsNext as BuildingsNextIcon, SvgCalendar as CalendarAshIcon, SvgCalendar$1 as CalendarIcon, SvgCalendarNext as CalendarNextIcon, SvgCamera as CameraAshIcon, SvgCamera$1 as CameraIcon, SvgCanada as CanadaFlag, SvgCaretDown as CaretDownAshIcon, SvgCaretDown$1 as CaretDownIcon, SvgCaretDownNext as CaretDownNextIcon, SvgCaretLeft as CaretLeftAshIcon, SvgCaretLeft$1 as CaretLeftIcon, SvgCaretLeftNext as CaretLeftNextIcon, SvgCaretLineLeft as CaretLineLeftIcon, SvgCaretLineRight as CaretLineRightIcon, SvgCaretRight as CaretRightAshIcon, SvgCaretRight$1 as CaretRightIcon, SvgCaretRightNext as CaretRightNextIcon, SvgCaretUp as CaretUpAshIcon, SvgCaretUp$1 as CaretUpIcon, SvgCaretUpNext as CaretUpNextIcon, SvgCashInHand as CashInHandIcon, SvgChartBar as ChartBarAshIcon, SvgChartBar$1 as ChartBarIcon, SvgChartBarNext as ChartBarNextIcon, SvgChartCircles as ChartCirclesAshIcon, SvgChartCircles$1 as ChartCirclesIcon, SvgChartCirclesNext as ChartCirclesNextIcon, SvgChartDonut as ChartDonutAshIcon, SvgChartDonut$1 as ChartDonutIcon, SvgChartDonutNext as ChartDonutNextIcon, SvgChartLine as ChartLineAshIcon, SvgChartLine$1 as ChartLineIcon, SvgChartLineNext as ChartLineNextIcon, SvgChartPie as ChartPieAshIcon, SvgChartPie$1 as ChartPieIcon, SvgChartPieNext as ChartPieNextIcon, SvgChat as ChatAshIcon, SvgChat$1 as ChatIcon, SvgChatNext as ChatNextIcon, SvgChats as ChatsAshIcon, SvgChatsNext as ChatsNextIcon, SvgCheckPayment as CheckPaymentAshIcon, SvgCheckPayment$1 as CheckPaymentIcon, SvgCheckPaymentNext as CheckPaymentNextIcon, SvgCheckboxes as CheckboxesIcon, SvgCheckmark as CheckmarkAshIcon, SvgCheckmarkBox as CheckmarkBoxIcon, SvgCheckmarkCircle as CheckmarkCircleAshIcon, SvgCheckmarkCircle$1 as CheckmarkCircleIcon, SvgCheckmarkCircleNext as CheckmarkCircleNextIcon, SvgCheckmarkCircleSolid as CheckmarkCircleSolidIcon, SvgCheckmark$1 as CheckmarkIcon, SvgCheckmarkMinusSquare as CheckmarkMinusSquareAshIcon, SvgCheckmarkSquare as CheckmarkSquareAshIcon, SvgCheckmarkSquareNext as CheckmarkSquareNextIcon, SvgChina as ChinaFlag, SvgCircleArrowDown as CircleArrowDownAshIcon, SvgCircleArrowDownNext as CircleArrowDownNextIcon, SvgCircleArrowLeft as CircleArrowLeftAshIcon, SvgCircleArrowLeftNext as CircleArrowLeftNextIcon, SvgCircleArrowRight as CircleArrowRightAshIcon, SvgCircleArrowRightNext as CircleArrowRightNextIcon, SvgCircleArrowUp as CircleArrowUpAshIcon, SvgCircleArrowUpNext as CircleArrowUpNextIcon, SvgCircle as CircleAshIcon, SvgCircleFillArrowDown as CircleFillArrowDownAshIcon, SvgCircleFillArrowLeft as CircleFillArrowLeftAshIcon, SvgCircleFillArrowRight as CircleFillArrowRightAshIcon, SvgCircleFillArrowUp as CircleFillArrowUpAshIcon, SvgCircle$1 as CircleIcon, SvgCircleMinusArrow as CircleMinusArrowIcon, SvgCircleNext as CircleNextIcon, SvgCircleSelected as CircleSelectedAshIcon, SvgCircleSelectedNext as CircleSelectedNextIcon, SvgCircleSolid as CircleSolidIcon, SvgClipboardCheckmark as ClipboardCheckmarkIcon, SvgClipboardDocument as ClipboardDocumentIcon, SvgClipboard as ClipboardIcon, SvgClockArrowLeft as ClockArrowLeftIcon, SvgClock as ClockAshIcon, SvgClockCheckmark as ClockCheckmarkIcon, SvgClock$1 as ClockIcon, SvgClockMoney as ClockMoneyAshIcon, SvgClockMoney$1 as ClockMoneyIcon, SvgClockMoneyNext as ClockMoneyNextIcon, SvgClockNext as ClockNextIcon, SvgClockRush as ClockRushAshIcon, SvgCloseX as CloseXAshIcon, SvgCollapseAll as CollapseAllAshIcon, SvgColumns as ColumnsAshIcon, SvgColumns$1 as ColumnsIcon, SvgColumnsNext as ColumnsNextIcon, SvgColumnsX as ColumnsXAshIcon, SvgColumnsX$1 as ColumnsXIcon, SvgColumnsXNext as ColumnsXNextIcon, SvgCompany as CompanyGradientAshIcon, SvgContactCard as ContactCardAshIcon, SvgContactCard$1 as ContactCardIcon, SvgContactCardNext as ContactCardNextIcon, SvgContainerArrowDown as ContainerArrowDownAshIcon, SvgContainerArrowDown$1 as ContainerArrowDownIcon, SvgContainerArrowDownNext as ContainerArrowDownNextIcon, SvgContainerArrowUp as ContainerArrowUpAshIcon, SvgContainerArrowUp$1 as ContainerArrowUpIcon, SvgContainerArrowUpNext as ContainerArrowUpNextIcon, SvgCreditCard as CreditCardAshIcon, SvgCreditCard$1 as CreditCardIcon, SvgCreditCardNext as CreditCardNextIcon, SvgCylinderStack as CylinderStackIcon, SvgCzechRepublic as CzechRepublicFlag, SvgDenmark as DenmarkFlag, SvgDocumentArrow as DocumentArrowAshIcon, SvgDocumentArrowDown as DocumentArrowDownIcon, SvgDocumentArrow$1 as DocumentArrowIcon, SvgDocumentArrowNext as DocumentArrowNextIcon, SvgDocument as DocumentAshIcon, SvgDocumentCheck as DocumentCheckIcon, SvgDocumentClock as DocumentClockIcon, SvgDocumentCsv as DocumentCsvAshIcon, SvgDocumentCsv$1 as DocumentCsvIcon, SvgDocumentCsvNext as DocumentCsvNextIcon, SvgDocumentDollarSign as DocumentDollarSignIcon, SvgDocument$1 as DocumentIcon, SvgDocumentLines as DocumentLinesIcon, SvgDocumentMagnify as DocumentMagnifyAshIcon, SvgDocumentMagnify$1 as DocumentMagnifyIcon, SvgDocumentMagnifyNext as DocumentMagnifyNextIcon, SvgDocumentMinus as DocumentMinusAshIcon, SvgDocumentMinus$1 as DocumentMinusIcon, SvgDocumentMinusNext as DocumentMinusNextIcon, SvgDocumentNext as DocumentNextIcon, SvgDocumentPayment as DocumentPaymentAshIcon, SvgDocumentPayment$1 as DocumentPaymentIcon, SvgDocumentPaymentNext as DocumentPaymentNextIcon, SvgDocumentPdf as DocumentPdfAshIcon, SvgDocumentPdf$1 as DocumentPdfIcon, SvgDocumentPdfNext as DocumentPdfNextIcon, SvgDocumentPencil as DocumentPencilIcon, SvgDocumentPlus as DocumentPlusAshIcon, SvgDocumentPlus$1 as DocumentPlusIcon, SvgDocumentPlusNext as DocumentPlusNextIcon, SvgDocumentPo as DocumentPoAshIcon, SvgDocumentPoNext as DocumentPoNextIcon, SvgDocumentQuestion as DocumentQuestionIcon, SvgDocumentSlash as DocumentSlashIcon, SvgDocumentXls as DocumentXlsAshIcon, SvgDocumentXls$1 as DocumentXlsIcon, SvgDocumentXlsNext as DocumentXlsNextIcon, SvgDocumentXml as DocumentXmlAshIcon, SvgDocumentXml$1 as DocumentXmlIcon, SvgDocumentXmlNext as DocumentXmlNextIcon, SvgDocuments as DocumentsAshIcon, SvgDocuments$1 as DocumentsIcon, SvgDocumentsNext as DocumentsNextIcon, SvgDoorArrowIn as DoorArrowInIcon, SvgDoorArrowOut as DoorArrowOutIcon, SvgDormant as DormantAshIcon, SvgDotDotDot as DotDotDotAshIcon, SvgDotDotDotCircle as DotDotDotCircleAshIcon, SvgDotDotDotNext as DotDotDotNextIcon, SvgDrag as DragAshIcon, SvgDrawerArrowDown as DrawerArrowDownIcon, SvgDrawerArrowUp as DrawerArrowUpIcon, SvgDrawer as DrawerIcon, SvgEnvelope as EnvelopeAshIcon, SvgEnvelopeDocument as EnvelopeDocumentIcon, SvgEnvelope$1 as EnvelopeIcon, SvgEnvelopeNext as EnvelopeNextIcon, SvgEnvelopeOpen as EnvelopeOpenIcon, SvgEurope as EuropeFlag, SvgExclamationCircle as ExclamationCircleAshIcon, SvgExclamationCircle$1 as ExclamationCircleIcon, SvgExclamationCircleNext as ExclamationCircleNextIcon, SvgExclamationCircleSolid as ExclamationCircleSolidIcon, SvgExclamationTriangle as ExclamationTriangleAshIcon, SvgExclamationTriangle$1 as ExclamationTriangleIcon, SvgExclamationTriangleNext as ExclamationTriangleNextIcon, SvgExclamationTriangleSolid as ExclamationTriangleSolidIcon, SvgExpandAll as ExpandAllAshIcon, SvgEye as EyeAshIcon, SvgEye$1 as EyeIcon, SvgEyeLine as EyeLineAshIcon, SvgEyeLine$1 as EyeLineIcon, SvgEyeLineNext as EyeLineNextIcon, SvgEyeNext as EyeNextIcon, SvgFaceId as FaceIdAshIcon, SvgFaceId$1 as FaceIdIcon, SvgFilter as FilterAshIcon, SvgFilter$1 as FilterIcon, SvgFilterNext as FilterNextIcon, SvgFilterStacked as FilterStackedIcon, SvgFingerprintId as FingerprintIdAshIcon, SvgFingerprintId$1 as FingerprintIdIcon, SvgFlag as FlagAshIcon, SvgFlag$1 as FlagIcon, SvgFlagNext as FlagNextIcon, SvgFlip as FlipAshIcon, SvgFlip$1 as FlipIcon, SvgFloppyDisk as FloppyDiskIcon, SvgFlowchart as FlowchartAshIcon, SvgFolder as FolderIcon, SvgFolderLock as FolderLockIcon, SvgFolderMinus as FolderMinusIcon, SvgFolderOpen as FolderOpenIcon, SvgFolderPlus as FolderPlusIcon, SvgFolderZip as FolderZipIcon, SvgFunnel as FunnelAshIcon, SvgFunnelNext as FunnelNextIcon, SvgGauge as GaugeIcon, SvgGavel as GavelAshIcon, SvgGavel$1 as GavelIcon, SvgGavelNext as GavelNextIcon, SvgGear as GearAshIcon, SvgGear$1 as GearIcon, SvgGearNext as GearNextIcon, SvgGears as GearsIcon, SvgGlobe as GlobeAshIcon, SvgGlobeGears as GlobeGearsIcon, SvgGlobe$1 as GlobeIcon, SvgGlobeNext as GlobeNextIcon, SvgGoal as GoalAshIcon, SvgGraduationCap as GraduationCapAshIcon, SvgGraduationCap$1 as GraduationCapIcon, SvgGraduationCapNext as GraduationCapNextIcon, SvgHandout as HandoutIcon, SvgHandshake as HandshakeAshIcon, SvgHandshakeNext as HandshakeNextIcon, SvgHome as HomeAshIcon, SvgHome$1 as HomeIcon, SvgHomeNext as HomeNextIcon, SvgHongKong as HongKongFlag, SvgHungary as HungaryFlag, SvgImage as ImageIcon, SvgInfoCircle as InfoCircleAshIcon, SvgInfoCircle$1 as InfoCircleIcon, SvgInfoCircleNext as InfoCircleNextIcon, SvgInfoCircleSolid as InfoCircleSolidIcon, SvgIsrael as IsraelFlag, SvgJapan as JapanFlag, SvgKey as KeyIcon, SvgKuwait as KuwaitFlag, SvgLayoutBrowser as LayoutBrowserIcon, SvgLetters as LettersIcon, SvgLightbulb as LightbulbIcon, SvgLinesArrowDown as LinesArrowDownIcon, SvgLines as LinesAshIcon, SvgLines$1 as LinesIcon, SvgLinesNext as LinesNextIcon, SvgLinkedEdit as LinkedEditAshIcon, SvgList as ListAshIcon, SvgListBrowser as ListBrowserIcon, SvgList$1 as ListIcon, SvgListNext as ListNextIcon, SvgListNumber as ListNumberIcon, SvgListOutline as ListOutlineIcon, SvgLocator as LocatorIcon, SvgLock as LockAshIcon, SvgLock$1 as LockIcon, SvgLockNext as LockNextIcon, SvgMagnify as MagnifyAshIcon, SvgMagnifyCircle as MagnifyCircleAshIcon, SvgMagnifyCircleNext as MagnifyCircleNextIcon, SvgMagnify$1 as MagnifyIcon, SvgMagnifyMinus as MagnifyMinusIcon, SvgMagnifyNext as MagnifyNextIcon, SvgMagnifyPlus as MagnifyPlusIcon, SvgMexico as MexicoFlag, SvgMicrophone as MicrophoneAshIcon, SvgMicrophone$1 as MicrophoneIcon, SvgMicrophoneNext as MicrophoneNextIcon, SvgMicrophoneSlash as MicrophoneSlashAshIcon, SvgMicrophoneSlash$1 as MicrophoneSlashIcon, SvgMicrophoneSlashNext as MicrophoneSlashNextIcon, SvgMinusCircle as MinusCircleAshIcon, SvgMinusCircle$1 as MinusCircleIcon, SvgMinusCircleNext as MinusCircleNextIcon, SvgMinusCircleSolid as MinusCircleSolidIcon, SvgMinus as MinusIcon, SvgMonitor as MonitorIcon, SvgNetworkBranch as NetworkBranchIcon, SvgNetwork as NetworkIcon, SvgNewZealand as NewZealandFlag, SvgNorway as NorwayFlag, SvgNotification as NotificationAshIcon, SvgPaperClip as PaperClipAshIcon, SvgPaperClip$1 as PaperClipIcon, SvgPaperClipNext as PaperClipNextIcon, SvgPause as PauseAshIcon, SvgPauseNext as PauseNextIcon, SvgPayment as PaymentAshIcon, SvgPayment$1 as PaymentIcon, SvgPaymentLeftArrow as PaymentLeftArrowIcon, SvgPaymentNext as PaymentNextIcon, SvgPaymentQuick as PaymentQuickIcon, SvgPencil as PencilAshIcon, SvgPencil$1 as PencilIcon, SvgPencilNext as PencilNextIcon, SvgPeople as PeopleAshIcon, SvgPeople$1 as PeopleIcon, SvgPeopleNext as PeopleNextIcon, SvgPerson as PersonAshIcon, SvgPerson$1 as PersonGradientAshIcon, SvgPerson$2 as PersonIcon, SvgPersonMinus as PersonMinusAshIcon, SvgPersonMinus$1 as PersonMinusIcon, SvgPersonMinusNext as PersonMinusNextIcon, SvgPersonNetwork as PersonNetworkIcon, SvgPersonNext as PersonNextIcon, SvgPersonPlus as PersonPlusAshIcon, SvgPersonPlus$1 as PersonPlusIcon, SvgPersonPlusNext as PersonPlusNextIcon, SvgPersonX as PersonXIcon, SvgPhone as PhoneAshIcon, SvgPhone$1 as PhoneIcon, SvgPhoneMobile as PhoneMobileIcon, SvgPhoneNext as PhoneNextIcon, SvgPhoneTouchScreen as PhoneTouchScreenIcon, SvgPin as PinAshIcon, SvgPin$1 as PinIcon, SvgPinNext as PinNextIcon, SvgPlay as PlayAshIcon, SvgPlayNext as PlayNextIcon, SvgPlusCircle as PlusCircleAshIcon, SvgPlusCircleFill as PlusCircleFillAshIcon, SvgPlusCircle$1 as PlusCircleIcon, SvgPlusCircleNext as PlusCircleNextIcon, SvgPlusCircleSolid as PlusCircleSolidIcon, SvgPlus as PlusIcon, SvgPoland as PolandFlag, SvgPower as PowerIcon, SvgPrinter as PrinterAshIcon, SvgPrinter$1 as PrinterIcon, SvgPrinterNext as PrinterNextIcon, SvgPuck as PuckIcon, SvgQuestionCircle as QuestionCircleAshIcon, SvgQuestionCircle$1 as QuestionCircleIcon, SvgQuestionCircleNext as QuestionCircleNextIcon, SvgQuestionCircleSolid as QuestionCircleSolidIcon, SvgQuestionMark as QuestionMarkIcon, SvgRibbonAward as RibbonAwardIcon, SvgRole as RoleGradientAshIcon, SvgScales as ScalesAshIcon, SvgScales$1 as ScalesIcon, SvgScalesNext as ScalesNextIcon, SvgServers as ServersIcon, SvgSettings as SettingsIcon, SvgShield as ShieldAshIcon, SvgShieldCheckmark as ShieldCheckmarkIcon, SvgShieldDollar as ShieldDollarIcon, SvgShield$1 as ShieldIcon, SvgShieldNext as ShieldNextIcon, SvgSingapore as SingaporeFlag, SvgSlashCircle as SlashCircleIcon, SvgSnowflake as SnowflakeAshIcon, SvgSnowflake$1 as SnowflakeIcon, SvgSnowflakeNext as SnowflakeNextIcon, SvgSouthAfrica as SouthAfricaFlag, SvgSquare as SquareAshIcon, SvgSquareNext as SquareNextIcon, SvgSquaresFour as SquaresFourAshIcon, SvgSquaresFour$1 as SquaresFourIcon, SvgSquaresFourNext as SquaresFourNextIcon, SvgSquaresNine as SquaresNineIcon, SvgSquaresStacked as SquaresStackedIcon, SvgStar as StarAshIcon, SvgStar$1 as StarIcon, SvgStarNext as StarNextIcon, SvgSweden as SwedenFlag, SvgSwitzerland as SwitzerlandFlag, SvgTable as TableAshIcon, SvgTable$1 as TableIcon, SvgTableNext as TableNextIcon, SvgTablePivot as TablePivotIcon, SvgTarget as TargetAshIcon, SvgThailand as ThailandFlag, SvgTools as ToolsIcon, SvgTransactionAdd as TransactionAddAshIcon, SvgTransactionNext as TransactionNextAshIcon, SvgTransactionRemove as TransactionRemoveAshIcon, SvgTransactionUpdate as TransactionUpdateAshIcon, SvgTransfer as TransferAshIcon, SvgTransferNext as TransferNextIcon, SvgTrashCan as TrashCanAshIcon, SvgTrashCan$1 as TrashCanIcon, SvgTrashCanNext as TrashCanNextIcon, SvgTriangle as TriangleAshIcon, SvgTriangleDown as TriangleDownIcon, SvgTriangleLeft as TriangleLeftIcon, SvgTriangleNext as TriangleNextIcon, SvgTriangleRight as TriangleRightIcon, SvgTriangleUp as TriangleUpIcon, SvgTurkey as TurkeyFlag, SvgUmbrella as UmbrellaAshIcon, SvgUmbrella$1 as UmbrellaIcon, SvgUmbrellaNext as UmbrellaNextIcon, SvgUnitedArabEmirates as UnitedArabEmiratesFlag, SvgUnitedKingdom as UnitedKingdomFlag, SvgUnitedStates as UnitedStatesFlag, SvgUnlock as UnlockAshIcon, SvgUnlock$1 as UnlockIcon, SvgUnlockNext as UnlockNextIcon, SvgUnpin as UnpinAshIcon, SvgUseFunds as UseFundsAshIcon, SvgUseFundsNext as UseFundsNextIcon, SvgVideoCamera as VideoCameraIcon, SvgWifi as WifiIcon, SvgWrench as WrenchIcon, SvgXCircle as XCircleAshIcon, SvgXCircleFill as XCircleFillAshIcon, SvgXCircle$1 as XCircleIcon, SvgXCircleNext as XCircleNextIcon, SvgXCircleSolid as XCircleSolidIcon, SvgX as XIcon, StyledIcon as Icon, withTitle, ActionableIcon$1 as ActionableIcon, ActionableMenuIcon };
